export const getTmbCards = {
    "data": {
        "stopLocationOrCoordLocation": [
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d4a3ba28-5531-4062-860b-7790ed93fae2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d4a3ba28-5531-4062-860b-7790ed93fae2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d4a3ba28-5531-4062-860b-7790ed93fae2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d4a3ba28-5531-4062-860b-7790ed93fae2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDRhM2JhMjgtNTUzMS00MDYyLTg2MGItNzc5MGVkOTNmYWUyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDRhM2JhMjgtNTUzMS00MDYyLTg2MGItNzc5MGVkOTNmYWUyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d4a3ba28-5531-4062-860b-7790ed93fae2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d4a3ba28-5531-4062-860b-7790ed93fae2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2138514@Y=41357578@L=%23mcp%3AV%3Adonkey-barcelona%3Ad4a3ba28-5531-4062-860b-7790ed93fae2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad4a3ba28-5531-4062-860b-7790ed93fae2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.138514,
                    "lat": 41.357578
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4e622911-c615-445d-a4e1-a50beda5696f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4e622911-c615-445d-a4e1-a50beda5696f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4e622911-c615-445d-a4e1-a50beda5696f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4e622911-c615-445d-a4e1-a50beda5696f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGU2MjI5MTEtYzYxNS00NDVkLWE0ZTEtYTUwYmVkYTU2OTZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGU2MjI5MTEtYzYxNS00NDVkLWE0ZTEtYTUwYmVkYTU2OTZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4e622911-c615-445d-a4e1-a50beda5696f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4e622911-c615-445d-a4e1-a50beda5696f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2138456@Y=41357586@L=%23mcp%3AV%3Adonkey-barcelona%3A4e622911-c615-445d-a4e1-a50beda5696f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4e622911-c615-445d-a4e1-a50beda5696f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.138456,
                    "lat": 41.357586
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5efa0575-bea8-4b36-8125-246c5df620f2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5efa0575-bea8-4b36-8125-246c5df620f2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5efa0575-bea8-4b36-8125-246c5df620f2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5efa0575-bea8-4b36-8125-246c5df620f2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWVmYTA1NzUtYmVhOC00YjM2LTgxMjUtMjQ2YzVkZjYyMGYyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWVmYTA1NzUtYmVhOC00YjM2LTgxMjUtMjQ2YzVkZjYyMGYyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5efa0575-bea8-4b36-8125-246c5df620f2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5efa0575-bea8-4b36-8125-246c5df620f2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2129785@Y=41360744@L=%23mcp%3AV%3Adonkey-barcelona%3A5efa0575-bea8-4b36-8125-246c5df620f2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5efa0575-bea8-4b36-8125-246c5df620f2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.129785,
                    "lat": 41.360744
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=68b4ce27-ca91-4d39-ad74-2d722ca14083",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=68b4ce27-ca91-4d39-ad74-2d722ca14083"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=68b4ce27-ca91-4d39-ad74-2d722ca14083",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=68b4ce27-ca91-4d39-ad74-2d722ca14083"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjhiNGNlMjctY2E5MS00ZDM5LWFkNzQtMmQ3MjJjYTE0MDgzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjhiNGNlMjctY2E5MS00ZDM5LWFkNzQtMmQ3MjJjYTE0MDgzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:68b4ce27-ca91-4d39-ad74-2d722ca14083_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "68b4ce27-ca91-4d39-ad74-2d722ca14083",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2129763@Y=41360748@L=%23mcp%3AV%3Adonkey-barcelona%3A68b4ce27-ca91-4d39-ad74-2d722ca14083_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A68b4ce27-ca91-4d39-ad74-2d722ca14083_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.129763,
                    "lat": 41.360748
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0a82f8f3-d45e-40c1-9364-c4fafbbeb041",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0a82f8f3-d45e-40c1-9364-c4fafbbeb041"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0a82f8f3-d45e-40c1-9364-c4fafbbeb041",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0a82f8f3-d45e-40c1-9364-c4fafbbeb041"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGE4MmY4ZjMtZDQ1ZS00MGMxLTkzNjQtYzRmYWZiYmViMDQxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGE4MmY4ZjMtZDQ1ZS00MGMxLTkzNjQtYzRmYWZiYmViMDQxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0a82f8f3-d45e-40c1-9364-c4fafbbeb041_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0a82f8f3-d45e-40c1-9364-c4fafbbeb041",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2129775@Y=41360767@L=%23mcp%3AV%3Adonkey-barcelona%3A0a82f8f3-d45e-40c1-9364-c4fafbbeb041_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0a82f8f3-d45e-40c1-9364-c4fafbbeb041_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.129775,
                    "lat": 41.360767
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7df02717-6c1e-404a-bb1f-4578ae45f6f0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7df02717-6c1e-404a-bb1f-4578ae45f6f0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7df02717-6c1e-404a-bb1f-4578ae45f6f0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7df02717-6c1e-404a-bb1f-4578ae45f6f0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2RmMDI3MTctNmMxZS00MDRhLWJiMWYtNDU3OGFlNDVmNmYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2RmMDI3MTctNmMxZS00MDRhLWJiMWYtNDU3OGFlNDVmNmYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7df02717-6c1e-404a-bb1f-4578ae45f6f0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7df02717-6c1e-404a-bb1f-4578ae45f6f0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2134233@Y=41364190@L=%23mcp%3AV%3Adonkey-barcelona%3A7df02717-6c1e-404a-bb1f-4578ae45f6f0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7df02717-6c1e-404a-bb1f-4578ae45f6f0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.134233,
                    "lat": 41.36419
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=71e89c54-8831-4d6a-a495-7a050d3fb3d7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=71e89c54-8831-4d6a-a495-7a050d3fb3d7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=71e89c54-8831-4d6a-a495-7a050d3fb3d7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=71e89c54-8831-4d6a-a495-7a050d3fb3d7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzFlODljNTQtODgzMS00ZDZhLWE0OTUtN2EwNTBkM2ZiM2Q3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzFlODljNTQtODgzMS00ZDZhLWE0OTUtN2EwNTBkM2ZiM2Q3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:71e89c54-8831-4d6a-a495-7a050d3fb3d7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "71e89c54-8831-4d6a-a495-7a050d3fb3d7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2134233@Y=41364190@L=%23mcp%3AV%3Adonkey-barcelona%3A71e89c54-8831-4d6a-a495-7a050d3fb3d7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A71e89c54-8831-4d6a-a495-7a050d3fb3d7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.134233,
                    "lat": 41.36419
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a6b51709-64b4-4bb7-b929-8844f1759267",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a6b51709-64b4-4bb7-b929-8844f1759267"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a6b51709-64b4-4bb7-b929-8844f1759267",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a6b51709-64b4-4bb7-b929-8844f1759267"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTZiNTE3MDktNjRiNC00YmI3LWI5MjktODg0NGYxNzU5MjY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTZiNTE3MDktNjRiNC00YmI3LWI5MjktODg0NGYxNzU5MjY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a6b51709-64b4-4bb7-b929-8844f1759267_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a6b51709-64b4-4bb7-b929-8844f1759267",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2137809@Y=41364499@L=%23mcp%3AV%3Adonkey-barcelona%3Aa6b51709-64b4-4bb7-b929-8844f1759267_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa6b51709-64b4-4bb7-b929-8844f1759267_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.137809,
                    "lat": 41.364499
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0239b483-fb30-4c69-ae22-622685c23da5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0239b483-fb30-4c69-ae22-622685c23da5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0239b483-fb30-4c69-ae22-622685c23da5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0239b483-fb30-4c69-ae22-622685c23da5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDIzOWI0ODMtZmIzMC00YzY5LWFlMjItNjIyNjg1YzIzZGE1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDIzOWI0ODMtZmIzMC00YzY5LWFlMjItNjIyNjg1YzIzZGE1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0239b483-fb30-4c69-ae22-622685c23da5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0239b483-fb30-4c69-ae22-622685c23da5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2137749@Y=41364570@L=%23mcp%3AV%3Adonkey-barcelona%3A0239b483-fb30-4c69-ae22-622685c23da5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0239b483-fb30-4c69-ae22-622685c23da5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.137749,
                    "lat": 41.36457
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=60e75661-8409-4a36-ac39-60ab2e1d5954",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=60e75661-8409-4a36-ac39-60ab2e1d5954"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=60e75661-8409-4a36-ac39-60ab2e1d5954",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=60e75661-8409-4a36-ac39-60ab2e1d5954"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjBlNzU2NjEtODQwOS00YTM2LWFjMzktNjBhYjJlMWQ1OTU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjBlNzU2NjEtODQwOS00YTM2LWFjMzktNjBhYjJlMWQ1OTU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:60e75661-8409-4a36-ac39-60ab2e1d5954_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "60e75661-8409-4a36-ac39-60ab2e1d5954",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187594@Y=41367519@L=%23mcp%3AV%3Adonkey-barcelona%3A60e75661-8409-4a36-ac39-60ab2e1d5954_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A60e75661-8409-4a36-ac39-60ab2e1d5954_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187594,
                    "lat": 41.367519
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8467126d-1235-4c2b-b1b5-c2f016894854",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8467126d-1235-4c2b-b1b5-c2f016894854"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8467126d-1235-4c2b-b1b5-c2f016894854",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8467126d-1235-4c2b-b1b5-c2f016894854"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODQ2NzEyNmQtMTIzNS00YzJiLWIxYjUtYzJmMDE2ODk0ODU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODQ2NzEyNmQtMTIzNS00YzJiLWIxYjUtYzJmMDE2ODk0ODU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8467126d-1235-4c2b-b1b5-c2f016894854_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8467126d-1235-4c2b-b1b5-c2f016894854",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187613@Y=41367561@L=%23mcp%3AV%3Adonkey-barcelona%3A8467126d-1235-4c2b-b1b5-c2f016894854_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8467126d-1235-4c2b-b1b5-c2f016894854_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187613,
                    "lat": 41.367561
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1f69a138-66fa-468f-95fb-2dffc0b6b8f1",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1f69a138-66fa-468f-95fb-2dffc0b6b8f1"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1f69a138-66fa-468f-95fb-2dffc0b6b8f1",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1f69a138-66fa-468f-95fb-2dffc0b6b8f1"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWY2OWExMzgtNjZmYS00NjhmLTk1ZmItMmRmZmMwYjZiOGYxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWY2OWExMzgtNjZmYS00NjhmLTk1ZmItMmRmZmMwYjZiOGYxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1f69a138-66fa-468f-95fb-2dffc0b6b8f1_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1f69a138-66fa-468f-95fb-2dffc0b6b8f1",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187627@Y=41367570@L=%23mcp%3AV%3Adonkey-barcelona%3A1f69a138-66fa-468f-95fb-2dffc0b6b8f1_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1f69a138-66fa-468f-95fb-2dffc0b6b8f1_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187627,
                    "lat": 41.36757
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fe3f58b4-773c-48ed-a905-5a684d9c9819",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fe3f58b4-773c-48ed-a905-5a684d9c9819"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fe3f58b4-773c-48ed-a905-5a684d9c9819",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fe3f58b4-773c-48ed-a905-5a684d9c9819"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmUzZjU4YjQtNzczYy00OGVkLWE5MDUtNWE2ODRkOWM5ODE5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmUzZjU4YjQtNzczYy00OGVkLWE5MDUtNWE2ODRkOWM5ODE5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:fe3f58b4-773c-48ed-a905-5a684d9c9819_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "fe3f58b4-773c-48ed-a905-5a684d9c9819",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187653@Y=41367576@L=%23mcp%3AV%3Adonkey-barcelona%3Afe3f58b4-773c-48ed-a905-5a684d9c9819_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Afe3f58b4-773c-48ed-a905-5a684d9c9819_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187653,
                    "lat": 41.367576
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6f53b45f-d4f5-4255-9ea8-ed9865d6fcf2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6f53b45f-d4f5-4255-9ea8-ed9865d6fcf2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6f53b45f-d4f5-4255-9ea8-ed9865d6fcf2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6f53b45f-d4f5-4255-9ea8-ed9865d6fcf2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmY1M2I0NWYtZDRmNS00MjU1LTllYTgtZWQ5ODY1ZDZmY2YyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmY1M2I0NWYtZDRmNS00MjU1LTllYTgtZWQ5ODY1ZDZmY2YyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6f53b45f-d4f5-4255-9ea8-ed9865d6fcf2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6f53b45f-d4f5-4255-9ea8-ed9865d6fcf2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187667@Y=41367631@L=%23mcp%3AV%3Adonkey-barcelona%3A6f53b45f-d4f5-4255-9ea8-ed9865d6fcf2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6f53b45f-d4f5-4255-9ea8-ed9865d6fcf2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187667,
                    "lat": 41.367631
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0d8a7bae-a183-47c9-816a-5e01a01989a8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0d8a7bae-a183-47c9-816a-5e01a01989a8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0d8a7bae-a183-47c9-816a-5e01a01989a8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0d8a7bae-a183-47c9-816a-5e01a01989a8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGQ4YTdiYWUtYTE4My00N2M5LTgxNmEtNWUwMWEwMTk4OWE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGQ4YTdiYWUtYTE4My00N2M5LTgxNmEtNWUwMWEwMTk4OWE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0d8a7bae-a183-47c9-816a-5e01a01989a8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0d8a7bae-a183-47c9-816a-5e01a01989a8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187731@Y=41367646@L=%23mcp%3AV%3Adonkey-barcelona%3A0d8a7bae-a183-47c9-816a-5e01a01989a8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0d8a7bae-a183-47c9-816a-5e01a01989a8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187731,
                    "lat": 41.367646
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1c4c1867-0e54-49de-a976-c266a3abc4bc",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1c4c1867-0e54-49de-a976-c266a3abc4bc"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1c4c1867-0e54-49de-a976-c266a3abc4bc",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1c4c1867-0e54-49de-a976-c266a3abc4bc"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWM0YzE4NjctMGU1NC00OWRlLWE5NzYtYzI2NmEzYWJjNGJjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWM0YzE4NjctMGU1NC00OWRlLWE5NzYtYzI2NmEzYWJjNGJjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1c4c1867-0e54-49de-a976-c266a3abc4bc_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1c4c1867-0e54-49de-a976-c266a3abc4bc",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187681@Y=41367676@L=%23mcp%3AV%3Adonkey-barcelona%3A1c4c1867-0e54-49de-a976-c266a3abc4bc_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1c4c1867-0e54-49de-a976-c266a3abc4bc_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187681,
                    "lat": 41.367676
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=074d8a0f-42ac-43a1-b139-6207fb9de286",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=074d8a0f-42ac-43a1-b139-6207fb9de286"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=074d8a0f-42ac-43a1-b139-6207fb9de286",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=074d8a0f-42ac-43a1-b139-6207fb9de286"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDc0ZDhhMGYtNDJhYy00M2ExLWIxMzktNjIwN2ZiOWRlMjg2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDc0ZDhhMGYtNDJhYy00M2ExLWIxMzktNjIwN2ZiOWRlMjg2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:074d8a0f-42ac-43a1-b139-6207fb9de286_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "074d8a0f-42ac-43a1-b139-6207fb9de286",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187633@Y=41367693@L=%23mcp%3AV%3Adonkey-barcelona%3A074d8a0f-42ac-43a1-b139-6207fb9de286_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A074d8a0f-42ac-43a1-b139-6207fb9de286_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187633,
                    "lat": 41.367693
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b2c153b8-b805-4e62-916e-c45c5afbfa03",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b2c153b8-b805-4e62-916e-c45c5afbfa03"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b2c153b8-b805-4e62-916e-c45c5afbfa03",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b2c153b8-b805-4e62-916e-c45c5afbfa03"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjJjMTUzYjgtYjgwNS00ZTYyLTkxNmUtYzQ1YzVhZmJmYTAzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjJjMTUzYjgtYjgwNS00ZTYyLTkxNmUtYzQ1YzVhZmJmYTAzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b2c153b8-b805-4e62-916e-c45c5afbfa03_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b2c153b8-b805-4e62-916e-c45c5afbfa03",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187653@Y=41367711@L=%23mcp%3AV%3Adonkey-barcelona%3Ab2c153b8-b805-4e62-916e-c45c5afbfa03_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab2c153b8-b805-4e62-916e-c45c5afbfa03_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187653,
                    "lat": 41.367711
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=20a63da5-5616-45a3-bc37-07f33ca5dec4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=20a63da5-5616-45a3-bc37-07f33ca5dec4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=20a63da5-5616-45a3-bc37-07f33ca5dec4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=20a63da5-5616-45a3-bc37-07f33ca5dec4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjBhNjNkYTUtNTYxNi00NWEzLWJjMzctMDdmMzNjYTVkZWM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjBhNjNkYTUtNTYxNi00NWEzLWJjMzctMDdmMzNjYTVkZWM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:20a63da5-5616-45a3-bc37-07f33ca5dec4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "20a63da5-5616-45a3-bc37-07f33ca5dec4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187625@Y=41367736@L=%23mcp%3AV%3Adonkey-barcelona%3A20a63da5-5616-45a3-bc37-07f33ca5dec4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A20a63da5-5616-45a3-bc37-07f33ca5dec4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187625,
                    "lat": 41.367736
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b458fc1d-aca4-4139-9b7d-f49eb3abb46d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b458fc1d-aca4-4139-9b7d-f49eb3abb46d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b458fc1d-aca4-4139-9b7d-f49eb3abb46d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b458fc1d-aca4-4139-9b7d-f49eb3abb46d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjQ1OGZjMWQtYWNhNC00MTM5LTliN2QtZjQ5ZWIzYWJiNDZkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjQ1OGZjMWQtYWNhNC00MTM5LTliN2QtZjQ5ZWIzYWJiNDZkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b458fc1d-aca4-4139-9b7d-f49eb3abb46d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b458fc1d-aca4-4139-9b7d-f49eb3abb46d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187671@Y=41367745@L=%23mcp%3AV%3Adonkey-barcelona%3Ab458fc1d-aca4-4139-9b7d-f49eb3abb46d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab458fc1d-aca4-4139-9b7d-f49eb3abb46d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187671,
                    "lat": 41.367745
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e258c3fd-89a3-45c6-bb0a-a5aaf2ac7d0a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e258c3fd-89a3-45c6-bb0a-a5aaf2ac7d0a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e258c3fd-89a3-45c6-bb0a-a5aaf2ac7d0a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e258c3fd-89a3-45c6-bb0a-a5aaf2ac7d0a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTI1OGMzZmQtODlhMy00NWM2LWJiMGEtYTVhYWYyYWM3ZDBhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTI1OGMzZmQtODlhMy00NWM2LWJiMGEtYTVhYWYyYWM3ZDBhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e258c3fd-89a3-45c6-bb0a-a5aaf2ac7d0a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e258c3fd-89a3-45c6-bb0a-a5aaf2ac7d0a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2139942@Y=41367902@L=%23mcp%3AV%3Adonkey-barcelona%3Ae258c3fd-89a3-45c6-bb0a-a5aaf2ac7d0a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae258c3fd-89a3-45c6-bb0a-a5aaf2ac7d0a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.139942,
                    "lat": 41.367902
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bdbaf6cd-3e18-4bb5-a2eb-38f0f8d07681",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bdbaf6cd-3e18-4bb5-a2eb-38f0f8d07681"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bdbaf6cd-3e18-4bb5-a2eb-38f0f8d07681",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bdbaf6cd-3e18-4bb5-a2eb-38f0f8d07681"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmRiYWY2Y2QtM2UxOC00YmI1LWEyZWItMzhmMGY4ZDA3NjgxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmRiYWY2Y2QtM2UxOC00YmI1LWEyZWItMzhmMGY4ZDA3NjgxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:bdbaf6cd-3e18-4bb5-a2eb-38f0f8d07681_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "bdbaf6cd-3e18-4bb5-a2eb-38f0f8d07681",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2139966@Y=41367912@L=%23mcp%3AV%3Adonkey-barcelona%3Abdbaf6cd-3e18-4bb5-a2eb-38f0f8d07681_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Abdbaf6cd-3e18-4bb5-a2eb-38f0f8d07681_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.139966,
                    "lat": 41.367912
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1a180608-2a5b-4174-b468-bce49549ae6f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1a180608-2a5b-4174-b468-bce49549ae6f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1a180608-2a5b-4174-b468-bce49549ae6f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1a180608-2a5b-4174-b468-bce49549ae6f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWExODA2MDgtMmE1Yi00MTc0LWI0NjgtYmNlNDk1NDlhZTZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWExODA2MDgtMmE1Yi00MTc0LWI0NjgtYmNlNDk1NDlhZTZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1a180608-2a5b-4174-b468-bce49549ae6f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1a180608-2a5b-4174-b468-bce49549ae6f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2139965@Y=41367917@L=%23mcp%3AV%3Adonkey-barcelona%3A1a180608-2a5b-4174-b468-bce49549ae6f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1a180608-2a5b-4174-b468-bce49549ae6f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.139965,
                    "lat": 41.367917
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=087545f7-9b42-46d5-a56c-8745983ee2c1",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=087545f7-9b42-46d5-a56c-8745983ee2c1"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=087545f7-9b42-46d5-a56c-8745983ee2c1",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=087545f7-9b42-46d5-a56c-8745983ee2c1"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDg3NTQ1ZjctOWI0Mi00NmQ1LWE1NmMtODc0NTk4M2VlMmMxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDg3NTQ1ZjctOWI0Mi00NmQ1LWE1NmMtODc0NTk4M2VlMmMxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:087545f7-9b42-46d5-a56c-8745983ee2c1_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "087545f7-9b42-46d5-a56c-8745983ee2c1",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2140122@Y=41368033@L=%23mcp%3AV%3Adonkey-barcelona%3A087545f7-9b42-46d5-a56c-8745983ee2c1_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A087545f7-9b42-46d5-a56c-8745983ee2c1_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.140122,
                    "lat": 41.368033
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ddc1feed-8315-4ee2-981e-5920e18626df",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ddc1feed-8315-4ee2-981e-5920e18626df"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ddc1feed-8315-4ee2-981e-5920e18626df",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ddc1feed-8315-4ee2-981e-5920e18626df"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGRjMWZlZWQtODMxNS00ZWUyLTk4MWUtNTkyMGUxODYyNmRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGRjMWZlZWQtODMxNS00ZWUyLTk4MWUtNTkyMGUxODYyNmRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ddc1feed-8315-4ee2-981e-5920e18626df_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ddc1feed-8315-4ee2-981e-5920e18626df",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2140302@Y=41368137@L=%23mcp%3AV%3Adonkey-barcelona%3Addc1feed-8315-4ee2-981e-5920e18626df_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Addc1feed-8315-4ee2-981e-5920e18626df_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.140302,
                    "lat": 41.368137
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=aa413225-aec6-4090-bbb7-cc8cf8f90234",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=aa413225-aec6-4090-bbb7-cc8cf8f90234"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=aa413225-aec6-4090-bbb7-cc8cf8f90234",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=aa413225-aec6-4090-bbb7-cc8cf8f90234"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWE0MTMyMjUtYWVjNi00MDkwLWJiYjctY2M4Y2Y4ZjkwMjM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWE0MTMyMjUtYWVjNi00MDkwLWJiYjctY2M4Y2Y4ZjkwMjM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:aa413225-aec6-4090-bbb7-cc8cf8f90234_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "aa413225-aec6-4090-bbb7-cc8cf8f90234",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2140534@Y=41368249@L=%23mcp%3AV%3Adonkey-barcelona%3Aaa413225-aec6-4090-bbb7-cc8cf8f90234_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aaa413225-aec6-4090-bbb7-cc8cf8f90234_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.140534,
                    "lat": 41.368249
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1fb7c115-3123-46c4-98e7-f078c8dbf8da",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1fb7c115-3123-46c4-98e7-f078c8dbf8da"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1fb7c115-3123-46c4-98e7-f078c8dbf8da",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1fb7c115-3123-46c4-98e7-f078c8dbf8da"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWZiN2MxMTUtMzEyMy00NmM0LTk4ZTctZjA3OGM4ZGJmOGRhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWZiN2MxMTUtMzEyMy00NmM0LTk4ZTctZjA3OGM4ZGJmOGRhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1fb7c115-3123-46c4-98e7-f078c8dbf8da_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1fb7c115-3123-46c4-98e7-f078c8dbf8da",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2140534@Y=41368249@L=%23mcp%3AV%3Adonkey-barcelona%3A1fb7c115-3123-46c4-98e7-f078c8dbf8da_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1fb7c115-3123-46c4-98e7-f078c8dbf8da_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.140534,
                    "lat": 41.368249
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1fbbf7dc-8655-4ad2-8bec-0d0bcd5e50f5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1fbbf7dc-8655-4ad2-8bec-0d0bcd5e50f5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1fbbf7dc-8655-4ad2-8bec-0d0bcd5e50f5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1fbbf7dc-8655-4ad2-8bec-0d0bcd5e50f5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWZiYmY3ZGMtODY1NS00YWQyLThiZWMtMGQwYmNkNWU1MGY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWZiYmY3ZGMtODY1NS00YWQyLThiZWMtMGQwYmNkNWU1MGY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1fbbf7dc-8655-4ad2-8bec-0d0bcd5e50f5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1fbbf7dc-8655-4ad2-8bec-0d0bcd5e50f5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188054@Y=41369188@L=%23mcp%3AV%3Adonkey-barcelona%3A1fbbf7dc-8655-4ad2-8bec-0d0bcd5e50f5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1fbbf7dc-8655-4ad2-8bec-0d0bcd5e50f5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188054,
                    "lat": 41.369188
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1adf1aca-b110-42fe-9fa2-7d5c2e046203",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1adf1aca-b110-42fe-9fa2-7d5c2e046203"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1adf1aca-b110-42fe-9fa2-7d5c2e046203",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1adf1aca-b110-42fe-9fa2-7d5c2e046203"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWFkZjFhY2EtYjExMC00MmZlLTlmYTItN2Q1YzJlMDQ2MjAzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWFkZjFhY2EtYjExMC00MmZlLTlmYTItN2Q1YzJlMDQ2MjAzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1adf1aca-b110-42fe-9fa2-7d5c2e046203_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1adf1aca-b110-42fe-9fa2-7d5c2e046203",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188054@Y=41369227@L=%23mcp%3AV%3Adonkey-barcelona%3A1adf1aca-b110-42fe-9fa2-7d5c2e046203_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1adf1aca-b110-42fe-9fa2-7d5c2e046203_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188054,
                    "lat": 41.369227
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e4f2cdcd-5cb1-4d02-a9bf-4b1dd0203df6",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e4f2cdcd-5cb1-4d02-a9bf-4b1dd0203df6"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e4f2cdcd-5cb1-4d02-a9bf-4b1dd0203df6",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e4f2cdcd-5cb1-4d02-a9bf-4b1dd0203df6"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTRmMmNkY2QtNWNiMS00ZDAyLWE5YmYtNGIxZGQwMjAzZGY2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTRmMmNkY2QtNWNiMS00ZDAyLWE5YmYtNGIxZGQwMjAzZGY2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e4f2cdcd-5cb1-4d02-a9bf-4b1dd0203df6_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e4f2cdcd-5cb1-4d02-a9bf-4b1dd0203df6",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188041@Y=41369240@L=%23mcp%3AV%3Adonkey-barcelona%3Ae4f2cdcd-5cb1-4d02-a9bf-4b1dd0203df6_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae4f2cdcd-5cb1-4d02-a9bf-4b1dd0203df6_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188041,
                    "lat": 41.36924
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=aaee7a25-1d70-4fe7-aadd-4da85423dfb6",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=aaee7a25-1d70-4fe7-aadd-4da85423dfb6"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=aaee7a25-1d70-4fe7-aadd-4da85423dfb6",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=aaee7a25-1d70-4fe7-aadd-4da85423dfb6"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWFlZTdhMjUtMWQ3MC00ZmU3LWFhZGQtNGRhODU0MjNkZmI2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWFlZTdhMjUtMWQ3MC00ZmU3LWFhZGQtNGRhODU0MjNkZmI2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:aaee7a25-1d70-4fe7-aadd-4da85423dfb6_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "aaee7a25-1d70-4fe7-aadd-4da85423dfb6",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187992@Y=41369243@L=%23mcp%3AV%3Adonkey-barcelona%3Aaaee7a25-1d70-4fe7-aadd-4da85423dfb6_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aaaee7a25-1d70-4fe7-aadd-4da85423dfb6_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187992,
                    "lat": 41.369243
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9cd6ef8a-ce0f-4aa7-a919-1bb567277e55",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9cd6ef8a-ce0f-4aa7-a919-1bb567277e55"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9cd6ef8a-ce0f-4aa7-a919-1bb567277e55",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9cd6ef8a-ce0f-4aa7-a919-1bb567277e55"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWNkNmVmOGEtY2UwZi00YWE3LWE5MTktMWJiNTY3Mjc3ZTU1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWNkNmVmOGEtY2UwZi00YWE3LWE5MTktMWJiNTY3Mjc3ZTU1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9cd6ef8a-ce0f-4aa7-a919-1bb567277e55_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9cd6ef8a-ce0f-4aa7-a919-1bb567277e55",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187992@Y=41369243@L=%23mcp%3AV%3Adonkey-barcelona%3A9cd6ef8a-ce0f-4aa7-a919-1bb567277e55_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9cd6ef8a-ce0f-4aa7-a919-1bb567277e55_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187992,
                    "lat": 41.369243
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ef545779-43b0-448f-b420-5ce3ab086acb",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ef545779-43b0-448f-b420-5ce3ab086acb"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ef545779-43b0-448f-b420-5ce3ab086acb",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ef545779-43b0-448f-b420-5ce3ab086acb"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWY1NDU3NzktNDNiMC00NDhmLWI0MjAtNWNlM2FiMDg2YWNiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWY1NDU3NzktNDNiMC00NDhmLWI0MjAtNWNlM2FiMDg2YWNiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ef545779-43b0-448f-b420-5ce3ab086acb_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ef545779-43b0-448f-b420-5ce3ab086acb",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188973@Y=41369914@L=%23mcp%3AV%3Adonkey-barcelona%3Aef545779-43b0-448f-b420-5ce3ab086acb_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aef545779-43b0-448f-b420-5ce3ab086acb_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188973,
                    "lat": 41.369914
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6e9ac444-a8d9-42c5-bc96-667b4e6845aa",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6e9ac444-a8d9-42c5-bc96-667b4e6845aa"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6e9ac444-a8d9-42c5-bc96-667b4e6845aa",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6e9ac444-a8d9-42c5-bc96-667b4e6845aa"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmU5YWM0NDQtYThkOS00MmM1LWJjOTYtNjY3YjRlNjg0NWFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmU5YWM0NDQtYThkOS00MmM1LWJjOTYtNjY3YjRlNjg0NWFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6e9ac444-a8d9-42c5-bc96-667b4e6845aa_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6e9ac444-a8d9-42c5-bc96-667b4e6845aa",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188910@Y=41370098@L=%23mcp%3AV%3Adonkey-barcelona%3A6e9ac444-a8d9-42c5-bc96-667b4e6845aa_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6e9ac444-a8d9-42c5-bc96-667b4e6845aa_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.18891,
                    "lat": 41.370098
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b982465c-dedb-43ca-9291-0738ed84bc7d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b982465c-dedb-43ca-9291-0738ed84bc7d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b982465c-dedb-43ca-9291-0738ed84bc7d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b982465c-dedb-43ca-9291-0738ed84bc7d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjk4MjQ2NWMtZGVkYi00M2NhLTkyOTEtMDczOGVkODRiYzdkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjk4MjQ2NWMtZGVkYi00M2NhLTkyOTEtMDczOGVkODRiYzdkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b982465c-dedb-43ca-9291-0738ed84bc7d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b982465c-dedb-43ca-9291-0738ed84bc7d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2155464@Y=41370394@L=%23mcp%3AV%3Adonkey-barcelona%3Ab982465c-dedb-43ca-9291-0738ed84bc7d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab982465c-dedb-43ca-9291-0738ed84bc7d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.155464,
                    "lat": 41.370394
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9d993227-f097-4257-929c-47035c216fc4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9d993227-f097-4257-929c-47035c216fc4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9d993227-f097-4257-929c-47035c216fc4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9d993227-f097-4257-929c-47035c216fc4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWQ5OTMyMjctZjA5Ny00MjU3LTkyOWMtNDcwMzVjMjE2ZmM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWQ5OTMyMjctZjA5Ny00MjU3LTkyOWMtNDcwMzVjMjE2ZmM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9d993227-f097-4257-929c-47035c216fc4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9d993227-f097-4257-929c-47035c216fc4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188886@Y=41370714@L=%23mcp%3AV%3Adonkey-barcelona%3A9d993227-f097-4257-929c-47035c216fc4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9d993227-f097-4257-929c-47035c216fc4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188886,
                    "lat": 41.370714
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=90679fc9-2fca-46ae-92ee-aeb3fdd1af79",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=90679fc9-2fca-46ae-92ee-aeb3fdd1af79"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=90679fc9-2fca-46ae-92ee-aeb3fdd1af79",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=90679fc9-2fca-46ae-92ee-aeb3fdd1af79"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTA2NzlmYzktMmZjYS00NmFlLTkyZWUtYWViM2ZkZDFhZjc5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTA2NzlmYzktMmZjYS00NmFlLTkyZWUtYWViM2ZkZDFhZjc5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:90679fc9-2fca-46ae-92ee-aeb3fdd1af79_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "90679fc9-2fca-46ae-92ee-aeb3fdd1af79",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188886@Y=41370714@L=%23mcp%3AV%3Adonkey-barcelona%3A90679fc9-2fca-46ae-92ee-aeb3fdd1af79_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A90679fc9-2fca-46ae-92ee-aeb3fdd1af79_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188886,
                    "lat": 41.370714
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d80ed3e7-4b5b-4d94-8d23-951c6e9ee6de",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d80ed3e7-4b5b-4d94-8d23-951c6e9ee6de"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d80ed3e7-4b5b-4d94-8d23-951c6e9ee6de",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d80ed3e7-4b5b-4d94-8d23-951c6e9ee6de"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDgwZWQzZTctNGI1Yi00ZDk0LThkMjMtOTUxYzZlOWVlNmRlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDgwZWQzZTctNGI1Yi00ZDk0LThkMjMtOTUxYzZlOWVlNmRlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d80ed3e7-4b5b-4d94-8d23-951c6e9ee6de_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d80ed3e7-4b5b-4d94-8d23-951c6e9ee6de",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188886@Y=41370714@L=%23mcp%3AV%3Adonkey-barcelona%3Ad80ed3e7-4b5b-4d94-8d23-951c6e9ee6de_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad80ed3e7-4b5b-4d94-8d23-951c6e9ee6de_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188886,
                    "lat": 41.370714
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6d755e22-b73b-4718-ad15-774bad0b336c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6d755e22-b73b-4718-ad15-774bad0b336c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6d755e22-b73b-4718-ad15-774bad0b336c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6d755e22-b73b-4718-ad15-774bad0b336c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmQ3NTVlMjItYjczYi00NzE4LWFkMTUtNzc0YmFkMGIzMzZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmQ3NTVlMjItYjczYi00NzE4LWFkMTUtNzc0YmFkMGIzMzZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6d755e22-b73b-4718-ad15-774bad0b336c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6d755e22-b73b-4718-ad15-774bad0b336c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188874@Y=41370963@L=%23mcp%3AV%3Adonkey-barcelona%3A6d755e22-b73b-4718-ad15-774bad0b336c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6d755e22-b73b-4718-ad15-774bad0b336c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188874,
                    "lat": 41.370963
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fe52c94c-a6c3-42f0-a12b-ad8c6e288a65",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fe52c94c-a6c3-42f0-a12b-ad8c6e288a65"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fe52c94c-a6c3-42f0-a12b-ad8c6e288a65",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fe52c94c-a6c3-42f0-a12b-ad8c6e288a65"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmU1MmM5NGMtYTZjMy00MmYwLWExMmItYWQ4YzZlMjg4YTY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmU1MmM5NGMtYTZjMy00MmYwLWExMmItYWQ4YzZlMjg4YTY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:fe52c94c-a6c3-42f0-a12b-ad8c6e288a65_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "fe52c94c-a6c3-42f0-a12b-ad8c6e288a65",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188898@Y=41370974@L=%23mcp%3AV%3Adonkey-barcelona%3Afe52c94c-a6c3-42f0-a12b-ad8c6e288a65_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Afe52c94c-a6c3-42f0-a12b-ad8c6e288a65_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188898,
                    "lat": 41.370974
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4ced9504-7304-436a-87c4-b8ec9bd18732",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4ced9504-7304-436a-87c4-b8ec9bd18732"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4ced9504-7304-436a-87c4-b8ec9bd18732",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4ced9504-7304-436a-87c4-b8ec9bd18732"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGNlZDk1MDQtNzMwNC00MzZhLTg3YzQtYjhlYzliZDE4NzMyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGNlZDk1MDQtNzMwNC00MzZhLTg3YzQtYjhlYzliZDE4NzMyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4ced9504-7304-436a-87c4-b8ec9bd18732_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4ced9504-7304-436a-87c4-b8ec9bd18732",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188915@Y=41371004@L=%23mcp%3AV%3Adonkey-barcelona%3A4ced9504-7304-436a-87c4-b8ec9bd18732_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4ced9504-7304-436a-87c4-b8ec9bd18732_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188915,
                    "lat": 41.371004
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d03e4e97-d8e0-4fec-ba18-5a9e5e97a388",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d03e4e97-d8e0-4fec-ba18-5a9e5e97a388"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d03e4e97-d8e0-4fec-ba18-5a9e5e97a388",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d03e4e97-d8e0-4fec-ba18-5a9e5e97a388"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDAzZTRlOTctZDhlMC00ZmVjLWJhMTgtNWE5ZTVlOTdhMzg4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDAzZTRlOTctZDhlMC00ZmVjLWJhMTgtNWE5ZTVlOTdhMzg4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d03e4e97-d8e0-4fec-ba18-5a9e5e97a388_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d03e4e97-d8e0-4fec-ba18-5a9e5e97a388",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188909@Y=41371007@L=%23mcp%3AV%3Adonkey-barcelona%3Ad03e4e97-d8e0-4fec-ba18-5a9e5e97a388_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad03e4e97-d8e0-4fec-ba18-5a9e5e97a388_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188909,
                    "lat": 41.371007
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c07924f0-899c-4a33-b642-45fc52c223e8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c07924f0-899c-4a33-b642-45fc52c223e8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c07924f0-899c-4a33-b642-45fc52c223e8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c07924f0-899c-4a33-b642-45fc52c223e8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzA3OTI0ZjAtODk5Yy00YTMzLWI2NDItNDVmYzUyYzIyM2U4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzA3OTI0ZjAtODk5Yy00YTMzLWI2NDItNDVmYzUyYzIyM2U4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c07924f0-899c-4a33-b642-45fc52c223e8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c07924f0-899c-4a33-b642-45fc52c223e8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188909@Y=41371010@L=%23mcp%3AV%3Adonkey-barcelona%3Ac07924f0-899c-4a33-b642-45fc52c223e8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac07924f0-899c-4a33-b642-45fc52c223e8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188909,
                    "lat": 41.37101
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b2b85ffd-3fdf-4f57-ab43-6c4769e394c0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b2b85ffd-3fdf-4f57-ab43-6c4769e394c0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b2b85ffd-3fdf-4f57-ab43-6c4769e394c0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b2b85ffd-3fdf-4f57-ab43-6c4769e394c0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjJiODVmZmQtM2ZkZi00ZjU3LWFiNDMtNmM0NzY5ZTM5NGMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjJiODVmZmQtM2ZkZi00ZjU3LWFiNDMtNmM0NzY5ZTM5NGMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b2b85ffd-3fdf-4f57-ab43-6c4769e394c0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b2b85ffd-3fdf-4f57-ab43-6c4769e394c0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188903@Y=41371043@L=%23mcp%3AV%3Adonkey-barcelona%3Ab2b85ffd-3fdf-4f57-ab43-6c4769e394c0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab2b85ffd-3fdf-4f57-ab43-6c4769e394c0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188903,
                    "lat": 41.371043
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=19a0c519-7bda-4623-a6f9-169aedf75ff8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=19a0c519-7bda-4623-a6f9-169aedf75ff8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=19a0c519-7bda-4623-a6f9-169aedf75ff8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=19a0c519-7bda-4623-a6f9-169aedf75ff8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTlhMGM1MTktN2JkYS00NjIzLWE2ZjktMTY5YWVkZjc1ZmY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTlhMGM1MTktN2JkYS00NjIzLWE2ZjktMTY5YWVkZjc1ZmY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:19a0c519-7bda-4623-a6f9-169aedf75ff8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "19a0c519-7bda-4623-a6f9-169aedf75ff8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188950@Y=41371348@L=%23mcp%3AV%3Adonkey-barcelona%3A19a0c519-7bda-4623-a6f9-169aedf75ff8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A19a0c519-7bda-4623-a6f9-169aedf75ff8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.18895,
                    "lat": 41.371348
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=da1bae64-b300-42a1-b95a-eedd0f349fcd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=da1bae64-b300-42a1-b95a-eedd0f349fcd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=da1bae64-b300-42a1-b95a-eedd0f349fcd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=da1bae64-b300-42a1-b95a-eedd0f349fcd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGExYmFlNjQtYjMwMC00MmExLWI5NWEtZWVkZDBmMzQ5ZmNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGExYmFlNjQtYjMwMC00MmExLWI5NWEtZWVkZDBmMzQ5ZmNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:da1bae64-b300-42a1-b95a-eedd0f349fcd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "da1bae64-b300-42a1-b95a-eedd0f349fcd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188990@Y=41371353@L=%23mcp%3AV%3Adonkey-barcelona%3Ada1bae64-b300-42a1-b95a-eedd0f349fcd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ada1bae64-b300-42a1-b95a-eedd0f349fcd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.18899,
                    "lat": 41.371353
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=15e399be-9ba3-4899-a6c9-2c6e69a0a4a1",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=15e399be-9ba3-4899-a6c9-2c6e69a0a4a1"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=15e399be-9ba3-4899-a6c9-2c6e69a0a4a1",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=15e399be-9ba3-4899-a6c9-2c6e69a0a4a1"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTVlMzk5YmUtOWJhMy00ODk5LWE2YzktMmM2ZTY5YTBhNGExIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTVlMzk5YmUtOWJhMy00ODk5LWE2YzktMmM2ZTY5YTBhNGExIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:15e399be-9ba3-4899-a6c9-2c6e69a0a4a1_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "15e399be-9ba3-4899-a6c9-2c6e69a0a4a1",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188953@Y=41371360@L=%23mcp%3AV%3Adonkey-barcelona%3A15e399be-9ba3-4899-a6c9-2c6e69a0a4a1_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A15e399be-9ba3-4899-a6c9-2c6e69a0a4a1_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188953,
                    "lat": 41.37136
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e55dd720-df03-4cb9-b6b3-98e5795ab43c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e55dd720-df03-4cb9-b6b3-98e5795ab43c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e55dd720-df03-4cb9-b6b3-98e5795ab43c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e55dd720-df03-4cb9-b6b3-98e5795ab43c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTU1ZGQ3MjAtZGYwMy00Y2I5LWI2YjMtOThlNTc5NWFiNDNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTU1ZGQ3MjAtZGYwMy00Y2I5LWI2YjMtOThlNTc5NWFiNDNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e55dd720-df03-4cb9-b6b3-98e5795ab43c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e55dd720-df03-4cb9-b6b3-98e5795ab43c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189000@Y=41371367@L=%23mcp%3AV%3Adonkey-barcelona%3Ae55dd720-df03-4cb9-b6b3-98e5795ab43c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae55dd720-df03-4cb9-b6b3-98e5795ab43c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189,
                    "lat": 41.371367
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7eb898ab-96cf-417d-a124-c458edbe7218",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7eb898ab-96cf-417d-a124-c458edbe7218"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7eb898ab-96cf-417d-a124-c458edbe7218",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7eb898ab-96cf-417d-a124-c458edbe7218"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2ViODk4YWItOTZjZi00MTdkLWExMjQtYzQ1OGVkYmU3MjE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2ViODk4YWItOTZjZi00MTdkLWExMjQtYzQ1OGVkYmU3MjE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7eb898ab-96cf-417d-a124-c458edbe7218_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7eb898ab-96cf-417d-a124-c458edbe7218",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189026@Y=41371698@L=%23mcp%3AV%3Adonkey-barcelona%3A7eb898ab-96cf-417d-a124-c458edbe7218_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7eb898ab-96cf-417d-a124-c458edbe7218_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189026,
                    "lat": 41.371698
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5355ff99-c361-410d-9f4c-35cd5f4797f3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5355ff99-c361-410d-9f4c-35cd5f4797f3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5355ff99-c361-410d-9f4c-35cd5f4797f3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5355ff99-c361-410d-9f4c-35cd5f4797f3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTM1NWZmOTktYzM2MS00MTBkLTlmNGMtMzVjZDVmNDc5N2YzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTM1NWZmOTktYzM2MS00MTBkLTlmNGMtMzVjZDVmNDc5N2YzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5355ff99-c361-410d-9f4c-35cd5f4797f3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5355ff99-c361-410d-9f4c-35cd5f4797f3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2179740@Y=41372350@L=%23mcp%3AV%3Adonkey-barcelona%3A5355ff99-c361-410d-9f4c-35cd5f4797f3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5355ff99-c361-410d-9f4c-35cd5f4797f3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.17974,
                    "lat": 41.37235
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4df49513-1ed6-41c0-b360-1c6e5699e7e5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4df49513-1ed6-41c0-b360-1c6e5699e7e5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4df49513-1ed6-41c0-b360-1c6e5699e7e5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4df49513-1ed6-41c0-b360-1c6e5699e7e5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGRmNDk1MTMtMWVkNi00MWMwLWIzNjAtMWM2ZTU2OTllN2U1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGRmNDk1MTMtMWVkNi00MWMwLWIzNjAtMWM2ZTU2OTllN2U1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4df49513-1ed6-41c0-b360-1c6e5699e7e5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4df49513-1ed6-41c0-b360-1c6e5699e7e5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2179620@Y=41372378@L=%23mcp%3AV%3Adonkey-barcelona%3A4df49513-1ed6-41c0-b360-1c6e5699e7e5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4df49513-1ed6-41c0-b360-1c6e5699e7e5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.17962,
                    "lat": 41.372378
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3fc28ede-3179-4118-83b6-80accd64d033",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3fc28ede-3179-4118-83b6-80accd64d033"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3fc28ede-3179-4118-83b6-80accd64d033",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3fc28ede-3179-4118-83b6-80accd64d033"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2ZjMjhlZGUtMzE3OS00MTE4LTgzYjYtODBhY2NkNjRkMDMzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2ZjMjhlZGUtMzE3OS00MTE4LTgzYjYtODBhY2NkNjRkMDMzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3fc28ede-3179-4118-83b6-80accd64d033_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3fc28ede-3179-4118-83b6-80accd64d033",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2179727@Y=41372392@L=%23mcp%3AV%3Adonkey-barcelona%3A3fc28ede-3179-4118-83b6-80accd64d033_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3fc28ede-3179-4118-83b6-80accd64d033_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.179727,
                    "lat": 41.372392
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=081c9dcc-3d31-4df6-98e1-0b275bbfb367",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=081c9dcc-3d31-4df6-98e1-0b275bbfb367"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=081c9dcc-3d31-4df6-98e1-0b275bbfb367",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=081c9dcc-3d31-4df6-98e1-0b275bbfb367"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDgxYzlkY2MtM2QzMS00ZGY2LTk4ZTEtMGIyNzViYmZiMzY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDgxYzlkY2MtM2QzMS00ZGY2LTk4ZTEtMGIyNzViYmZiMzY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:081c9dcc-3d31-4df6-98e1-0b275bbfb367_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "081c9dcc-3d31-4df6-98e1-0b275bbfb367",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2179449@Y=41372519@L=%23mcp%3AV%3Adonkey-barcelona%3A081c9dcc-3d31-4df6-98e1-0b275bbfb367_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A081c9dcc-3d31-4df6-98e1-0b275bbfb367_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.179449,
                    "lat": 41.372519
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a9fe71ac-35ff-483b-a878-bb906f88a885",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a9fe71ac-35ff-483b-a878-bb906f88a885"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a9fe71ac-35ff-483b-a878-bb906f88a885",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a9fe71ac-35ff-483b-a878-bb906f88a885"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTlmZTcxYWMtMzVmZi00ODNiLWE4NzgtYmI5MDZmODhhODg1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTlmZTcxYWMtMzVmZi00ODNiLWE4NzgtYmI5MDZmODhhODg1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a9fe71ac-35ff-483b-a878-bb906f88a885_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a9fe71ac-35ff-483b-a878-bb906f88a885",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173581@Y=41372696@L=%23mcp%3AV%3Adonkey-barcelona%3Aa9fe71ac-35ff-483b-a878-bb906f88a885_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa9fe71ac-35ff-483b-a878-bb906f88a885_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173581,
                    "lat": 41.372696
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1401f1fe-368a-4240-bc5d-dadb4951582e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1401f1fe-368a-4240-bc5d-dadb4951582e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1401f1fe-368a-4240-bc5d-dadb4951582e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1401f1fe-368a-4240-bc5d-dadb4951582e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTQwMWYxZmUtMzY4YS00MjQwLWJjNWQtZGFkYjQ5NTE1ODJlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTQwMWYxZmUtMzY4YS00MjQwLWJjNWQtZGFkYjQ5NTE1ODJlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1401f1fe-368a-4240-bc5d-dadb4951582e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1401f1fe-368a-4240-bc5d-dadb4951582e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189228@Y=41372928@L=%23mcp%3AV%3Adonkey-barcelona%3A1401f1fe-368a-4240-bc5d-dadb4951582e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1401f1fe-368a-4240-bc5d-dadb4951582e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189228,
                    "lat": 41.372928
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=93fc78d6-7e69-4af0-9aad-aab68c8acc35",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=93fc78d6-7e69-4af0-9aad-aab68c8acc35"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=93fc78d6-7e69-4af0-9aad-aab68c8acc35",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=93fc78d6-7e69-4af0-9aad-aab68c8acc35"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTNmYzc4ZDYtN2U2OS00YWYwLTlhYWQtYWFiNjhjOGFjYzM1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTNmYzc4ZDYtN2U2OS00YWYwLTlhYWQtYWFiNjhjOGFjYzM1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:93fc78d6-7e69-4af0-9aad-aab68c8acc35_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "93fc78d6-7e69-4af0-9aad-aab68c8acc35",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189228@Y=41372928@L=%23mcp%3AV%3Adonkey-barcelona%3A93fc78d6-7e69-4af0-9aad-aab68c8acc35_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A93fc78d6-7e69-4af0-9aad-aab68c8acc35_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189228,
                    "lat": 41.372928
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e1bb9e11-d096-4790-870b-31b418969704",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e1bb9e11-d096-4790-870b-31b418969704"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e1bb9e11-d096-4790-870b-31b418969704",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e1bb9e11-d096-4790-870b-31b418969704"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTFiYjllMTEtZDA5Ni00NzkwLTg3MGItMzFiNDE4OTY5NzA0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTFiYjllMTEtZDA5Ni00NzkwLTg3MGItMzFiNDE4OTY5NzA0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e1bb9e11-d096-4790-870b-31b418969704_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e1bb9e11-d096-4790-870b-31b418969704",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2157483@Y=41372955@L=%23mcp%3AV%3Adonkey-barcelona%3Ae1bb9e11-d096-4790-870b-31b418969704_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae1bb9e11-d096-4790-870b-31b418969704_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.157483,
                    "lat": 41.372955
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=48c212f7-bd91-4d66-81c5-3545319af800",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=48c212f7-bd91-4d66-81c5-3545319af800"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=48c212f7-bd91-4d66-81c5-3545319af800",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=48c212f7-bd91-4d66-81c5-3545319af800"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDhjMjEyZjctYmQ5MS00ZDY2LTgxYzUtMzU0NTMxOWFmODAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDhjMjEyZjctYmQ5MS00ZDY2LTgxYzUtMzU0NTMxOWFmODAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:48c212f7-bd91-4d66-81c5-3545319af800_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "48c212f7-bd91-4d66-81c5-3545319af800",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2169987@Y=41373020@L=%23mcp%3AV%3Adonkey-barcelona%3A48c212f7-bd91-4d66-81c5-3545319af800_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A48c212f7-bd91-4d66-81c5-3545319af800_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.169987,
                    "lat": 41.37302
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e49b7d17-cd24-46c5-a9b5-9dff8078dff2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e49b7d17-cd24-46c5-a9b5-9dff8078dff2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e49b7d17-cd24-46c5-a9b5-9dff8078dff2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e49b7d17-cd24-46c5-a9b5-9dff8078dff2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTQ5YjdkMTctY2QyNC00NmM1LWE5YjUtOWRmZjgwNzhkZmYyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTQ5YjdkMTctY2QyNC00NmM1LWE5YjUtOWRmZjgwNzhkZmYyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e49b7d17-cd24-46c5-a9b5-9dff8078dff2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e49b7d17-cd24-46c5-a9b5-9dff8078dff2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170056@Y=41373023@L=%23mcp%3AV%3Adonkey-barcelona%3Ae49b7d17-cd24-46c5-a9b5-9dff8078dff2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae49b7d17-cd24-46c5-a9b5-9dff8078dff2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.170056,
                    "lat": 41.373023
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5e0b2130-cd8d-4a99-b65f-cb9e452ac818",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5e0b2130-cd8d-4a99-b65f-cb9e452ac818"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5e0b2130-cd8d-4a99-b65f-cb9e452ac818",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5e0b2130-cd8d-4a99-b65f-cb9e452ac818"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWUwYjIxMzAtY2Q4ZC00YTk5LWI2NWYtY2I5ZTQ1MmFjODE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWUwYjIxMzAtY2Q4ZC00YTk5LWI2NWYtY2I5ZTQ1MmFjODE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5e0b2130-cd8d-4a99-b65f-cb9e452ac818_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5e0b2130-cd8d-4a99-b65f-cb9e452ac818",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2157436@Y=41373072@L=%23mcp%3AV%3Adonkey-barcelona%3A5e0b2130-cd8d-4a99-b65f-cb9e452ac818_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5e0b2130-cd8d-4a99-b65f-cb9e452ac818_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.157436,
                    "lat": 41.373072
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=687ec7cf-8f0c-4ae4-83f8-ece575bef0bb",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=687ec7cf-8f0c-4ae4-83f8-ece575bef0bb"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=687ec7cf-8f0c-4ae4-83f8-ece575bef0bb",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=687ec7cf-8f0c-4ae4-83f8-ece575bef0bb"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjg3ZWM3Y2YtOGYwYy00YWU0LTgzZjgtZWNlNTc1YmVmMGJiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjg3ZWM3Y2YtOGYwYy00YWU0LTgzZjgtZWNlNTc1YmVmMGJiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:687ec7cf-8f0c-4ae4-83f8-ece575bef0bb_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "687ec7cf-8f0c-4ae4-83f8-ece575bef0bb",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189233@Y=41373120@L=%23mcp%3AV%3Adonkey-barcelona%3A687ec7cf-8f0c-4ae4-83f8-ece575bef0bb_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A687ec7cf-8f0c-4ae4-83f8-ece575bef0bb_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189233,
                    "lat": 41.37312
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ab425d8b-75ff-4667-b02f-a230e71cd03c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ab425d8b-75ff-4667-b02f-a230e71cd03c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ab425d8b-75ff-4667-b02f-a230e71cd03c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ab425d8b-75ff-4667-b02f-a230e71cd03c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWI0MjVkOGItNzVmZi00NjY3LWIwMmYtYTIzMGU3MWNkMDNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWI0MjVkOGItNzVmZi00NjY3LWIwMmYtYTIzMGU3MWNkMDNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ab425d8b-75ff-4667-b02f-a230e71cd03c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ab425d8b-75ff-4667-b02f-a230e71cd03c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173198@Y=41373123@L=%23mcp%3AV%3Adonkey-barcelona%3Aab425d8b-75ff-4667-b02f-a230e71cd03c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aab425d8b-75ff-4667-b02f-a230e71cd03c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173198,
                    "lat": 41.373123
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1bb3b8f5-3507-4b42-838f-105492be3822",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1bb3b8f5-3507-4b42-838f-105492be3822"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1bb3b8f5-3507-4b42-838f-105492be3822",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1bb3b8f5-3507-4b42-838f-105492be3822"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWJiM2I4ZjUtMzUwNy00YjQyLTgzOGYtMTA1NDkyYmUzODIyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWJiM2I4ZjUtMzUwNy00YjQyLTgzOGYtMTA1NDkyYmUzODIyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1bb3b8f5-3507-4b42-838f-105492be3822_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1bb3b8f5-3507-4b42-838f-105492be3822",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2146421@Y=41373161@L=%23mcp%3AV%3Adonkey-barcelona%3A1bb3b8f5-3507-4b42-838f-105492be3822_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1bb3b8f5-3507-4b42-838f-105492be3822_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.146421,
                    "lat": 41.373161
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ef8511df-fe9b-41e6-b63b-fadfbd473a34",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ef8511df-fe9b-41e6-b63b-fadfbd473a34"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ef8511df-fe9b-41e6-b63b-fadfbd473a34",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ef8511df-fe9b-41e6-b63b-fadfbd473a34"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWY4NTExZGYtZmU5Yi00MWU2LWI2M2ItZmFkZmJkNDczYTM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWY4NTExZGYtZmU5Yi00MWU2LWI2M2ItZmFkZmJkNDczYTM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ef8511df-fe9b-41e6-b63b-fadfbd473a34_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ef8511df-fe9b-41e6-b63b-fadfbd473a34",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173489@Y=41373276@L=%23mcp%3AV%3Adonkey-barcelona%3Aef8511df-fe9b-41e6-b63b-fadfbd473a34_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aef8511df-fe9b-41e6-b63b-fadfbd473a34_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173489,
                    "lat": 41.373276
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=52fa694a-1632-443e-85f5-ffa6616be475",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=52fa694a-1632-443e-85f5-ffa6616be475"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=52fa694a-1632-443e-85f5-ffa6616be475",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=52fa694a-1632-443e-85f5-ffa6616be475"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTJmYTY5NGEtMTYzMi00NDNlLTg1ZjUtZmZhNjYxNmJlNDc1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTJmYTY5NGEtMTYzMi00NDNlLTg1ZjUtZmZhNjYxNmJlNDc1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:52fa694a-1632-443e-85f5-ffa6616be475_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "52fa694a-1632-443e-85f5-ffa6616be475",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173385@Y=41373312@L=%23mcp%3AV%3Adonkey-barcelona%3A52fa694a-1632-443e-85f5-ffa6616be475_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A52fa694a-1632-443e-85f5-ffa6616be475_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173385,
                    "lat": 41.373312
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ee79eb0d-4dd5-4328-a59a-3f624f1bd94b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ee79eb0d-4dd5-4328-a59a-3f624f1bd94b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ee79eb0d-4dd5-4328-a59a-3f624f1bd94b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ee79eb0d-4dd5-4328-a59a-3f624f1bd94b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWU3OWViMGQtNGRkNS00MzI4LWE1OWEtM2Y2MjRmMWJkOTRiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWU3OWViMGQtNGRkNS00MzI4LWE1OWEtM2Y2MjRmMWJkOTRiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ee79eb0d-4dd5-4328-a59a-3f624f1bd94b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ee79eb0d-4dd5-4328-a59a-3f624f1bd94b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173362@Y=41373418@L=%23mcp%3AV%3Adonkey-barcelona%3Aee79eb0d-4dd5-4328-a59a-3f624f1bd94b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aee79eb0d-4dd5-4328-a59a-3f624f1bd94b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173362,
                    "lat": 41.373418
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5bcdc9b1-8ecb-4be4-8699-100abb382b18",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5bcdc9b1-8ecb-4be4-8699-100abb382b18"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5bcdc9b1-8ecb-4be4-8699-100abb382b18",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5bcdc9b1-8ecb-4be4-8699-100abb382b18"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWJjZGM5YjEtOGVjYi00YmU0LTg2OTktMTAwYWJiMzgyYjE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWJjZGM5YjEtOGVjYi00YmU0LTg2OTktMTAwYWJiMzgyYjE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5bcdc9b1-8ecb-4be4-8699-100abb382b18_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5bcdc9b1-8ecb-4be4-8699-100abb382b18",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173459@Y=41373437@L=%23mcp%3AV%3Adonkey-barcelona%3A5bcdc9b1-8ecb-4be4-8699-100abb382b18_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5bcdc9b1-8ecb-4be4-8699-100abb382b18_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173459,
                    "lat": 41.373437
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ebeb29b3-82d4-4f28-862d-cdeed059e0fe",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ebeb29b3-82d4-4f28-862d-cdeed059e0fe"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ebeb29b3-82d4-4f28-862d-cdeed059e0fe",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ebeb29b3-82d4-4f28-862d-cdeed059e0fe"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWJlYjI5YjMtODJkNC00ZjI4LTg2MmQtY2RlZWQwNTllMGZlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWJlYjI5YjMtODJkNC00ZjI4LTg2MmQtY2RlZWQwNTllMGZlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ebeb29b3-82d4-4f28-862d-cdeed059e0fe_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ebeb29b3-82d4-4f28-862d-cdeed059e0fe",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2162707@Y=41373450@L=%23mcp%3AV%3Adonkey-barcelona%3Aebeb29b3-82d4-4f28-862d-cdeed059e0fe_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aebeb29b3-82d4-4f28-862d-cdeed059e0fe_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.162707,
                    "lat": 41.37345
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6b676be7-6709-4699-b2eb-606667a8eba7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6b676be7-6709-4699-b2eb-606667a8eba7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6b676be7-6709-4699-b2eb-606667a8eba7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6b676be7-6709-4699-b2eb-606667a8eba7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmI2NzZiZTctNjcwOS00Njk5LWIyZWItNjA2NjY3YThlYmE3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmI2NzZiZTctNjcwOS00Njk5LWIyZWItNjA2NjY3YThlYmE3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6b676be7-6709-4699-b2eb-606667a8eba7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6b676be7-6709-4699-b2eb-606667a8eba7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189314@Y=41373454@L=%23mcp%3AV%3Adonkey-barcelona%3A6b676be7-6709-4699-b2eb-606667a8eba7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6b676be7-6709-4699-b2eb-606667a8eba7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189314,
                    "lat": 41.373454
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ec5a74da-2b38-4535-8a10-3b8efd533e0f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ec5a74da-2b38-4535-8a10-3b8efd533e0f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ec5a74da-2b38-4535-8a10-3b8efd533e0f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ec5a74da-2b38-4535-8a10-3b8efd533e0f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWM1YTc0ZGEtMmIzOC00NTM1LThhMTAtM2I4ZWZkNTMzZTBmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWM1YTc0ZGEtMmIzOC00NTM1LThhMTAtM2I4ZWZkNTMzZTBmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ec5a74da-2b38-4535-8a10-3b8efd533e0f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ec5a74da-2b38-4535-8a10-3b8efd533e0f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2164845@Y=41373476@L=%23mcp%3AV%3Adonkey-barcelona%3Aec5a74da-2b38-4535-8a10-3b8efd533e0f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aec5a74da-2b38-4535-8a10-3b8efd533e0f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.164845,
                    "lat": 41.373476
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1b2498c4-3460-4473-9711-0f6491c2cf66",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1b2498c4-3460-4473-9711-0f6491c2cf66"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1b2498c4-3460-4473-9711-0f6491c2cf66",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1b2498c4-3460-4473-9711-0f6491c2cf66"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWIyNDk4YzQtMzQ2MC00NDczLTk3MTEtMGY2NDkxYzJjZjY2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWIyNDk4YzQtMzQ2MC00NDczLTk3MTEtMGY2NDkxYzJjZjY2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1b2498c4-3460-4473-9711-0f6491c2cf66_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1b2498c4-3460-4473-9711-0f6491c2cf66",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173464@Y=41373480@L=%23mcp%3AV%3Adonkey-barcelona%3A1b2498c4-3460-4473-9711-0f6491c2cf66_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1b2498c4-3460-4473-9711-0f6491c2cf66_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173464,
                    "lat": 41.37348
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=19fa0e4c-c8ac-4834-817f-7fb402be78b0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=19fa0e4c-c8ac-4834-817f-7fb402be78b0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=19fa0e4c-c8ac-4834-817f-7fb402be78b0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=19fa0e4c-c8ac-4834-817f-7fb402be78b0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTlmYTBlNGMtYzhhYy00ODM0LTgxN2YtN2ZiNDAyYmU3OGIwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTlmYTBlNGMtYzhhYy00ODM0LTgxN2YtN2ZiNDAyYmU3OGIwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:19fa0e4c-c8ac-4834-817f-7fb402be78b0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "19fa0e4c-c8ac-4834-817f-7fb402be78b0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189303@Y=41373481@L=%23mcp%3AV%3Adonkey-barcelona%3A19fa0e4c-c8ac-4834-817f-7fb402be78b0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A19fa0e4c-c8ac-4834-817f-7fb402be78b0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189303,
                    "lat": 41.373481
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=27644c3b-2bfc-400c-b115-cd235cfe42ca",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=27644c3b-2bfc-400c-b115-cd235cfe42ca"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=27644c3b-2bfc-400c-b115-cd235cfe42ca",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=27644c3b-2bfc-400c-b115-cd235cfe42ca"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjc2NDRjM2ItMmJmYy00MDBjLWIxMTUtY2QyMzVjZmU0MmNhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjc2NDRjM2ItMmJmYy00MDBjLWIxMTUtY2QyMzVjZmU0MmNhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:27644c3b-2bfc-400c-b115-cd235cfe42ca_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "27644c3b-2bfc-400c-b115-cd235cfe42ca",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189286@Y=41373484@L=%23mcp%3AV%3Adonkey-barcelona%3A27644c3b-2bfc-400c-b115-cd235cfe42ca_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A27644c3b-2bfc-400c-b115-cd235cfe42ca_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189286,
                    "lat": 41.373484
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c500c010-ff07-4927-b0b6-78d405c4b10e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c500c010-ff07-4927-b0b6-78d405c4b10e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c500c010-ff07-4927-b0b6-78d405c4b10e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c500c010-ff07-4927-b0b6-78d405c4b10e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzUwMGMwMTAtZmYwNy00OTI3LWIwYjYtNzhkNDA1YzRiMTBlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzUwMGMwMTAtZmYwNy00OTI3LWIwYjYtNzhkNDA1YzRiMTBlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c500c010-ff07-4927-b0b6-78d405c4b10e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c500c010-ff07-4927-b0b6-78d405c4b10e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189282@Y=41373491@L=%23mcp%3AV%3Adonkey-barcelona%3Ac500c010-ff07-4927-b0b6-78d405c4b10e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac500c010-ff07-4927-b0b6-78d405c4b10e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189282,
                    "lat": 41.373491
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5c98c3f9-c907-4bc3-9ac3-2f3d278aecd5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5c98c3f9-c907-4bc3-9ac3-2f3d278aecd5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5c98c3f9-c907-4bc3-9ac3-2f3d278aecd5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5c98c3f9-c907-4bc3-9ac3-2f3d278aecd5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWM5OGMzZjktYzkwNy00YmMzLTlhYzMtMmYzZDI3OGFlY2Q1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWM5OGMzZjktYzkwNy00YmMzLTlhYzMtMmYzZDI3OGFlY2Q1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5c98c3f9-c907-4bc3-9ac3-2f3d278aecd5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5c98c3f9-c907-4bc3-9ac3-2f3d278aecd5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173496@Y=41373506@L=%23mcp%3AV%3Adonkey-barcelona%3A5c98c3f9-c907-4bc3-9ac3-2f3d278aecd5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5c98c3f9-c907-4bc3-9ac3-2f3d278aecd5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173496,
                    "lat": 41.373506
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7044656b-96b3-4978-ac58-1fe650ac7fcb",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7044656b-96b3-4978-ac58-1fe650ac7fcb"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7044656b-96b3-4978-ac58-1fe650ac7fcb",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7044656b-96b3-4978-ac58-1fe650ac7fcb"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzA0NDY1NmItOTZiMy00OTc4LWFjNTgtMWZlNjUwYWM3ZmNiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzA0NDY1NmItOTZiMy00OTc4LWFjNTgtMWZlNjUwYWM3ZmNiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7044656b-96b3-4978-ac58-1fe650ac7fcb_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7044656b-96b3-4978-ac58-1fe650ac7fcb",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189296@Y=41373522@L=%23mcp%3AV%3Adonkey-barcelona%3A7044656b-96b3-4978-ac58-1fe650ac7fcb_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7044656b-96b3-4978-ac58-1fe650ac7fcb_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189296,
                    "lat": 41.373522
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ea9189cd-42fa-4dc2-9da1-e7475e381d79",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ea9189cd-42fa-4dc2-9da1-e7475e381d79"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ea9189cd-42fa-4dc2-9da1-e7475e381d79",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ea9189cd-42fa-4dc2-9da1-e7475e381d79"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWE5MTg5Y2QtNDJmYS00ZGMyLTlkYTEtZTc0NzVlMzgxZDc5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWE5MTg5Y2QtNDJmYS00ZGMyLTlkYTEtZTc0NzVlMzgxZDc5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ea9189cd-42fa-4dc2-9da1-e7475e381d79_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ea9189cd-42fa-4dc2-9da1-e7475e381d79",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173294@Y=41373523@L=%23mcp%3AV%3Adonkey-barcelona%3Aea9189cd-42fa-4dc2-9da1-e7475e381d79_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aea9189cd-42fa-4dc2-9da1-e7475e381d79_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173294,
                    "lat": 41.373523
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=db9e0a1b-1169-49c2-bfc3-ce6871e05f03",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=db9e0a1b-1169-49c2-bfc3-ce6871e05f03"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=db9e0a1b-1169-49c2-bfc3-ce6871e05f03",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=db9e0a1b-1169-49c2-bfc3-ce6871e05f03"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGI5ZTBhMWItMTE2OS00OWMyLWJmYzMtY2U2ODcxZTA1ZjAzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGI5ZTBhMWItMTE2OS00OWMyLWJmYzMtY2U2ODcxZTA1ZjAzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:db9e0a1b-1169-49c2-bfc3-ce6871e05f03_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "db9e0a1b-1169-49c2-bfc3-ce6871e05f03",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2174624@Y=41373575@L=%23mcp%3AV%3Adonkey-barcelona%3Adb9e0a1b-1169-49c2-bfc3-ce6871e05f03_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Adb9e0a1b-1169-49c2-bfc3-ce6871e05f03_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.174624,
                    "lat": 41.373575
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=587fa56f-1782-4f04-9d9f-c1880e5f6edc",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=587fa56f-1782-4f04-9d9f-c1880e5f6edc"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=587fa56f-1782-4f04-9d9f-c1880e5f6edc",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=587fa56f-1782-4f04-9d9f-c1880e5f6edc"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTg3ZmE1NmYtMTc4Mi00ZjA0LTlkOWYtYzE4ODBlNWY2ZWRjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTg3ZmE1NmYtMTc4Mi00ZjA0LTlkOWYtYzE4ODBlNWY2ZWRjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:587fa56f-1782-4f04-9d9f-c1880e5f6edc_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "587fa56f-1782-4f04-9d9f-c1880e5f6edc",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188606@Y=41373661@L=%23mcp%3AV%3Adonkey-barcelona%3A587fa56f-1782-4f04-9d9f-c1880e5f6edc_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A587fa56f-1782-4f04-9d9f-c1880e5f6edc_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188606,
                    "lat": 41.373661
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cb0f3f9f-b96b-4648-b6e9-98bab7d8eb69",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cb0f3f9f-b96b-4648-b6e9-98bab7d8eb69"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cb0f3f9f-b96b-4648-b6e9-98bab7d8eb69",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cb0f3f9f-b96b-4648-b6e9-98bab7d8eb69"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2IwZjNmOWYtYjk2Yi00NjQ4LWI2ZTktOThiYWI3ZDhlYjY5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2IwZjNmOWYtYjk2Yi00NjQ4LWI2ZTktOThiYWI3ZDhlYjY5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cb0f3f9f-b96b-4648-b6e9-98bab7d8eb69_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cb0f3f9f-b96b-4648-b6e9-98bab7d8eb69",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188785@Y=41373696@L=%23mcp%3AV%3Adonkey-barcelona%3Acb0f3f9f-b96b-4648-b6e9-98bab7d8eb69_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acb0f3f9f-b96b-4648-b6e9-98bab7d8eb69_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188785,
                    "lat": 41.373696
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5fa68adb-ba6b-45ce-aa1c-52233173a349",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5fa68adb-ba6b-45ce-aa1c-52233173a349"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5fa68adb-ba6b-45ce-aa1c-52233173a349",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5fa68adb-ba6b-45ce-aa1c-52233173a349"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWZhNjhhZGItYmE2Yi00NWNlLWFhMWMtNTIyMzMxNzNhMzQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWZhNjhhZGItYmE2Yi00NWNlLWFhMWMtNTIyMzMxNzNhMzQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5fa68adb-ba6b-45ce-aa1c-52233173a349_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5fa68adb-ba6b-45ce-aa1c-52233173a349",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2158836@Y=41373698@L=%23mcp%3AV%3Adonkey-barcelona%3A5fa68adb-ba6b-45ce-aa1c-52233173a349_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5fa68adb-ba6b-45ce-aa1c-52233173a349_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.158836,
                    "lat": 41.373698
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dce2c429-2662-4589-b283-481d00f91d86",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dce2c429-2662-4589-b283-481d00f91d86"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dce2c429-2662-4589-b283-481d00f91d86",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dce2c429-2662-4589-b283-481d00f91d86"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGNlMmM0MjktMjY2Mi00NTg5LWIyODMtNDgxZDAwZjkxZDg2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGNlMmM0MjktMjY2Mi00NTg5LWIyODMtNDgxZDAwZjkxZDg2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:dce2c429-2662-4589-b283-481d00f91d86_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "dce2c429-2662-4589-b283-481d00f91d86",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188704@Y=41373708@L=%23mcp%3AV%3Adonkey-barcelona%3Adce2c429-2662-4589-b283-481d00f91d86_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Adce2c429-2662-4589-b283-481d00f91d86_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188704,
                    "lat": 41.373708
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6779e7c6-9cc0-4dd3-9dc4-2966e4a08e99",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6779e7c6-9cc0-4dd3-9dc4-2966e4a08e99"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6779e7c6-9cc0-4dd3-9dc4-2966e4a08e99",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6779e7c6-9cc0-4dd3-9dc4-2966e4a08e99"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjc3OWU3YzYtOWNjMC00ZGQzLTlkYzQtMjk2NmU0YTA4ZTk5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjc3OWU3YzYtOWNjMC00ZGQzLTlkYzQtMjk2NmU0YTA4ZTk5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6779e7c6-9cc0-4dd3-9dc4-2966e4a08e99_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6779e7c6-9cc0-4dd3-9dc4-2966e4a08e99",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2158820@Y=41373727@L=%23mcp%3AV%3Adonkey-barcelona%3A6779e7c6-9cc0-4dd3-9dc4-2966e4a08e99_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6779e7c6-9cc0-4dd3-9dc4-2966e4a08e99_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.15882,
                    "lat": 41.373727
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6e4ec9fa-a86c-4048-87ea-1b343055b4b7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6e4ec9fa-a86c-4048-87ea-1b343055b4b7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6e4ec9fa-a86c-4048-87ea-1b343055b4b7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6e4ec9fa-a86c-4048-87ea-1b343055b4b7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmU0ZWM5ZmEtYTg2Yy00MDQ4LTg3ZWEtMWIzNDMwNTViNGI3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmU0ZWM5ZmEtYTg2Yy00MDQ4LTg3ZWEtMWIzNDMwNTViNGI3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6e4ec9fa-a86c-4048-87ea-1b343055b4b7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6e4ec9fa-a86c-4048-87ea-1b343055b4b7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2158815@Y=41373763@L=%23mcp%3AV%3Adonkey-barcelona%3A6e4ec9fa-a86c-4048-87ea-1b343055b4b7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6e4ec9fa-a86c-4048-87ea-1b343055b4b7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.158815,
                    "lat": 41.373763
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cdaf1b54-8e37-4679-8198-1fcc4c146364",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cdaf1b54-8e37-4679-8198-1fcc4c146364"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cdaf1b54-8e37-4679-8198-1fcc4c146364",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cdaf1b54-8e37-4679-8198-1fcc4c146364"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2RhZjFiNTQtOGUzNy00Njc5LTgxOTgtMWZjYzRjMTQ2MzY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2RhZjFiNTQtOGUzNy00Njc5LTgxOTgtMWZjYzRjMTQ2MzY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cdaf1b54-8e37-4679-8198-1fcc4c146364_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cdaf1b54-8e37-4679-8198-1fcc4c146364",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2158758@Y=41373777@L=%23mcp%3AV%3Adonkey-barcelona%3Acdaf1b54-8e37-4679-8198-1fcc4c146364_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acdaf1b54-8e37-4679-8198-1fcc4c146364_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.158758,
                    "lat": 41.373777
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2b885f86-51cf-44d4-a95f-153e39ffe109",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2b885f86-51cf-44d4-a95f-153e39ffe109"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2b885f86-51cf-44d4-a95f-153e39ffe109",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2b885f86-51cf-44d4-a95f-153e39ffe109"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmI4ODVmODYtNTFjZi00NGQ0LWE5NWYtMTUzZTM5ZmZlMTA5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmI4ODVmODYtNTFjZi00NGQ0LWE5NWYtMTUzZTM5ZmZlMTA5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2b885f86-51cf-44d4-a95f-153e39ffe109_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2b885f86-51cf-44d4-a95f-153e39ffe109",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2175257@Y=41374532@L=%23mcp%3AV%3Adonkey-barcelona%3A2b885f86-51cf-44d4-a95f-153e39ffe109_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2b885f86-51cf-44d4-a95f-153e39ffe109_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.175257,
                    "lat": 41.374532
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=10312f2c-6e8b-41fd-9bc0-eb011dfb32cc",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=10312f2c-6e8b-41fd-9bc0-eb011dfb32cc"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=10312f2c-6e8b-41fd-9bc0-eb011dfb32cc",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=10312f2c-6e8b-41fd-9bc0-eb011dfb32cc"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTAzMTJmMmMtNmU4Yi00MWZkLTliYzAtZWIwMTFkZmIzMmNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTAzMTJmMmMtNmU4Yi00MWZkLTliYzAtZWIwMTFkZmIzMmNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:10312f2c-6e8b-41fd-9bc0-eb011dfb32cc_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "10312f2c-6e8b-41fd-9bc0-eb011dfb32cc",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2160300@Y=41374778@L=%23mcp%3AV%3Adonkey-barcelona%3A10312f2c-6e8b-41fd-9bc0-eb011dfb32cc_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A10312f2c-6e8b-41fd-9bc0-eb011dfb32cc_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.1603,
                    "lat": 41.374778
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bc0f55db-98de-45a8-b40c-72b5300a91e9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bc0f55db-98de-45a8-b40c-72b5300a91e9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bc0f55db-98de-45a8-b40c-72b5300a91e9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bc0f55db-98de-45a8-b40c-72b5300a91e9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmMwZjU1ZGItOThkZS00NWE4LWI0MGMtNzJiNTMwMGE5MWU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmMwZjU1ZGItOThkZS00NWE4LWI0MGMtNzJiNTMwMGE5MWU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:bc0f55db-98de-45a8-b40c-72b5300a91e9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "bc0f55db-98de-45a8-b40c-72b5300a91e9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2167727@Y=41374788@L=%23mcp%3AV%3Adonkey-barcelona%3Abc0f55db-98de-45a8-b40c-72b5300a91e9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Abc0f55db-98de-45a8-b40c-72b5300a91e9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.167727,
                    "lat": 41.374788
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=abdb4778-6667-4584-adaf-5d03e8317c47",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=abdb4778-6667-4584-adaf-5d03e8317c47"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=abdb4778-6667-4584-adaf-5d03e8317c47",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=abdb4778-6667-4584-adaf-5d03e8317c47"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWJkYjQ3NzgtNjY2Ny00NTg0LWFkYWYtNWQwM2U4MzE3YzQ3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWJkYjQ3NzgtNjY2Ny00NTg0LWFkYWYtNWQwM2U4MzE3YzQ3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:abdb4778-6667-4584-adaf-5d03e8317c47_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "abdb4778-6667-4584-adaf-5d03e8317c47",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2167717@Y=41374799@L=%23mcp%3AV%3Adonkey-barcelona%3Aabdb4778-6667-4584-adaf-5d03e8317c47_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aabdb4778-6667-4584-adaf-5d03e8317c47_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.167717,
                    "lat": 41.374799
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=61cb7be6-37e9-4449-9845-c3919517de6b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=61cb7be6-37e9-4449-9845-c3919517de6b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=61cb7be6-37e9-4449-9845-c3919517de6b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=61cb7be6-37e9-4449-9845-c3919517de6b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjFjYjdiZTYtMzdlOS00NDQ5LTk4NDUtYzM5MTk1MTdkZTZiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjFjYjdiZTYtMzdlOS00NDQ5LTk4NDUtYzM5MTk1MTdkZTZiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:61cb7be6-37e9-4449-9845-c3919517de6b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "61cb7be6-37e9-4449-9845-c3919517de6b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2157677@Y=41374867@L=%23mcp%3AV%3Adonkey-barcelona%3A61cb7be6-37e9-4449-9845-c3919517de6b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A61cb7be6-37e9-4449-9845-c3919517de6b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.157677,
                    "lat": 41.374867
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=59c2c684-d0f6-4b93-b347-9741aca9b3ca",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=59c2c684-d0f6-4b93-b347-9741aca9b3ca"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=59c2c684-d0f6-4b93-b347-9741aca9b3ca",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=59c2c684-d0f6-4b93-b347-9741aca9b3ca"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTljMmM2ODQtZDBmNi00YjkzLWIzNDctOTc0MWFjYTliM2NhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTljMmM2ODQtZDBmNi00YjkzLWIzNDctOTc0MWFjYTliM2NhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:59c2c684-d0f6-4b93-b347-9741aca9b3ca_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "59c2c684-d0f6-4b93-b347-9741aca9b3ca",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2157724@Y=41374929@L=%23mcp%3AV%3Adonkey-barcelona%3A59c2c684-d0f6-4b93-b347-9741aca9b3ca_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A59c2c684-d0f6-4b93-b347-9741aca9b3ca_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.157724,
                    "lat": 41.374929
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1e9bec6e-3210-4940-b39e-e4f579c6e7fd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1e9bec6e-3210-4940-b39e-e4f579c6e7fd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1e9bec6e-3210-4940-b39e-e4f579c6e7fd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1e9bec6e-3210-4940-b39e-e4f579c6e7fd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWU5YmVjNmUtMzIxMC00OTQwLWIzOWUtZTRmNTc5YzZlN2ZkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWU5YmVjNmUtMzIxMC00OTQwLWIzOWUtZTRmNTc5YzZlN2ZkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1e9bec6e-3210-4940-b39e-e4f579c6e7fd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1e9bec6e-3210-4940-b39e-e4f579c6e7fd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2155647@Y=41374957@L=%23mcp%3AV%3Adonkey-barcelona%3A1e9bec6e-3210-4940-b39e-e4f579c6e7fd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1e9bec6e-3210-4940-b39e-e4f579c6e7fd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.155647,
                    "lat": 41.374957
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2c1a9242-4d9a-4f73-84a8-e52fdb69cbd5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2c1a9242-4d9a-4f73-84a8-e52fdb69cbd5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2c1a9242-4d9a-4f73-84a8-e52fdb69cbd5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2c1a9242-4d9a-4f73-84a8-e52fdb69cbd5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmMxYTkyNDItNGQ5YS00ZjczLTg0YTgtZTUyZmRiNjljYmQ1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmMxYTkyNDItNGQ5YS00ZjczLTg0YTgtZTUyZmRiNjljYmQ1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2c1a9242-4d9a-4f73-84a8-e52fdb69cbd5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2c1a9242-4d9a-4f73-84a8-e52fdb69cbd5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2157760@Y=41374983@L=%23mcp%3AV%3Adonkey-barcelona%3A2c1a9242-4d9a-4f73-84a8-e52fdb69cbd5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2c1a9242-4d9a-4f73-84a8-e52fdb69cbd5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.15776,
                    "lat": 41.374983
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6c11ca4d-0adb-4fb9-a686-14c73b8a638e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6c11ca4d-0adb-4fb9-a686-14c73b8a638e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6c11ca4d-0adb-4fb9-a686-14c73b8a638e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6c11ca4d-0adb-4fb9-a686-14c73b8a638e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmMxMWNhNGQtMGFkYi00ZmI5LWE2ODYtMTRjNzNiOGE2MzhlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmMxMWNhNGQtMGFkYi00ZmI5LWE2ODYtMTRjNzNiOGE2MzhlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6c11ca4d-0adb-4fb9-a686-14c73b8a638e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6c11ca4d-0adb-4fb9-a686-14c73b8a638e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2136633@Y=41375171@L=%23mcp%3AV%3Adonkey-barcelona%3A6c11ca4d-0adb-4fb9-a686-14c73b8a638e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6c11ca4d-0adb-4fb9-a686-14c73b8a638e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.136633,
                    "lat": 41.375171
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=42c4e4f8-c967-41dd-8390-6797ec355564",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=42c4e4f8-c967-41dd-8390-6797ec355564"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=42c4e4f8-c967-41dd-8390-6797ec355564",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=42c4e4f8-c967-41dd-8390-6797ec355564"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDJjNGU0ZjgtYzk2Ny00MWRkLTgzOTAtNjc5N2VjMzU1NTY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDJjNGU0ZjgtYzk2Ny00MWRkLTgzOTAtNjc5N2VjMzU1NTY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:42c4e4f8-c967-41dd-8390-6797ec355564_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "42c4e4f8-c967-41dd-8390-6797ec355564",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2136584@Y=41375189@L=%23mcp%3AV%3Adonkey-barcelona%3A42c4e4f8-c967-41dd-8390-6797ec355564_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A42c4e4f8-c967-41dd-8390-6797ec355564_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.136584,
                    "lat": 41.375189
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8e224ded-ef0d-4d50-9020-94ec61649dce",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8e224ded-ef0d-4d50-9020-94ec61649dce"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8e224ded-ef0d-4d50-9020-94ec61649dce",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8e224ded-ef0d-4d50-9020-94ec61649dce"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGUyMjRkZWQtZWYwZC00ZDUwLTkwMjAtOTRlYzYxNjQ5ZGNlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGUyMjRkZWQtZWYwZC00ZDUwLTkwMjAtOTRlYzYxNjQ5ZGNlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8e224ded-ef0d-4d50-9020-94ec61649dce_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8e224ded-ef0d-4d50-9020-94ec61649dce",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2140361@Y=41375226@L=%23mcp%3AV%3Adonkey-barcelona%3A8e224ded-ef0d-4d50-9020-94ec61649dce_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8e224ded-ef0d-4d50-9020-94ec61649dce_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.140361,
                    "lat": 41.375226
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a27803a2-db7a-41bb-9d66-4ae56aee9998",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a27803a2-db7a-41bb-9d66-4ae56aee9998"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a27803a2-db7a-41bb-9d66-4ae56aee9998",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a27803a2-db7a-41bb-9d66-4ae56aee9998"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTI3ODAzYTItZGI3YS00MWJiLTlkNjYtNGFlNTZhZWU5OTk4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTI3ODAzYTItZGI3YS00MWJiLTlkNjYtNGFlNTZhZWU5OTk4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a27803a2-db7a-41bb-9d66-4ae56aee9998_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a27803a2-db7a-41bb-9d66-4ae56aee9998",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2177636@Y=41375238@L=%23mcp%3AV%3Adonkey-barcelona%3Aa27803a2-db7a-41bb-9d66-4ae56aee9998_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa27803a2-db7a-41bb-9d66-4ae56aee9998_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.177636,
                    "lat": 41.375238
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1384f876-aa48-42fb-89f5-f9cf0555ae37",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1384f876-aa48-42fb-89f5-f9cf0555ae37"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1384f876-aa48-42fb-89f5-f9cf0555ae37",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1384f876-aa48-42fb-89f5-f9cf0555ae37"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTM4NGY4NzYtYWE0OC00MmZiLTg5ZjUtZjljZjA1NTVhZTM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTM4NGY4NzYtYWE0OC00MmZiLTg5ZjUtZjljZjA1NTVhZTM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1384f876-aa48-42fb-89f5-f9cf0555ae37_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1384f876-aa48-42fb-89f5-f9cf0555ae37",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2142674@Y=41375334@L=%23mcp%3AV%3Adonkey-barcelona%3A1384f876-aa48-42fb-89f5-f9cf0555ae37_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1384f876-aa48-42fb-89f5-f9cf0555ae37_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.142674,
                    "lat": 41.375334
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1738541e-b3df-4bb2-b703-354c61a3fa3d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1738541e-b3df-4bb2-b703-354c61a3fa3d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1738541e-b3df-4bb2-b703-354c61a3fa3d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1738541e-b3df-4bb2-b703-354c61a3fa3d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTczODU0MWUtYjNkZi00YmIyLWI3MDMtMzU0YzYxYTNmYTNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTczODU0MWUtYjNkZi00YmIyLWI3MDMtMzU0YzYxYTNmYTNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1738541e-b3df-4bb2-b703-354c61a3fa3d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1738541e-b3df-4bb2-b703-354c61a3fa3d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2158919@Y=41375369@L=%23mcp%3AV%3Adonkey-barcelona%3A1738541e-b3df-4bb2-b703-354c61a3fa3d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1738541e-b3df-4bb2-b703-354c61a3fa3d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.158919,
                    "lat": 41.375369
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=06bd58ac-8cac-40c7-a08c-9dd209bad022",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=06bd58ac-8cac-40c7-a08c-9dd209bad022"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=06bd58ac-8cac-40c7-a08c-9dd209bad022",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=06bd58ac-8cac-40c7-a08c-9dd209bad022"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDZiZDU4YWMtOGNhYy00MGM3LWEwOGMtOWRkMjA5YmFkMDIyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDZiZDU4YWMtOGNhYy00MGM3LWEwOGMtOWRkMjA5YmFkMDIyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:06bd58ac-8cac-40c7-a08c-9dd209bad022_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "06bd58ac-8cac-40c7-a08c-9dd209bad022",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2177149@Y=41375387@L=%23mcp%3AV%3Adonkey-barcelona%3A06bd58ac-8cac-40c7-a08c-9dd209bad022_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A06bd58ac-8cac-40c7-a08c-9dd209bad022_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.177149,
                    "lat": 41.375387
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=12787d84-425b-41de-ad9e-de072d00dd5d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=12787d84-425b-41de-ad9e-de072d00dd5d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=12787d84-425b-41de-ad9e-de072d00dd5d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=12787d84-425b-41de-ad9e-de072d00dd5d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTI3ODdkODQtNDI1Yi00MWRlLWFkOWUtZGUwNzJkMDBkZDVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTI3ODdkODQtNDI1Yi00MWRlLWFkOWUtZGUwNzJkMDBkZDVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:12787d84-425b-41de-ad9e-de072d00dd5d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "12787d84-425b-41de-ad9e-de072d00dd5d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2177097@Y=41375390@L=%23mcp%3AV%3Adonkey-barcelona%3A12787d84-425b-41de-ad9e-de072d00dd5d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A12787d84-425b-41de-ad9e-de072d00dd5d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.177097,
                    "lat": 41.37539
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=63a49dca-41dc-46e2-b0b0-3bb9ba5a1589",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=63a49dca-41dc-46e2-b0b0-3bb9ba5a1589"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=63a49dca-41dc-46e2-b0b0-3bb9ba5a1589",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=63a49dca-41dc-46e2-b0b0-3bb9ba5a1589"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjNhNDlkY2EtNDFkYy00NmUyLWIwYjAtM2JiOWJhNWExNTg5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjNhNDlkY2EtNDFkYy00NmUyLWIwYjAtM2JiOWJhNWExNTg5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:63a49dca-41dc-46e2-b0b0-3bb9ba5a1589_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "63a49dca-41dc-46e2-b0b0-3bb9ba5a1589",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2156739@Y=41375397@L=%23mcp%3AV%3Adonkey-barcelona%3A63a49dca-41dc-46e2-b0b0-3bb9ba5a1589_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A63a49dca-41dc-46e2-b0b0-3bb9ba5a1589_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.156739,
                    "lat": 41.375397
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=da88155c-6e7b-42ec-aa48-0a81c7d91250",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=da88155c-6e7b-42ec-aa48-0a81c7d91250"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=da88155c-6e7b-42ec-aa48-0a81c7d91250",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=da88155c-6e7b-42ec-aa48-0a81c7d91250"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGE4ODE1NWMtNmU3Yi00MmVjLWFhNDgtMGE4MWM3ZDkxMjUwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGE4ODE1NWMtNmU3Yi00MmVjLWFhNDgtMGE4MWM3ZDkxMjUwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:da88155c-6e7b-42ec-aa48-0a81c7d91250_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "da88155c-6e7b-42ec-aa48-0a81c7d91250",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2177080@Y=41375426@L=%23mcp%3AV%3Adonkey-barcelona%3Ada88155c-6e7b-42ec-aa48-0a81c7d91250_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ada88155c-6e7b-42ec-aa48-0a81c7d91250_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.17708,
                    "lat": 41.375426
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ca1e37f0-7089-4043-a609-0b34467aa806",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ca1e37f0-7089-4043-a609-0b34467aa806"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ca1e37f0-7089-4043-a609-0b34467aa806",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ca1e37f0-7089-4043-a609-0b34467aa806"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2ExZTM3ZjAtNzA4OS00MDQzLWE2MDktMGIzNDQ2N2FhODA2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2ExZTM3ZjAtNzA4OS00MDQzLWE2MDktMGIzNDQ2N2FhODA2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ca1e37f0-7089-4043-a609-0b34467aa806_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ca1e37f0-7089-4043-a609-0b34467aa806",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2154323@Y=41375428@L=%23mcp%3AV%3Adonkey-barcelona%3Aca1e37f0-7089-4043-a609-0b34467aa806_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aca1e37f0-7089-4043-a609-0b34467aa806_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.154323,
                    "lat": 41.375428
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=611a0c12-00e2-4230-b48c-d090c0a17a89",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=611a0c12-00e2-4230-b48c-d090c0a17a89"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=611a0c12-00e2-4230-b48c-d090c0a17a89",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=611a0c12-00e2-4230-b48c-d090c0a17a89"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjExYTBjMTItMDBlMi00MjMwLWI0OGMtZDA5MGMwYTE3YTg5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjExYTBjMTItMDBlMi00MjMwLWI0OGMtZDA5MGMwYTE3YTg5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:611a0c12-00e2-4230-b48c-d090c0a17a89_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "611a0c12-00e2-4230-b48c-d090c0a17a89",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2161101@Y=41375437@L=%23mcp%3AV%3Adonkey-barcelona%3A611a0c12-00e2-4230-b48c-d090c0a17a89_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A611a0c12-00e2-4230-b48c-d090c0a17a89_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.161101,
                    "lat": 41.375437
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d763e259-267e-42db-9d7f-90601f5d2639",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d763e259-267e-42db-9d7f-90601f5d2639"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d763e259-267e-42db-9d7f-90601f5d2639",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d763e259-267e-42db-9d7f-90601f5d2639"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDc2M2UyNTktMjY3ZS00MmRiLTlkN2YtOTA2MDFmNWQyNjM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDc2M2UyNTktMjY3ZS00MmRiLTlkN2YtOTA2MDFmNWQyNjM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d763e259-267e-42db-9d7f-90601f5d2639_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d763e259-267e-42db-9d7f-90601f5d2639",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2154297@Y=41375450@L=%23mcp%3AV%3Adonkey-barcelona%3Ad763e259-267e-42db-9d7f-90601f5d2639_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad763e259-267e-42db-9d7f-90601f5d2639_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.154297,
                    "lat": 41.37545
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1c806c12-a7cf-4698-bf95-c4c199c300e8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1c806c12-a7cf-4698-bf95-c4c199c300e8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1c806c12-a7cf-4698-bf95-c4c199c300e8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1c806c12-a7cf-4698-bf95-c4c199c300e8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWM4MDZjMTItYTdjZi00Njk4LWJmOTUtYzRjMTk5YzMwMGU4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWM4MDZjMTItYTdjZi00Njk4LWJmOTUtYzRjMTk5YzMwMGU4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1c806c12-a7cf-4698-bf95-c4c199c300e8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1c806c12-a7cf-4698-bf95-c4c199c300e8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189253@Y=41375460@L=%23mcp%3AV%3Adonkey-barcelona%3A1c806c12-a7cf-4698-bf95-c4c199c300e8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1c806c12-a7cf-4698-bf95-c4c199c300e8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189253,
                    "lat": 41.37546
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cf804930-0db8-485d-bfd5-70bf2ccc00dd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cf804930-0db8-485d-bfd5-70bf2ccc00dd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cf804930-0db8-485d-bfd5-70bf2ccc00dd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cf804930-0db8-485d-bfd5-70bf2ccc00dd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2Y4MDQ5MzAtMGRiOC00ODVkLWJmZDUtNzBiZjJjY2MwMGRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2Y4MDQ5MzAtMGRiOC00ODVkLWJmZDUtNzBiZjJjY2MwMGRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cf804930-0db8-485d-bfd5-70bf2ccc00dd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cf804930-0db8-485d-bfd5-70bf2ccc00dd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2135868@Y=41375466@L=%23mcp%3AV%3Adonkey-barcelona%3Acf804930-0db8-485d-bfd5-70bf2ccc00dd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acf804930-0db8-485d-bfd5-70bf2ccc00dd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.135868,
                    "lat": 41.375466
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6da9dd0e-ef3e-4ae6-a415-3540ed6e40c7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6da9dd0e-ef3e-4ae6-a415-3540ed6e40c7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6da9dd0e-ef3e-4ae6-a415-3540ed6e40c7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6da9dd0e-ef3e-4ae6-a415-3540ed6e40c7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmRhOWRkMGUtZWYzZS00YWU2LWE0MTUtMzU0MGVkNmU0MGM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmRhOWRkMGUtZWYzZS00YWU2LWE0MTUtMzU0MGVkNmU0MGM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6da9dd0e-ef3e-4ae6-a415-3540ed6e40c7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6da9dd0e-ef3e-4ae6-a415-3540ed6e40c7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2135882@Y=41375475@L=%23mcp%3AV%3Adonkey-barcelona%3A6da9dd0e-ef3e-4ae6-a415-3540ed6e40c7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6da9dd0e-ef3e-4ae6-a415-3540ed6e40c7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.135882,
                    "lat": 41.375475
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5a4c67b9-ce8e-429e-a6c3-5744ded05aba",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5a4c67b9-ce8e-429e-a6c3-5744ded05aba"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5a4c67b9-ce8e-429e-a6c3-5744ded05aba",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5a4c67b9-ce8e-429e-a6c3-5744ded05aba"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWE0YzY3YjktY2U4ZS00MjllLWE2YzMtNTc0NGRlZDA1YWJhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWE0YzY3YjktY2U4ZS00MjllLWE2YzMtNTc0NGRlZDA1YWJhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5a4c67b9-ce8e-429e-a6c3-5744ded05aba_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5a4c67b9-ce8e-429e-a6c3-5744ded05aba",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2161103@Y=41375487@L=%23mcp%3AV%3Adonkey-barcelona%3A5a4c67b9-ce8e-429e-a6c3-5744ded05aba_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5a4c67b9-ce8e-429e-a6c3-5744ded05aba_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.161103,
                    "lat": 41.375487
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3c9c87cc-6906-4619-8df6-e2f0fcf66583",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3c9c87cc-6906-4619-8df6-e2f0fcf66583"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3c9c87cc-6906-4619-8df6-e2f0fcf66583",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3c9c87cc-6906-4619-8df6-e2f0fcf66583"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2M5Yzg3Y2MtNjkwNi00NjE5LThkZjYtZTJmMGZjZjY2NTgzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2M5Yzg3Y2MtNjkwNi00NjE5LThkZjYtZTJmMGZjZjY2NTgzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3c9c87cc-6906-4619-8df6-e2f0fcf66583_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3c9c87cc-6906-4619-8df6-e2f0fcf66583",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2160434@Y=41375626@L=%23mcp%3AV%3Adonkey-barcelona%3A3c9c87cc-6906-4619-8df6-e2f0fcf66583_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3c9c87cc-6906-4619-8df6-e2f0fcf66583_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.160434,
                    "lat": 41.375626
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1bfc8f65-3095-4515-a29d-e03db64fc22d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1bfc8f65-3095-4515-a29d-e03db64fc22d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1bfc8f65-3095-4515-a29d-e03db64fc22d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1bfc8f65-3095-4515-a29d-e03db64fc22d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWJmYzhmNjUtMzA5NS00NTE1LWEyOWQtZTAzZGI2NGZjMjJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWJmYzhmNjUtMzA5NS00NTE1LWEyOWQtZTAzZGI2NGZjMjJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1bfc8f65-3095-4515-a29d-e03db64fc22d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1bfc8f65-3095-4515-a29d-e03db64fc22d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2160426@Y=41375636@L=%23mcp%3AV%3Adonkey-barcelona%3A1bfc8f65-3095-4515-a29d-e03db64fc22d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1bfc8f65-3095-4515-a29d-e03db64fc22d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.160426,
                    "lat": 41.375636
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e20bfd1f-584c-452b-8ace-170fe052a47e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e20bfd1f-584c-452b-8ace-170fe052a47e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e20bfd1f-584c-452b-8ace-170fe052a47e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e20bfd1f-584c-452b-8ace-170fe052a47e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTIwYmZkMWYtNTg0Yy00NTJiLThhY2UtMTcwZmUwNTJhNDdlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTIwYmZkMWYtNTg0Yy00NTJiLThhY2UtMTcwZmUwNTJhNDdlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e20bfd1f-584c-452b-8ace-170fe052a47e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e20bfd1f-584c-452b-8ace-170fe052a47e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2160300@Y=41375639@L=%23mcp%3AV%3Adonkey-barcelona%3Ae20bfd1f-584c-452b-8ace-170fe052a47e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae20bfd1f-584c-452b-8ace-170fe052a47e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.1603,
                    "lat": 41.375639
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9be2d11e-ecc4-4f14-9468-b1a17288787b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9be2d11e-ecc4-4f14-9468-b1a17288787b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9be2d11e-ecc4-4f14-9468-b1a17288787b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9be2d11e-ecc4-4f14-9468-b1a17288787b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWJlMmQxMWUtZWNjNC00ZjE0LTk0NjgtYjFhMTcyODg3ODdiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWJlMmQxMWUtZWNjNC00ZjE0LTk0NjgtYjFhMTcyODg3ODdiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9be2d11e-ecc4-4f14-9468-b1a17288787b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9be2d11e-ecc4-4f14-9468-b1a17288787b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2162546@Y=41375651@L=%23mcp%3AV%3Adonkey-barcelona%3A9be2d11e-ecc4-4f14-9468-b1a17288787b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9be2d11e-ecc4-4f14-9468-b1a17288787b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.162546,
                    "lat": 41.375651
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c6d84bba-87bb-4cae-af17-f11a0afb8b4b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c6d84bba-87bb-4cae-af17-f11a0afb8b4b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c6d84bba-87bb-4cae-af17-f11a0afb8b4b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c6d84bba-87bb-4cae-af17-f11a0afb8b4b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzZkODRiYmEtODdiYi00Y2FlLWFmMTctZjExYTBhZmI4YjRiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzZkODRiYmEtODdiYi00Y2FlLWFmMTctZjExYTBhZmI4YjRiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c6d84bba-87bb-4cae-af17-f11a0afb8b4b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c6d84bba-87bb-4cae-af17-f11a0afb8b4b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2160396@Y=41375656@L=%23mcp%3AV%3Adonkey-barcelona%3Ac6d84bba-87bb-4cae-af17-f11a0afb8b4b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac6d84bba-87bb-4cae-af17-f11a0afb8b4b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.160396,
                    "lat": 41.375656
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=65a3ff5b-e184-49e1-9ec0-a752b45aacd6",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=65a3ff5b-e184-49e1-9ec0-a752b45aacd6"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=65a3ff5b-e184-49e1-9ec0-a752b45aacd6",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=65a3ff5b-e184-49e1-9ec0-a752b45aacd6"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjVhM2ZmNWItZTE4NC00OWUxLTllYzAtYTc1MmI0NWFhY2Q2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjVhM2ZmNWItZTE4NC00OWUxLTllYzAtYTc1MmI0NWFhY2Q2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:65a3ff5b-e184-49e1-9ec0-a752b45aacd6_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "65a3ff5b-e184-49e1-9ec0-a752b45aacd6",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2124566@Y=41375678@L=%23mcp%3AV%3Adonkey-barcelona%3A65a3ff5b-e184-49e1-9ec0-a752b45aacd6_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A65a3ff5b-e184-49e1-9ec0-a752b45aacd6_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.124566,
                    "lat": 41.375678
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1586c4b7-aa06-411f-8503-10ef20410748",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1586c4b7-aa06-411f-8503-10ef20410748"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1586c4b7-aa06-411f-8503-10ef20410748",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1586c4b7-aa06-411f-8503-10ef20410748"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTU4NmM0YjctYWEwNi00MTFmLTg1MDMtMTBlZjIwNDEwNzQ4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTU4NmM0YjctYWEwNi00MTFmLTg1MDMtMTBlZjIwNDEwNzQ4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1586c4b7-aa06-411f-8503-10ef20410748_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1586c4b7-aa06-411f-8503-10ef20410748",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2162684@Y=41375699@L=%23mcp%3AV%3Adonkey-barcelona%3A1586c4b7-aa06-411f-8503-10ef20410748_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1586c4b7-aa06-411f-8503-10ef20410748_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.162684,
                    "lat": 41.375699
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=edcf2b7b-7b2a-48c5-9b6a-b89ac9a99b47",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=edcf2b7b-7b2a-48c5-9b6a-b89ac9a99b47"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=edcf2b7b-7b2a-48c5-9b6a-b89ac9a99b47",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=edcf2b7b-7b2a-48c5-9b6a-b89ac9a99b47"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWRjZjJiN2ItN2IyYS00OGM1LTliNmEtYjg5YWM5YTk5YjQ3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWRjZjJiN2ItN2IyYS00OGM1LTliNmEtYjg5YWM5YTk5YjQ3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:edcf2b7b-7b2a-48c5-9b6a-b89ac9a99b47_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "edcf2b7b-7b2a-48c5-9b6a-b89ac9a99b47",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2153663@Y=41375755@L=%23mcp%3AV%3Adonkey-barcelona%3Aedcf2b7b-7b2a-48c5-9b6a-b89ac9a99b47_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aedcf2b7b-7b2a-48c5-9b6a-b89ac9a99b47_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.153663,
                    "lat": 41.375755
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=eed17a29-d791-4584-b11d-675d514f856c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=eed17a29-d791-4584-b11d-675d514f856c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=eed17a29-d791-4584-b11d-675d514f856c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=eed17a29-d791-4584-b11d-675d514f856c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWVkMTdhMjktZDc5MS00NTg0LWIxMWQtNjc1ZDUxNGY4NTZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWVkMTdhMjktZDc5MS00NTg0LWIxMWQtNjc1ZDUxNGY4NTZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:eed17a29-d791-4584-b11d-675d514f856c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "eed17a29-d791-4584-b11d-675d514f856c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2157632@Y=41375796@L=%23mcp%3AV%3Adonkey-barcelona%3Aeed17a29-d791-4584-b11d-675d514f856c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aeed17a29-d791-4584-b11d-675d514f856c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.157632,
                    "lat": 41.375796
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=167d2710-c74c-49b4-955e-c4044ecb1f54",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=167d2710-c74c-49b4-955e-c4044ecb1f54"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=167d2710-c74c-49b4-955e-c4044ecb1f54",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=167d2710-c74c-49b4-955e-c4044ecb1f54"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTY3ZDI3MTAtYzc0Yy00OWI0LTk1NWUtYzQwNDRlY2IxZjU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTY3ZDI3MTAtYzc0Yy00OWI0LTk1NWUtYzQwNDRlY2IxZjU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:167d2710-c74c-49b4-955e-c4044ecb1f54_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "167d2710-c74c-49b4-955e-c4044ecb1f54",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188453@Y=41375803@L=%23mcp%3AV%3Adonkey-barcelona%3A167d2710-c74c-49b4-955e-c4044ecb1f54_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A167d2710-c74c-49b4-955e-c4044ecb1f54_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188453,
                    "lat": 41.375803
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4aace6f9-6fea-407f-9901-e27c9e5ac26a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4aace6f9-6fea-407f-9901-e27c9e5ac26a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4aace6f9-6fea-407f-9901-e27c9e5ac26a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4aace6f9-6fea-407f-9901-e27c9e5ac26a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGFhY2U2ZjktNmZlYS00MDdmLTk5MDEtZTI3YzllNWFjMjZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGFhY2U2ZjktNmZlYS00MDdmLTk5MDEtZTI3YzllNWFjMjZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4aace6f9-6fea-407f-9901-e27c9e5ac26a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4aace6f9-6fea-407f-9901-e27c9e5ac26a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2164739@Y=41375847@L=%23mcp%3AV%3Adonkey-barcelona%3A4aace6f9-6fea-407f-9901-e27c9e5ac26a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4aace6f9-6fea-407f-9901-e27c9e5ac26a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.164739,
                    "lat": 41.375847
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=897793ba-8f17-4dc8-8739-e48817e3e239",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=897793ba-8f17-4dc8-8739-e48817e3e239"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=897793ba-8f17-4dc8-8739-e48817e3e239",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=897793ba-8f17-4dc8-8739-e48817e3e239"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODk3NzkzYmEtOGYxNy00ZGM4LTg3MzktZTQ4ODE3ZTNlMjM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODk3NzkzYmEtOGYxNy00ZGM4LTg3MzktZTQ4ODE3ZTNlMjM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:897793ba-8f17-4dc8-8739-e48817e3e239_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "897793ba-8f17-4dc8-8739-e48817e3e239",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2157819@Y=41375892@L=%23mcp%3AV%3Adonkey-barcelona%3A897793ba-8f17-4dc8-8739-e48817e3e239_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A897793ba-8f17-4dc8-8739-e48817e3e239_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.157819,
                    "lat": 41.375892
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f2e14923-e11d-47fa-a095-918d97ebc0ed",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f2e14923-e11d-47fa-a095-918d97ebc0ed"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f2e14923-e11d-47fa-a095-918d97ebc0ed",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f2e14923-e11d-47fa-a095-918d97ebc0ed"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjJlMTQ5MjMtZTExZC00N2ZhLWEwOTUtOTE4ZDk3ZWJjMGVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjJlMTQ5MjMtZTExZC00N2ZhLWEwOTUtOTE4ZDk3ZWJjMGVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f2e14923-e11d-47fa-a095-918d97ebc0ed_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f2e14923-e11d-47fa-a095-918d97ebc0ed",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2164303@Y=41376197@L=%23mcp%3AV%3Adonkey-barcelona%3Af2e14923-e11d-47fa-a095-918d97ebc0ed_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af2e14923-e11d-47fa-a095-918d97ebc0ed_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.164303,
                    "lat": 41.376197
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=98fe9202-63fd-413f-acf7-1c7f93e442ff",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=98fe9202-63fd-413f-acf7-1c7f93e442ff"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=98fe9202-63fd-413f-acf7-1c7f93e442ff",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=98fe9202-63fd-413f-acf7-1c7f93e442ff"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOThmZTkyMDItNjNmZC00MTNmLWFjZjctMWM3ZjkzZTQ0MmZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOThmZTkyMDItNjNmZC00MTNmLWFjZjctMWM3ZjkzZTQ0MmZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:98fe9202-63fd-413f-acf7-1c7f93e442ff_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "98fe9202-63fd-413f-acf7-1c7f93e442ff",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2136520@Y=41376228@L=%23mcp%3AV%3Adonkey-barcelona%3A98fe9202-63fd-413f-acf7-1c7f93e442ff_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A98fe9202-63fd-413f-acf7-1c7f93e442ff_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.13652,
                    "lat": 41.376228
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9d575f2c-cb4f-4822-9118-1d292fd02281",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9d575f2c-cb4f-4822-9118-1d292fd02281"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9d575f2c-cb4f-4822-9118-1d292fd02281",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9d575f2c-cb4f-4822-9118-1d292fd02281"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWQ1NzVmMmMtY2I0Zi00ODIyLTkxMTgtMWQyOTJmZDAyMjgxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWQ1NzVmMmMtY2I0Zi00ODIyLTkxMTgtMWQyOTJmZDAyMjgxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9d575f2c-cb4f-4822-9118-1d292fd02281_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9d575f2c-cb4f-4822-9118-1d292fd02281",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2164076@Y=41376315@L=%23mcp%3AV%3Adonkey-barcelona%3A9d575f2c-cb4f-4822-9118-1d292fd02281_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9d575f2c-cb4f-4822-9118-1d292fd02281_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.164076,
                    "lat": 41.376315
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1d1c716a-7187-4272-9e78-141d89bd3a30",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1d1c716a-7187-4272-9e78-141d89bd3a30"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1d1c716a-7187-4272-9e78-141d89bd3a30",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1d1c716a-7187-4272-9e78-141d89bd3a30"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWQxYzcxNmEtNzE4Ny00MjcyLTllNzgtMTQxZDg5YmQzYTMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWQxYzcxNmEtNzE4Ny00MjcyLTllNzgtMTQxZDg5YmQzYTMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1d1c716a-7187-4272-9e78-141d89bd3a30_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1d1c716a-7187-4272-9e78-141d89bd3a30",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2137011@Y=41376533@L=%23mcp%3AV%3Adonkey-barcelona%3A1d1c716a-7187-4272-9e78-141d89bd3a30_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1d1c716a-7187-4272-9e78-141d89bd3a30_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.137011,
                    "lat": 41.376533
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d36979b3-9ed6-4103-9a87-7c1de94c0749",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d36979b3-9ed6-4103-9a87-7c1de94c0749"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d36979b3-9ed6-4103-9a87-7c1de94c0749",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d36979b3-9ed6-4103-9a87-7c1de94c0749"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDM2OTc5YjMtOWVkNi00MTAzLTlhODctN2MxZGU5NGMwNzQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDM2OTc5YjMtOWVkNi00MTAzLTlhODctN2MxZGU5NGMwNzQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d36979b3-9ed6-4103-9a87-7c1de94c0749_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d36979b3-9ed6-4103-9a87-7c1de94c0749",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2136962@Y=41376612@L=%23mcp%3AV%3Adonkey-barcelona%3Ad36979b3-9ed6-4103-9a87-7c1de94c0749_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad36979b3-9ed6-4103-9a87-7c1de94c0749_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.136962,
                    "lat": 41.376612
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=df483c02-3e01-40e6-9899-e2c8671065b0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=df483c02-3e01-40e6-9899-e2c8671065b0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=df483c02-3e01-40e6-9899-e2c8671065b0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=df483c02-3e01-40e6-9899-e2c8671065b0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGY0ODNjMDItM2UwMS00MGU2LTk4OTktZTJjODY3MTA2NWIwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGY0ODNjMDItM2UwMS00MGU2LTk4OTktZTJjODY3MTA2NWIwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:df483c02-3e01-40e6-9899-e2c8671065b0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "df483c02-3e01-40e6-9899-e2c8671065b0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2167442@Y=41376738@L=%23mcp%3AV%3Adonkey-barcelona%3Adf483c02-3e01-40e6-9899-e2c8671065b0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Adf483c02-3e01-40e6-9899-e2c8671065b0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.167442,
                    "lat": 41.376738
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=83922bde-86e4-47ed-b112-a92b56c0071b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=83922bde-86e4-47ed-b112-a92b56c0071b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=83922bde-86e4-47ed-b112-a92b56c0071b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=83922bde-86e4-47ed-b112-a92b56c0071b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODM5MjJiZGUtODZlNC00N2VkLWIxMTItYTkyYjU2YzAwNzFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODM5MjJiZGUtODZlNC00N2VkLWIxMTItYTkyYjU2YzAwNzFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:83922bde-86e4-47ed-b112-a92b56c0071b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "83922bde-86e4-47ed-b112-a92b56c0071b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2169712@Y=41376768@L=%23mcp%3AV%3Adonkey-barcelona%3A83922bde-86e4-47ed-b112-a92b56c0071b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A83922bde-86e4-47ed-b112-a92b56c0071b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.169712,
                    "lat": 41.376768
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5b04d1ba-3678-4bc2-bd17-d37e900b6162",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5b04d1ba-3678-4bc2-bd17-d37e900b6162"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5b04d1ba-3678-4bc2-bd17-d37e900b6162",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5b04d1ba-3678-4bc2-bd17-d37e900b6162"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWIwNGQxYmEtMzY3OC00YmMyLWJkMTctZDM3ZTkwMGI2MTYyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWIwNGQxYmEtMzY3OC00YmMyLWJkMTctZDM3ZTkwMGI2MTYyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5b04d1ba-3678-4bc2-bd17-d37e900b6162_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5b04d1ba-3678-4bc2-bd17-d37e900b6162",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2149440@Y=41376928@L=%23mcp%3AV%3Adonkey-barcelona%3A5b04d1ba-3678-4bc2-bd17-d37e900b6162_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5b04d1ba-3678-4bc2-bd17-d37e900b6162_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.14944,
                    "lat": 41.376928
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8f61747c-098a-48a6-b457-df5692ada6eb",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8f61747c-098a-48a6-b457-df5692ada6eb"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8f61747c-098a-48a6-b457-df5692ada6eb",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8f61747c-098a-48a6-b457-df5692ada6eb"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGY2MTc0N2MtMDk4YS00OGE2LWI0NTctZGY1NjkyYWRhNmViIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGY2MTc0N2MtMDk4YS00OGE2LWI0NTctZGY1NjkyYWRhNmViIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8f61747c-098a-48a6-b457-df5692ada6eb_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8f61747c-098a-48a6-b457-df5692ada6eb",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171842@Y=41377044@L=%23mcp%3AV%3Adonkey-barcelona%3A8f61747c-098a-48a6-b457-df5692ada6eb_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8f61747c-098a-48a6-b457-df5692ada6eb_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171842,
                    "lat": 41.377044
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9554e6c3-e513-49e7-8049-06c81019d78f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9554e6c3-e513-49e7-8049-06c81019d78f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9554e6c3-e513-49e7-8049-06c81019d78f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9554e6c3-e513-49e7-8049-06c81019d78f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTU1NGU2YzMtZTUxMy00OWU3LTgwNDktMDZjODEwMTlkNzhmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTU1NGU2YzMtZTUxMy00OWU3LTgwNDktMDZjODEwMTlkNzhmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9554e6c3-e513-49e7-8049-06c81019d78f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9554e6c3-e513-49e7-8049-06c81019d78f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171849@Y=41377055@L=%23mcp%3AV%3Adonkey-barcelona%3A9554e6c3-e513-49e7-8049-06c81019d78f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9554e6c3-e513-49e7-8049-06c81019d78f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171849,
                    "lat": 41.377055
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6b7e2392-315e-4a9b-b4ba-d782fca88b97",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6b7e2392-315e-4a9b-b4ba-d782fca88b97"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6b7e2392-315e-4a9b-b4ba-d782fca88b97",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6b7e2392-315e-4a9b-b4ba-d782fca88b97"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmI3ZTIzOTItMzE1ZS00YTliLWI0YmEtZDc4MmZjYTg4Yjk3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmI3ZTIzOTItMzE1ZS00YTliLWI0YmEtZDc4MmZjYTg4Yjk3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6b7e2392-315e-4a9b-b4ba-d782fca88b97_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6b7e2392-315e-4a9b-b4ba-d782fca88b97",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171612@Y=41377242@L=%23mcp%3AV%3Adonkey-barcelona%3A6b7e2392-315e-4a9b-b4ba-d782fca88b97_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6b7e2392-315e-4a9b-b4ba-d782fca88b97_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171612,
                    "lat": 41.377242
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2d48df0a-f17d-4438-9d0b-4f9bb2b03f5b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2d48df0a-f17d-4438-9d0b-4f9bb2b03f5b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2d48df0a-f17d-4438-9d0b-4f9bb2b03f5b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2d48df0a-f17d-4438-9d0b-4f9bb2b03f5b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmQ0OGRmMGEtZjE3ZC00NDM4LTlkMGItNGY5YmIyYjAzZjViIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmQ0OGRmMGEtZjE3ZC00NDM4LTlkMGItNGY5YmIyYjAzZjViIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2d48df0a-f17d-4438-9d0b-4f9bb2b03f5b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2d48df0a-f17d-4438-9d0b-4f9bb2b03f5b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171061@Y=41377444@L=%23mcp%3AV%3Adonkey-barcelona%3A2d48df0a-f17d-4438-9d0b-4f9bb2b03f5b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2d48df0a-f17d-4438-9d0b-4f9bb2b03f5b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171061,
                    "lat": 41.377444
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=30124717-eba1-4040-8aa7-547bc8b4846e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=30124717-eba1-4040-8aa7-547bc8b4846e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=30124717-eba1-4040-8aa7-547bc8b4846e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=30124717-eba1-4040-8aa7-547bc8b4846e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzAxMjQ3MTctZWJhMS00MDQwLThhYTctNTQ3YmM4YjQ4NDZlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzAxMjQ3MTctZWJhMS00MDQwLThhYTctNTQ3YmM4YjQ4NDZlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:30124717-eba1-4040-8aa7-547bc8b4846e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "30124717-eba1-4040-8aa7-547bc8b4846e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191310@Y=41377490@L=%23mcp%3AV%3Adonkey-barcelona%3A30124717-eba1-4040-8aa7-547bc8b4846e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A30124717-eba1-4040-8aa7-547bc8b4846e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.19131,
                    "lat": 41.37749
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6644cc0a-0dc9-42e9-903b-2ea083bf2095",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6644cc0a-0dc9-42e9-903b-2ea083bf2095"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6644cc0a-0dc9-42e9-903b-2ea083bf2095",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6644cc0a-0dc9-42e9-903b-2ea083bf2095"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjY0NGNjMGEtMGRjOS00MmU5LTkwM2ItMmVhMDgzYmYyMDk1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjY0NGNjMGEtMGRjOS00MmU5LTkwM2ItMmVhMDgzYmYyMDk1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6644cc0a-0dc9-42e9-903b-2ea083bf2095_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6644cc0a-0dc9-42e9-903b-2ea083bf2095",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191326@Y=41377509@L=%23mcp%3AV%3Adonkey-barcelona%3A6644cc0a-0dc9-42e9-903b-2ea083bf2095_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6644cc0a-0dc9-42e9-903b-2ea083bf2095_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191326,
                    "lat": 41.377509
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4140d18b-fdfe-4d1e-9c6e-5c193d463d70",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4140d18b-fdfe-4d1e-9c6e-5c193d463d70"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4140d18b-fdfe-4d1e-9c6e-5c193d463d70",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4140d18b-fdfe-4d1e-9c6e-5c193d463d70"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDE0MGQxOGItZmRmZS00ZDFlLTljNmUtNWMxOTNkNDYzZDcwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDE0MGQxOGItZmRmZS00ZDFlLTljNmUtNWMxOTNkNDYzZDcwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4140d18b-fdfe-4d1e-9c6e-5c193d463d70_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4140d18b-fdfe-4d1e-9c6e-5c193d463d70",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170959@Y=41377609@L=%23mcp%3AV%3Adonkey-barcelona%3A4140d18b-fdfe-4d1e-9c6e-5c193d463d70_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4140d18b-fdfe-4d1e-9c6e-5c193d463d70_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.170959,
                    "lat": 41.377609
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=beb98067-a04e-41c0-a6af-b2eadbdb8ee6",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=beb98067-a04e-41c0-a6af-b2eadbdb8ee6"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=beb98067-a04e-41c0-a6af-b2eadbdb8ee6",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=beb98067-a04e-41c0-a6af-b2eadbdb8ee6"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmViOTgwNjctYTA0ZS00MWMwLWE2YWYtYjJlYWRiZGI4ZWU2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmViOTgwNjctYTA0ZS00MWMwLWE2YWYtYjJlYWRiZGI4ZWU2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:beb98067-a04e-41c0-a6af-b2eadbdb8ee6_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "beb98067-a04e-41c0-a6af-b2eadbdb8ee6",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2164007@Y=41377613@L=%23mcp%3AV%3Adonkey-barcelona%3Abeb98067-a04e-41c0-a6af-b2eadbdb8ee6_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Abeb98067-a04e-41c0-a6af-b2eadbdb8ee6_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.164007,
                    "lat": 41.377613
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6339ceae-6224-4306-b835-dda3dc718014",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6339ceae-6224-4306-b835-dda3dc718014"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6339ceae-6224-4306-b835-dda3dc718014",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6339ceae-6224-4306-b835-dda3dc718014"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjMzOWNlYWUtNjIyNC00MzA2LWI4MzUtZGRhM2RjNzE4MDE0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjMzOWNlYWUtNjIyNC00MzA2LWI4MzUtZGRhM2RjNzE4MDE0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6339ceae-6224-4306-b835-dda3dc718014_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6339ceae-6224-4306-b835-dda3dc718014",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2157529@Y=41377734@L=%23mcp%3AV%3Adonkey-barcelona%3A6339ceae-6224-4306-b835-dda3dc718014_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6339ceae-6224-4306-b835-dda3dc718014_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.157529,
                    "lat": 41.377734
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=264287d0-50d3-41e2-b8c0-fb227d178025",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=264287d0-50d3-41e2-b8c0-fb227d178025"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=264287d0-50d3-41e2-b8c0-fb227d178025",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=264287d0-50d3-41e2-b8c0-fb227d178025"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjY0Mjg3ZDAtNTBkMy00MWUyLWI4YzAtZmIyMjdkMTc4MDI1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjY0Mjg3ZDAtNTBkMy00MWUyLWI4YzAtZmIyMjdkMTc4MDI1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:264287d0-50d3-41e2-b8c0-fb227d178025_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "264287d0-50d3-41e2-b8c0-fb227d178025",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2161913@Y=41377763@L=%23mcp%3AV%3Adonkey-barcelona%3A264287d0-50d3-41e2-b8c0-fb227d178025_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A264287d0-50d3-41e2-b8c0-fb227d178025_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.161913,
                    "lat": 41.377763
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1562c86a-90f2-4911-9e0d-c110930c88fd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1562c86a-90f2-4911-9e0d-c110930c88fd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1562c86a-90f2-4911-9e0d-c110930c88fd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1562c86a-90f2-4911-9e0d-c110930c88fd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTU2MmM4NmEtOTBmMi00OTExLTllMGQtYzExMDkzMGM4OGZkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTU2MmM4NmEtOTBmMi00OTExLTllMGQtYzExMDkzMGM4OGZkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1562c86a-90f2-4911-9e0d-c110930c88fd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1562c86a-90f2-4911-9e0d-c110930c88fd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2161913@Y=41377763@L=%23mcp%3AV%3Adonkey-barcelona%3A1562c86a-90f2-4911-9e0d-c110930c88fd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1562c86a-90f2-4911-9e0d-c110930c88fd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.161913,
                    "lat": 41.377763
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=63e99bfc-230b-4f0e-b1d3-1045825fcc92",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=63e99bfc-230b-4f0e-b1d3-1045825fcc92"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=63e99bfc-230b-4f0e-b1d3-1045825fcc92",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=63e99bfc-230b-4f0e-b1d3-1045825fcc92"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjNlOTliZmMtMjMwYi00ZjBlLWIxZDMtMTA0NTgyNWZjYzkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjNlOTliZmMtMjMwYi00ZjBlLWIxZDMtMTA0NTgyNWZjYzkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:63e99bfc-230b-4f0e-b1d3-1045825fcc92_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "63e99bfc-230b-4f0e-b1d3-1045825fcc92",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2159810@Y=41377783@L=%23mcp%3AV%3Adonkey-barcelona%3A63e99bfc-230b-4f0e-b1d3-1045825fcc92_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A63e99bfc-230b-4f0e-b1d3-1045825fcc92_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.15981,
                    "lat": 41.377783
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7cf03cc7-4503-46f4-beea-6b33802147f0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7cf03cc7-4503-46f4-beea-6b33802147f0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7cf03cc7-4503-46f4-beea-6b33802147f0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7cf03cc7-4503-46f4-beea-6b33802147f0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2NmMDNjYzctNDUwMy00NmY0LWJlZWEtNmIzMzgwMjE0N2YwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2NmMDNjYzctNDUwMy00NmY0LWJlZWEtNmIzMzgwMjE0N2YwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7cf03cc7-4503-46f4-beea-6b33802147f0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7cf03cc7-4503-46f4-beea-6b33802147f0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188368@Y=41377802@L=%23mcp%3AV%3Adonkey-barcelona%3A7cf03cc7-4503-46f4-beea-6b33802147f0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7cf03cc7-4503-46f4-beea-6b33802147f0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188368,
                    "lat": 41.377802
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f280d30b-745e-40ec-bb83-aa17c9b66436",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f280d30b-745e-40ec-bb83-aa17c9b66436"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f280d30b-745e-40ec-bb83-aa17c9b66436",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f280d30b-745e-40ec-bb83-aa17c9b66436"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjI4MGQzMGItNzQ1ZS00MGVjLWJiODMtYWExN2M5YjY2NDM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjI4MGQzMGItNzQ1ZS00MGVjLWJiODMtYWExN2M5YjY2NDM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f280d30b-745e-40ec-bb83-aa17c9b66436_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f280d30b-745e-40ec-bb83-aa17c9b66436",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2161866@Y=41377939@L=%23mcp%3AV%3Adonkey-barcelona%3Af280d30b-745e-40ec-bb83-aa17c9b66436_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af280d30b-745e-40ec-bb83-aa17c9b66436_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.161866,
                    "lat": 41.377939
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2ef01ea2-fab5-4abc-9323-ce0843244f1d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2ef01ea2-fab5-4abc-9323-ce0843244f1d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2ef01ea2-fab5-4abc-9323-ce0843244f1d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2ef01ea2-fab5-4abc-9323-ce0843244f1d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmVmMDFlYTItZmFiNS00YWJjLTkzMjMtY2UwODQzMjQ0ZjFkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmVmMDFlYTItZmFiNS00YWJjLTkzMjMtY2UwODQzMjQ0ZjFkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2ef01ea2-fab5-4abc-9323-ce0843244f1d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2ef01ea2-fab5-4abc-9323-ce0843244f1d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2121632@Y=41377958@L=%23mcp%3AV%3Adonkey-barcelona%3A2ef01ea2-fab5-4abc-9323-ce0843244f1d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2ef01ea2-fab5-4abc-9323-ce0843244f1d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.121632,
                    "lat": 41.377958
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f923fe19-09ff-4882-8b6a-ffda33d45aab",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f923fe19-09ff-4882-8b6a-ffda33d45aab"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f923fe19-09ff-4882-8b6a-ffda33d45aab",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f923fe19-09ff-4882-8b6a-ffda33d45aab"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjkyM2ZlMTktMDlmZi00ODgyLThiNmEtZmZkYTMzZDQ1YWFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjkyM2ZlMTktMDlmZi00ODgyLThiNmEtZmZkYTMzZDQ1YWFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f923fe19-09ff-4882-8b6a-ffda33d45aab_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f923fe19-09ff-4882-8b6a-ffda33d45aab",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188013@Y=41377975@L=%23mcp%3AV%3Adonkey-barcelona%3Af923fe19-09ff-4882-8b6a-ffda33d45aab_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af923fe19-09ff-4882-8b6a-ffda33d45aab_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188013,
                    "lat": 41.377975
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=095d8504-7f57-4ac5-b286-db1b2ac9340b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=095d8504-7f57-4ac5-b286-db1b2ac9340b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=095d8504-7f57-4ac5-b286-db1b2ac9340b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=095d8504-7f57-4ac5-b286-db1b2ac9340b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDk1ZDg1MDQtN2Y1Ny00YWM1LWIyODYtZGIxYjJhYzkzNDBiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDk1ZDg1MDQtN2Y1Ny00YWM1LWIyODYtZGIxYjJhYzkzNDBiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:095d8504-7f57-4ac5-b286-db1b2ac9340b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "095d8504-7f57-4ac5-b286-db1b2ac9340b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2121650@Y=41378055@L=%23mcp%3AV%3Adonkey-barcelona%3A095d8504-7f57-4ac5-b286-db1b2ac9340b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A095d8504-7f57-4ac5-b286-db1b2ac9340b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.12165,
                    "lat": 41.378055
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d0361032-6375-4fb8-8cec-1437433fcce9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d0361032-6375-4fb8-8cec-1437433fcce9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d0361032-6375-4fb8-8cec-1437433fcce9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d0361032-6375-4fb8-8cec-1437433fcce9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDAzNjEwMzItNjM3NS00ZmI4LThjZWMtMTQzNzQzM2ZjY2U5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDAzNjEwMzItNjM3NS00ZmI4LThjZWMtMTQzNzQzM2ZjY2U5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d0361032-6375-4fb8-8cec-1437433fcce9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d0361032-6375-4fb8-8cec-1437433fcce9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170448@Y=41378140@L=%23mcp%3AV%3Adonkey-barcelona%3Ad0361032-6375-4fb8-8cec-1437433fcce9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad0361032-6375-4fb8-8cec-1437433fcce9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.170448,
                    "lat": 41.37814
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d8175865-60ea-4f4f-a4df-4f00d4808b15",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d8175865-60ea-4f4f-a4df-4f00d4808b15"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d8175865-60ea-4f4f-a4df-4f00d4808b15",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d8175865-60ea-4f4f-a4df-4f00d4808b15"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDgxNzU4NjUtNjBlYS00ZjRmLWE0ZGYtNGYwMGQ0ODA4YjE1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDgxNzU4NjUtNjBlYS00ZjRmLWE0ZGYtNGYwMGQ0ODA4YjE1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d8175865-60ea-4f4f-a4df-4f00d4808b15_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d8175865-60ea-4f4f-a4df-4f00d4808b15",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2139088@Y=41378169@L=%23mcp%3AV%3Adonkey-barcelona%3Ad8175865-60ea-4f4f-a4df-4f00d4808b15_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad8175865-60ea-4f4f-a4df-4f00d4808b15_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.139088,
                    "lat": 41.378169
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=25baf134-aee1-47a6-b699-ddcc606ce18f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=25baf134-aee1-47a6-b699-ddcc606ce18f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=25baf134-aee1-47a6-b699-ddcc606ce18f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=25baf134-aee1-47a6-b699-ddcc606ce18f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjViYWYxMzQtYWVlMS00N2E2LWI2OTktZGRjYzYwNmNlMThmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjViYWYxMzQtYWVlMS00N2E2LWI2OTktZGRjYzYwNmNlMThmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:25baf134-aee1-47a6-b699-ddcc606ce18f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "25baf134-aee1-47a6-b699-ddcc606ce18f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170487@Y=41378176@L=%23mcp%3AV%3Adonkey-barcelona%3A25baf134-aee1-47a6-b699-ddcc606ce18f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A25baf134-aee1-47a6-b699-ddcc606ce18f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.170487,
                    "lat": 41.378176
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=609c65a5-5b0d-46d7-84db-ec12b2799543",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=609c65a5-5b0d-46d7-84db-ec12b2799543"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=609c65a5-5b0d-46d7-84db-ec12b2799543",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=609c65a5-5b0d-46d7-84db-ec12b2799543"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjA5YzY1YTUtNWIwZC00NmQ3LTg0ZGItZWMxMmIyNzk5NTQzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjA5YzY1YTUtNWIwZC00NmQ3LTg0ZGItZWMxMmIyNzk5NTQzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:609c65a5-5b0d-46d7-84db-ec12b2799543_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "609c65a5-5b0d-46d7-84db-ec12b2799543",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2179482@Y=41378297@L=%23mcp%3AV%3Adonkey-barcelona%3A609c65a5-5b0d-46d7-84db-ec12b2799543_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A609c65a5-5b0d-46d7-84db-ec12b2799543_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.179482,
                    "lat": 41.378297
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=39f208b8-d392-4180-83c0-2e642c2dba04",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=39f208b8-d392-4180-83c0-2e642c2dba04"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=39f208b8-d392-4180-83c0-2e642c2dba04",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=39f208b8-d392-4180-83c0-2e642c2dba04"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzlmMjA4YjgtZDM5Mi00MTgwLTgzYzAtMmU2NDJjMmRiYTA0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzlmMjA4YjgtZDM5Mi00MTgwLTgzYzAtMmU2NDJjMmRiYTA0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:39f208b8-d392-4180-83c0-2e642c2dba04_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "39f208b8-d392-4180-83c0-2e642c2dba04",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2160507@Y=41378330@L=%23mcp%3AV%3Adonkey-barcelona%3A39f208b8-d392-4180-83c0-2e642c2dba04_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A39f208b8-d392-4180-83c0-2e642c2dba04_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.160507,
                    "lat": 41.37833
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9e6f7e17-3eb9-47f5-90bf-3bf870d80549",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9e6f7e17-3eb9-47f5-90bf-3bf870d80549"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9e6f7e17-3eb9-47f5-90bf-3bf870d80549",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9e6f7e17-3eb9-47f5-90bf-3bf870d80549"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWU2ZjdlMTctM2ViOS00N2Y1LTkwYmYtM2JmODcwZDgwNTQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWU2ZjdlMTctM2ViOS00N2Y1LTkwYmYtM2JmODcwZDgwNTQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9e6f7e17-3eb9-47f5-90bf-3bf870d80549_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9e6f7e17-3eb9-47f5-90bf-3bf870d80549",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2179484@Y=41378339@L=%23mcp%3AV%3Adonkey-barcelona%3A9e6f7e17-3eb9-47f5-90bf-3bf870d80549_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9e6f7e17-3eb9-47f5-90bf-3bf870d80549_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.179484,
                    "lat": 41.378339
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c1fe9469-6dfe-4988-85a8-144c084db5e4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c1fe9469-6dfe-4988-85a8-144c084db5e4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c1fe9469-6dfe-4988-85a8-144c084db5e4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c1fe9469-6dfe-4988-85a8-144c084db5e4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzFmZTk0NjktNmRmZS00OTg4LTg1YTgtMTQ0YzA4NGRiNWU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzFmZTk0NjktNmRmZS00OTg4LTg1YTgtMTQ0YzA4NGRiNWU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c1fe9469-6dfe-4988-85a8-144c084db5e4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c1fe9469-6dfe-4988-85a8-144c084db5e4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2179389@Y=41378382@L=%23mcp%3AV%3Adonkey-barcelona%3Ac1fe9469-6dfe-4988-85a8-144c084db5e4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac1fe9469-6dfe-4988-85a8-144c084db5e4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.179389,
                    "lat": 41.378382
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=de31afc0-5845-4abb-8c9e-d8643d08d7be",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=de31afc0-5845-4abb-8c9e-d8643d08d7be"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=de31afc0-5845-4abb-8c9e-d8643d08d7be",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=de31afc0-5845-4abb-8c9e-d8643d08d7be"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGUzMWFmYzAtNTg0NS00YWJiLThjOWUtZDg2NDNkMDhkN2JlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGUzMWFmYzAtNTg0NS00YWJiLThjOWUtZDg2NDNkMDhkN2JlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:de31afc0-5845-4abb-8c9e-d8643d08d7be_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "de31afc0-5845-4abb-8c9e-d8643d08d7be",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2169613@Y=41378417@L=%23mcp%3AV%3Adonkey-barcelona%3Ade31afc0-5845-4abb-8c9e-d8643d08d7be_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ade31afc0-5845-4abb-8c9e-d8643d08d7be_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.169613,
                    "lat": 41.378417
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=817f79a7-c673-4f59-985f-ed33f163785b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=817f79a7-c673-4f59-985f-ed33f163785b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=817f79a7-c673-4f59-985f-ed33f163785b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=817f79a7-c673-4f59-985f-ed33f163785b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODE3Zjc5YTctYzY3My00ZjU5LTk4NWYtZWQzM2YxNjM3ODViIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODE3Zjc5YTctYzY3My00ZjU5LTk4NWYtZWQzM2YxNjM3ODViIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:817f79a7-c673-4f59-985f-ed33f163785b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "817f79a7-c673-4f59-985f-ed33f163785b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2169403@Y=41378435@L=%23mcp%3AV%3Adonkey-barcelona%3A817f79a7-c673-4f59-985f-ed33f163785b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A817f79a7-c673-4f59-985f-ed33f163785b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.169403,
                    "lat": 41.378435
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5edfe585-b8f3-47e4-ab14-9016d7f271a8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5edfe585-b8f3-47e4-ab14-9016d7f271a8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5edfe585-b8f3-47e4-ab14-9016d7f271a8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5edfe585-b8f3-47e4-ab14-9016d7f271a8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWVkZmU1ODUtYjhmMy00N2U0LWFiMTQtOTAxNmQ3ZjI3MWE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWVkZmU1ODUtYjhmMy00N2U0LWFiMTQtOTAxNmQ3ZjI3MWE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5edfe585-b8f3-47e4-ab14-9016d7f271a8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5edfe585-b8f3-47e4-ab14-9016d7f271a8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2160738@Y=41378448@L=%23mcp%3AV%3Adonkey-barcelona%3A5edfe585-b8f3-47e4-ab14-9016d7f271a8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5edfe585-b8f3-47e4-ab14-9016d7f271a8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.160738,
                    "lat": 41.378448
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4e083e2c-8730-48eb-85c0-78f96cb68087",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4e083e2c-8730-48eb-85c0-78f96cb68087"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4e083e2c-8730-48eb-85c0-78f96cb68087",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4e083e2c-8730-48eb-85c0-78f96cb68087"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGUwODNlMmMtODczMC00OGViLTg1YzAtNzhmOTZjYjY4MDg3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGUwODNlMmMtODczMC00OGViLTg1YzAtNzhmOTZjYjY4MDg3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4e083e2c-8730-48eb-85c0-78f96cb68087_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4e083e2c-8730-48eb-85c0-78f96cb68087",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2161011@Y=41378561@L=%23mcp%3AV%3Adonkey-barcelona%3A4e083e2c-8730-48eb-85c0-78f96cb68087_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4e083e2c-8730-48eb-85c0-78f96cb68087_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.161011,
                    "lat": 41.378561
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6861927b-e71d-4bcb-87aa-e4f55d59a1ae",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6861927b-e71d-4bcb-87aa-e4f55d59a1ae"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6861927b-e71d-4bcb-87aa-e4f55d59a1ae",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6861927b-e71d-4bcb-87aa-e4f55d59a1ae"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjg2MTkyN2ItZTcxZC00YmNiLTg3YWEtZTRmNTVkNTlhMWFlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjg2MTkyN2ItZTcxZC00YmNiLTg3YWEtZTRmNTVkNTlhMWFlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6861927b-e71d-4bcb-87aa-e4f55d59a1ae_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6861927b-e71d-4bcb-87aa-e4f55d59a1ae",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171322@Y=41378655@L=%23mcp%3AV%3Adonkey-barcelona%3A6861927b-e71d-4bcb-87aa-e4f55d59a1ae_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6861927b-e71d-4bcb-87aa-e4f55d59a1ae_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171322,
                    "lat": 41.378655
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9d0dd732-48d3-40c4-9988-025e54c8a9f1",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9d0dd732-48d3-40c4-9988-025e54c8a9f1"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9d0dd732-48d3-40c4-9988-025e54c8a9f1",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9d0dd732-48d3-40c4-9988-025e54c8a9f1"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWQwZGQ3MzItNDhkMy00MGM0LTk5ODgtMDI1ZTU0YzhhOWYxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWQwZGQ3MzItNDhkMy00MGM0LTk5ODgtMDI1ZTU0YzhhOWYxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9d0dd732-48d3-40c4-9988-025e54c8a9f1_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9d0dd732-48d3-40c4-9988-025e54c8a9f1",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2160747@Y=41378737@L=%23mcp%3AV%3Adonkey-barcelona%3A9d0dd732-48d3-40c4-9988-025e54c8a9f1_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9d0dd732-48d3-40c4-9988-025e54c8a9f1_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.160747,
                    "lat": 41.378737
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=921ff6b3-f656-4246-89d8-6825a03ade59",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=921ff6b3-f656-4246-89d8-6825a03ade59"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=921ff6b3-f656-4246-89d8-6825a03ade59",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=921ff6b3-f656-4246-89d8-6825a03ade59"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTIxZmY2YjMtZjY1Ni00MjQ2LTg5ZDgtNjgyNWEwM2FkZTU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTIxZmY2YjMtZjY1Ni00MjQ2LTg5ZDgtNjgyNWEwM2FkZTU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:921ff6b3-f656-4246-89d8-6825a03ade59_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "921ff6b3-f656-4246-89d8-6825a03ade59",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171400@Y=41378752@L=%23mcp%3AV%3Adonkey-barcelona%3A921ff6b3-f656-4246-89d8-6825a03ade59_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A921ff6b3-f656-4246-89d8-6825a03ade59_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.1714,
                    "lat": 41.378752
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1dca0f0b-9849-4396-b605-0cb70e27154a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1dca0f0b-9849-4396-b605-0cb70e27154a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1dca0f0b-9849-4396-b605-0cb70e27154a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1dca0f0b-9849-4396-b605-0cb70e27154a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWRjYTBmMGItOTg0OS00Mzk2LWI2MDUtMGNiNzBlMjcxNTRhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWRjYTBmMGItOTg0OS00Mzk2LWI2MDUtMGNiNzBlMjcxNTRhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1dca0f0b-9849-4396-b605-0cb70e27154a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1dca0f0b-9849-4396-b605-0cb70e27154a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2142364@Y=41378832@L=%23mcp%3AV%3Adonkey-barcelona%3A1dca0f0b-9849-4396-b605-0cb70e27154a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1dca0f0b-9849-4396-b605-0cb70e27154a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.142364,
                    "lat": 41.378832
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5b23c9b9-d1a6-4f8a-8225-00b0a96990ee",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5b23c9b9-d1a6-4f8a-8225-00b0a96990ee"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5b23c9b9-d1a6-4f8a-8225-00b0a96990ee",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5b23c9b9-d1a6-4f8a-8225-00b0a96990ee"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWIyM2M5YjktZDFhNi00ZjhhLTgyMjUtMDBiMGE5Njk5MGVlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWIyM2M5YjktZDFhNi00ZjhhLTgyMjUtMDBiMGE5Njk5MGVlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5b23c9b9-d1a6-4f8a-8225-00b0a96990ee_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5b23c9b9-d1a6-4f8a-8225-00b0a96990ee",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2151586@Y=41378838@L=%23mcp%3AV%3Adonkey-barcelona%3A5b23c9b9-d1a6-4f8a-8225-00b0a96990ee_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5b23c9b9-d1a6-4f8a-8225-00b0a96990ee_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.151586,
                    "lat": 41.378838
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f32ebc27-9219-44a5-9b55-1dc01ef4803c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f32ebc27-9219-44a5-9b55-1dc01ef4803c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f32ebc27-9219-44a5-9b55-1dc01ef4803c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f32ebc27-9219-44a5-9b55-1dc01ef4803c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjMyZWJjMjctOTIxOS00NGE1LTliNTUtMWRjMDFlZjQ4MDNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjMyZWJjMjctOTIxOS00NGE1LTliNTUtMWRjMDFlZjQ4MDNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f32ebc27-9219-44a5-9b55-1dc01ef4803c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f32ebc27-9219-44a5-9b55-1dc01ef4803c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2151549@Y=41378883@L=%23mcp%3AV%3Adonkey-barcelona%3Af32ebc27-9219-44a5-9b55-1dc01ef4803c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af32ebc27-9219-44a5-9b55-1dc01ef4803c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.151549,
                    "lat": 41.378883
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3a2131ad-4c67-4c8e-a2f0-4775e6c91070",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3a2131ad-4c67-4c8e-a2f0-4775e6c91070"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3a2131ad-4c67-4c8e-a2f0-4775e6c91070",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3a2131ad-4c67-4c8e-a2f0-4775e6c91070"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2EyMTMxYWQtNGM2Ny00YzhlLWEyZjAtNDc3NWU2YzkxMDcwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2EyMTMxYWQtNGM2Ny00YzhlLWEyZjAtNDc3NWU2YzkxMDcwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3a2131ad-4c67-4c8e-a2f0-4775e6c91070_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3a2131ad-4c67-4c8e-a2f0-4775e6c91070",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168751@Y=41378900@L=%23mcp%3AV%3Adonkey-barcelona%3A3a2131ad-4c67-4c8e-a2f0-4775e6c91070_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3a2131ad-4c67-4c8e-a2f0-4775e6c91070_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.168751,
                    "lat": 41.3789
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=615c2f5d-c141-43c6-9db6-2dd3acfd398c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=615c2f5d-c141-43c6-9db6-2dd3acfd398c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=615c2f5d-c141-43c6-9db6-2dd3acfd398c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=615c2f5d-c141-43c6-9db6-2dd3acfd398c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjE1YzJmNWQtYzE0MS00M2M2LTlkYjYtMmRkM2FjZmQzOThjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjE1YzJmNWQtYzE0MS00M2M2LTlkYjYtMmRkM2FjZmQzOThjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:615c2f5d-c141-43c6-9db6-2dd3acfd398c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "615c2f5d-c141-43c6-9db6-2dd3acfd398c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2153866@Y=41378945@L=%23mcp%3AV%3Adonkey-barcelona%3A615c2f5d-c141-43c6-9db6-2dd3acfd398c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A615c2f5d-c141-43c6-9db6-2dd3acfd398c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.153866,
                    "lat": 41.378945
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e5b2fba8-7b85-465f-ba41-0947e85f3f54",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e5b2fba8-7b85-465f-ba41-0947e85f3f54"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e5b2fba8-7b85-465f-ba41-0947e85f3f54",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e5b2fba8-7b85-465f-ba41-0947e85f3f54"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTViMmZiYTgtN2I4NS00NjVmLWJhNDEtMDk0N2U4NWYzZjU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTViMmZiYTgtN2I4NS00NjVmLWJhNDEtMDk0N2U4NWYzZjU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e5b2fba8-7b85-465f-ba41-0947e85f3f54_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e5b2fba8-7b85-465f-ba41-0947e85f3f54",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2154204@Y=41379040@L=%23mcp%3AV%3Adonkey-barcelona%3Ae5b2fba8-7b85-465f-ba41-0947e85f3f54_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae5b2fba8-7b85-465f-ba41-0947e85f3f54_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.154204,
                    "lat": 41.37904
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d0726e5a-da35-4795-832e-9baa69713ca7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d0726e5a-da35-4795-832e-9baa69713ca7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d0726e5a-da35-4795-832e-9baa69713ca7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d0726e5a-da35-4795-832e-9baa69713ca7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDA3MjZlNWEtZGEzNS00Nzk1LTgzMmUtOWJhYTY5NzEzY2E3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDA3MjZlNWEtZGEzNS00Nzk1LTgzMmUtOWJhYTY5NzEzY2E3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d0726e5a-da35-4795-832e-9baa69713ca7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d0726e5a-da35-4795-832e-9baa69713ca7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2180670@Y=41379077@L=%23mcp%3AV%3Adonkey-barcelona%3Ad0726e5a-da35-4795-832e-9baa69713ca7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad0726e5a-da35-4795-832e-9baa69713ca7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.18067,
                    "lat": 41.379077
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=29a8ded5-60e0-4fdb-ad06-3eb9ba09562b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=29a8ded5-60e0-4fdb-ad06-3eb9ba09562b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=29a8ded5-60e0-4fdb-ad06-3eb9ba09562b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=29a8ded5-60e0-4fdb-ad06-3eb9ba09562b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjlhOGRlZDUtNjBlMC00ZmRiLWFkMDYtM2ViOWJhMDk1NjJiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjlhOGRlZDUtNjBlMC00ZmRiLWFkMDYtM2ViOWJhMDk1NjJiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:29a8ded5-60e0-4fdb-ad06-3eb9ba09562b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "29a8ded5-60e0-4fdb-ad06-3eb9ba09562b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2149103@Y=41379149@L=%23mcp%3AV%3Adonkey-barcelona%3A29a8ded5-60e0-4fdb-ad06-3eb9ba09562b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A29a8ded5-60e0-4fdb-ad06-3eb9ba09562b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.149103,
                    "lat": 41.379149
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c8f9831b-ec98-4bec-9c22-42029d8f3df3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c8f9831b-ec98-4bec-9c22-42029d8f3df3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c8f9831b-ec98-4bec-9c22-42029d8f3df3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c8f9831b-ec98-4bec-9c22-42029d8f3df3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzhmOTgzMWItZWM5OC00YmVjLTljMjItNDIwMjlkOGYzZGYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzhmOTgzMWItZWM5OC00YmVjLTljMjItNDIwMjlkOGYzZGYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c8f9831b-ec98-4bec-9c22-42029d8f3df3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c8f9831b-ec98-4bec-9c22-42029d8f3df3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2142952@Y=41379155@L=%23mcp%3AV%3Adonkey-barcelona%3Ac8f9831b-ec98-4bec-9c22-42029d8f3df3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac8f9831b-ec98-4bec-9c22-42029d8f3df3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.142952,
                    "lat": 41.379155
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1db48852-1339-43a8-a72b-5d9a45bf3050",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1db48852-1339-43a8-a72b-5d9a45bf3050"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1db48852-1339-43a8-a72b-5d9a45bf3050",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1db48852-1339-43a8-a72b-5d9a45bf3050"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWRiNDg4NTItMTMzOS00M2E4LWE3MmItNWQ5YTQ1YmYzMDUwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWRiNDg4NTItMTMzOS00M2E4LWE3MmItNWQ5YTQ1YmYzMDUwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1db48852-1339-43a8-a72b-5d9a45bf3050_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1db48852-1339-43a8-a72b-5d9a45bf3050",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2142892@Y=41379204@L=%23mcp%3AV%3Adonkey-barcelona%3A1db48852-1339-43a8-a72b-5d9a45bf3050_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1db48852-1339-43a8-a72b-5d9a45bf3050_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.142892,
                    "lat": 41.379204
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=04480558-e507-459e-aab1-7567fe664f36",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=04480558-e507-459e-aab1-7567fe664f36"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=04480558-e507-459e-aab1-7567fe664f36",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=04480558-e507-459e-aab1-7567fe664f36"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDQ0ODA1NTgtZTUwNy00NTllLWFhYjEtNzU2N2ZlNjY0ZjM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDQ0ODA1NTgtZTUwNy00NTllLWFhYjEtNzU2N2ZlNjY0ZjM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:04480558-e507-459e-aab1-7567fe664f36_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "04480558-e507-459e-aab1-7567fe664f36",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168157@Y=41379232@L=%23mcp%3AV%3Adonkey-barcelona%3A04480558-e507-459e-aab1-7567fe664f36_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A04480558-e507-459e-aab1-7567fe664f36_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.168157,
                    "lat": 41.379232
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3ec82384-d706-4371-9182-ed21e0d49f0b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3ec82384-d706-4371-9182-ed21e0d49f0b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3ec82384-d706-4371-9182-ed21e0d49f0b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3ec82384-d706-4371-9182-ed21e0d49f0b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2VjODIzODQtZDcwNi00MzcxLTkxODItZWQyMWUwZDQ5ZjBiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2VjODIzODQtZDcwNi00MzcxLTkxODItZWQyMWUwZDQ5ZjBiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3ec82384-d706-4371-9182-ed21e0d49f0b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3ec82384-d706-4371-9182-ed21e0d49f0b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171930@Y=41379294@L=%23mcp%3AV%3Adonkey-barcelona%3A3ec82384-d706-4371-9182-ed21e0d49f0b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3ec82384-d706-4371-9182-ed21e0d49f0b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.17193,
                    "lat": 41.379294
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6aee392e-aae5-45b7-a563-7095da11511a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6aee392e-aae5-45b7-a563-7095da11511a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6aee392e-aae5-45b7-a563-7095da11511a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6aee392e-aae5-45b7-a563-7095da11511a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmFlZTM5MmUtYWFlNS00NWI3LWE1NjMtNzA5NWRhMTE1MTFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmFlZTM5MmUtYWFlNS00NWI3LWE1NjMtNzA5NWRhMTE1MTFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6aee392e-aae5-45b7-a563-7095da11511a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6aee392e-aae5-45b7-a563-7095da11511a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2162100@Y=41379347@L=%23mcp%3AV%3Adonkey-barcelona%3A6aee392e-aae5-45b7-a563-7095da11511a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6aee392e-aae5-45b7-a563-7095da11511a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.1621,
                    "lat": 41.379347
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=430f9c8f-fb64-45b7-8549-250e52e2c498",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=430f9c8f-fb64-45b7-8549-250e52e2c498"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=430f9c8f-fb64-45b7-8549-250e52e2c498",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=430f9c8f-fb64-45b7-8549-250e52e2c498"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDMwZjljOGYtZmI2NC00NWI3LTg1NDktMjUwZTUyZTJjNDk4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDMwZjljOGYtZmI2NC00NWI3LTg1NDktMjUwZTUyZTJjNDk4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:430f9c8f-fb64-45b7-8549-250e52e2c498_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "430f9c8f-fb64-45b7-8549-250e52e2c498",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168236@Y=41379348@L=%23mcp%3AV%3Adonkey-barcelona%3A430f9c8f-fb64-45b7-8549-250e52e2c498_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A430f9c8f-fb64-45b7-8549-250e52e2c498_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.168236,
                    "lat": 41.379348
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1e826cc8-c69a-4e90-9005-b8be38b35459",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1e826cc8-c69a-4e90-9005-b8be38b35459"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1e826cc8-c69a-4e90-9005-b8be38b35459",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1e826cc8-c69a-4e90-9005-b8be38b35459"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWU4MjZjYzgtYzY5YS00ZTkwLTkwMDUtYjhiZTM4YjM1NDU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWU4MjZjYzgtYzY5YS00ZTkwLTkwMDUtYjhiZTM4YjM1NDU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1e826cc8-c69a-4e90-9005-b8be38b35459_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1e826cc8-c69a-4e90-9005-b8be38b35459",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2162174@Y=41379356@L=%23mcp%3AV%3Adonkey-barcelona%3A1e826cc8-c69a-4e90-9005-b8be38b35459_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1e826cc8-c69a-4e90-9005-b8be38b35459_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.162174,
                    "lat": 41.379356
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=104a3163-4383-4646-8282-25f3a080a114",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=104a3163-4383-4646-8282-25f3a080a114"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=104a3163-4383-4646-8282-25f3a080a114",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=104a3163-4383-4646-8282-25f3a080a114"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTA0YTMxNjMtNDM4My00NjQ2LTgyODItMjVmM2EwODBhMTE0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTA0YTMxNjMtNDM4My00NjQ2LTgyODItMjVmM2EwODBhMTE0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:104a3163-4383-4646-8282-25f3a080a114_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "104a3163-4383-4646-8282-25f3a080a114",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2127691@Y=41379371@L=%23mcp%3AV%3Adonkey-barcelona%3A104a3163-4383-4646-8282-25f3a080a114_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A104a3163-4383-4646-8282-25f3a080a114_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.127691,
                    "lat": 41.379371
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=65e4dc52-05ff-4960-8206-bc64b88e345d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=65e4dc52-05ff-4960-8206-bc64b88e345d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=65e4dc52-05ff-4960-8206-bc64b88e345d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=65e4dc52-05ff-4960-8206-bc64b88e345d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjVlNGRjNTItMDVmZi00OTYwLTgyMDYtYmM2NGI4OGUzNDVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjVlNGRjNTItMDVmZi00OTYwLTgyMDYtYmM2NGI4OGUzNDVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:65e4dc52-05ff-4960-8206-bc64b88e345d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "65e4dc52-05ff-4960-8206-bc64b88e345d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2162234@Y=41379377@L=%23mcp%3AV%3Adonkey-barcelona%3A65e4dc52-05ff-4960-8206-bc64b88e345d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A65e4dc52-05ff-4960-8206-bc64b88e345d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.162234,
                    "lat": 41.379377
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bd857257-99a0-4e48-9e45-fdb397184f00",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bd857257-99a0-4e48-9e45-fdb397184f00"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bd857257-99a0-4e48-9e45-fdb397184f00",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bd857257-99a0-4e48-9e45-fdb397184f00"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmQ4NTcyNTctOTlhMC00ZTQ4LTllNDUtZmRiMzk3MTg0ZjAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmQ4NTcyNTctOTlhMC00ZTQ4LTllNDUtZmRiMzk3MTg0ZjAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:bd857257-99a0-4e48-9e45-fdb397184f00_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "bd857257-99a0-4e48-9e45-fdb397184f00",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2162230@Y=41379380@L=%23mcp%3AV%3Adonkey-barcelona%3Abd857257-99a0-4e48-9e45-fdb397184f00_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Abd857257-99a0-4e48-9e45-fdb397184f00_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.16223,
                    "lat": 41.37938
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2856a42b-c00e-4bba-a0e1-99c8f0314475",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2856a42b-c00e-4bba-a0e1-99c8f0314475"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2856a42b-c00e-4bba-a0e1-99c8f0314475",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2856a42b-c00e-4bba-a0e1-99c8f0314475"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjg1NmE0MmItYzAwZS00YmJhLWEwZTEtOTljOGYwMzE0NDc1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjg1NmE0MmItYzAwZS00YmJhLWEwZTEtOTljOGYwMzE0NDc1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2856a42b-c00e-4bba-a0e1-99c8f0314475_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2856a42b-c00e-4bba-a0e1-99c8f0314475",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168245@Y=41379420@L=%23mcp%3AV%3Adonkey-barcelona%3A2856a42b-c00e-4bba-a0e1-99c8f0314475_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2856a42b-c00e-4bba-a0e1-99c8f0314475_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.168245,
                    "lat": 41.37942
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4538e8a7-210e-40e4-94dd-1d792eaad0df",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4538e8a7-210e-40e4-94dd-1d792eaad0df"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4538e8a7-210e-40e4-94dd-1d792eaad0df",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4538e8a7-210e-40e4-94dd-1d792eaad0df"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDUzOGU4YTctMjEwZS00MGU0LTk0ZGQtMWQ3OTJlYWFkMGRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDUzOGU4YTctMjEwZS00MGU0LTk0ZGQtMWQ3OTJlYWFkMGRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4538e8a7-210e-40e4-94dd-1d792eaad0df_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4538e8a7-210e-40e4-94dd-1d792eaad0df",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2159914@Y=41379489@L=%23mcp%3AV%3Adonkey-barcelona%3A4538e8a7-210e-40e4-94dd-1d792eaad0df_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4538e8a7-210e-40e4-94dd-1d792eaad0df_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.159914,
                    "lat": 41.379489
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=96006166-f8df-46d7-9f37-7caf246ca62c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=96006166-f8df-46d7-9f37-7caf246ca62c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=96006166-f8df-46d7-9f37-7caf246ca62c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=96006166-f8df-46d7-9f37-7caf246ca62c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTYwMDYxNjYtZjhkZi00NmQ3LTlmMzctN2NhZjI0NmNhNjJjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTYwMDYxNjYtZjhkZi00NmQ3LTlmMzctN2NhZjI0NmNhNjJjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:96006166-f8df-46d7-9f37-7caf246ca62c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "96006166-f8df-46d7-9f37-7caf246ca62c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2159814@Y=41379547@L=%23mcp%3AV%3Adonkey-barcelona%3A96006166-f8df-46d7-9f37-7caf246ca62c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A96006166-f8df-46d7-9f37-7caf246ca62c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.159814,
                    "lat": 41.379547
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8578da18-23d5-4330-9ba7-dbc7835910e7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8578da18-23d5-4330-9ba7-dbc7835910e7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8578da18-23d5-4330-9ba7-dbc7835910e7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8578da18-23d5-4330-9ba7-dbc7835910e7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODU3OGRhMTgtMjNkNS00MzMwLTliYTctZGJjNzgzNTkxMGU3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODU3OGRhMTgtMjNkNS00MzMwLTliYTctZGJjNzgzNTkxMGU3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8578da18-23d5-4330-9ba7-dbc7835910e7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8578da18-23d5-4330-9ba7-dbc7835910e7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2159733@Y=41379555@L=%23mcp%3AV%3Adonkey-barcelona%3A8578da18-23d5-4330-9ba7-dbc7835910e7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8578da18-23d5-4330-9ba7-dbc7835910e7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.159733,
                    "lat": 41.379555
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=66683d2d-55ea-461d-b48b-4fce016004df",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=66683d2d-55ea-461d-b48b-4fce016004df"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=66683d2d-55ea-461d-b48b-4fce016004df",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=66683d2d-55ea-461d-b48b-4fce016004df"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjY2ODNkMmQtNTVlYS00NjFkLWI0OGItNGZjZTAxNjAwNGRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjY2ODNkMmQtNTVlYS00NjFkLWI0OGItNGZjZTAxNjAwNGRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:66683d2d-55ea-461d-b48b-4fce016004df_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "66683d2d-55ea-461d-b48b-4fce016004df",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168624@Y=41379632@L=%23mcp%3AV%3Adonkey-barcelona%3A66683d2d-55ea-461d-b48b-4fce016004df_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A66683d2d-55ea-461d-b48b-4fce016004df_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.168624,
                    "lat": 41.379632
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cbad36d8-0b14-46b4-9c02-0ff90caabf2c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cbad36d8-0b14-46b4-9c02-0ff90caabf2c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cbad36d8-0b14-46b4-9c02-0ff90caabf2c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cbad36d8-0b14-46b4-9c02-0ff90caabf2c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2JhZDM2ZDgtMGIxNC00NmI0LTljMDItMGZmOTBjYWFiZjJjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2JhZDM2ZDgtMGIxNC00NmI0LTljMDItMGZmOTBjYWFiZjJjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cbad36d8-0b14-46b4-9c02-0ff90caabf2c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cbad36d8-0b14-46b4-9c02-0ff90caabf2c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168492@Y=41379644@L=%23mcp%3AV%3Adonkey-barcelona%3Acbad36d8-0b14-46b4-9c02-0ff90caabf2c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acbad36d8-0b14-46b4-9c02-0ff90caabf2c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.168492,
                    "lat": 41.379644
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=96c35ec8-7dba-4566-9ae6-d9f2667b651b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=96c35ec8-7dba-4566-9ae6-d9f2667b651b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=96c35ec8-7dba-4566-9ae6-d9f2667b651b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=96c35ec8-7dba-4566-9ae6-d9f2667b651b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTZjMzVlYzgtN2RiYS00NTY2LTlhZTYtZDlmMjY2N2I2NTFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTZjMzVlYzgtN2RiYS00NTY2LTlhZTYtZDlmMjY2N2I2NTFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:96c35ec8-7dba-4566-9ae6-d9f2667b651b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "96c35ec8-7dba-4566-9ae6-d9f2667b651b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168590@Y=41379646@L=%23mcp%3AV%3Adonkey-barcelona%3A96c35ec8-7dba-4566-9ae6-d9f2667b651b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A96c35ec8-7dba-4566-9ae6-d9f2667b651b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.16859,
                    "lat": 41.379646
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5259182c-d2e6-4737-b60b-e551bd200259",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5259182c-d2e6-4737-b60b-e551bd200259"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5259182c-d2e6-4737-b60b-e551bd200259",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5259182c-d2e6-4737-b60b-e551bd200259"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTI1OTE4MmMtZDJlNi00NzM3LWI2MGItZTU1MWJkMjAwMjU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTI1OTE4MmMtZDJlNi00NzM3LWI2MGItZTU1MWJkMjAwMjU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5259182c-d2e6-4737-b60b-e551bd200259_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5259182c-d2e6-4737-b60b-e551bd200259",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2159281@Y=41379732@L=%23mcp%3AV%3Adonkey-barcelona%3A5259182c-d2e6-4737-b60b-e551bd200259_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5259182c-d2e6-4737-b60b-e551bd200259_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.159281,
                    "lat": 41.379732
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0e406db4-fe3e-4316-93ab-f7fc8c569e83",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0e406db4-fe3e-4316-93ab-f7fc8c569e83"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0e406db4-fe3e-4316-93ab-f7fc8c569e83",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0e406db4-fe3e-4316-93ab-f7fc8c569e83"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGU0MDZkYjQtZmUzZS00MzE2LTkzYWItZjdmYzhjNTY5ZTgzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGU0MDZkYjQtZmUzZS00MzE2LTkzYWItZjdmYzhjNTY5ZTgzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0e406db4-fe3e-4316-93ab-f7fc8c569e83_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0e406db4-fe3e-4316-93ab-f7fc8c569e83",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2175288@Y=41379835@L=%23mcp%3AV%3Adonkey-barcelona%3A0e406db4-fe3e-4316-93ab-f7fc8c569e83_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0e406db4-fe3e-4316-93ab-f7fc8c569e83_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.175288,
                    "lat": 41.379835
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ecd4b633-5ae0-443c-a8be-7100b510bc32",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ecd4b633-5ae0-443c-a8be-7100b510bc32"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ecd4b633-5ae0-443c-a8be-7100b510bc32",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ecd4b633-5ae0-443c-a8be-7100b510bc32"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWNkNGI2MzMtNWFlMC00NDNjLWE4YmUtNzEwMGI1MTBiYzMyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWNkNGI2MzMtNWFlMC00NDNjLWE4YmUtNzEwMGI1MTBiYzMyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ecd4b633-5ae0-443c-a8be-7100b510bc32_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ecd4b633-5ae0-443c-a8be-7100b510bc32",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2192817@Y=41379921@L=%23mcp%3AV%3Adonkey-barcelona%3Aecd4b633-5ae0-443c-a8be-7100b510bc32_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aecd4b633-5ae0-443c-a8be-7100b510bc32_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.192817,
                    "lat": 41.379921
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3dade090-6701-458a-ac81-46245d70d6ce",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3dade090-6701-458a-ac81-46245d70d6ce"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3dade090-6701-458a-ac81-46245d70d6ce",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3dade090-6701-458a-ac81-46245d70d6ce"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2RhZGUwOTAtNjcwMS00NThhLWFjODEtNDYyNDVkNzBkNmNlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2RhZGUwOTAtNjcwMS00NThhLWFjODEtNDYyNDVkNzBkNmNlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3dade090-6701-458a-ac81-46245d70d6ce_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3dade090-6701-458a-ac81-46245d70d6ce",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2178702@Y=41380072@L=%23mcp%3AV%3Adonkey-barcelona%3A3dade090-6701-458a-ac81-46245d70d6ce_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3dade090-6701-458a-ac81-46245d70d6ce_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.178702,
                    "lat": 41.380072
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3f75cd78-0226-498f-97f8-8542e8cd7fb3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3f75cd78-0226-498f-97f8-8542e8cd7fb3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3f75cd78-0226-498f-97f8-8542e8cd7fb3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3f75cd78-0226-498f-97f8-8542e8cd7fb3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2Y3NWNkNzgtMDIyNi00OThmLTk3ZjgtODU0MmU4Y2Q3ZmIzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2Y3NWNkNzgtMDIyNi00OThmLTk3ZjgtODU0MmU4Y2Q3ZmIzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3f75cd78-0226-498f-97f8-8542e8cd7fb3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3f75cd78-0226-498f-97f8-8542e8cd7fb3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171022@Y=41380280@L=%23mcp%3AV%3Adonkey-barcelona%3A3f75cd78-0226-498f-97f8-8542e8cd7fb3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3f75cd78-0226-498f-97f8-8542e8cd7fb3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171022,
                    "lat": 41.38028
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fad20777-fa9b-4c28-bc15-c1cb103c09f3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fad20777-fa9b-4c28-bc15-c1cb103c09f3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fad20777-fa9b-4c28-bc15-c1cb103c09f3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fad20777-fa9b-4c28-bc15-c1cb103c09f3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmFkMjA3NzctZmE5Yi00YzI4LWJjMTUtYzFjYjEwM2MwOWYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmFkMjA3NzctZmE5Yi00YzI4LWJjMTUtYzFjYjEwM2MwOWYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:fad20777-fa9b-4c28-bc15-c1cb103c09f3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "fad20777-fa9b-4c28-bc15-c1cb103c09f3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171051@Y=41380323@L=%23mcp%3AV%3Adonkey-barcelona%3Afad20777-fa9b-4c28-bc15-c1cb103c09f3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Afad20777-fa9b-4c28-bc15-c1cb103c09f3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171051,
                    "lat": 41.380323
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4b6569df-66bd-4c37-b2aa-d2e74a565add",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4b6569df-66bd-4c37-b2aa-d2e74a565add"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4b6569df-66bd-4c37-b2aa-d2e74a565add",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4b6569df-66bd-4c37-b2aa-d2e74a565add"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGI2NTY5ZGYtNjZiZC00YzM3LWIyYWEtZDJlNzRhNTY1YWRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGI2NTY5ZGYtNjZiZC00YzM3LWIyYWEtZDJlNzRhNTY1YWRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4b6569df-66bd-4c37-b2aa-d2e74a565add_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4b6569df-66bd-4c37-b2aa-d2e74a565add",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171001@Y=41380403@L=%23mcp%3AV%3Adonkey-barcelona%3A4b6569df-66bd-4c37-b2aa-d2e74a565add_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4b6569df-66bd-4c37-b2aa-d2e74a565add_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171001,
                    "lat": 41.380403
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b3101d7f-0c6f-4de2-b930-1da4f5afc6c4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b3101d7f-0c6f-4de2-b930-1da4f5afc6c4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b3101d7f-0c6f-4de2-b930-1da4f5afc6c4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b3101d7f-0c6f-4de2-b930-1da4f5afc6c4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjMxMDFkN2YtMGM2Zi00ZGUyLWI5MzAtMWRhNGY1YWZjNmM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjMxMDFkN2YtMGM2Zi00ZGUyLWI5MzAtMWRhNGY1YWZjNmM0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b3101d7f-0c6f-4de2-b930-1da4f5afc6c4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b3101d7f-0c6f-4de2-b930-1da4f5afc6c4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2164368@Y=41380454@L=%23mcp%3AV%3Adonkey-barcelona%3Ab3101d7f-0c6f-4de2-b930-1da4f5afc6c4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab3101d7f-0c6f-4de2-b930-1da4f5afc6c4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.164368,
                    "lat": 41.380454
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b0551e68-c02f-40e7-817d-9eb8059d66cd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b0551e68-c02f-40e7-817d-9eb8059d66cd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b0551e68-c02f-40e7-817d-9eb8059d66cd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b0551e68-c02f-40e7-817d-9eb8059d66cd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjA1NTFlNjgtYzAyZi00MGU3LTgxN2QtOWViODA1OWQ2NmNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjA1NTFlNjgtYzAyZi00MGU3LTgxN2QtOWViODA1OWQ2NmNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b0551e68-c02f-40e7-817d-9eb8059d66cd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b0551e68-c02f-40e7-817d-9eb8059d66cd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2177473@Y=41380561@L=%23mcp%3AV%3Adonkey-barcelona%3Ab0551e68-c02f-40e7-817d-9eb8059d66cd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab0551e68-c02f-40e7-817d-9eb8059d66cd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.177473,
                    "lat": 41.380561
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4ec8e824-44c2-4c4f-a3d0-b5eb771b5d96",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4ec8e824-44c2-4c4f-a3d0-b5eb771b5d96"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4ec8e824-44c2-4c4f-a3d0-b5eb771b5d96",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4ec8e824-44c2-4c4f-a3d0-b5eb771b5d96"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGVjOGU4MjQtNDRjMi00YzRmLWEzZDAtYjVlYjc3MWI1ZDk2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGVjOGU4MjQtNDRjMi00YzRmLWEzZDAtYjVlYjc3MWI1ZDk2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4ec8e824-44c2-4c4f-a3d0-b5eb771b5d96_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4ec8e824-44c2-4c4f-a3d0-b5eb771b5d96",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2177506@Y=41380590@L=%23mcp%3AV%3Adonkey-barcelona%3A4ec8e824-44c2-4c4f-a3d0-b5eb771b5d96_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4ec8e824-44c2-4c4f-a3d0-b5eb771b5d96_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.177506,
                    "lat": 41.38059
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ac7344b1-cc20-4419-ab9b-2be29b6288d7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ac7344b1-cc20-4419-ab9b-2be29b6288d7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ac7344b1-cc20-4419-ab9b-2be29b6288d7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ac7344b1-cc20-4419-ab9b-2be29b6288d7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWM3MzQ0YjEtY2MyMC00NDE5LWFiOWItMmJlMjliNjI4OGQ3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWM3MzQ0YjEtY2MyMC00NDE5LWFiOWItMmJlMjliNjI4OGQ3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ac7344b1-cc20-4419-ab9b-2be29b6288d7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ac7344b1-cc20-4419-ab9b-2be29b6288d7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170767@Y=41380692@L=%23mcp%3AV%3Adonkey-barcelona%3Aac7344b1-cc20-4419-ab9b-2be29b6288d7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aac7344b1-cc20-4419-ab9b-2be29b6288d7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.170767,
                    "lat": 41.380692
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a24d3f87-4fc5-45d5-87e9-a02d27f0f838",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a24d3f87-4fc5-45d5-87e9-a02d27f0f838"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a24d3f87-4fc5-45d5-87e9-a02d27f0f838",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a24d3f87-4fc5-45d5-87e9-a02d27f0f838"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTI0ZDNmODctNGZjNS00NWQ1LTg3ZTktYTAyZDI3ZjBmODM4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTI0ZDNmODctNGZjNS00NWQ1LTg3ZTktYTAyZDI3ZjBmODM4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a24d3f87-4fc5-45d5-87e9-a02d27f0f838_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a24d3f87-4fc5-45d5-87e9-a02d27f0f838",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170800@Y=41380707@L=%23mcp%3AV%3Adonkey-barcelona%3Aa24d3f87-4fc5-45d5-87e9-a02d27f0f838_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa24d3f87-4fc5-45d5-87e9-a02d27f0f838_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.1708,
                    "lat": 41.380707
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fa463bce-914c-4d6f-b6e3-87a4d6e801dd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fa463bce-914c-4d6f-b6e3-87a4d6e801dd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fa463bce-914c-4d6f-b6e3-87a4d6e801dd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fa463bce-914c-4d6f-b6e3-87a4d6e801dd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmE0NjNiY2UtOTE0Yy00ZDZmLWI2ZTMtODdhNGQ2ZTgwMWRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmE0NjNiY2UtOTE0Yy00ZDZmLWI2ZTMtODdhNGQ2ZTgwMWRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:fa463bce-914c-4d6f-b6e3-87a4d6e801dd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "fa463bce-914c-4d6f-b6e3-87a4d6e801dd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171707@Y=41380837@L=%23mcp%3AV%3Adonkey-barcelona%3Afa463bce-914c-4d6f-b6e3-87a4d6e801dd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Afa463bce-914c-4d6f-b6e3-87a4d6e801dd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171707,
                    "lat": 41.380837
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1fc38f11-1b7f-42ea-a782-6d21ad07e31b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1fc38f11-1b7f-42ea-a782-6d21ad07e31b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1fc38f11-1b7f-42ea-a782-6d21ad07e31b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1fc38f11-1b7f-42ea-a782-6d21ad07e31b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWZjMzhmMTEtMWI3Zi00MmVhLWE3ODItNmQyMWFkMDdlMzFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWZjMzhmMTEtMWI3Zi00MmVhLWE3ODItNmQyMWFkMDdlMzFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1fc38f11-1b7f-42ea-a782-6d21ad07e31b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1fc38f11-1b7f-42ea-a782-6d21ad07e31b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171745@Y=41380844@L=%23mcp%3AV%3Adonkey-barcelona%3A1fc38f11-1b7f-42ea-a782-6d21ad07e31b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1fc38f11-1b7f-42ea-a782-6d21ad07e31b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171745,
                    "lat": 41.380844
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9b8dd0d6-2433-4fbd-be36-d25ac48a4e5a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9b8dd0d6-2433-4fbd-be36-d25ac48a4e5a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9b8dd0d6-2433-4fbd-be36-d25ac48a4e5a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9b8dd0d6-2433-4fbd-be36-d25ac48a4e5a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWI4ZGQwZDYtMjQzMy00ZmJkLWJlMzYtZDI1YWM0OGE0ZTVhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWI4ZGQwZDYtMjQzMy00ZmJkLWJlMzYtZDI1YWM0OGE0ZTVhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9b8dd0d6-2433-4fbd-be36-d25ac48a4e5a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9b8dd0d6-2433-4fbd-be36-d25ac48a4e5a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170892@Y=41380852@L=%23mcp%3AV%3Adonkey-barcelona%3A9b8dd0d6-2433-4fbd-be36-d25ac48a4e5a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9b8dd0d6-2433-4fbd-be36-d25ac48a4e5a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.170892,
                    "lat": 41.380852
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8146ef46-794f-45ca-969f-963fd5900bdf",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8146ef46-794f-45ca-969f-963fd5900bdf"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8146ef46-794f-45ca-969f-963fd5900bdf",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8146ef46-794f-45ca-969f-963fd5900bdf"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODE0NmVmNDYtNzk0Zi00NWNhLTk2OWYtOTYzZmQ1OTAwYmRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODE0NmVmNDYtNzk0Zi00NWNhLTk2OWYtOTYzZmQ1OTAwYmRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8146ef46-794f-45ca-969f-963fd5900bdf_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8146ef46-794f-45ca-969f-963fd5900bdf",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2118839@Y=41381110@L=%23mcp%3AV%3Adonkey-barcelona%3A8146ef46-794f-45ca-969f-963fd5900bdf_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8146ef46-794f-45ca-969f-963fd5900bdf_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.118839,
                    "lat": 41.38111
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4b3a5fa8-0330-45c0-91db-8bd30fe8bcf2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4b3a5fa8-0330-45c0-91db-8bd30fe8bcf2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4b3a5fa8-0330-45c0-91db-8bd30fe8bcf2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4b3a5fa8-0330-45c0-91db-8bd30fe8bcf2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGIzYTVmYTgtMDMzMC00NWMwLTkxZGItOGJkMzBmZThiY2YyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGIzYTVmYTgtMDMzMC00NWMwLTkxZGItOGJkMzBmZThiY2YyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4b3a5fa8-0330-45c0-91db-8bd30fe8bcf2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4b3a5fa8-0330-45c0-91db-8bd30fe8bcf2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2159603@Y=41381113@L=%23mcp%3AV%3Adonkey-barcelona%3A4b3a5fa8-0330-45c0-91db-8bd30fe8bcf2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4b3a5fa8-0330-45c0-91db-8bd30fe8bcf2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.159603,
                    "lat": 41.381113
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6b18fb10-a2ed-4c32-b6f8-f80fb1bdd1bf",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6b18fb10-a2ed-4c32-b6f8-f80fb1bdd1bf"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6b18fb10-a2ed-4c32-b6f8-f80fb1bdd1bf",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6b18fb10-a2ed-4c32-b6f8-f80fb1bdd1bf"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmIxOGZiMTAtYTJlZC00YzMyLWI2ZjgtZjgwZmIxYmRkMWJmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmIxOGZiMTAtYTJlZC00YzMyLWI2ZjgtZjgwZmIxYmRkMWJmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6b18fb10-a2ed-4c32-b6f8-f80fb1bdd1bf_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6b18fb10-a2ed-4c32-b6f8-f80fb1bdd1bf",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2152528@Y=41381205@L=%23mcp%3AV%3Adonkey-barcelona%3A6b18fb10-a2ed-4c32-b6f8-f80fb1bdd1bf_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6b18fb10-a2ed-4c32-b6f8-f80fb1bdd1bf_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.152528,
                    "lat": 41.381205
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8acfce34-cda9-4724-ac7e-8c0f3f6b8f1a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8acfce34-cda9-4724-ac7e-8c0f3f6b8f1a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8acfce34-cda9-4724-ac7e-8c0f3f6b8f1a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8acfce34-cda9-4724-ac7e-8c0f3f6b8f1a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGFjZmNlMzQtY2RhOS00NzI0LWFjN2UtOGMwZjNmNmI4ZjFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGFjZmNlMzQtY2RhOS00NzI0LWFjN2UtOGMwZjNmNmI4ZjFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8acfce34-cda9-4724-ac7e-8c0f3f6b8f1a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8acfce34-cda9-4724-ac7e-8c0f3f6b8f1a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2150805@Y=41381249@L=%23mcp%3AV%3Adonkey-barcelona%3A8acfce34-cda9-4724-ac7e-8c0f3f6b8f1a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8acfce34-cda9-4724-ac7e-8c0f3f6b8f1a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.150805,
                    "lat": 41.381249
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=aa3dc0c7-a11f-4fcd-9f2a-2fdd612a08ec",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=aa3dc0c7-a11f-4fcd-9f2a-2fdd612a08ec"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=aa3dc0c7-a11f-4fcd-9f2a-2fdd612a08ec",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=aa3dc0c7-a11f-4fcd-9f2a-2fdd612a08ec"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWEzZGMwYzctYTExZi00ZmNkLTlmMmEtMmZkZDYxMmEwOGVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWEzZGMwYzctYTExZi00ZmNkLTlmMmEtMmZkZDYxMmEwOGVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:aa3dc0c7-a11f-4fcd-9f2a-2fdd612a08ec_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "aa3dc0c7-a11f-4fcd-9f2a-2fdd612a08ec",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2126301@Y=41381296@L=%23mcp%3AV%3Adonkey-barcelona%3Aaa3dc0c7-a11f-4fcd-9f2a-2fdd612a08ec_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aaa3dc0c7-a11f-4fcd-9f2a-2fdd612a08ec_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.126301,
                    "lat": 41.381296
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=97acb35c-1c6d-4c25-92d4-dee050586852",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=97acb35c-1c6d-4c25-92d4-dee050586852"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=97acb35c-1c6d-4c25-92d4-dee050586852",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=97acb35c-1c6d-4c25-92d4-dee050586852"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTdhY2IzNWMtMWM2ZC00YzI1LTkyZDQtZGVlMDUwNTg2ODUyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTdhY2IzNWMtMWM2ZC00YzI1LTkyZDQtZGVlMDUwNTg2ODUyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:97acb35c-1c6d-4c25-92d4-dee050586852_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "97acb35c-1c6d-4c25-92d4-dee050586852",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2167199@Y=41381307@L=%23mcp%3AV%3Adonkey-barcelona%3A97acb35c-1c6d-4c25-92d4-dee050586852_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A97acb35c-1c6d-4c25-92d4-dee050586852_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.167199,
                    "lat": 41.381307
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=27f4e1db-ea2b-4e30-8d26-2ec7c25baf94",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=27f4e1db-ea2b-4e30-8d26-2ec7c25baf94"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=27f4e1db-ea2b-4e30-8d26-2ec7c25baf94",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=27f4e1db-ea2b-4e30-8d26-2ec7c25baf94"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjdmNGUxZGItZWEyYi00ZTMwLThkMjYtMmVjN2MyNWJhZjk0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjdmNGUxZGItZWEyYi00ZTMwLThkMjYtMmVjN2MyNWJhZjk0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:27f4e1db-ea2b-4e30-8d26-2ec7c25baf94_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "27f4e1db-ea2b-4e30-8d26-2ec7c25baf94",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2126346@Y=41381335@L=%23mcp%3AV%3Adonkey-barcelona%3A27f4e1db-ea2b-4e30-8d26-2ec7c25baf94_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A27f4e1db-ea2b-4e30-8d26-2ec7c25baf94_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.126346,
                    "lat": 41.381335
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ce91eb84-255e-4bd0-a51a-7a4596f21307",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ce91eb84-255e-4bd0-a51a-7a4596f21307"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ce91eb84-255e-4bd0-a51a-7a4596f21307",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ce91eb84-255e-4bd0-a51a-7a4596f21307"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2U5MWViODQtMjU1ZS00YmQwLWE1MWEtN2E0NTk2ZjIxMzA3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2U5MWViODQtMjU1ZS00YmQwLWE1MWEtN2E0NTk2ZjIxMzA3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ce91eb84-255e-4bd0-a51a-7a4596f21307_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ce91eb84-255e-4bd0-a51a-7a4596f21307",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2126308@Y=41381339@L=%23mcp%3AV%3Adonkey-barcelona%3Ace91eb84-255e-4bd0-a51a-7a4596f21307_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ace91eb84-255e-4bd0-a51a-7a4596f21307_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.126308,
                    "lat": 41.381339
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a82c6180-320b-46fd-88e2-437c4cc4e888",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a82c6180-320b-46fd-88e2-437c4cc4e888"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a82c6180-320b-46fd-88e2-437c4cc4e888",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a82c6180-320b-46fd-88e2-437c4cc4e888"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTgyYzYxODAtMzIwYi00NmZkLTg4ZTItNDM3YzRjYzRlODg4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTgyYzYxODAtMzIwYi00NmZkLTg4ZTItNDM3YzRjYzRlODg4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a82c6180-320b-46fd-88e2-437c4cc4e888_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a82c6180-320b-46fd-88e2-437c4cc4e888",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168836@Y=41381504@L=%23mcp%3AV%3Adonkey-barcelona%3Aa82c6180-320b-46fd-88e2-437c4cc4e888_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa82c6180-320b-46fd-88e2-437c4cc4e888_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.168836,
                    "lat": 41.381504
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ef101f0f-1e97-4a4d-b937-e38942f41b49",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ef101f0f-1e97-4a4d-b937-e38942f41b49"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ef101f0f-1e97-4a4d-b937-e38942f41b49",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ef101f0f-1e97-4a4d-b937-e38942f41b49"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWYxMDFmMGYtMWU5Ny00YTRkLWI5MzctZTM4OTQyZjQxYjQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWYxMDFmMGYtMWU5Ny00YTRkLWI5MzctZTM4OTQyZjQxYjQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ef101f0f-1e97-4a4d-b937-e38942f41b49_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ef101f0f-1e97-4a4d-b937-e38942f41b49",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187741@Y=41381519@L=%23mcp%3AV%3Adonkey-barcelona%3Aef101f0f-1e97-4a4d-b937-e38942f41b49_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aef101f0f-1e97-4a4d-b937-e38942f41b49_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187741,
                    "lat": 41.381519
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a25e399b-fe59-4bd9-872d-6a2d0fd8680a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a25e399b-fe59-4bd9-872d-6a2d0fd8680a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a25e399b-fe59-4bd9-872d-6a2d0fd8680a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a25e399b-fe59-4bd9-872d-6a2d0fd8680a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTI1ZTM5OWItZmU1OS00YmQ5LTg3MmQtNmEyZDBmZDg2ODBhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTI1ZTM5OWItZmU1OS00YmQ5LTg3MmQtNmEyZDBmZDg2ODBhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a25e399b-fe59-4bd9-872d-6a2d0fd8680a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a25e399b-fe59-4bd9-872d-6a2d0fd8680a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187741@Y=41381519@L=%23mcp%3AV%3Adonkey-barcelona%3Aa25e399b-fe59-4bd9-872d-6a2d0fd8680a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa25e399b-fe59-4bd9-872d-6a2d0fd8680a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187741,
                    "lat": 41.381519
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cf389ce9-ddb5-4c19-b758-a9b67dd8e3d9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cf389ce9-ddb5-4c19-b758-a9b67dd8e3d9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cf389ce9-ddb5-4c19-b758-a9b67dd8e3d9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cf389ce9-ddb5-4c19-b758-a9b67dd8e3d9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2YzODljZTktZGRiNS00YzE5LWI3NTgtYTliNjdkZDhlM2Q5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2YzODljZTktZGRiNS00YzE5LWI3NTgtYTliNjdkZDhlM2Q5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cf389ce9-ddb5-4c19-b758-a9b67dd8e3d9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cf389ce9-ddb5-4c19-b758-a9b67dd8e3d9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2128028@Y=41381764@L=%23mcp%3AV%3Adonkey-barcelona%3Acf389ce9-ddb5-4c19-b758-a9b67dd8e3d9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acf389ce9-ddb5-4c19-b758-a9b67dd8e3d9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.128028,
                    "lat": 41.381764
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=af7f1517-0d12-4992-8c3b-efc30b1357d7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=af7f1517-0d12-4992-8c3b-efc30b1357d7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=af7f1517-0d12-4992-8c3b-efc30b1357d7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=af7f1517-0d12-4992-8c3b-efc30b1357d7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWY3ZjE1MTctMGQxMi00OTkyLThjM2ItZWZjMzBiMTM1N2Q3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWY3ZjE1MTctMGQxMi00OTkyLThjM2ItZWZjMzBiMTM1N2Q3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:af7f1517-0d12-4992-8c3b-efc30b1357d7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "af7f1517-0d12-4992-8c3b-efc30b1357d7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2174329@Y=41381799@L=%23mcp%3AV%3Adonkey-barcelona%3Aaf7f1517-0d12-4992-8c3b-efc30b1357d7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aaf7f1517-0d12-4992-8c3b-efc30b1357d7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.174329,
                    "lat": 41.381799
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f161b3f3-58a7-4654-b338-750813fd1003",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f161b3f3-58a7-4654-b338-750813fd1003"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f161b3f3-58a7-4654-b338-750813fd1003",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f161b3f3-58a7-4654-b338-750813fd1003"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjE2MWIzZjMtNThhNy00NjU0LWIzMzgtNzUwODEzZmQxMDAzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjE2MWIzZjMtNThhNy00NjU0LWIzMzgtNzUwODEzZmQxMDAzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f161b3f3-58a7-4654-b338-750813fd1003_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f161b3f3-58a7-4654-b338-750813fd1003",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2181763@Y=41381926@L=%23mcp%3AV%3Adonkey-barcelona%3Af161b3f3-58a7-4654-b338-750813fd1003_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af161b3f3-58a7-4654-b338-750813fd1003_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.181763,
                    "lat": 41.381926
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9c66f544-4e22-41b0-9e0f-2d6c4da78ecc",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9c66f544-4e22-41b0-9e0f-2d6c4da78ecc"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9c66f544-4e22-41b0-9e0f-2d6c4da78ecc",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9c66f544-4e22-41b0-9e0f-2d6c4da78ecc"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWM2NmY1NDQtNGUyMi00MWIwLTllMGYtMmQ2YzRkYTc4ZWNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWM2NmY1NDQtNGUyMi00MWIwLTllMGYtMmQ2YzRkYTc4ZWNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9c66f544-4e22-41b0-9e0f-2d6c4da78ecc_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9c66f544-4e22-41b0-9e0f-2d6c4da78ecc",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2135997@Y=41382031@L=%23mcp%3AV%3Adonkey-barcelona%3A9c66f544-4e22-41b0-9e0f-2d6c4da78ecc_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9c66f544-4e22-41b0-9e0f-2d6c4da78ecc_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.135997,
                    "lat": 41.382031
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=db753727-140c-4f84-aa55-6406afbe5aaf",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=db753727-140c-4f84-aa55-6406afbe5aaf"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=db753727-140c-4f84-aa55-6406afbe5aaf",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=db753727-140c-4f84-aa55-6406afbe5aaf"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGI3NTM3MjctMTQwYy00Zjg0LWFhNTUtNjQwNmFmYmU1YWFmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGI3NTM3MjctMTQwYy00Zjg0LWFhNTUtNjQwNmFmYmU1YWFmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:db753727-140c-4f84-aa55-6406afbe5aaf_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "db753727-140c-4f84-aa55-6406afbe5aaf",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2185459@Y=41382197@L=%23mcp%3AV%3Adonkey-barcelona%3Adb753727-140c-4f84-aa55-6406afbe5aaf_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Adb753727-140c-4f84-aa55-6406afbe5aaf_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.185459,
                    "lat": 41.382197
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b407acca-03c8-4ad6-9a33-b1a4ab1e5ec0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b407acca-03c8-4ad6-9a33-b1a4ab1e5ec0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b407acca-03c8-4ad6-9a33-b1a4ab1e5ec0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b407acca-03c8-4ad6-9a33-b1a4ab1e5ec0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjQwN2FjY2EtMDNjOC00YWQ2LTlhMzMtYjFhNGFiMWU1ZWMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjQwN2FjY2EtMDNjOC00YWQ2LTlhMzMtYjFhNGFiMWU1ZWMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b407acca-03c8-4ad6-9a33-b1a4ab1e5ec0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b407acca-03c8-4ad6-9a33-b1a4ab1e5ec0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2174347@Y=41382242@L=%23mcp%3AV%3Adonkey-barcelona%3Ab407acca-03c8-4ad6-9a33-b1a4ab1e5ec0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab407acca-03c8-4ad6-9a33-b1a4ab1e5ec0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.174347,
                    "lat": 41.382242
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b09a1bb0-534d-4615-a1c4-4be055326045",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b09a1bb0-534d-4615-a1c4-4be055326045"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b09a1bb0-534d-4615-a1c4-4be055326045",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b09a1bb0-534d-4615-a1c4-4be055326045"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjA5YTFiYjAtNTM0ZC00NjE1LWExYzQtNGJlMDU1MzI2MDQ1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjA5YTFiYjAtNTM0ZC00NjE1LWExYzQtNGJlMDU1MzI2MDQ1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b09a1bb0-534d-4615-a1c4-4be055326045_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b09a1bb0-534d-4615-a1c4-4be055326045",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2185525@Y=41382336@L=%23mcp%3AV%3Adonkey-barcelona%3Ab09a1bb0-534d-4615-a1c4-4be055326045_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab09a1bb0-534d-4615-a1c4-4be055326045_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.185525,
                    "lat": 41.382336
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a6aeb0b9-9c6a-4c0e-9458-70034a60edd2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a6aeb0b9-9c6a-4c0e-9458-70034a60edd2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a6aeb0b9-9c6a-4c0e-9458-70034a60edd2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a6aeb0b9-9c6a-4c0e-9458-70034a60edd2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTZhZWIwYjktOWM2YS00YzBlLTk0NTgtNzAwMzRhNjBlZGQyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTZhZWIwYjktOWM2YS00YzBlLTk0NTgtNzAwMzRhNjBlZGQyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a6aeb0b9-9c6a-4c0e-9458-70034a60edd2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a6aeb0b9-9c6a-4c0e-9458-70034a60edd2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2128377@Y=41382719@L=%23mcp%3AV%3Adonkey-barcelona%3Aa6aeb0b9-9c6a-4c0e-9458-70034a60edd2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa6aeb0b9-9c6a-4c0e-9458-70034a60edd2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.128377,
                    "lat": 41.382719
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=921da477-31a2-4695-aea9-4dfb6748423a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=921da477-31a2-4695-aea9-4dfb6748423a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=921da477-31a2-4695-aea9-4dfb6748423a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=921da477-31a2-4695-aea9-4dfb6748423a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTIxZGE0NzctMzFhMi00Njk1LWFlYTktNGRmYjY3NDg0MjNhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTIxZGE0NzctMzFhMi00Njk1LWFlYTktNGRmYjY3NDg0MjNhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:921da477-31a2-4695-aea9-4dfb6748423a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "921da477-31a2-4695-aea9-4dfb6748423a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2166356@Y=41382730@L=%23mcp%3AV%3Adonkey-barcelona%3A921da477-31a2-4695-aea9-4dfb6748423a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A921da477-31a2-4695-aea9-4dfb6748423a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.166356,
                    "lat": 41.38273
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a34fe41c-b7dc-45b8-b839-d7609f1ed7d4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a34fe41c-b7dc-45b8-b839-d7609f1ed7d4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a34fe41c-b7dc-45b8-b839-d7609f1ed7d4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a34fe41c-b7dc-45b8-b839-d7609f1ed7d4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTM0ZmU0MWMtYjdkYy00NWI4LWI4MzktZDc2MDlmMWVkN2Q0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTM0ZmU0MWMtYjdkYy00NWI4LWI4MzktZDc2MDlmMWVkN2Q0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a34fe41c-b7dc-45b8-b839-d7609f1ed7d4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a34fe41c-b7dc-45b8-b839-d7609f1ed7d4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2175391@Y=41382761@L=%23mcp%3AV%3Adonkey-barcelona%3Aa34fe41c-b7dc-45b8-b839-d7609f1ed7d4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa34fe41c-b7dc-45b8-b839-d7609f1ed7d4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.175391,
                    "lat": 41.382761
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e0cdc492-98e3-4085-8fd7-bbe0ca772ba8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e0cdc492-98e3-4085-8fd7-bbe0ca772ba8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e0cdc492-98e3-4085-8fd7-bbe0ca772ba8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e0cdc492-98e3-4085-8fd7-bbe0ca772ba8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTBjZGM0OTItOThlMy00MDg1LThmZDctYmJlMGNhNzcyYmE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTBjZGM0OTItOThlMy00MDg1LThmZDctYmJlMGNhNzcyYmE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e0cdc492-98e3-4085-8fd7-bbe0ca772ba8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e0cdc492-98e3-4085-8fd7-bbe0ca772ba8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2175500@Y=41382841@L=%23mcp%3AV%3Adonkey-barcelona%3Ae0cdc492-98e3-4085-8fd7-bbe0ca772ba8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae0cdc492-98e3-4085-8fd7-bbe0ca772ba8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.1755,
                    "lat": 41.382841
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=16d94591-9bba-48f1-85d3-28f94153ae23",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=16d94591-9bba-48f1-85d3-28f94153ae23"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=16d94591-9bba-48f1-85d3-28f94153ae23",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=16d94591-9bba-48f1-85d3-28f94153ae23"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTZkOTQ1OTEtOWJiYS00OGYxLTg1ZDMtMjhmOTQxNTNhZTIzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTZkOTQ1OTEtOWJiYS00OGYxLTg1ZDMtMjhmOTQxNTNhZTIzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:16d94591-9bba-48f1-85d3-28f94153ae23_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "16d94591-9bba-48f1-85d3-28f94153ae23",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2148094@Y=41382890@L=%23mcp%3AV%3Adonkey-barcelona%3A16d94591-9bba-48f1-85d3-28f94153ae23_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A16d94591-9bba-48f1-85d3-28f94153ae23_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.148094,
                    "lat": 41.38289
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c4c9e0ed-479f-471a-9b8b-cce65232477b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c4c9e0ed-479f-471a-9b8b-cce65232477b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c4c9e0ed-479f-471a-9b8b-cce65232477b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c4c9e0ed-479f-471a-9b8b-cce65232477b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzRjOWUwZWQtNDc5Zi00NzFhLTliOGItY2NlNjUyMzI0NzdiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzRjOWUwZWQtNDc5Zi00NzFhLTliOGItY2NlNjUyMzI0NzdiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c4c9e0ed-479f-471a-9b8b-cce65232477b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c4c9e0ed-479f-471a-9b8b-cce65232477b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187881@Y=41382911@L=%23mcp%3AV%3Adonkey-barcelona%3Ac4c9e0ed-479f-471a-9b8b-cce65232477b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac4c9e0ed-479f-471a-9b8b-cce65232477b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187881,
                    "lat": 41.382911
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cef4f3cb-b53f-492b-bd15-7b0dfd3cc083",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cef4f3cb-b53f-492b-bd15-7b0dfd3cc083"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cef4f3cb-b53f-492b-bd15-7b0dfd3cc083",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cef4f3cb-b53f-492b-bd15-7b0dfd3cc083"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2VmNGYzY2ItYjUzZi00OTJiLWJkMTUtN2IwZGZkM2NjMDgzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2VmNGYzY2ItYjUzZi00OTJiLWJkMTUtN2IwZGZkM2NjMDgzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cef4f3cb-b53f-492b-bd15-7b0dfd3cc083_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cef4f3cb-b53f-492b-bd15-7b0dfd3cc083",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2175648@Y=41382971@L=%23mcp%3AV%3Adonkey-barcelona%3Acef4f3cb-b53f-492b-bd15-7b0dfd3cc083_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acef4f3cb-b53f-492b-bd15-7b0dfd3cc083_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.175648,
                    "lat": 41.382971
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f2611823-a5d8-4089-ba2a-f9820696ac0f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f2611823-a5d8-4089-ba2a-f9820696ac0f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f2611823-a5d8-4089-ba2a-f9820696ac0f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f2611823-a5d8-4089-ba2a-f9820696ac0f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjI2MTE4MjMtYTVkOC00MDg5LWJhMmEtZjk4MjA2OTZhYzBmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjI2MTE4MjMtYTVkOC00MDg5LWJhMmEtZjk4MjA2OTZhYzBmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f2611823-a5d8-4089-ba2a-f9820696ac0f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f2611823-a5d8-4089-ba2a-f9820696ac0f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2183514@Y=41383165@L=%23mcp%3AV%3Adonkey-barcelona%3Af2611823-a5d8-4089-ba2a-f9820696ac0f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af2611823-a5d8-4089-ba2a-f9820696ac0f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.183514,
                    "lat": 41.383165
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=49a9d96a-6cf1-4599-afcb-60d8e48ecabd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=49a9d96a-6cf1-4599-afcb-60d8e48ecabd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=49a9d96a-6cf1-4599-afcb-60d8e48ecabd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=49a9d96a-6cf1-4599-afcb-60d8e48ecabd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDlhOWQ5NmEtNmNmMS00NTk5LWFmY2ItNjBkOGU0OGVjYWJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDlhOWQ5NmEtNmNmMS00NTk5LWFmY2ItNjBkOGU0OGVjYWJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:49a9d96a-6cf1-4599-afcb-60d8e48ecabd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "49a9d96a-6cf1-4599-afcb-60d8e48ecabd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2167546@Y=41383277@L=%23mcp%3AV%3Adonkey-barcelona%3A49a9d96a-6cf1-4599-afcb-60d8e48ecabd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A49a9d96a-6cf1-4599-afcb-60d8e48ecabd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.167546,
                    "lat": 41.383277
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d51dbe04-ee0f-4291-893a-d4378dd21bd9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d51dbe04-ee0f-4291-893a-d4378dd21bd9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d51dbe04-ee0f-4291-893a-d4378dd21bd9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d51dbe04-ee0f-4291-893a-d4378dd21bd9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDUxZGJlMDQtZWUwZi00MjkxLTg5M2EtZDQzNzhkZDIxYmQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDUxZGJlMDQtZWUwZi00MjkxLTg5M2EtZDQzNzhkZDIxYmQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d51dbe04-ee0f-4291-893a-d4378dd21bd9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d51dbe04-ee0f-4291-893a-d4378dd21bd9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2159945@Y=41383371@L=%23mcp%3AV%3Adonkey-barcelona%3Ad51dbe04-ee0f-4291-893a-d4378dd21bd9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad51dbe04-ee0f-4291-893a-d4378dd21bd9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.159945,
                    "lat": 41.383371
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0c129d2a-3af4-4925-b5bc-a90d00ddb604",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0c129d2a-3af4-4925-b5bc-a90d00ddb604"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0c129d2a-3af4-4925-b5bc-a90d00ddb604",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0c129d2a-3af4-4925-b5bc-a90d00ddb604"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGMxMjlkMmEtM2FmNC00OTI1LWI1YmMtYTkwZDAwZGRiNjA0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGMxMjlkMmEtM2FmNC00OTI1LWI1YmMtYTkwZDAwZGRiNjA0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0c129d2a-3af4-4925-b5bc-a90d00ddb604_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0c129d2a-3af4-4925-b5bc-a90d00ddb604",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2180345@Y=41383453@L=%23mcp%3AV%3Adonkey-barcelona%3A0c129d2a-3af4-4925-b5bc-a90d00ddb604_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0c129d2a-3af4-4925-b5bc-a90d00ddb604_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.180345,
                    "lat": 41.383453
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=59e5cb11-c35d-4b57-8108-d72255c381d0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=59e5cb11-c35d-4b57-8108-d72255c381d0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=59e5cb11-c35d-4b57-8108-d72255c381d0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=59e5cb11-c35d-4b57-8108-d72255c381d0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTllNWNiMTEtYzM1ZC00YjU3LTgxMDgtZDcyMjU1YzM4MWQwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTllNWNiMTEtYzM1ZC00YjU3LTgxMDgtZDcyMjU1YzM4MWQwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:59e5cb11-c35d-4b57-8108-d72255c381d0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "59e5cb11-c35d-4b57-8108-d72255c381d0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191681@Y=41383809@L=%23mcp%3AV%3Adonkey-barcelona%3A59e5cb11-c35d-4b57-8108-d72255c381d0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A59e5cb11-c35d-4b57-8108-d72255c381d0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191681,
                    "lat": 41.383809
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a1480738-fa3c-4631-bd1e-ad2e3710ed19",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a1480738-fa3c-4631-bd1e-ad2e3710ed19"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a1480738-fa3c-4631-bd1e-ad2e3710ed19",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a1480738-fa3c-4631-bd1e-ad2e3710ed19"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTE0ODA3MzgtZmEzYy00NjMxLWJkMWUtYWQyZTM3MTBlZDE5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTE0ODA3MzgtZmEzYy00NjMxLWJkMWUtYWQyZTM3MTBlZDE5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a1480738-fa3c-4631-bd1e-ad2e3710ed19_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a1480738-fa3c-4631-bd1e-ad2e3710ed19",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2160805@Y=41383897@L=%23mcp%3AV%3Adonkey-barcelona%3Aa1480738-fa3c-4631-bd1e-ad2e3710ed19_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa1480738-fa3c-4631-bd1e-ad2e3710ed19_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.160805,
                    "lat": 41.383897
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2e520f31-e8e2-4f2a-b4af-1b838e5caa07",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2e520f31-e8e2-4f2a-b4af-1b838e5caa07"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2e520f31-e8e2-4f2a-b4af-1b838e5caa07",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2e520f31-e8e2-4f2a-b4af-1b838e5caa07"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmU1MjBmMzEtZThlMi00ZjJhLWI0YWYtMWI4MzhlNWNhYTA3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmU1MjBmMzEtZThlMi00ZjJhLWI0YWYtMWI4MzhlNWNhYTA3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2e520f31-e8e2-4f2a-b4af-1b838e5caa07_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2e520f31-e8e2-4f2a-b4af-1b838e5caa07",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2149158@Y=41383945@L=%23mcp%3AV%3Adonkey-barcelona%3A2e520f31-e8e2-4f2a-b4af-1b838e5caa07_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2e520f31-e8e2-4f2a-b4af-1b838e5caa07_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.149158,
                    "lat": 41.383945
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=33de4a34-8d0f-4ee4-b147-26a97ab85124",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=33de4a34-8d0f-4ee4-b147-26a97ab85124"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=33de4a34-8d0f-4ee4-b147-26a97ab85124",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=33de4a34-8d0f-4ee4-b147-26a97ab85124"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzNkZTRhMzQtOGQwZi00ZWU0LWIxNDctMjZhOTdhYjg1MTI0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzNkZTRhMzQtOGQwZi00ZWU0LWIxNDctMjZhOTdhYjg1MTI0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:33de4a34-8d0f-4ee4-b147-26a97ab85124_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "33de4a34-8d0f-4ee4-b147-26a97ab85124",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2182617@Y=41384304@L=%23mcp%3AV%3Adonkey-barcelona%3A33de4a34-8d0f-4ee4-b147-26a97ab85124_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A33de4a34-8d0f-4ee4-b147-26a97ab85124_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.182617,
                    "lat": 41.384304
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6ba0249c-b914-4345-b870-003223cf0615",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6ba0249c-b914-4345-b870-003223cf0615"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6ba0249c-b914-4345-b870-003223cf0615",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6ba0249c-b914-4345-b870-003223cf0615"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmJhMDI0OWMtYjkxNC00MzQ1LWI4NzAtMDAzMjIzY2YwNjE1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmJhMDI0OWMtYjkxNC00MzQ1LWI4NzAtMDAzMjIzY2YwNjE1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6ba0249c-b914-4345-b870-003223cf0615_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6ba0249c-b914-4345-b870-003223cf0615",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2182617@Y=41384304@L=%23mcp%3AV%3Adonkey-barcelona%3A6ba0249c-b914-4345-b870-003223cf0615_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6ba0249c-b914-4345-b870-003223cf0615_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.182617,
                    "lat": 41.384304
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ff4b36e8-073d-4c9c-b1c4-e50195665e49",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ff4b36e8-073d-4c9c-b1c4-e50195665e49"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ff4b36e8-073d-4c9c-b1c4-e50195665e49",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ff4b36e8-073d-4c9c-b1c4-e50195665e49"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmY0YjM2ZTgtMDczZC00YzljLWIxYzQtZTUwMTk1NjY1ZTQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmY0YjM2ZTgtMDczZC00YzljLWIxYzQtZTUwMTk1NjY1ZTQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ff4b36e8-073d-4c9c-b1c4-e50195665e49_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ff4b36e8-073d-4c9c-b1c4-e50195665e49",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2166398@Y=41384365@L=%23mcp%3AV%3Adonkey-barcelona%3Aff4b36e8-073d-4c9c-b1c4-e50195665e49_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aff4b36e8-073d-4c9c-b1c4-e50195665e49_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.166398,
                    "lat": 41.384365
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fa3b31b0-d236-4959-ab6e-7621bfb7fb60",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fa3b31b0-d236-4959-ab6e-7621bfb7fb60"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fa3b31b0-d236-4959-ab6e-7621bfb7fb60",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fa3b31b0-d236-4959-ab6e-7621bfb7fb60"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmEzYjMxYjAtZDIzNi00OTU5LWFiNmUtNzYyMWJmYjdmYjYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmEzYjMxYjAtZDIzNi00OTU5LWFiNmUtNzYyMWJmYjdmYjYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:fa3b31b0-d236-4959-ab6e-7621bfb7fb60_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "fa3b31b0-d236-4959-ab6e-7621bfb7fb60",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171943@Y=41384456@L=%23mcp%3AV%3Adonkey-barcelona%3Afa3b31b0-d236-4959-ab6e-7621bfb7fb60_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Afa3b31b0-d236-4959-ab6e-7621bfb7fb60_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171943,
                    "lat": 41.384456
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e65a12cd-b92d-4273-97c2-b4bbeecc70ac",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e65a12cd-b92d-4273-97c2-b4bbeecc70ac"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e65a12cd-b92d-4273-97c2-b4bbeecc70ac",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e65a12cd-b92d-4273-97c2-b4bbeecc70ac"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTY1YTEyY2QtYjkyZC00MjczLTk3YzItYjRiYmVlY2M3MGFjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTY1YTEyY2QtYjkyZC00MjczLTk3YzItYjRiYmVlY2M3MGFjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e65a12cd-b92d-4273-97c2-b4bbeecc70ac_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e65a12cd-b92d-4273-97c2-b4bbeecc70ac",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171829@Y=41384459@L=%23mcp%3AV%3Adonkey-barcelona%3Ae65a12cd-b92d-4273-97c2-b4bbeecc70ac_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae65a12cd-b92d-4273-97c2-b4bbeecc70ac_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171829,
                    "lat": 41.384459
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=99bb1eec-6de2-4b1a-abb6-5207cedb5f24",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=99bb1eec-6de2-4b1a-abb6-5207cedb5f24"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=99bb1eec-6de2-4b1a-abb6-5207cedb5f24",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=99bb1eec-6de2-4b1a-abb6-5207cedb5f24"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTliYjFlZWMtNmRlMi00YjFhLWFiYjYtNTIwN2NlZGI1ZjI0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTliYjFlZWMtNmRlMi00YjFhLWFiYjYtNTIwN2NlZGI1ZjI0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:99bb1eec-6de2-4b1a-abb6-5207cedb5f24_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "99bb1eec-6de2-4b1a-abb6-5207cedb5f24",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2176038@Y=41384737@L=%23mcp%3AV%3Adonkey-barcelona%3A99bb1eec-6de2-4b1a-abb6-5207cedb5f24_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A99bb1eec-6de2-4b1a-abb6-5207cedb5f24_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.176038,
                    "lat": 41.384737
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a7bba04c-013f-4e89-a129-5956dea8e592",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a7bba04c-013f-4e89-a129-5956dea8e592"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a7bba04c-013f-4e89-a129-5956dea8e592",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a7bba04c-013f-4e89-a129-5956dea8e592"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTdiYmEwNGMtMDEzZi00ZTg5LWExMjktNTk1NmRlYThlNTkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTdiYmEwNGMtMDEzZi00ZTg5LWExMjktNTk1NmRlYThlNTkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a7bba04c-013f-4e89-a129-5956dea8e592_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a7bba04c-013f-4e89-a129-5956dea8e592",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2195899@Y=41384738@L=%23mcp%3AV%3Adonkey-barcelona%3Aa7bba04c-013f-4e89-a129-5956dea8e592_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa7bba04c-013f-4e89-a129-5956dea8e592_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.195899,
                    "lat": 41.384738
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d6bd89f7-804d-4358-9c74-432c14a3da53",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d6bd89f7-804d-4358-9c74-432c14a3da53"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d6bd89f7-804d-4358-9c74-432c14a3da53",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d6bd89f7-804d-4358-9c74-432c14a3da53"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDZiZDg5ZjctODA0ZC00MzU4LTljNzQtNDMyYzE0YTNkYTUzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDZiZDg5ZjctODA0ZC00MzU4LTljNzQtNDMyYzE0YTNkYTUzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d6bd89f7-804d-4358-9c74-432c14a3da53_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d6bd89f7-804d-4358-9c74-432c14a3da53",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2176245@Y=41384749@L=%23mcp%3AV%3Adonkey-barcelona%3Ad6bd89f7-804d-4358-9c74-432c14a3da53_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad6bd89f7-804d-4358-9c74-432c14a3da53_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.176245,
                    "lat": 41.384749
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=42ebf8a1-d72d-4e09-961f-b5da4c26e173",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=42ebf8a1-d72d-4e09-961f-b5da4c26e173"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=42ebf8a1-d72d-4e09-961f-b5da4c26e173",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=42ebf8a1-d72d-4e09-961f-b5da4c26e173"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDJlYmY4YTEtZDcyZC00ZTA5LTk2MWYtYjVkYTRjMjZlMTczIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDJlYmY4YTEtZDcyZC00ZTA5LTk2MWYtYjVkYTRjMjZlMTczIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:42ebf8a1-d72d-4e09-961f-b5da4c26e173_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "42ebf8a1-d72d-4e09-961f-b5da4c26e173",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2184913@Y=41384774@L=%23mcp%3AV%3Adonkey-barcelona%3A42ebf8a1-d72d-4e09-961f-b5da4c26e173_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A42ebf8a1-d72d-4e09-961f-b5da4c26e173_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.184913,
                    "lat": 41.384774
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=00597f02-f2b9-4365-867b-cdf2ed94088a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=00597f02-f2b9-4365-867b-cdf2ed94088a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=00597f02-f2b9-4365-867b-cdf2ed94088a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=00597f02-f2b9-4365-867b-cdf2ed94088a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDA1OTdmMDItZjJiOS00MzY1LTg2N2ItY2RmMmVkOTQwODhhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDA1OTdmMDItZjJiOS00MzY1LTg2N2ItY2RmMmVkOTQwODhhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:00597f02-f2b9-4365-867b-cdf2ed94088a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "00597f02-f2b9-4365-867b-cdf2ed94088a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2179756@Y=41384798@L=%23mcp%3AV%3Adonkey-barcelona%3A00597f02-f2b9-4365-867b-cdf2ed94088a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A00597f02-f2b9-4365-867b-cdf2ed94088a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.179756,
                    "lat": 41.384798
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cc997e4b-40bd-4d8b-920e-93c8a8090391",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cc997e4b-40bd-4d8b-920e-93c8a8090391"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cc997e4b-40bd-4d8b-920e-93c8a8090391",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cc997e4b-40bd-4d8b-920e-93c8a8090391"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2M5OTdlNGItNDBiZC00ZDhiLTkyMGUtOTNjOGE4MDkwMzkxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2M5OTdlNGItNDBiZC00ZDhiLTkyMGUtOTNjOGE4MDkwMzkxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cc997e4b-40bd-4d8b-920e-93c8a8090391_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cc997e4b-40bd-4d8b-920e-93c8a8090391",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2176328@Y=41384865@L=%23mcp%3AV%3Adonkey-barcelona%3Acc997e4b-40bd-4d8b-920e-93c8a8090391_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acc997e4b-40bd-4d8b-920e-93c8a8090391_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.176328,
                    "lat": 41.384865
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f9f1987d-86a5-46f8-86f1-9b0b349ae86a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f9f1987d-86a5-46f8-86f1-9b0b349ae86a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f9f1987d-86a5-46f8-86f1-9b0b349ae86a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f9f1987d-86a5-46f8-86f1-9b0b349ae86a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjlmMTk4N2QtODZhNS00NmY4LTg2ZjEtOWIwYjM0OWFlODZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjlmMTk4N2QtODZhNS00NmY4LTg2ZjEtOWIwYjM0OWFlODZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f9f1987d-86a5-46f8-86f1-9b0b349ae86a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f9f1987d-86a5-46f8-86f1-9b0b349ae86a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2165565@Y=41384905@L=%23mcp%3AV%3Adonkey-barcelona%3Af9f1987d-86a5-46f8-86f1-9b0b349ae86a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af9f1987d-86a5-46f8-86f1-9b0b349ae86a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.165565,
                    "lat": 41.384905
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f3b25feb-4326-4c97-9844-70c6506bbbc6",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f3b25feb-4326-4c97-9844-70c6506bbbc6"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f3b25feb-4326-4c97-9844-70c6506bbbc6",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f3b25feb-4326-4c97-9844-70c6506bbbc6"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjNiMjVmZWItNDMyNi00Yzk3LTk4NDQtNzBjNjUwNmJiYmM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjNiMjVmZWItNDMyNi00Yzk3LTk4NDQtNzBjNjUwNmJiYmM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f3b25feb-4326-4c97-9844-70c6506bbbc6_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f3b25feb-4326-4c97-9844-70c6506bbbc6",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2192796@Y=41384930@L=%23mcp%3AV%3Adonkey-barcelona%3Af3b25feb-4326-4c97-9844-70c6506bbbc6_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af3b25feb-4326-4c97-9844-70c6506bbbc6_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.192796,
                    "lat": 41.38493
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=556a5703-6adb-463d-bacb-3e1f306997be",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=556a5703-6adb-463d-bacb-3e1f306997be"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=556a5703-6adb-463d-bacb-3e1f306997be",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=556a5703-6adb-463d-bacb-3e1f306997be"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTU2YTU3MDMtNmFkYi00NjNkLWJhY2ItM2UxZjMwNjk5N2JlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTU2YTU3MDMtNmFkYi00NjNkLWJhY2ItM2UxZjMwNjk5N2JlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:556a5703-6adb-463d-bacb-3e1f306997be_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "556a5703-6adb-463d-bacb-3e1f306997be",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196132@Y=41384938@L=%23mcp%3AV%3Adonkey-barcelona%3A556a5703-6adb-463d-bacb-3e1f306997be_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A556a5703-6adb-463d-bacb-3e1f306997be_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196132,
                    "lat": 41.384938
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=499b8963-176a-4f2b-9772-5f4a98a6f2dc",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=499b8963-176a-4f2b-9772-5f4a98a6f2dc"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=499b8963-176a-4f2b-9772-5f4a98a6f2dc",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=499b8963-176a-4f2b-9772-5f4a98a6f2dc"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDk5Yjg5NjMtMTc2YS00ZjJiLTk3NzItNWY0YTk4YTZmMmRjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDk5Yjg5NjMtMTc2YS00ZjJiLTk3NzItNWY0YTk4YTZmMmRjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:499b8963-176a-4f2b-9772-5f4a98a6f2dc_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "499b8963-176a-4f2b-9772-5f4a98a6f2dc",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2157933@Y=41385151@L=%23mcp%3AV%3Adonkey-barcelona%3A499b8963-176a-4f2b-9772-5f4a98a6f2dc_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A499b8963-176a-4f2b-9772-5f4a98a6f2dc_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.157933,
                    "lat": 41.385151
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4966e96f-1508-45b9-a076-ce1ab72901ee",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4966e96f-1508-45b9-a076-ce1ab72901ee"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4966e96f-1508-45b9-a076-ce1ab72901ee",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4966e96f-1508-45b9-a076-ce1ab72901ee"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDk2NmU5NmYtMTUwOC00NWI5LWEwNzYtY2UxYWI3MjkwMWVlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDk2NmU5NmYtMTUwOC00NWI5LWEwNzYtY2UxYWI3MjkwMWVlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4966e96f-1508-45b9-a076-ce1ab72901ee_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4966e96f-1508-45b9-a076-ce1ab72901ee",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2176562@Y=41385224@L=%23mcp%3AV%3Adonkey-barcelona%3A4966e96f-1508-45b9-a076-ce1ab72901ee_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4966e96f-1508-45b9-a076-ce1ab72901ee_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.176562,
                    "lat": 41.385224
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=23bdf2b2-04ef-444c-9c6f-9d4719a7b5f3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=23bdf2b2-04ef-444c-9c6f-9d4719a7b5f3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=23bdf2b2-04ef-444c-9c6f-9d4719a7b5f3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=23bdf2b2-04ef-444c-9c6f-9d4719a7b5f3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjNiZGYyYjItMDRlZi00NDRjLTljNmYtOWQ0NzE5YTdiNWYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjNiZGYyYjItMDRlZi00NDRjLTljNmYtOWQ0NzE5YTdiNWYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:23bdf2b2-04ef-444c-9c6f-9d4719a7b5f3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "23bdf2b2-04ef-444c-9c6f-9d4719a7b5f3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2113509@Y=41385304@L=%23mcp%3AV%3Adonkey-barcelona%3A23bdf2b2-04ef-444c-9c6f-9d4719a7b5f3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A23bdf2b2-04ef-444c-9c6f-9d4719a7b5f3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.113509,
                    "lat": 41.385304
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=65d1075e-0304-4476-96bf-5204db6fe5bd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=65d1075e-0304-4476-96bf-5204db6fe5bd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=65d1075e-0304-4476-96bf-5204db6fe5bd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=65d1075e-0304-4476-96bf-5204db6fe5bd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjVkMTA3NWUtMDMwNC00NDc2LTk2YmYtNTIwNGRiNmZlNWJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjVkMTA3NWUtMDMwNC00NDc2LTk2YmYtNTIwNGRiNmZlNWJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:65d1075e-0304-4476-96bf-5204db6fe5bd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "65d1075e-0304-4476-96bf-5204db6fe5bd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2155178@Y=41385444@L=%23mcp%3AV%3Adonkey-barcelona%3A65d1075e-0304-4476-96bf-5204db6fe5bd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A65d1075e-0304-4476-96bf-5204db6fe5bd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.155178,
                    "lat": 41.385444
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e30bbabd-d50b-4d3d-a654-89a348028b27",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e30bbabd-d50b-4d3d-a654-89a348028b27"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e30bbabd-d50b-4d3d-a654-89a348028b27",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e30bbabd-d50b-4d3d-a654-89a348028b27"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTMwYmJhYmQtZDUwYi00ZDNkLWE2NTQtODlhMzQ4MDI4YjI3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTMwYmJhYmQtZDUwYi00ZDNkLWE2NTQtODlhMzQ4MDI4YjI3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e30bbabd-d50b-4d3d-a654-89a348028b27_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e30bbabd-d50b-4d3d-a654-89a348028b27",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2186343@Y=41385457@L=%23mcp%3AV%3Adonkey-barcelona%3Ae30bbabd-d50b-4d3d-a654-89a348028b27_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae30bbabd-d50b-4d3d-a654-89a348028b27_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.186343,
                    "lat": 41.385457
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=974b178f-2621-422c-9f65-546a0d7835be",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=974b178f-2621-422c-9f65-546a0d7835be"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=974b178f-2621-422c-9f65-546a0d7835be",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=974b178f-2621-422c-9f65-546a0d7835be"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTc0YjE3OGYtMjYyMS00MjJjLTlmNjUtNTQ2YTBkNzgzNWJlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTc0YjE3OGYtMjYyMS00MjJjLTlmNjUtNTQ2YTBkNzgzNWJlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:974b178f-2621-422c-9f65-546a0d7835be_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "974b178f-2621-422c-9f65-546a0d7835be",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2155239@Y=41385474@L=%23mcp%3AV%3Adonkey-barcelona%3A974b178f-2621-422c-9f65-546a0d7835be_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A974b178f-2621-422c-9f65-546a0d7835be_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.155239,
                    "lat": 41.385474
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9976a0ab-9233-4fea-9494-9c9ed0c7b608",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9976a0ab-9233-4fea-9494-9c9ed0c7b608"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9976a0ab-9233-4fea-9494-9c9ed0c7b608",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9976a0ab-9233-4fea-9494-9c9ed0c7b608"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTk3NmEwYWItOTIzMy00ZmVhLTk0OTQtOWM5ZWQwYzdiNjA4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTk3NmEwYWItOTIzMy00ZmVhLTk0OTQtOWM5ZWQwYzdiNjA4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9976a0ab-9233-4fea-9494-9c9ed0c7b608_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9976a0ab-9233-4fea-9494-9c9ed0c7b608",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196932@Y=41385630@L=%23mcp%3AV%3Adonkey-barcelona%3A9976a0ab-9233-4fea-9494-9c9ed0c7b608_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9976a0ab-9233-4fea-9494-9c9ed0c7b608_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196932,
                    "lat": 41.38563
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4c92a8a5-e834-47aa-a53d-dd44dfc53980",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4c92a8a5-e834-47aa-a53d-dd44dfc53980"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4c92a8a5-e834-47aa-a53d-dd44dfc53980",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4c92a8a5-e834-47aa-a53d-dd44dfc53980"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGM5MmE4YTUtZTgzNC00N2FhLWE1M2QtZGQ0NGRmYzUzOTgwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGM5MmE4YTUtZTgzNC00N2FhLWE1M2QtZGQ0NGRmYzUzOTgwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4c92a8a5-e834-47aa-a53d-dd44dfc53980_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4c92a8a5-e834-47aa-a53d-dd44dfc53980",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2167178@Y=41385639@L=%23mcp%3AV%3Adonkey-barcelona%3A4c92a8a5-e834-47aa-a53d-dd44dfc53980_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4c92a8a5-e834-47aa-a53d-dd44dfc53980_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.167178,
                    "lat": 41.385639
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=02e25981-66a4-4d0a-affe-aa45b04f539f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=02e25981-66a4-4d0a-affe-aa45b04f539f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=02e25981-66a4-4d0a-affe-aa45b04f539f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=02e25981-66a4-4d0a-affe-aa45b04f539f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDJlMjU5ODEtNjZhNC00ZDBhLWFmZmUtYWE0NWIwNGY1MzlmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDJlMjU5ODEtNjZhNC00ZDBhLWFmZmUtYWE0NWIwNGY1MzlmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:02e25981-66a4-4d0a-affe-aa45b04f539f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "02e25981-66a4-4d0a-affe-aa45b04f539f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196931@Y=41385647@L=%23mcp%3AV%3Adonkey-barcelona%3A02e25981-66a4-4d0a-affe-aa45b04f539f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A02e25981-66a4-4d0a-affe-aa45b04f539f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196931,
                    "lat": 41.385647
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2d6a04e9-cda7-4789-8975-52b831dcfbb9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2d6a04e9-cda7-4789-8975-52b831dcfbb9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2d6a04e9-cda7-4789-8975-52b831dcfbb9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2d6a04e9-cda7-4789-8975-52b831dcfbb9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmQ2YTA0ZTktY2RhNy00Nzg5LTg5NzUtNTJiODMxZGNmYmI5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmQ2YTA0ZTktY2RhNy00Nzg5LTg5NzUtNTJiODMxZGNmYmI5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2d6a04e9-cda7-4789-8975-52b831dcfbb9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2d6a04e9-cda7-4789-8975-52b831dcfbb9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168701@Y=41385672@L=%23mcp%3AV%3Adonkey-barcelona%3A2d6a04e9-cda7-4789-8975-52b831dcfbb9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2d6a04e9-cda7-4789-8975-52b831dcfbb9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.168701,
                    "lat": 41.385672
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0a34ae34-a812-40bd-b358-42188beacdb8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0a34ae34-a812-40bd-b358-42188beacdb8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0a34ae34-a812-40bd-b358-42188beacdb8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0a34ae34-a812-40bd-b358-42188beacdb8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGEzNGFlMzQtYTgxMi00MGJkLWIzNTgtNDIxODhiZWFjZGI4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGEzNGFlMzQtYTgxMi00MGJkLWIzNTgtNDIxODhiZWFjZGI4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0a34ae34-a812-40bd-b358-42188beacdb8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0a34ae34-a812-40bd-b358-42188beacdb8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196862@Y=41385695@L=%23mcp%3AV%3Adonkey-barcelona%3A0a34ae34-a812-40bd-b358-42188beacdb8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0a34ae34-a812-40bd-b358-42188beacdb8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196862,
                    "lat": 41.385695
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d173cc1a-3fc6-49d5-8ebe-7d3679deca4c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d173cc1a-3fc6-49d5-8ebe-7d3679deca4c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d173cc1a-3fc6-49d5-8ebe-7d3679deca4c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d173cc1a-3fc6-49d5-8ebe-7d3679deca4c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDE3M2NjMWEtM2ZjNi00OWQ1LThlYmUtN2QzNjc5ZGVjYTRjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDE3M2NjMWEtM2ZjNi00OWQ1LThlYmUtN2QzNjc5ZGVjYTRjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d173cc1a-3fc6-49d5-8ebe-7d3679deca4c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d173cc1a-3fc6-49d5-8ebe-7d3679deca4c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196923@Y=41385695@L=%23mcp%3AV%3Adonkey-barcelona%3Ad173cc1a-3fc6-49d5-8ebe-7d3679deca4c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad173cc1a-3fc6-49d5-8ebe-7d3679deca4c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196923,
                    "lat": 41.385695
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7a7608d6-90c6-46b8-8721-a68534afe5e1",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7a7608d6-90c6-46b8-8721-a68534afe5e1"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7a7608d6-90c6-46b8-8721-a68534afe5e1",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7a7608d6-90c6-46b8-8721-a68534afe5e1"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2E3NjA4ZDYtOTBjNi00NmI4LTg3MjEtYTY4NTM0YWZlNWUxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2E3NjA4ZDYtOTBjNi00NmI4LTg3MjEtYTY4NTM0YWZlNWUxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7a7608d6-90c6-46b8-8721-a68534afe5e1_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7a7608d6-90c6-46b8-8721-a68534afe5e1",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2194309@Y=41385731@L=%23mcp%3AV%3Adonkey-barcelona%3A7a7608d6-90c6-46b8-8721-a68534afe5e1_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7a7608d6-90c6-46b8-8721-a68534afe5e1_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.194309,
                    "lat": 41.385731
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=37a6efa2-3c70-42ae-8ff6-a31fae8ac8c9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=37a6efa2-3c70-42ae-8ff6-a31fae8ac8c9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=37a6efa2-3c70-42ae-8ff6-a31fae8ac8c9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=37a6efa2-3c70-42ae-8ff6-a31fae8ac8c9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzdhNmVmYTItM2M3MC00MmFlLThmZjYtYTMxZmFlOGFjOGM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzdhNmVmYTItM2M3MC00MmFlLThmZjYtYTMxZmFlOGFjOGM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:37a6efa2-3c70-42ae-8ff6-a31fae8ac8c9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "37a6efa2-3c70-42ae-8ff6-a31fae8ac8c9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2177722@Y=41385732@L=%23mcp%3AV%3Adonkey-barcelona%3A37a6efa2-3c70-42ae-8ff6-a31fae8ac8c9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A37a6efa2-3c70-42ae-8ff6-a31fae8ac8c9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.177722,
                    "lat": 41.385732
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=26d39659-74c4-4015-8fb5-3bb09af53a53",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=26d39659-74c4-4015-8fb5-3bb09af53a53"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=26d39659-74c4-4015-8fb5-3bb09af53a53",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=26d39659-74c4-4015-8fb5-3bb09af53a53"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjZkMzk2NTktNzRjNC00MDE1LThmYjUtM2JiMDlhZjUzYTUzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjZkMzk2NTktNzRjNC00MDE1LThmYjUtM2JiMDlhZjUzYTUzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:26d39659-74c4-4015-8fb5-3bb09af53a53_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "26d39659-74c4-4015-8fb5-3bb09af53a53",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2182392@Y=41385898@L=%23mcp%3AV%3Adonkey-barcelona%3A26d39659-74c4-4015-8fb5-3bb09af53a53_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A26d39659-74c4-4015-8fb5-3bb09af53a53_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.182392,
                    "lat": 41.385898
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f10668c3-90eb-4d87-b3d2-61672b8ea26a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f10668c3-90eb-4d87-b3d2-61672b8ea26a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f10668c3-90eb-4d87-b3d2-61672b8ea26a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f10668c3-90eb-4d87-b3d2-61672b8ea26a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjEwNjY4YzMtOTBlYi00ZDg3LWIzZDItNjE2NzJiOGVhMjZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjEwNjY4YzMtOTBlYi00ZDg3LWIzZDItNjE2NzJiOGVhMjZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f10668c3-90eb-4d87-b3d2-61672b8ea26a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f10668c3-90eb-4d87-b3d2-61672b8ea26a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2186535@Y=41385973@L=%23mcp%3AV%3Adonkey-barcelona%3Af10668c3-90eb-4d87-b3d2-61672b8ea26a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af10668c3-90eb-4d87-b3d2-61672b8ea26a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.186535,
                    "lat": 41.385973
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=409a30c1-f84b-44ac-9e76-447adaee62ae",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=409a30c1-f84b-44ac-9e76-447adaee62ae"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=409a30c1-f84b-44ac-9e76-447adaee62ae",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=409a30c1-f84b-44ac-9e76-447adaee62ae"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDA5YTMwYzEtZjg0Yi00NGFjLTllNzYtNDQ3YWRhZWU2MmFlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDA5YTMwYzEtZjg0Yi00NGFjLTllNzYtNDQ3YWRhZWU2MmFlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:409a30c1-f84b-44ac-9e76-447adaee62ae_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "409a30c1-f84b-44ac-9e76-447adaee62ae",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2167650@Y=41386006@L=%23mcp%3AV%3Adonkey-barcelona%3A409a30c1-f84b-44ac-9e76-447adaee62ae_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A409a30c1-f84b-44ac-9e76-447adaee62ae_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.16765,
                    "lat": 41.386006
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a77e91ca-7afa-42fa-a445-68ceed6e72d4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a77e91ca-7afa-42fa-a445-68ceed6e72d4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a77e91ca-7afa-42fa-a445-68ceed6e72d4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a77e91ca-7afa-42fa-a445-68ceed6e72d4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTc3ZTkxY2EtN2FmYS00MmZhLWE0NDUtNjhjZWVkNmU3MmQ0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTc3ZTkxY2EtN2FmYS00MmZhLWE0NDUtNjhjZWVkNmU3MmQ0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a77e91ca-7afa-42fa-a445-68ceed6e72d4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a77e91ca-7afa-42fa-a445-68ceed6e72d4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2177536@Y=41386018@L=%23mcp%3AV%3Adonkey-barcelona%3Aa77e91ca-7afa-42fa-a445-68ceed6e72d4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa77e91ca-7afa-42fa-a445-68ceed6e72d4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.177536,
                    "lat": 41.386018
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2b522f20-588b-49e5-8a86-eabf1b2ec3a3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2b522f20-588b-49e5-8a86-eabf1b2ec3a3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2b522f20-588b-49e5-8a86-eabf1b2ec3a3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2b522f20-588b-49e5-8a86-eabf1b2ec3a3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmI1MjJmMjAtNTg4Yi00OWU1LThhODYtZWFiZjFiMmVjM2EzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmI1MjJmMjAtNTg4Yi00OWU1LThhODYtZWFiZjFiMmVjM2EzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2b522f20-588b-49e5-8a86-eabf1b2ec3a3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2b522f20-588b-49e5-8a86-eabf1b2ec3a3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2186572@Y=41386033@L=%23mcp%3AV%3Adonkey-barcelona%3A2b522f20-588b-49e5-8a86-eabf1b2ec3a3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2b522f20-588b-49e5-8a86-eabf1b2ec3a3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.186572,
                    "lat": 41.386033
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=54d2bb92-8c1f-4cc3-bc7d-4e6060447a99",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=54d2bb92-8c1f-4cc3-bc7d-4e6060447a99"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=54d2bb92-8c1f-4cc3-bc7d-4e6060447a99",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=54d2bb92-8c1f-4cc3-bc7d-4e6060447a99"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTRkMmJiOTItOGMxZi00Y2MzLWJjN2QtNGU2MDYwNDQ3YTk5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTRkMmJiOTItOGMxZi00Y2MzLWJjN2QtNGU2MDYwNDQ3YTk5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:54d2bb92-8c1f-4cc3-bc7d-4e6060447a99_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "54d2bb92-8c1f-4cc3-bc7d-4e6060447a99",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2186502@Y=41386102@L=%23mcp%3AV%3Adonkey-barcelona%3A54d2bb92-8c1f-4cc3-bc7d-4e6060447a99_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A54d2bb92-8c1f-4cc3-bc7d-4e6060447a99_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.186502,
                    "lat": 41.386102
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=efe55164-b272-446a-b94f-537f43a7f6f0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=efe55164-b272-446a-b94f-537f43a7f6f0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=efe55164-b272-446a-b94f-537f43a7f6f0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=efe55164-b272-446a-b94f-537f43a7f6f0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWZlNTUxNjQtYjI3Mi00NDZhLWI5NGYtNTM3ZjQzYTdmNmYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWZlNTUxNjQtYjI3Mi00NDZhLWI5NGYtNTM3ZjQzYTdmNmYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:efe55164-b272-446a-b94f-537f43a7f6f0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "efe55164-b272-446a-b94f-537f43a7f6f0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2197620@Y=41386375@L=%23mcp%3AV%3Adonkey-barcelona%3Aefe55164-b272-446a-b94f-537f43a7f6f0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aefe55164-b272-446a-b94f-537f43a7f6f0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.19762,
                    "lat": 41.386375
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8455f607-24e2-4c87-81f8-5ec4019e2a24",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8455f607-24e2-4c87-81f8-5ec4019e2a24"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8455f607-24e2-4c87-81f8-5ec4019e2a24",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8455f607-24e2-4c87-81f8-5ec4019e2a24"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODQ1NWY2MDctMjRlMi00Yzg3LTgxZjgtNWVjNDAxOWUyYTI0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODQ1NWY2MDctMjRlMi00Yzg3LTgxZjgtNWVjNDAxOWUyYTI0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8455f607-24e2-4c87-81f8-5ec4019e2a24_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8455f607-24e2-4c87-81f8-5ec4019e2a24",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2184598@Y=41386383@L=%23mcp%3AV%3Adonkey-barcelona%3A8455f607-24e2-4c87-81f8-5ec4019e2a24_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8455f607-24e2-4c87-81f8-5ec4019e2a24_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.184598,
                    "lat": 41.386383
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8c6b526a-209a-4c97-a46a-7921f6163c46",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8c6b526a-209a-4c97-a46a-7921f6163c46"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8c6b526a-209a-4c97-a46a-7921f6163c46",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8c6b526a-209a-4c97-a46a-7921f6163c46"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGM2YjUyNmEtMjA5YS00Yzk3LWE0NmEtNzkyMWY2MTYzYzQ2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGM2YjUyNmEtMjA5YS00Yzk3LWE0NmEtNzkyMWY2MTYzYzQ2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8c6b526a-209a-4c97-a46a-7921f6163c46_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8c6b526a-209a-4c97-a46a-7921f6163c46",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2197561@Y=41386407@L=%23mcp%3AV%3Adonkey-barcelona%3A8c6b526a-209a-4c97-a46a-7921f6163c46_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8c6b526a-209a-4c97-a46a-7921f6163c46_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.197561,
                    "lat": 41.386407
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=409eee85-7968-49c0-8628-2c3cef04eda2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=409eee85-7968-49c0-8628-2c3cef04eda2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=409eee85-7968-49c0-8628-2c3cef04eda2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=409eee85-7968-49c0-8628-2c3cef04eda2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDA5ZWVlODUtNzk2OC00OWMwLTg2MjgtMmMzY2VmMDRlZGEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDA5ZWVlODUtNzk2OC00OWMwLTg2MjgtMmMzY2VmMDRlZGEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:409eee85-7968-49c0-8628-2c3cef04eda2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "409eee85-7968-49c0-8628-2c3cef04eda2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2182376@Y=41386480@L=%23mcp%3AV%3Adonkey-barcelona%3A409eee85-7968-49c0-8628-2c3cef04eda2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A409eee85-7968-49c0-8628-2c3cef04eda2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.182376,
                    "lat": 41.38648
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4422073e-a462-43e8-bb84-31a83144255e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4422073e-a462-43e8-bb84-31a83144255e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4422073e-a462-43e8-bb84-31a83144255e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4422073e-a462-43e8-bb84-31a83144255e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDQyMjA3M2UtYTQ2Mi00M2U4LWJiODQtMzFhODMxNDQyNTVlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDQyMjA3M2UtYTQ2Mi00M2U4LWJiODQtMzFhODMxNDQyNTVlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4422073e-a462-43e8-bb84-31a83144255e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4422073e-a462-43e8-bb84-31a83144255e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2195448@Y=41386792@L=%23mcp%3AV%3Adonkey-barcelona%3A4422073e-a462-43e8-bb84-31a83144255e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4422073e-a462-43e8-bb84-31a83144255e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.195448,
                    "lat": 41.386792
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=79cbfe00-675d-4080-8d5b-ebb551e44b4e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=79cbfe00-675d-4080-8d5b-ebb551e44b4e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=79cbfe00-675d-4080-8d5b-ebb551e44b4e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=79cbfe00-675d-4080-8d5b-ebb551e44b4e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzljYmZlMDAtNjc1ZC00MDgwLThkNWItZWJiNTUxZTQ0YjRlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzljYmZlMDAtNjc1ZC00MDgwLThkNWItZWJiNTUxZTQ0YjRlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:79cbfe00-675d-4080-8d5b-ebb551e44b4e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "79cbfe00-675d-4080-8d5b-ebb551e44b4e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2195479@Y=41386828@L=%23mcp%3AV%3Adonkey-barcelona%3A79cbfe00-675d-4080-8d5b-ebb551e44b4e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A79cbfe00-675d-4080-8d5b-ebb551e44b4e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.195479,
                    "lat": 41.386828
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e5c07999-c777-4d48-b7ed-811befebf987",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e5c07999-c777-4d48-b7ed-811befebf987"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e5c07999-c777-4d48-b7ed-811befebf987",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e5c07999-c777-4d48-b7ed-811befebf987"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTVjMDc5OTktYzc3Ny00ZDQ4LWI3ZWQtODExYmVmZWJmOTg3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTVjMDc5OTktYzc3Ny00ZDQ4LWI3ZWQtODExYmVmZWJmOTg3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e5c07999-c777-4d48-b7ed-811befebf987_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e5c07999-c777-4d48-b7ed-811befebf987",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2183720@Y=41387026@L=%23mcp%3AV%3Adonkey-barcelona%3Ae5c07999-c777-4d48-b7ed-811befebf987_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae5c07999-c777-4d48-b7ed-811befebf987_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.18372,
                    "lat": 41.387026
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3258d031-c612-4133-90f1-978048a572c2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3258d031-c612-4133-90f1-978048a572c2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3258d031-c612-4133-90f1-978048a572c2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3258d031-c612-4133-90f1-978048a572c2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzI1OGQwMzEtYzYxMi00MTMzLTkwZjEtOTc4MDQ4YTU3MmMyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzI1OGQwMzEtYzYxMi00MTMzLTkwZjEtOTc4MDQ4YTU3MmMyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3258d031-c612-4133-90f1-978048a572c2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3258d031-c612-4133-90f1-978048a572c2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171056@Y=41387075@L=%23mcp%3AV%3Adonkey-barcelona%3A3258d031-c612-4133-90f1-978048a572c2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3258d031-c612-4133-90f1-978048a572c2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171056,
                    "lat": 41.387075
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4b9216f2-f277-49d9-a6ef-3d83a67742e3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4b9216f2-f277-49d9-a6ef-3d83a67742e3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4b9216f2-f277-49d9-a6ef-3d83a67742e3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4b9216f2-f277-49d9-a6ef-3d83a67742e3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGI5MjE2ZjItZjI3Ny00OWQ5LWE2ZWYtM2Q4M2E2Nzc0MmUzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGI5MjE2ZjItZjI3Ny00OWQ5LWE2ZWYtM2Q4M2E2Nzc0MmUzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4b9216f2-f277-49d9-a6ef-3d83a67742e3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4b9216f2-f277-49d9-a6ef-3d83a67742e3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171491@Y=41387222@L=%23mcp%3AV%3Adonkey-barcelona%3A4b9216f2-f277-49d9-a6ef-3d83a67742e3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4b9216f2-f277-49d9-a6ef-3d83a67742e3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171491,
                    "lat": 41.387222
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=652dc376-de75-4393-af06-9f6bcf48d4f5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=652dc376-de75-4393-af06-9f6bcf48d4f5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=652dc376-de75-4393-af06-9f6bcf48d4f5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=652dc376-de75-4393-af06-9f6bcf48d4f5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjUyZGMzNzYtZGU3NS00MzkzLWFmMDYtOWY2YmNmNDhkNGY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjUyZGMzNzYtZGU3NS00MzkzLWFmMDYtOWY2YmNmNDhkNGY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:652dc376-de75-4393-af06-9f6bcf48d4f5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "652dc376-de75-4393-af06-9f6bcf48d4f5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2143006@Y=41387456@L=%23mcp%3AV%3Adonkey-barcelona%3A652dc376-de75-4393-af06-9f6bcf48d4f5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A652dc376-de75-4393-af06-9f6bcf48d4f5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.143006,
                    "lat": 41.387456
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=09057a7a-9c51-40c3-9dfc-7ff26fc22f92",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=09057a7a-9c51-40c3-9dfc-7ff26fc22f92"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=09057a7a-9c51-40c3-9dfc-7ff26fc22f92",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=09057a7a-9c51-40c3-9dfc-7ff26fc22f92"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDkwNTdhN2EtOWM1MS00MGMzLTlkZmMtN2ZmMjZmYzIyZjkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDkwNTdhN2EtOWM1MS00MGMzLTlkZmMtN2ZmMjZmYzIyZjkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:09057a7a-9c51-40c3-9dfc-7ff26fc22f92_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "09057a7a-9c51-40c3-9dfc-7ff26fc22f92",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2143002@Y=41387514@L=%23mcp%3AV%3Adonkey-barcelona%3A09057a7a-9c51-40c3-9dfc-7ff26fc22f92_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A09057a7a-9c51-40c3-9dfc-7ff26fc22f92_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.143002,
                    "lat": 41.387514
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=53b5c4f4-dcd3-4382-8e89-cf2d9cb3a68f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=53b5c4f4-dcd3-4382-8e89-cf2d9cb3a68f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=53b5c4f4-dcd3-4382-8e89-cf2d9cb3a68f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=53b5c4f4-dcd3-4382-8e89-cf2d9cb3a68f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTNiNWM0ZjQtZGNkMy00MzgyLThlODktY2YyZDljYjNhNjhmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTNiNWM0ZjQtZGNkMy00MzgyLThlODktY2YyZDljYjNhNjhmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:53b5c4f4-dcd3-4382-8e89-cf2d9cb3a68f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "53b5c4f4-dcd3-4382-8e89-cf2d9cb3a68f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2182974@Y=41387585@L=%23mcp%3AV%3Adonkey-barcelona%3A53b5c4f4-dcd3-4382-8e89-cf2d9cb3a68f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A53b5c4f4-dcd3-4382-8e89-cf2d9cb3a68f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.182974,
                    "lat": 41.387585
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=18799b5a-3551-47f2-bdbc-4819cb7c0e6a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=18799b5a-3551-47f2-bdbc-4819cb7c0e6a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=18799b5a-3551-47f2-bdbc-4819cb7c0e6a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=18799b5a-3551-47f2-bdbc-4819cb7c0e6a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTg3OTliNWEtMzU1MS00N2YyLWJkYmMtNDgxOWNiN2MwZTZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTg3OTliNWEtMzU1MS00N2YyLWJkYmMtNDgxOWNiN2MwZTZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:18799b5a-3551-47f2-bdbc-4819cb7c0e6a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "18799b5a-3551-47f2-bdbc-4819cb7c0e6a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2175252@Y=41387851@L=%23mcp%3AV%3Adonkey-barcelona%3A18799b5a-3551-47f2-bdbc-4819cb7c0e6a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A18799b5a-3551-47f2-bdbc-4819cb7c0e6a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.175252,
                    "lat": 41.387851
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bb56edc0-6825-47e0-9de2-192c594d6e07",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bb56edc0-6825-47e0-9de2-192c594d6e07"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bb56edc0-6825-47e0-9de2-192c594d6e07",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bb56edc0-6825-47e0-9de2-192c594d6e07"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmI1NmVkYzAtNjgyNS00N2UwLTlkZTItMTkyYzU5NGQ2ZTA3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmI1NmVkYzAtNjgyNS00N2UwLTlkZTItMTkyYzU5NGQ2ZTA3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:bb56edc0-6825-47e0-9de2-192c594d6e07_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "bb56edc0-6825-47e0-9de2-192c594d6e07",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2174209@Y=41387857@L=%23mcp%3AV%3Adonkey-barcelona%3Abb56edc0-6825-47e0-9de2-192c594d6e07_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Abb56edc0-6825-47e0-9de2-192c594d6e07_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.174209,
                    "lat": 41.387857
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c51bdba2-40aa-4cbb-bb45-148321cb1fdd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c51bdba2-40aa-4cbb-bb45-148321cb1fdd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c51bdba2-40aa-4cbb-bb45-148321cb1fdd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c51bdba2-40aa-4cbb-bb45-148321cb1fdd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzUxYmRiYTItNDBhYS00Y2JiLWJiNDUtMTQ4MzIxY2IxZmRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzUxYmRiYTItNDBhYS00Y2JiLWJiNDUtMTQ4MzIxY2IxZmRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c51bdba2-40aa-4cbb-bb45-148321cb1fdd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c51bdba2-40aa-4cbb-bb45-148321cb1fdd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2175028@Y=41388338@L=%23mcp%3AV%3Adonkey-barcelona%3Ac51bdba2-40aa-4cbb-bb45-148321cb1fdd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac51bdba2-40aa-4cbb-bb45-148321cb1fdd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.175028,
                    "lat": 41.388338
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5f1ddeb4-4e22-49a6-869a-6e1fa1077412",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5f1ddeb4-4e22-49a6-869a-6e1fa1077412"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5f1ddeb4-4e22-49a6-869a-6e1fa1077412",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5f1ddeb4-4e22-49a6-869a-6e1fa1077412"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWYxZGRlYjQtNGUyMi00OWE2LTg2OWEtNmUxZmExMDc3NDEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWYxZGRlYjQtNGUyMi00OWE2LTg2OWEtNmUxZmExMDc3NDEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5f1ddeb4-4e22-49a6-869a-6e1fa1077412_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5f1ddeb4-4e22-49a6-869a-6e1fa1077412",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2195157@Y=41388354@L=%23mcp%3AV%3Adonkey-barcelona%3A5f1ddeb4-4e22-49a6-869a-6e1fa1077412_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5f1ddeb4-4e22-49a6-869a-6e1fa1077412_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.195157,
                    "lat": 41.388354
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1eb5eb2b-3e68-4ad1-a98c-432be8b2aaed",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1eb5eb2b-3e68-4ad1-a98c-432be8b2aaed"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1eb5eb2b-3e68-4ad1-a98c-432be8b2aaed",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1eb5eb2b-3e68-4ad1-a98c-432be8b2aaed"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWViNWViMmItM2U2OC00YWQxLWE5OGMtNDMyYmU4YjJhYWVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWViNWViMmItM2U2OC00YWQxLWE5OGMtNDMyYmU4YjJhYWVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1eb5eb2b-3e68-4ad1-a98c-432be8b2aaed_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1eb5eb2b-3e68-4ad1-a98c-432be8b2aaed",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2199368@Y=41388682@L=%23mcp%3AV%3Adonkey-barcelona%3A1eb5eb2b-3e68-4ad1-a98c-432be8b2aaed_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1eb5eb2b-3e68-4ad1-a98c-432be8b2aaed_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.199368,
                    "lat": 41.388682
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=875da922-5296-4e17-87b9-797f725d520e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=875da922-5296-4e17-87b9-797f725d520e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=875da922-5296-4e17-87b9-797f725d520e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=875da922-5296-4e17-87b9-797f725d520e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODc1ZGE5MjItNTI5Ni00ZTE3LTg3YjktNzk3ZjcyNWQ1MjBlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODc1ZGE5MjItNTI5Ni00ZTE3LTg3YjktNzk3ZjcyNWQ1MjBlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:875da922-5296-4e17-87b9-797f725d520e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "875da922-5296-4e17-87b9-797f725d520e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2199368@Y=41388682@L=%23mcp%3AV%3Adonkey-barcelona%3A875da922-5296-4e17-87b9-797f725d520e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A875da922-5296-4e17-87b9-797f725d520e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.199368,
                    "lat": 41.388682
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d2cfa69f-4a85-4974-9ed7-9bf6ef775930",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d2cfa69f-4a85-4974-9ed7-9bf6ef775930"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d2cfa69f-4a85-4974-9ed7-9bf6ef775930",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d2cfa69f-4a85-4974-9ed7-9bf6ef775930"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDJjZmE2OWYtNGE4NS00OTc0LTllZDctOWJmNmVmNzc1OTMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDJjZmE2OWYtNGE4NS00OTc0LTllZDctOWJmNmVmNzc1OTMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d2cfa69f-4a85-4974-9ed7-9bf6ef775930_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d2cfa69f-4a85-4974-9ed7-9bf6ef775930",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2199353@Y=41388689@L=%23mcp%3AV%3Adonkey-barcelona%3Ad2cfa69f-4a85-4974-9ed7-9bf6ef775930_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad2cfa69f-4a85-4974-9ed7-9bf6ef775930_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.199353,
                    "lat": 41.388689
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2780cdda-7f25-4e42-84f1-9b4ebedad88d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2780cdda-7f25-4e42-84f1-9b4ebedad88d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2780cdda-7f25-4e42-84f1-9b4ebedad88d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2780cdda-7f25-4e42-84f1-9b4ebedad88d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjc4MGNkZGEtN2YyNS00ZTQyLTg0ZjEtOWI0ZWJlZGFkODhkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjc4MGNkZGEtN2YyNS00ZTQyLTg0ZjEtOWI0ZWJlZGFkODhkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2780cdda-7f25-4e42-84f1-9b4ebedad88d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2780cdda-7f25-4e42-84f1-9b4ebedad88d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2143324@Y=41388931@L=%23mcp%3AV%3Adonkey-barcelona%3A2780cdda-7f25-4e42-84f1-9b4ebedad88d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2780cdda-7f25-4e42-84f1-9b4ebedad88d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.143324,
                    "lat": 41.388931
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=58b8c804-ee89-42fc-927e-2c1a8b44e20f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=58b8c804-ee89-42fc-927e-2c1a8b44e20f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=58b8c804-ee89-42fc-927e-2c1a8b44e20f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=58b8c804-ee89-42fc-927e-2c1a8b44e20f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNThiOGM4MDQtZWU4OS00MmZjLTkyN2UtMmMxYThiNDRlMjBmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNThiOGM4MDQtZWU4OS00MmZjLTkyN2UtMmMxYThiNDRlMjBmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:58b8c804-ee89-42fc-927e-2c1a8b44e20f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "58b8c804-ee89-42fc-927e-2c1a8b44e20f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173666@Y=41389157@L=%23mcp%3AV%3Adonkey-barcelona%3A58b8c804-ee89-42fc-927e-2c1a8b44e20f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A58b8c804-ee89-42fc-927e-2c1a8b44e20f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173666,
                    "lat": 41.389157
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2f93f4d6-1a17-4e14-b748-845b703dddf4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2f93f4d6-1a17-4e14-b748-845b703dddf4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2f93f4d6-1a17-4e14-b748-845b703dddf4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2f93f4d6-1a17-4e14-b748-845b703dddf4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmY5M2Y0ZDYtMWExNy00ZTE0LWI3NDgtODQ1YjcwM2RkZGY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmY5M2Y0ZDYtMWExNy00ZTE0LWI3NDgtODQ1YjcwM2RkZGY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2f93f4d6-1a17-4e14-b748-845b703dddf4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2f93f4d6-1a17-4e14-b748-845b703dddf4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173927@Y=41389293@L=%23mcp%3AV%3Adonkey-barcelona%3A2f93f4d6-1a17-4e14-b748-845b703dddf4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2f93f4d6-1a17-4e14-b748-845b703dddf4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173927,
                    "lat": 41.389293
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d235700f-0237-49cc-a237-cf7f76420ba3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d235700f-0237-49cc-a237-cf7f76420ba3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d235700f-0237-49cc-a237-cf7f76420ba3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d235700f-0237-49cc-a237-cf7f76420ba3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDIzNTcwMGYtMDIzNy00OWNjLWEyMzctY2Y3Zjc2NDIwYmEzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDIzNTcwMGYtMDIzNy00OWNjLWEyMzctY2Y3Zjc2NDIwYmEzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d235700f-0237-49cc-a237-cf7f76420ba3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d235700f-0237-49cc-a237-cf7f76420ba3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2139872@Y=41389750@L=%23mcp%3AV%3Adonkey-barcelona%3Ad235700f-0237-49cc-a237-cf7f76420ba3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad235700f-0237-49cc-a237-cf7f76420ba3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.139872,
                    "lat": 41.38975
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4e8a400d-ee5d-4379-a42c-5f3570d1a533",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4e8a400d-ee5d-4379-a42c-5f3570d1a533"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4e8a400d-ee5d-4379-a42c-5f3570d1a533",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4e8a400d-ee5d-4379-a42c-5f3570d1a533"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGU4YTQwMGQtZWU1ZC00Mzc5LWE0MmMtNWYzNTcwZDFhNTMzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGU4YTQwMGQtZWU1ZC00Mzc5LWE0MmMtNWYzNTcwZDFhNTMzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4e8a400d-ee5d-4379-a42c-5f3570d1a533_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4e8a400d-ee5d-4379-a42c-5f3570d1a533",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2200721@Y=41389927@L=%23mcp%3AV%3Adonkey-barcelona%3A4e8a400d-ee5d-4379-a42c-5f3570d1a533_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4e8a400d-ee5d-4379-a42c-5f3570d1a533_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.200721,
                    "lat": 41.389927
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e7815a09-904a-4d1a-b358-11fcd3fa4bbe",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e7815a09-904a-4d1a-b358-11fcd3fa4bbe"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e7815a09-904a-4d1a-b358-11fcd3fa4bbe",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e7815a09-904a-4d1a-b358-11fcd3fa4bbe"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTc4MTVhMDktOTA0YS00ZDFhLWIzNTgtMTFmY2QzZmE0YmJlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTc4MTVhMDktOTA0YS00ZDFhLWIzNTgtMTFmY2QzZmE0YmJlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e7815a09-904a-4d1a-b358-11fcd3fa4bbe_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e7815a09-904a-4d1a-b358-11fcd3fa4bbe",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191118@Y=41389940@L=%23mcp%3AV%3Adonkey-barcelona%3Ae7815a09-904a-4d1a-b358-11fcd3fa4bbe_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae7815a09-904a-4d1a-b358-11fcd3fa4bbe_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191118,
                    "lat": 41.38994
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d34988ed-d4d1-432c-bd09-648d10771ba2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d34988ed-d4d1-432c-bd09-648d10771ba2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d34988ed-d4d1-432c-bd09-648d10771ba2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d34988ed-d4d1-432c-bd09-648d10771ba2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDM0OTg4ZWQtZDRkMS00MzJjLWJkMDktNjQ4ZDEwNzcxYmEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDM0OTg4ZWQtZDRkMS00MzJjLWJkMDktNjQ4ZDEwNzcxYmEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d34988ed-d4d1-432c-bd09-648d10771ba2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d34988ed-d4d1-432c-bd09-648d10771ba2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2175724@Y=41389960@L=%23mcp%3AV%3Adonkey-barcelona%3Ad34988ed-d4d1-432c-bd09-648d10771ba2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad34988ed-d4d1-432c-bd09-648d10771ba2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.175724,
                    "lat": 41.38996
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3cb19cc5-ea65-4bd4-bf9f-288bfa7e1968",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3cb19cc5-ea65-4bd4-bf9f-288bfa7e1968"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3cb19cc5-ea65-4bd4-bf9f-288bfa7e1968",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3cb19cc5-ea65-4bd4-bf9f-288bfa7e1968"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2NiMTljYzUtZWE2NS00YmQ0LWJmOWYtMjg4YmZhN2UxOTY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2NiMTljYzUtZWE2NS00YmQ0LWJmOWYtMjg4YmZhN2UxOTY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3cb19cc5-ea65-4bd4-bf9f-288bfa7e1968_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3cb19cc5-ea65-4bd4-bf9f-288bfa7e1968",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2175724@Y=41389960@L=%23mcp%3AV%3Adonkey-barcelona%3A3cb19cc5-ea65-4bd4-bf9f-288bfa7e1968_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3cb19cc5-ea65-4bd4-bf9f-288bfa7e1968_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.175724,
                    "lat": 41.38996
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=088b2297-a10e-44e6-99aa-7a4223e66dfa",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=088b2297-a10e-44e6-99aa-7a4223e66dfa"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=088b2297-a10e-44e6-99aa-7a4223e66dfa",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=088b2297-a10e-44e6-99aa-7a4223e66dfa"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDg4YjIyOTctYTEwZS00NGU2LTk5YWEtN2E0MjIzZTY2ZGZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDg4YjIyOTctYTEwZS00NGU2LTk5YWEtN2E0MjIzZTY2ZGZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:088b2297-a10e-44e6-99aa-7a4223e66dfa_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "088b2297-a10e-44e6-99aa-7a4223e66dfa",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2159744@Y=41390023@L=%23mcp%3AV%3Adonkey-barcelona%3A088b2297-a10e-44e6-99aa-7a4223e66dfa_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A088b2297-a10e-44e6-99aa-7a4223e66dfa_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.159744,
                    "lat": 41.390023
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=48057e21-aad9-4ef0-85d3-92ef0b8b68c1",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=48057e21-aad9-4ef0-85d3-92ef0b8b68c1"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=48057e21-aad9-4ef0-85d3-92ef0b8b68c1",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=48057e21-aad9-4ef0-85d3-92ef0b8b68c1"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDgwNTdlMjEtYWFkOS00ZWYwLTg1ZDMtOTJlZjBiOGI2OGMxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDgwNTdlMjEtYWFkOS00ZWYwLTg1ZDMtOTJlZjBiOGI2OGMxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:48057e21-aad9-4ef0-85d3-92ef0b8b68c1_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "48057e21-aad9-4ef0-85d3-92ef0b8b68c1",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189767@Y=41390143@L=%23mcp%3AV%3Adonkey-barcelona%3A48057e21-aad9-4ef0-85d3-92ef0b8b68c1_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A48057e21-aad9-4ef0-85d3-92ef0b8b68c1_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189767,
                    "lat": 41.390143
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=62ad680e-efdd-4d96-9d25-7359ecdb7a4d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=62ad680e-efdd-4d96-9d25-7359ecdb7a4d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=62ad680e-efdd-4d96-9d25-7359ecdb7a4d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=62ad680e-efdd-4d96-9d25-7359ecdb7a4d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjJhZDY4MGUtZWZkZC00ZDk2LTlkMjUtNzM1OWVjZGI3YTRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjJhZDY4MGUtZWZkZC00ZDk2LTlkMjUtNzM1OWVjZGI3YTRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:62ad680e-efdd-4d96-9d25-7359ecdb7a4d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "62ad680e-efdd-4d96-9d25-7359ecdb7a4d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2132267@Y=41390154@L=%23mcp%3AV%3Adonkey-barcelona%3A62ad680e-efdd-4d96-9d25-7359ecdb7a4d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A62ad680e-efdd-4d96-9d25-7359ecdb7a4d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.132267,
                    "lat": 41.390154
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=04d829ac-d6ac-4f37-863d-08ce3808c0e1",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=04d829ac-d6ac-4f37-863d-08ce3808c0e1"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=04d829ac-d6ac-4f37-863d-08ce3808c0e1",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=04d829ac-d6ac-4f37-863d-08ce3808c0e1"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDRkODI5YWMtZDZhYy00ZjM3LTg2M2QtMDhjZTM4MDhjMGUxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDRkODI5YWMtZDZhYy00ZjM3LTg2M2QtMDhjZTM4MDhjMGUxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:04d829ac-d6ac-4f37-863d-08ce3808c0e1_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "04d829ac-d6ac-4f37-863d-08ce3808c0e1",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2197323@Y=41390221@L=%23mcp%3AV%3Adonkey-barcelona%3A04d829ac-d6ac-4f37-863d-08ce3808c0e1_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A04d829ac-d6ac-4f37-863d-08ce3808c0e1_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.197323,
                    "lat": 41.390221
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0e910c65-b130-4c74-8d86-f9e4d781bcd9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0e910c65-b130-4c74-8d86-f9e4d781bcd9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0e910c65-b130-4c74-8d86-f9e4d781bcd9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0e910c65-b130-4c74-8d86-f9e4d781bcd9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGU5MTBjNjUtYjEzMC00Yzc0LThkODYtZjllNGQ3ODFiY2Q5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGU5MTBjNjUtYjEzMC00Yzc0LThkODYtZjllNGQ3ODFiY2Q5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0e910c65-b130-4c74-8d86-f9e4d781bcd9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0e910c65-b130-4c74-8d86-f9e4d781bcd9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2164512@Y=41390238@L=%23mcp%3AV%3Adonkey-barcelona%3A0e910c65-b130-4c74-8d86-f9e4d781bcd9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0e910c65-b130-4c74-8d86-f9e4d781bcd9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.164512,
                    "lat": 41.390238
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6a86fad4-8c8f-4d38-9460-dbedbc391a9d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6a86fad4-8c8f-4d38-9460-dbedbc391a9d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6a86fad4-8c8f-4d38-9460-dbedbc391a9d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6a86fad4-8c8f-4d38-9460-dbedbc391a9d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmE4NmZhZDQtOGM4Zi00ZDM4LTk0NjAtZGJlZGJjMzkxYTlkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmE4NmZhZDQtOGM4Zi00ZDM4LTk0NjAtZGJlZGJjMzkxYTlkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6a86fad4-8c8f-4d38-9460-dbedbc391a9d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6a86fad4-8c8f-4d38-9460-dbedbc391a9d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2197155@Y=41390303@L=%23mcp%3AV%3Adonkey-barcelona%3A6a86fad4-8c8f-4d38-9460-dbedbc391a9d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6a86fad4-8c8f-4d38-9460-dbedbc391a9d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.197155,
                    "lat": 41.390303
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ebc909c0-eac0-4570-9b5d-bffb6ddd5011",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ebc909c0-eac0-4570-9b5d-bffb6ddd5011"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ebc909c0-eac0-4570-9b5d-bffb6ddd5011",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ebc909c0-eac0-4570-9b5d-bffb6ddd5011"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWJjOTA5YzAtZWFjMC00NTcwLTliNWQtYmZmYjZkZGQ1MDExIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWJjOTA5YzAtZWFjMC00NTcwLTliNWQtYmZmYjZkZGQ1MDExIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ebc909c0-eac0-4570-9b5d-bffb6ddd5011_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ebc909c0-eac0-4570-9b5d-bffb6ddd5011",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2156084@Y=41390501@L=%23mcp%3AV%3Adonkey-barcelona%3Aebc909c0-eac0-4570-9b5d-bffb6ddd5011_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aebc909c0-eac0-4570-9b5d-bffb6ddd5011_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.156084,
                    "lat": 41.390501
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f1d7a58d-6dfc-49bf-a314-a963f7454fa5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f1d7a58d-6dfc-49bf-a314-a963f7454fa5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f1d7a58d-6dfc-49bf-a314-a963f7454fa5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f1d7a58d-6dfc-49bf-a314-a963f7454fa5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjFkN2E1OGQtNmRmYy00OWJmLWEzMTQtYTk2M2Y3NDU0ZmE1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjFkN2E1OGQtNmRmYy00OWJmLWEzMTQtYTk2M2Y3NDU0ZmE1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f1d7a58d-6dfc-49bf-a314-a963f7454fa5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f1d7a58d-6dfc-49bf-a314-a963f7454fa5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2201481@Y=41390859@L=%23mcp%3AV%3Adonkey-barcelona%3Af1d7a58d-6dfc-49bf-a314-a963f7454fa5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af1d7a58d-6dfc-49bf-a314-a963f7454fa5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.201481,
                    "lat": 41.390859
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=26f157af-e9e4-432e-8e93-6621b8e0592e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=26f157af-e9e4-432e-8e93-6621b8e0592e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=26f157af-e9e4-432e-8e93-6621b8e0592e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=26f157af-e9e4-432e-8e93-6621b8e0592e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjZmMTU3YWYtZTllNC00MzJlLThlOTMtNjYyMWI4ZTA1OTJlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjZmMTU3YWYtZTllNC00MzJlLThlOTMtNjYyMWI4ZTA1OTJlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:26f157af-e9e4-432e-8e93-6621b8e0592e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "26f157af-e9e4-432e-8e93-6621b8e0592e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2202589@Y=41391209@L=%23mcp%3AV%3Adonkey-barcelona%3A26f157af-e9e4-432e-8e93-6621b8e0592e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A26f157af-e9e4-432e-8e93-6621b8e0592e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.202589,
                    "lat": 41.391209
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c238caf2-aa47-4229-9b10-fd86fe2f1de8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c238caf2-aa47-4229-9b10-fd86fe2f1de8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c238caf2-aa47-4229-9b10-fd86fe2f1de8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c238caf2-aa47-4229-9b10-fd86fe2f1de8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzIzOGNhZjItYWE0Ny00MjI5LTliMTAtZmQ4NmZlMmYxZGU4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzIzOGNhZjItYWE0Ny00MjI5LTliMTAtZmQ4NmZlMmYxZGU4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c238caf2-aa47-4229-9b10-fd86fe2f1de8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c238caf2-aa47-4229-9b10-fd86fe2f1de8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2202581@Y=41391214@L=%23mcp%3AV%3Adonkey-barcelona%3Ac238caf2-aa47-4229-9b10-fd86fe2f1de8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac238caf2-aa47-4229-9b10-fd86fe2f1de8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.202581,
                    "lat": 41.391214
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7ec7bd6a-7148-4e18-83a4-67c1980e2174",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7ec7bd6a-7148-4e18-83a4-67c1980e2174"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7ec7bd6a-7148-4e18-83a4-67c1980e2174",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7ec7bd6a-7148-4e18-83a4-67c1980e2174"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2VjN2JkNmEtNzE0OC00ZTE4LTgzYTQtNjdjMTk4MGUyMTc0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2VjN2JkNmEtNzE0OC00ZTE4LTgzYTQtNjdjMTk4MGUyMTc0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7ec7bd6a-7148-4e18-83a4-67c1980e2174_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7ec7bd6a-7148-4e18-83a4-67c1980e2174",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2202573@Y=41391241@L=%23mcp%3AV%3Adonkey-barcelona%3A7ec7bd6a-7148-4e18-83a4-67c1980e2174_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7ec7bd6a-7148-4e18-83a4-67c1980e2174_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.202573,
                    "lat": 41.391241
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b0800614-228b-4fed-9467-2b379afdc818",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b0800614-228b-4fed-9467-2b379afdc818"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b0800614-228b-4fed-9467-2b379afdc818",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b0800614-228b-4fed-9467-2b379afdc818"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjA4MDA2MTQtMjI4Yi00ZmVkLTk0NjctMmIzNzlhZmRjODE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjA4MDA2MTQtMjI4Yi00ZmVkLTk0NjctMmIzNzlhZmRjODE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b0800614-228b-4fed-9467-2b379afdc818_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b0800614-228b-4fed-9467-2b379afdc818",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2200246@Y=41391484@L=%23mcp%3AV%3Adonkey-barcelona%3Ab0800614-228b-4fed-9467-2b379afdc818_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab0800614-228b-4fed-9467-2b379afdc818_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.200246,
                    "lat": 41.391484
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1a52a62a-bea5-4673-84a4-126df8f00af8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1a52a62a-bea5-4673-84a4-126df8f00af8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1a52a62a-bea5-4673-84a4-126df8f00af8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1a52a62a-bea5-4673-84a4-126df8f00af8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWE1MmE2MmEtYmVhNS00NjczLTg0YTQtMTI2ZGY4ZjAwYWY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWE1MmE2MmEtYmVhNS00NjczLTg0YTQtMTI2ZGY4ZjAwYWY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1a52a62a-bea5-4673-84a4-126df8f00af8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1a52a62a-bea5-4673-84a4-126df8f00af8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189033@Y=41391578@L=%23mcp%3AV%3Adonkey-barcelona%3A1a52a62a-bea5-4673-84a4-126df8f00af8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1a52a62a-bea5-4673-84a4-126df8f00af8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189033,
                    "lat": 41.391578
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=07af8650-6e5c-486b-9b4d-8d726dc12549",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=07af8650-6e5c-486b-9b4d-8d726dc12549"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=07af8650-6e5c-486b-9b4d-8d726dc12549",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=07af8650-6e5c-486b-9b4d-8d726dc12549"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDdhZjg2NTAtNmU1Yy00ODZiLTliNGQtOGQ3MjZkYzEyNTQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDdhZjg2NTAtNmU1Yy00ODZiLTliNGQtOGQ3MjZkYzEyNTQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:07af8650-6e5c-486b-9b4d-8d726dc12549_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "07af8650-6e5c-486b-9b4d-8d726dc12549",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191508@Y=41391657@L=%23mcp%3AV%3Adonkey-barcelona%3A07af8650-6e5c-486b-9b4d-8d726dc12549_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A07af8650-6e5c-486b-9b4d-8d726dc12549_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191508,
                    "lat": 41.391657
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dc1f5635-0295-4e6b-955a-aea343102960",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dc1f5635-0295-4e6b-955a-aea343102960"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dc1f5635-0295-4e6b-955a-aea343102960",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dc1f5635-0295-4e6b-955a-aea343102960"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGMxZjU2MzUtMDI5NS00ZTZiLTk1NWEtYWVhMzQzMTAyOTYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGMxZjU2MzUtMDI5NS00ZTZiLTk1NWEtYWVhMzQzMTAyOTYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:dc1f5635-0295-4e6b-955a-aea343102960_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "dc1f5635-0295-4e6b-955a-aea343102960",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2197809@Y=41391875@L=%23mcp%3AV%3Adonkey-barcelona%3Adc1f5635-0295-4e6b-955a-aea343102960_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Adc1f5635-0295-4e6b-955a-aea343102960_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.197809,
                    "lat": 41.391875
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6d017e92-c303-48ea-b281-5a74785cd09f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6d017e92-c303-48ea-b281-5a74785cd09f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6d017e92-c303-48ea-b281-5a74785cd09f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6d017e92-c303-48ea-b281-5a74785cd09f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmQwMTdlOTItYzMwMy00OGVhLWIyODEtNWE3NDc4NWNkMDlmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmQwMTdlOTItYzMwMy00OGVhLWIyODEtNWE3NDc4NWNkMDlmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6d017e92-c303-48ea-b281-5a74785cd09f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6d017e92-c303-48ea-b281-5a74785cd09f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2197809@Y=41391875@L=%23mcp%3AV%3Adonkey-barcelona%3A6d017e92-c303-48ea-b281-5a74785cd09f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6d017e92-c303-48ea-b281-5a74785cd09f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.197809,
                    "lat": 41.391875
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2d370075-0964-4583-acae-e9a7626add0f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2d370075-0964-4583-acae-e9a7626add0f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2d370075-0964-4583-acae-e9a7626add0f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2d370075-0964-4583-acae-e9a7626add0f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmQzNzAwNzUtMDk2NC00NTgzLWFjYWUtZTlhNzYyNmFkZDBmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmQzNzAwNzUtMDk2NC00NTgzLWFjYWUtZTlhNzYyNmFkZDBmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2d370075-0964-4583-acae-e9a7626add0f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2d370075-0964-4583-acae-e9a7626add0f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2204011@Y=41391932@L=%23mcp%3AV%3Adonkey-barcelona%3A2d370075-0964-4583-acae-e9a7626add0f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2d370075-0964-4583-acae-e9a7626add0f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.204011,
                    "lat": 41.391932
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e1198498-c714-4249-8b25-78f184d5cde9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e1198498-c714-4249-8b25-78f184d5cde9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e1198498-c714-4249-8b25-78f184d5cde9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e1198498-c714-4249-8b25-78f184d5cde9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTExOTg0OTgtYzcxNC00MjQ5LThiMjUtNzhmMTg0ZDVjZGU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTExOTg0OTgtYzcxNC00MjQ5LThiMjUtNzhmMTg0ZDVjZGU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e1198498-c714-4249-8b25-78f184d5cde9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e1198498-c714-4249-8b25-78f184d5cde9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2203987@Y=41391955@L=%23mcp%3AV%3Adonkey-barcelona%3Ae1198498-c714-4249-8b25-78f184d5cde9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae1198498-c714-4249-8b25-78f184d5cde9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.203987,
                    "lat": 41.391955
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b394c0ba-2fdf-4756-ab35-113715f93277",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b394c0ba-2fdf-4756-ab35-113715f93277"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b394c0ba-2fdf-4756-ab35-113715f93277",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b394c0ba-2fdf-4756-ab35-113715f93277"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjM5NGMwYmEtMmZkZi00NzU2LWFiMzUtMTEzNzE1ZjkzMjc3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjM5NGMwYmEtMmZkZi00NzU2LWFiMzUtMTEzNzE1ZjkzMjc3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b394c0ba-2fdf-4756-ab35-113715f93277_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b394c0ba-2fdf-4756-ab35-113715f93277",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2204044@Y=41391959@L=%23mcp%3AV%3Adonkey-barcelona%3Ab394c0ba-2fdf-4756-ab35-113715f93277_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab394c0ba-2fdf-4756-ab35-113715f93277_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.204044,
                    "lat": 41.391959
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b81c67bb-f843-47b3-9f8b-b3fb8157f7f3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b81c67bb-f843-47b3-9f8b-b3fb8157f7f3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b81c67bb-f843-47b3-9f8b-b3fb8157f7f3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b81c67bb-f843-47b3-9f8b-b3fb8157f7f3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjgxYzY3YmItZjg0My00N2IzLTlmOGItYjNmYjgxNTdmN2YzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjgxYzY3YmItZjg0My00N2IzLTlmOGItYjNmYjgxNTdmN2YzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b81c67bb-f843-47b3-9f8b-b3fb8157f7f3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b81c67bb-f843-47b3-9f8b-b3fb8157f7f3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2203990@Y=41391964@L=%23mcp%3AV%3Adonkey-barcelona%3Ab81c67bb-f843-47b3-9f8b-b3fb8157f7f3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab81c67bb-f843-47b3-9f8b-b3fb8157f7f3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.20399,
                    "lat": 41.391964
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5135ab35-8a91-4c51-acdb-0a4265d266d4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5135ab35-8a91-4c51-acdb-0a4265d266d4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5135ab35-8a91-4c51-acdb-0a4265d266d4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5135ab35-8a91-4c51-acdb-0a4265d266d4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTEzNWFiMzUtOGE5MS00YzUxLWFjZGItMGE0MjY1ZDI2NmQ0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTEzNWFiMzUtOGE5MS00YzUxLWFjZGItMGE0MjY1ZDI2NmQ0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5135ab35-8a91-4c51-acdb-0a4265d266d4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5135ab35-8a91-4c51-acdb-0a4265d266d4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2204037@Y=41391967@L=%23mcp%3AV%3Adonkey-barcelona%3A5135ab35-8a91-4c51-acdb-0a4265d266d4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5135ab35-8a91-4c51-acdb-0a4265d266d4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.204037,
                    "lat": 41.391967
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=02d6a313-4442-4567-b6ba-20104aa0a5ed",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=02d6a313-4442-4567-b6ba-20104aa0a5ed"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=02d6a313-4442-4567-b6ba-20104aa0a5ed",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=02d6a313-4442-4567-b6ba-20104aa0a5ed"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDJkNmEzMTMtNDQ0Mi00NTY3LWI2YmEtMjAxMDRhYTBhNWVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDJkNmEzMTMtNDQ0Mi00NTY3LWI2YmEtMjAxMDRhYTBhNWVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:02d6a313-4442-4567-b6ba-20104aa0a5ed_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "02d6a313-4442-4567-b6ba-20104aa0a5ed",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2204034@Y=41391977@L=%23mcp%3AV%3Adonkey-barcelona%3A02d6a313-4442-4567-b6ba-20104aa0a5ed_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A02d6a313-4442-4567-b6ba-20104aa0a5ed_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.204034,
                    "lat": 41.391977
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b70a49ad-0336-466b-9c7c-f96b862b526f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b70a49ad-0336-466b-9c7c-f96b862b526f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b70a49ad-0336-466b-9c7c-f96b862b526f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b70a49ad-0336-466b-9c7c-f96b862b526f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjcwYTQ5YWQtMDMzNi00NjZiLTljN2MtZjk2Yjg2MmI1MjZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjcwYTQ5YWQtMDMzNi00NjZiLTljN2MtZjk2Yjg2MmI1MjZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b70a49ad-0336-466b-9c7c-f96b862b526f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b70a49ad-0336-466b-9c7c-f96b862b526f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2204087@Y=41391979@L=%23mcp%3AV%3Adonkey-barcelona%3Ab70a49ad-0336-466b-9c7c-f96b862b526f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab70a49ad-0336-466b-9c7c-f96b862b526f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.204087,
                    "lat": 41.391979
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3905ee3f-9f55-463c-8ff8-6176ce04c85c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3905ee3f-9f55-463c-8ff8-6176ce04c85c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3905ee3f-9f55-463c-8ff8-6176ce04c85c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3905ee3f-9f55-463c-8ff8-6176ce04c85c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzkwNWVlM2YtOWY1NS00NjNjLThmZjgtNjE3NmNlMDRjODVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzkwNWVlM2YtOWY1NS00NjNjLThmZjgtNjE3NmNlMDRjODVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3905ee3f-9f55-463c-8ff8-6176ce04c85c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3905ee3f-9f55-463c-8ff8-6176ce04c85c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2204040@Y=41391988@L=%23mcp%3AV%3Adonkey-barcelona%3A3905ee3f-9f55-463c-8ff8-6176ce04c85c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3905ee3f-9f55-463c-8ff8-6176ce04c85c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.20404,
                    "lat": 41.391988
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a50540fc-3112-411a-8b2b-1a9b2dddb765",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a50540fc-3112-411a-8b2b-1a9b2dddb765"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a50540fc-3112-411a-8b2b-1a9b2dddb765",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a50540fc-3112-411a-8b2b-1a9b2dddb765"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTUwNTQwZmMtMzExMi00MTFhLThiMmItMWE5YjJkZGRiNzY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTUwNTQwZmMtMzExMi00MTFhLThiMmItMWE5YjJkZGRiNzY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a50540fc-3112-411a-8b2b-1a9b2dddb765_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a50540fc-3112-411a-8b2b-1a9b2dddb765",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2203994@Y=41392009@L=%23mcp%3AV%3Adonkey-barcelona%3Aa50540fc-3112-411a-8b2b-1a9b2dddb765_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa50540fc-3112-411a-8b2b-1a9b2dddb765_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.203994,
                    "lat": 41.392009
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=604554b1-f5f3-4b86-a73b-8ae0e0bbc462",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=604554b1-f5f3-4b86-a73b-8ae0e0bbc462"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=604554b1-f5f3-4b86-a73b-8ae0e0bbc462",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=604554b1-f5f3-4b86-a73b-8ae0e0bbc462"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjA0NTU0YjEtZjVmMy00Yjg2LWE3M2ItOGFlMGUwYmJjNDYyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjA0NTU0YjEtZjVmMy00Yjg2LWE3M2ItOGFlMGUwYmJjNDYyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:604554b1-f5f3-4b86-a73b-8ae0e0bbc462_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "604554b1-f5f3-4b86-a73b-8ae0e0bbc462",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2167124@Y=41392175@L=%23mcp%3AV%3Adonkey-barcelona%3A604554b1-f5f3-4b86-a73b-8ae0e0bbc462_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A604554b1-f5f3-4b86-a73b-8ae0e0bbc462_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.167124,
                    "lat": 41.392175
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7f65297f-69c6-4a54-8101-f21911ff4baa",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7f65297f-69c6-4a54-8101-f21911ff4baa"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7f65297f-69c6-4a54-8101-f21911ff4baa",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7f65297f-69c6-4a54-8101-f21911ff4baa"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2Y2NTI5N2YtNjljNi00YTU0LTgxMDEtZjIxOTExZmY0YmFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2Y2NTI5N2YtNjljNi00YTU0LTgxMDEtZjIxOTExZmY0YmFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7f65297f-69c6-4a54-8101-f21911ff4baa_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7f65297f-69c6-4a54-8101-f21911ff4baa",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190114@Y=41392296@L=%23mcp%3AV%3Adonkey-barcelona%3A7f65297f-69c6-4a54-8101-f21911ff4baa_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7f65297f-69c6-4a54-8101-f21911ff4baa_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.190114,
                    "lat": 41.392296
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1467d66a-b467-47c3-bea8-c4dca6bc4f0d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1467d66a-b467-47c3-bea8-c4dca6bc4f0d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1467d66a-b467-47c3-bea8-c4dca6bc4f0d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1467d66a-b467-47c3-bea8-c4dca6bc4f0d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTQ2N2Q2NmEtYjQ2Ny00N2MzLWJlYTgtYzRkY2E2YmM0ZjBkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTQ2N2Q2NmEtYjQ2Ny00N2MzLWJlYTgtYzRkY2E2YmM0ZjBkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1467d66a-b467-47c3-bea8-c4dca6bc4f0d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1467d66a-b467-47c3-bea8-c4dca6bc4f0d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2205064@Y=41392875@L=%23mcp%3AV%3Adonkey-barcelona%3A1467d66a-b467-47c3-bea8-c4dca6bc4f0d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1467d66a-b467-47c3-bea8-c4dca6bc4f0d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.205064,
                    "lat": 41.392875
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=00091c73-c4cb-4823-bbb2-258ed63e6f5c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=00091c73-c4cb-4823-bbb2-258ed63e6f5c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=00091c73-c4cb-4823-bbb2-258ed63e6f5c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=00091c73-c4cb-4823-bbb2-258ed63e6f5c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDAwOTFjNzMtYzRjYi00ODIzLWJiYjItMjU4ZWQ2M2U2ZjVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDAwOTFjNzMtYzRjYi00ODIzLWJiYjItMjU4ZWQ2M2U2ZjVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:00091c73-c4cb-4823-bbb2-258ed63e6f5c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "00091c73-c4cb-4823-bbb2-258ed63e6f5c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2205053@Y=41392903@L=%23mcp%3AV%3Adonkey-barcelona%3A00091c73-c4cb-4823-bbb2-258ed63e6f5c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A00091c73-c4cb-4823-bbb2-258ed63e6f5c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.205053,
                    "lat": 41.392903
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8b5bdaec-6abb-492b-9c5a-b112220f1493",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8b5bdaec-6abb-492b-9c5a-b112220f1493"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8b5bdaec-6abb-492b-9c5a-b112220f1493",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8b5bdaec-6abb-492b-9c5a-b112220f1493"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGI1YmRhZWMtNmFiYi00OTJiLTljNWEtYjExMjIyMGYxNDkzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGI1YmRhZWMtNmFiYi00OTJiLTljNWEtYjExMjIyMGYxNDkzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8b5bdaec-6abb-492b-9c5a-b112220f1493_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8b5bdaec-6abb-492b-9c5a-b112220f1493",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2182481@Y=41393025@L=%23mcp%3AV%3Adonkey-barcelona%3A8b5bdaec-6abb-492b-9c5a-b112220f1493_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8b5bdaec-6abb-492b-9c5a-b112220f1493_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.182481,
                    "lat": 41.393025
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e009c11b-5931-4357-92b4-01e562179e6b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e009c11b-5931-4357-92b4-01e562179e6b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e009c11b-5931-4357-92b4-01e562179e6b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e009c11b-5931-4357-92b4-01e562179e6b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTAwOWMxMWItNTkzMS00MzU3LTkyYjQtMDFlNTYyMTc5ZTZiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTAwOWMxMWItNTkzMS00MzU3LTkyYjQtMDFlNTYyMTc5ZTZiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e009c11b-5931-4357-92b4-01e562179e6b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e009c11b-5931-4357-92b4-01e562179e6b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173225@Y=41393054@L=%23mcp%3AV%3Adonkey-barcelona%3Ae009c11b-5931-4357-92b4-01e562179e6b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae009c11b-5931-4357-92b4-01e562179e6b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173225,
                    "lat": 41.393054
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=45fe96b0-4d71-4b6d-97d1-b1d131a55688",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=45fe96b0-4d71-4b6d-97d1-b1d131a55688"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=45fe96b0-4d71-4b6d-97d1-b1d131a55688",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=45fe96b0-4d71-4b6d-97d1-b1d131a55688"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDVmZTk2YjAtNGQ3MS00YjZkLTk3ZDEtYjFkMTMxYTU1Njg4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDVmZTk2YjAtNGQ3MS00YjZkLTk3ZDEtYjFkMTMxYTU1Njg4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:45fe96b0-4d71-4b6d-97d1-b1d131a55688_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "45fe96b0-4d71-4b6d-97d1-b1d131a55688",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2177778@Y=41393054@L=%23mcp%3AV%3Adonkey-barcelona%3A45fe96b0-4d71-4b6d-97d1-b1d131a55688_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A45fe96b0-4d71-4b6d-97d1-b1d131a55688_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.177778,
                    "lat": 41.393054
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=079b603a-26e3-4c13-aade-e6e9e59bdc55",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=079b603a-26e3-4c13-aade-e6e9e59bdc55"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=079b603a-26e3-4c13-aade-e6e9e59bdc55",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=079b603a-26e3-4c13-aade-e6e9e59bdc55"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDc5YjYwM2EtMjZlMy00YzEzLWFhZGUtZTZlOWU1OWJkYzU1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDc5YjYwM2EtMjZlMy00YzEzLWFhZGUtZTZlOWU1OWJkYzU1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:079b603a-26e3-4c13-aade-e6e9e59bdc55_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "079b603a-26e3-4c13-aade-e6e9e59bdc55",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189456@Y=41393133@L=%23mcp%3AV%3Adonkey-barcelona%3A079b603a-26e3-4c13-aade-e6e9e59bdc55_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A079b603a-26e3-4c13-aade-e6e9e59bdc55_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189456,
                    "lat": 41.393133
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=423a72ab-b0b4-45d6-a74e-baa90706250e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=423a72ab-b0b4-45d6-a74e-baa90706250e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=423a72ab-b0b4-45d6-a74e-baa90706250e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=423a72ab-b0b4-45d6-a74e-baa90706250e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDIzYTcyYWItYjBiNC00NWQ2LWE3NGUtYmFhOTA3MDYyNTBlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDIzYTcyYWItYjBiNC00NWQ2LWE3NGUtYmFhOTA3MDYyNTBlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:423a72ab-b0b4-45d6-a74e-baa90706250e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "423a72ab-b0b4-45d6-a74e-baa90706250e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2205478@Y=41393365@L=%23mcp%3AV%3Adonkey-barcelona%3A423a72ab-b0b4-45d6-a74e-baa90706250e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A423a72ab-b0b4-45d6-a74e-baa90706250e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.205478,
                    "lat": 41.393365
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e429687f-e0ea-4271-bcb0-cebb639024f4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e429687f-e0ea-4271-bcb0-cebb639024f4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e429687f-e0ea-4271-bcb0-cebb639024f4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e429687f-e0ea-4271-bcb0-cebb639024f4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTQyOTY4N2YtZTBlYS00MjcxLWJjYjAtY2ViYjYzOTAyNGY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTQyOTY4N2YtZTBlYS00MjcxLWJjYjAtY2ViYjYzOTAyNGY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e429687f-e0ea-4271-bcb0-cebb639024f4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e429687f-e0ea-4271-bcb0-cebb639024f4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2205503@Y=41393397@L=%23mcp%3AV%3Adonkey-barcelona%3Ae429687f-e0ea-4271-bcb0-cebb639024f4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae429687f-e0ea-4271-bcb0-cebb639024f4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.205503,
                    "lat": 41.393397
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=55773c78-5d51-4492-8727-11ffd330321f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=55773c78-5d51-4492-8727-11ffd330321f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=55773c78-5d51-4492-8727-11ffd330321f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=55773c78-5d51-4492-8727-11ffd330321f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTU3NzNjNzgtNWQ1MS00NDkyLTg3MjctMTFmZmQzMzAzMjFmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTU3NzNjNzgtNWQ1MS00NDkyLTg3MjctMTFmZmQzMzAzMjFmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:55773c78-5d51-4492-8727-11ffd330321f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "55773c78-5d51-4492-8727-11ffd330321f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2205539@Y=41393403@L=%23mcp%3AV%3Adonkey-barcelona%3A55773c78-5d51-4492-8727-11ffd330321f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A55773c78-5d51-4492-8727-11ffd330321f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.205539,
                    "lat": 41.393403
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3a767c87-ab0c-45f7-9b50-34875311a33c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3a767c87-ab0c-45f7-9b50-34875311a33c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3a767c87-ab0c-45f7-9b50-34875311a33c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3a767c87-ab0c-45f7-9b50-34875311a33c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2E3NjdjODctYWIwYy00NWY3LTliNTAtMzQ4NzUzMTFhMzNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2E3NjdjODctYWIwYy00NWY3LTliNTAtMzQ4NzUzMTFhMzNjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3a767c87-ab0c-45f7-9b50-34875311a33c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3a767c87-ab0c-45f7-9b50-34875311a33c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2205504@Y=41393405@L=%23mcp%3AV%3Adonkey-barcelona%3A3a767c87-ab0c-45f7-9b50-34875311a33c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3a767c87-ab0c-45f7-9b50-34875311a33c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.205504,
                    "lat": 41.393405
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0b07dc09-ce51-44b3-97e1-a415975f04b5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0b07dc09-ce51-44b3-97e1-a415975f04b5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0b07dc09-ce51-44b3-97e1-a415975f04b5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0b07dc09-ce51-44b3-97e1-a415975f04b5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGIwN2RjMDktY2U1MS00NGIzLTk3ZTEtYTQxNTk3NWYwNGI1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGIwN2RjMDktY2U1MS00NGIzLTk3ZTEtYTQxNTk3NWYwNGI1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0b07dc09-ce51-44b3-97e1-a415975f04b5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0b07dc09-ce51-44b3-97e1-a415975f04b5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2181932@Y=41393467@L=%23mcp%3AV%3Adonkey-barcelona%3A0b07dc09-ce51-44b3-97e1-a415975f04b5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0b07dc09-ce51-44b3-97e1-a415975f04b5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.181932,
                    "lat": 41.393467
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2df8324a-1819-49c9-aeba-eddd25c2fdcd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2df8324a-1819-49c9-aeba-eddd25c2fdcd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2df8324a-1819-49c9-aeba-eddd25c2fdcd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2df8324a-1819-49c9-aeba-eddd25c2fdcd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmRmODMyNGEtMTgxOS00OWM5LWFlYmEtZWRkZDI1YzJmZGNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmRmODMyNGEtMTgxOS00OWM5LWFlYmEtZWRkZDI1YzJmZGNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2df8324a-1819-49c9-aeba-eddd25c2fdcd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2df8324a-1819-49c9-aeba-eddd25c2fdcd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173383@Y=41393492@L=%23mcp%3AV%3Adonkey-barcelona%3A2df8324a-1819-49c9-aeba-eddd25c2fdcd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2df8324a-1819-49c9-aeba-eddd25c2fdcd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173383,
                    "lat": 41.393492
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d95d8bac-d076-49f9-b469-bc76e4fbdd37",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d95d8bac-d076-49f9-b469-bc76e4fbdd37"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d95d8bac-d076-49f9-b469-bc76e4fbdd37",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d95d8bac-d076-49f9-b469-bc76e4fbdd37"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDk1ZDhiYWMtZDA3Ni00OWY5LWI0NjktYmM3NmU0ZmJkZDM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDk1ZDhiYWMtZDA3Ni00OWY5LWI0NjktYmM3NmU0ZmJkZDM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d95d8bac-d076-49f9-b469-bc76e4fbdd37_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d95d8bac-d076-49f9-b469-bc76e4fbdd37",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2163012@Y=41393766@L=%23mcp%3AV%3Adonkey-barcelona%3Ad95d8bac-d076-49f9-b469-bc76e4fbdd37_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad95d8bac-d076-49f9-b469-bc76e4fbdd37_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.163012,
                    "lat": 41.393766
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=84b3a3b2-4582-4609-b3c1-e6d9798b845c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=84b3a3b2-4582-4609-b3c1-e6d9798b845c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=84b3a3b2-4582-4609-b3c1-e6d9798b845c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=84b3a3b2-4582-4609-b3c1-e6d9798b845c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODRiM2EzYjItNDU4Mi00NjA5LWIzYzEtZTZkOTc5OGI4NDVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODRiM2EzYjItNDU4Mi00NjA5LWIzYzEtZTZkOTc5OGI4NDVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:84b3a3b2-4582-4609-b3c1-e6d9798b845c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "84b3a3b2-4582-4609-b3c1-e6d9798b845c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2179113@Y=41393908@L=%23mcp%3AV%3Adonkey-barcelona%3A84b3a3b2-4582-4609-b3c1-e6d9798b845c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A84b3a3b2-4582-4609-b3c1-e6d9798b845c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.179113,
                    "lat": 41.393908
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2e7983ec-3d2c-4369-91a9-890bf0d83c36",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2e7983ec-3d2c-4369-91a9-890bf0d83c36"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2e7983ec-3d2c-4369-91a9-890bf0d83c36",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2e7983ec-3d2c-4369-91a9-890bf0d83c36"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmU3OTgzZWMtM2QyYy00MzY5LTkxYTktODkwYmYwZDgzYzM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmU3OTgzZWMtM2QyYy00MzY5LTkxYTktODkwYmYwZDgzYzM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2e7983ec-3d2c-4369-91a9-890bf0d83c36_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2e7983ec-3d2c-4369-91a9-890bf0d83c36",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2205686@Y=41394031@L=%23mcp%3AV%3Adonkey-barcelona%3A2e7983ec-3d2c-4369-91a9-890bf0d83c36_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2e7983ec-3d2c-4369-91a9-890bf0d83c36_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.205686,
                    "lat": 41.394031
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b712f67c-fb02-48a2-bd2d-f745f15d4e58",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b712f67c-fb02-48a2-bd2d-f745f15d4e58"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b712f67c-fb02-48a2-bd2d-f745f15d4e58",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b712f67c-fb02-48a2-bd2d-f745f15d4e58"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjcxMmY2N2MtZmIwMi00OGEyLWJkMmQtZjc0NWYxNWQ0ZTU4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjcxMmY2N2MtZmIwMi00OGEyLWJkMmQtZjc0NWYxNWQ0ZTU4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b712f67c-fb02-48a2-bd2d-f745f15d4e58_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b712f67c-fb02-48a2-bd2d-f745f15d4e58",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2194193@Y=41394485@L=%23mcp%3AV%3Adonkey-barcelona%3Ab712f67c-fb02-48a2-bd2d-f745f15d4e58_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab712f67c-fb02-48a2-bd2d-f745f15d4e58_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.194193,
                    "lat": 41.394485
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b98302cb-cfd9-40b3-b3be-e9d485f6e6bd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b98302cb-cfd9-40b3-b3be-e9d485f6e6bd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b98302cb-cfd9-40b3-b3be-e9d485f6e6bd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b98302cb-cfd9-40b3-b3be-e9d485f6e6bd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjk4MzAyY2ItY2ZkOS00MGIzLWIzYmUtZTlkNDg1ZjZlNmJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjk4MzAyY2ItY2ZkOS00MGIzLWIzYmUtZTlkNDg1ZjZlNmJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b98302cb-cfd9-40b3-b3be-e9d485f6e6bd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b98302cb-cfd9-40b3-b3be-e9d485f6e6bd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191031@Y=41395024@L=%23mcp%3AV%3Adonkey-barcelona%3Ab98302cb-cfd9-40b3-b3be-e9d485f6e6bd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab98302cb-cfd9-40b3-b3be-e9d485f6e6bd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191031,
                    "lat": 41.395024
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ee4357e4-8316-43f8-a4c2-e073a394716e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ee4357e4-8316-43f8-a4c2-e073a394716e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ee4357e4-8316-43f8-a4c2-e073a394716e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ee4357e4-8316-43f8-a4c2-e073a394716e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWU0MzU3ZTQtODMxNi00M2Y4LWE0YzItZTA3M2EzOTQ3MTZlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWU0MzU3ZTQtODMxNi00M2Y4LWE0YzItZTA3M2EzOTQ3MTZlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ee4357e4-8316-43f8-a4c2-e073a394716e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ee4357e4-8316-43f8-a4c2-e073a394716e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191200@Y=41395025@L=%23mcp%3AV%3Adonkey-barcelona%3Aee4357e4-8316-43f8-a4c2-e073a394716e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aee4357e4-8316-43f8-a4c2-e073a394716e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.1912,
                    "lat": 41.395025
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=28d6bad2-2661-45aa-b7f3-7a0259c060ed",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=28d6bad2-2661-45aa-b7f3-7a0259c060ed"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=28d6bad2-2661-45aa-b7f3-7a0259c060ed",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=28d6bad2-2661-45aa-b7f3-7a0259c060ed"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjhkNmJhZDItMjY2MS00NWFhLWI3ZjMtN2EwMjU5YzA2MGVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjhkNmJhZDItMjY2MS00NWFhLWI3ZjMtN2EwMjU5YzA2MGVkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:28d6bad2-2661-45aa-b7f3-7a0259c060ed_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "28d6bad2-2661-45aa-b7f3-7a0259c060ed",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191132@Y=41395027@L=%23mcp%3AV%3Adonkey-barcelona%3A28d6bad2-2661-45aa-b7f3-7a0259c060ed_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A28d6bad2-2661-45aa-b7f3-7a0259c060ed_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191132,
                    "lat": 41.395027
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=516fb36f-d5f8-4501-bdc3-eaf37d748459",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=516fb36f-d5f8-4501-bdc3-eaf37d748459"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=516fb36f-d5f8-4501-bdc3-eaf37d748459",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=516fb36f-d5f8-4501-bdc3-eaf37d748459"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTE2ZmIzNmYtZDVmOC00NTAxLWJkYzMtZWFmMzdkNzQ4NDU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTE2ZmIzNmYtZDVmOC00NTAxLWJkYzMtZWFmMzdkNzQ4NDU5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:516fb36f-d5f8-4501-bdc3-eaf37d748459_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "516fb36f-d5f8-4501-bdc3-eaf37d748459",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191007@Y=41395098@L=%23mcp%3AV%3Adonkey-barcelona%3A516fb36f-d5f8-4501-bdc3-eaf37d748459_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A516fb36f-d5f8-4501-bdc3-eaf37d748459_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191007,
                    "lat": 41.395098
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=388076e0-1b14-4cb6-9f84-0719be331d6a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=388076e0-1b14-4cb6-9f84-0719be331d6a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=388076e0-1b14-4cb6-9f84-0719be331d6a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=388076e0-1b14-4cb6-9f84-0719be331d6a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzg4MDc2ZTAtMWIxNC00Y2I2LTlmODQtMDcxOWJlMzMxZDZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzg4MDc2ZTAtMWIxNC00Y2I2LTlmODQtMDcxOWJlMzMxZDZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:388076e0-1b14-4cb6-9f84-0719be331d6a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "388076e0-1b14-4cb6-9f84-0719be331d6a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190886@Y=41395154@L=%23mcp%3AV%3Adonkey-barcelona%3A388076e0-1b14-4cb6-9f84-0719be331d6a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A388076e0-1b14-4cb6-9f84-0719be331d6a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.190886,
                    "lat": 41.395154
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f30f11ad-3964-4afb-b1a6-453578ae76f8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f30f11ad-3964-4afb-b1a6-453578ae76f8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f30f11ad-3964-4afb-b1a6-453578ae76f8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f30f11ad-3964-4afb-b1a6-453578ae76f8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjMwZjExYWQtMzk2NC00YWZiLWIxYTYtNDUzNTc4YWU3NmY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjMwZjExYWQtMzk2NC00YWZiLWIxYTYtNDUzNTc4YWU3NmY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f30f11ad-3964-4afb-b1a6-453578ae76f8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f30f11ad-3964-4afb-b1a6-453578ae76f8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196992@Y=41395491@L=%23mcp%3AV%3Adonkey-barcelona%3Af30f11ad-3964-4afb-b1a6-453578ae76f8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af30f11ad-3964-4afb-b1a6-453578ae76f8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196992,
                    "lat": 41.395491
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=48f0b544-f839-472f-bb41-21b9827cb7ae",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=48f0b544-f839-472f-bb41-21b9827cb7ae"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=48f0b544-f839-472f-bb41-21b9827cb7ae",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=48f0b544-f839-472f-bb41-21b9827cb7ae"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDhmMGI1NDQtZjgzOS00NzJmLWJiNDEtMjFiOTgyN2NiN2FlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDhmMGI1NDQtZjgzOS00NzJmLWJiNDEtMjFiOTgyN2NiN2FlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:48f0b544-f839-472f-bb41-21b9827cb7ae_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "48f0b544-f839-472f-bb41-21b9827cb7ae",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2192290@Y=41395547@L=%23mcp%3AV%3Adonkey-barcelona%3A48f0b544-f839-472f-bb41-21b9827cb7ae_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A48f0b544-f839-472f-bb41-21b9827cb7ae_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.19229,
                    "lat": 41.395547
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c00a3f9a-eebd-4f62-b6b3-f6f2ebf4c6bd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c00a3f9a-eebd-4f62-b6b3-f6f2ebf4c6bd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c00a3f9a-eebd-4f62-b6b3-f6f2ebf4c6bd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c00a3f9a-eebd-4f62-b6b3-f6f2ebf4c6bd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzAwYTNmOWEtZWViZC00ZjYyLWI2YjMtZjZmMmViZjRjNmJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzAwYTNmOWEtZWViZC00ZjYyLWI2YjMtZjZmMmViZjRjNmJkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c00a3f9a-eebd-4f62-b6b3-f6f2ebf4c6bd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c00a3f9a-eebd-4f62-b6b3-f6f2ebf4c6bd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190096@Y=41395790@L=%23mcp%3AV%3Adonkey-barcelona%3Ac00a3f9a-eebd-4f62-b6b3-f6f2ebf4c6bd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac00a3f9a-eebd-4f62-b6b3-f6f2ebf4c6bd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.190096,
                    "lat": 41.39579
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=35c1f735-13f1-4355-b863-f9b2b374f18c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=35c1f735-13f1-4355-b863-f9b2b374f18c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=35c1f735-13f1-4355-b863-f9b2b374f18c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=35c1f735-13f1-4355-b863-f9b2b374f18c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzVjMWY3MzUtMTNmMS00MzU1LWI4NjMtZjliMmIzNzRmMThjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzVjMWY3MzUtMTNmMS00MzU1LWI4NjMtZjliMmIzNzRmMThjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:35c1f735-13f1-4355-b863-f9b2b374f18c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "35c1f735-13f1-4355-b863-f9b2b374f18c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190133@Y=41395800@L=%23mcp%3AV%3Adonkey-barcelona%3A35c1f735-13f1-4355-b863-f9b2b374f18c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A35c1f735-13f1-4355-b863-f9b2b374f18c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.190133,
                    "lat": 41.3958
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=253073e2-087b-4d64-9063-902fc07de4fa",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=253073e2-087b-4d64-9063-902fc07de4fa"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=253073e2-087b-4d64-9063-902fc07de4fa",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=253073e2-087b-4d64-9063-902fc07de4fa"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjUzMDczZTItMDg3Yi00ZDY0LTkwNjMtOTAyZmMwN2RlNGZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjUzMDczZTItMDg3Yi00ZDY0LTkwNjMtOTAyZmMwN2RlNGZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:253073e2-087b-4d64-9063-902fc07de4fa_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "253073e2-087b-4d64-9063-902fc07de4fa",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2163015@Y=41395965@L=%23mcp%3AV%3Adonkey-barcelona%3A253073e2-087b-4d64-9063-902fc07de4fa_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A253073e2-087b-4d64-9063-902fc07de4fa_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.163015,
                    "lat": 41.395965
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=39939ce8-b9ea-4a0e-be12-cf5e7e650fda",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=39939ce8-b9ea-4a0e-be12-cf5e7e650fda"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=39939ce8-b9ea-4a0e-be12-cf5e7e650fda",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=39939ce8-b9ea-4a0e-be12-cf5e7e650fda"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzk5MzljZTgtYjllYS00YTBlLWJlMTItY2Y1ZTdlNjUwZmRhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzk5MzljZTgtYjllYS00YTBlLWJlMTItY2Y1ZTdlNjUwZmRhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:39939ce8-b9ea-4a0e-be12-cf5e7e650fda_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "39939ce8-b9ea-4a0e-be12-cf5e7e650fda",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2193096@Y=41395985@L=%23mcp%3AV%3Adonkey-barcelona%3A39939ce8-b9ea-4a0e-be12-cf5e7e650fda_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A39939ce8-b9ea-4a0e-be12-cf5e7e650fda_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.193096,
                    "lat": 41.395985
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ba4de6db-1e98-4530-b4c7-b7a55af27236",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ba4de6db-1e98-4530-b4c7-b7a55af27236"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ba4de6db-1e98-4530-b4c7-b7a55af27236",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ba4de6db-1e98-4530-b4c7-b7a55af27236"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmE0ZGU2ZGItMWU5OC00NTMwLWI0YzctYjdhNTVhZjI3MjM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmE0ZGU2ZGItMWU5OC00NTMwLWI0YzctYjdhNTVhZjI3MjM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ba4de6db-1e98-4530-b4c7-b7a55af27236_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ba4de6db-1e98-4530-b4c7-b7a55af27236",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170143@Y=41396074@L=%23mcp%3AV%3Adonkey-barcelona%3Aba4de6db-1e98-4530-b4c7-b7a55af27236_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aba4de6db-1e98-4530-b4c7-b7a55af27236_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.170143,
                    "lat": 41.396074
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=81a559cf-7769-480c-b2c3-5b959e1a3839",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=81a559cf-7769-480c-b2c3-5b959e1a3839"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=81a559cf-7769-480c-b2c3-5b959e1a3839",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=81a559cf-7769-480c-b2c3-5b959e1a3839"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODFhNTU5Y2YtNzc2OS00ODBjLWIyYzMtNWI5NTllMWEzODM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODFhNTU5Y2YtNzc2OS00ODBjLWIyYzMtNWI5NTllMWEzODM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:81a559cf-7769-480c-b2c3-5b959e1a3839_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "81a559cf-7769-480c-b2c3-5b959e1a3839",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196485@Y=41396128@L=%23mcp%3AV%3Adonkey-barcelona%3A81a559cf-7769-480c-b2c3-5b959e1a3839_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A81a559cf-7769-480c-b2c3-5b959e1a3839_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196485,
                    "lat": 41.396128
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=45db0f2f-f60f-414b-a016-cfc1dfc32f5b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=45db0f2f-f60f-414b-a016-cfc1dfc32f5b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=45db0f2f-f60f-414b-a016-cfc1dfc32f5b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=45db0f2f-f60f-414b-a016-cfc1dfc32f5b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDVkYjBmMmYtZjYwZi00MTRiLWEwMTYtY2ZjMWRmYzMyZjViIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDVkYjBmMmYtZjYwZi00MTRiLWEwMTYtY2ZjMWRmYzMyZjViIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:45db0f2f-f60f-414b-a016-cfc1dfc32f5b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "45db0f2f-f60f-414b-a016-cfc1dfc32f5b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196494@Y=41396139@L=%23mcp%3AV%3Adonkey-barcelona%3A45db0f2f-f60f-414b-a016-cfc1dfc32f5b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A45db0f2f-f60f-414b-a016-cfc1dfc32f5b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196494,
                    "lat": 41.396139
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=397a8c07-4739-4b6a-9c59-94ae5d3ce2b7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=397a8c07-4739-4b6a-9c59-94ae5d3ce2b7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=397a8c07-4739-4b6a-9c59-94ae5d3ce2b7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=397a8c07-4739-4b6a-9c59-94ae5d3ce2b7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzk3YThjMDctNDczOS00YjZhLTljNTktOTRhZTVkM2NlMmI3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzk3YThjMDctNDczOS00YjZhLTljNTktOTRhZTVkM2NlMmI3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:397a8c07-4739-4b6a-9c59-94ae5d3ce2b7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "397a8c07-4739-4b6a-9c59-94ae5d3ce2b7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189098@Y=41396601@L=%23mcp%3AV%3Adonkey-barcelona%3A397a8c07-4739-4b6a-9c59-94ae5d3ce2b7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A397a8c07-4739-4b6a-9c59-94ae5d3ce2b7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189098,
                    "lat": 41.396601
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2d59a0eb-a446-40a8-b7c4-0d6430a90a18",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2d59a0eb-a446-40a8-b7c4-0d6430a90a18"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2d59a0eb-a446-40a8-b7c4-0d6430a90a18",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2d59a0eb-a446-40a8-b7c4-0d6430a90a18"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmQ1OWEwZWItYTQ0Ni00MGE4LWI3YzQtMGQ2NDMwYTkwYTE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmQ1OWEwZWItYTQ0Ni00MGE4LWI3YzQtMGQ2NDMwYTkwYTE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2d59a0eb-a446-40a8-b7c4-0d6430a90a18_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2d59a0eb-a446-40a8-b7c4-0d6430a90a18",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2178164@Y=41396699@L=%23mcp%3AV%3Adonkey-barcelona%3A2d59a0eb-a446-40a8-b7c4-0d6430a90a18_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2d59a0eb-a446-40a8-b7c4-0d6430a90a18_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.178164,
                    "lat": 41.396699
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bc437b93-f04f-48a7-bbad-b37ee2642592",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bc437b93-f04f-48a7-bbad-b37ee2642592"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=bc437b93-f04f-48a7-bbad-b37ee2642592",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=bc437b93-f04f-48a7-bbad-b37ee2642592"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmM0MzdiOTMtZjA0Zi00OGE3LWJiYWQtYjM3ZWUyNjQyNTkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmM0MzdiOTMtZjA0Zi00OGE3LWJiYWQtYjM3ZWUyNjQyNTkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:bc437b93-f04f-48a7-bbad-b37ee2642592_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "bc437b93-f04f-48a7-bbad-b37ee2642592",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2210109@Y=41397011@L=%23mcp%3AV%3Adonkey-barcelona%3Abc437b93-f04f-48a7-bbad-b37ee2642592_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Abc437b93-f04f-48a7-bbad-b37ee2642592_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.210109,
                    "lat": 41.397011
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=67d194dd-132f-4345-8c70-39a3d7490b38",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=67d194dd-132f-4345-8c70-39a3d7490b38"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=67d194dd-132f-4345-8c70-39a3d7490b38",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=67d194dd-132f-4345-8c70-39a3d7490b38"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjdkMTk0ZGQtMTMyZi00MzQ1LThjNzAtMzlhM2Q3NDkwYjM4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjdkMTk0ZGQtMTMyZi00MzQ1LThjNzAtMzlhM2Q3NDkwYjM4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:67d194dd-132f-4345-8c70-39a3d7490b38_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "67d194dd-132f-4345-8c70-39a3d7490b38",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2168034@Y=41397111@L=%23mcp%3AV%3Adonkey-barcelona%3A67d194dd-132f-4345-8c70-39a3d7490b38_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A67d194dd-132f-4345-8c70-39a3d7490b38_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.168034,
                    "lat": 41.397111
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ec11e939-f440-42d8-8462-850075e6a4a8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ec11e939-f440-42d8-8462-850075e6a4a8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ec11e939-f440-42d8-8462-850075e6a4a8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ec11e939-f440-42d8-8462-850075e6a4a8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWMxMWU5MzktZjQ0MC00MmQ4LTg0NjItODUwMDc1ZTZhNGE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWMxMWU5MzktZjQ0MC00MmQ4LTg0NjItODUwMDc1ZTZhNGE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ec11e939-f440-42d8-8462-850075e6a4a8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ec11e939-f440-42d8-8462-850075e6a4a8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2194588@Y=41397173@L=%23mcp%3AV%3Adonkey-barcelona%3Aec11e939-f440-42d8-8462-850075e6a4a8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aec11e939-f440-42d8-8462-850075e6a4a8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.194588,
                    "lat": 41.397173
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9954a229-af1f-4485-b5d0-856750145200",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9954a229-af1f-4485-b5d0-856750145200"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9954a229-af1f-4485-b5d0-856750145200",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9954a229-af1f-4485-b5d0-856750145200"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTk1NGEyMjktYWYxZi00NDg1LWI1ZDAtODU2NzUwMTQ1MjAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTk1NGEyMjktYWYxZi00NDg1LWI1ZDAtODU2NzUwMTQ1MjAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9954a229-af1f-4485-b5d0-856750145200_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9954a229-af1f-4485-b5d0-856750145200",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2176022@Y=41397180@L=%23mcp%3AV%3Adonkey-barcelona%3A9954a229-af1f-4485-b5d0-856750145200_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9954a229-af1f-4485-b5d0-856750145200_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.176022,
                    "lat": 41.39718
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5f72343b-1175-4b3a-b6cf-ca4b8b28b323",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5f72343b-1175-4b3a-b6cf-ca4b8b28b323"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5f72343b-1175-4b3a-b6cf-ca4b8b28b323",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5f72343b-1175-4b3a-b6cf-ca4b8b28b323"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWY3MjM0M2ItMTE3NS00YjNhLWI2Y2YtY2E0YjhiMjhiMzIzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWY3MjM0M2ItMTE3NS00YjNhLWI2Y2YtY2E0YjhiMjhiMzIzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5f72343b-1175-4b3a-b6cf-ca4b8b28b323_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5f72343b-1175-4b3a-b6cf-ca4b8b28b323",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2185533@Y=41397260@L=%23mcp%3AV%3Adonkey-barcelona%3A5f72343b-1175-4b3a-b6cf-ca4b8b28b323_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5f72343b-1175-4b3a-b6cf-ca4b8b28b323_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.185533,
                    "lat": 41.39726
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9bd11337-8070-4608-b0f7-56d7ac56add3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9bd11337-8070-4608-b0f7-56d7ac56add3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9bd11337-8070-4608-b0f7-56d7ac56add3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9bd11337-8070-4608-b0f7-56d7ac56add3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWJkMTEzMzctODA3MC00NjA4LWIwZjctNTZkN2FjNTZhZGQzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWJkMTEzMzctODA3MC00NjA4LWIwZjctNTZkN2FjNTZhZGQzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9bd11337-8070-4608-b0f7-56d7ac56add3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9bd11337-8070-4608-b0f7-56d7ac56add3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2199354@Y=41397260@L=%23mcp%3AV%3Adonkey-barcelona%3A9bd11337-8070-4608-b0f7-56d7ac56add3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9bd11337-8070-4608-b0f7-56d7ac56add3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.199354,
                    "lat": 41.39726
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e29f2524-6af7-41f6-8308-6c418e89d495",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e29f2524-6af7-41f6-8308-6c418e89d495"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e29f2524-6af7-41f6-8308-6c418e89d495",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e29f2524-6af7-41f6-8308-6c418e89d495"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTI5ZjI1MjQtNmFmNy00MWY2LTgzMDgtNmM0MThlODlkNDk1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTI5ZjI1MjQtNmFmNy00MWY2LTgzMDgtNmM0MThlODlkNDk1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e29f2524-6af7-41f6-8308-6c418e89d495_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e29f2524-6af7-41f6-8308-6c418e89d495",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2193113@Y=41397529@L=%23mcp%3AV%3Adonkey-barcelona%3Ae29f2524-6af7-41f6-8308-6c418e89d495_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae29f2524-6af7-41f6-8308-6c418e89d495_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.193113,
                    "lat": 41.397529
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1c9b8477-95e4-4f04-8305-db92c9e69d61",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1c9b8477-95e4-4f04-8305-db92c9e69d61"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1c9b8477-95e4-4f04-8305-db92c9e69d61",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1c9b8477-95e4-4f04-8305-db92c9e69d61"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWM5Yjg0NzctOTVlNC00ZjA0LTgzMDUtZGI5MmM5ZTY5ZDYxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWM5Yjg0NzctOTVlNC00ZjA0LTgzMDUtZGI5MmM5ZTY5ZDYxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1c9b8477-95e4-4f04-8305-db92c9e69d61_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1c9b8477-95e4-4f04-8305-db92c9e69d61",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190249@Y=41397587@L=%23mcp%3AV%3Adonkey-barcelona%3A1c9b8477-95e4-4f04-8305-db92c9e69d61_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1c9b8477-95e4-4f04-8305-db92c9e69d61_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.190249,
                    "lat": 41.397587
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7436e445-bdd6-4b7a-8924-8f3218e4fc8a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7436e445-bdd6-4b7a-8924-8f3218e4fc8a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7436e445-bdd6-4b7a-8924-8f3218e4fc8a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7436e445-bdd6-4b7a-8924-8f3218e4fc8a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzQzNmU0NDUtYmRkNi00YjdhLTg5MjQtOGYzMjE4ZTRmYzhhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzQzNmU0NDUtYmRkNi00YjdhLTg5MjQtOGYzMjE4ZTRmYzhhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7436e445-bdd6-4b7a-8924-8f3218e4fc8a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7436e445-bdd6-4b7a-8924-8f3218e4fc8a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2202381@Y=41397770@L=%23mcp%3AV%3Adonkey-barcelona%3A7436e445-bdd6-4b7a-8924-8f3218e4fc8a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7436e445-bdd6-4b7a-8924-8f3218e4fc8a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.202381,
                    "lat": 41.39777
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7b6d0988-4ea0-444e-9966-acb223f9a33b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7b6d0988-4ea0-444e-9966-acb223f9a33b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7b6d0988-4ea0-444e-9966-acb223f9a33b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7b6d0988-4ea0-444e-9966-acb223f9a33b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2I2ZDA5ODgtNGVhMC00NDRlLTk5NjYtYWNiMjIzZjlhMzNiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2I2ZDA5ODgtNGVhMC00NDRlLTk5NjYtYWNiMjIzZjlhMzNiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7b6d0988-4ea0-444e-9966-acb223f9a33b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7b6d0988-4ea0-444e-9966-acb223f9a33b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2195658@Y=41397918@L=%23mcp%3AV%3Adonkey-barcelona%3A7b6d0988-4ea0-444e-9966-acb223f9a33b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7b6d0988-4ea0-444e-9966-acb223f9a33b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.195658,
                    "lat": 41.397918
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dba797e5-a1a7-4cb6-b53c-3fcccc0a36a4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dba797e5-a1a7-4cb6-b53c-3fcccc0a36a4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dba797e5-a1a7-4cb6-b53c-3fcccc0a36a4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dba797e5-a1a7-4cb6-b53c-3fcccc0a36a4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGJhNzk3ZTUtYTFhNy00Y2I2LWI1M2MtM2ZjY2NjMGEzNmE0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGJhNzk3ZTUtYTFhNy00Y2I2LWI1M2MtM2ZjY2NjMGEzNmE0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:dba797e5-a1a7-4cb6-b53c-3fcccc0a36a4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "dba797e5-a1a7-4cb6-b53c-3fcccc0a36a4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2174825@Y=41397927@L=%23mcp%3AV%3Adonkey-barcelona%3Adba797e5-a1a7-4cb6-b53c-3fcccc0a36a4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Adba797e5-a1a7-4cb6-b53c-3fcccc0a36a4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.174825,
                    "lat": 41.397927
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=720bc1ae-bc47-4f88-a360-e2a119b92774",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=720bc1ae-bc47-4f88-a360-e2a119b92774"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=720bc1ae-bc47-4f88-a360-e2a119b92774",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=720bc1ae-bc47-4f88-a360-e2a119b92774"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzIwYmMxYWUtYmM0Ny00Zjg4LWEzNjAtZTJhMTE5YjkyNzc0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzIwYmMxYWUtYmM0Ny00Zjg4LWEzNjAtZTJhMTE5YjkyNzc0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:720bc1ae-bc47-4f88-a360-e2a119b92774_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "720bc1ae-bc47-4f88-a360-e2a119b92774",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2174817@Y=41397929@L=%23mcp%3AV%3Adonkey-barcelona%3A720bc1ae-bc47-4f88-a360-e2a119b92774_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A720bc1ae-bc47-4f88-a360-e2a119b92774_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.174817,
                    "lat": 41.397929
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ec324867-967b-4a02-9e12-83ee6ce7f9a8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ec324867-967b-4a02-9e12-83ee6ce7f9a8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ec324867-967b-4a02-9e12-83ee6ce7f9a8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ec324867-967b-4a02-9e12-83ee6ce7f9a8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWMzMjQ4NjctOTY3Yi00YTAyLTllMTItODNlZTZjZTdmOWE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWMzMjQ4NjctOTY3Yi00YTAyLTllMTItODNlZTZjZTdmOWE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ec324867-967b-4a02-9e12-83ee6ce7f9a8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ec324867-967b-4a02-9e12-83ee6ce7f9a8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2174670@Y=41397997@L=%23mcp%3AV%3Adonkey-barcelona%3Aec324867-967b-4a02-9e12-83ee6ce7f9a8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aec324867-967b-4a02-9e12-83ee6ce7f9a8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.17467,
                    "lat": 41.397997
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=006fa8e5-5b31-4e6d-9a03-a6ece3586fd0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=006fa8e5-5b31-4e6d-9a03-a6ece3586fd0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=006fa8e5-5b31-4e6d-9a03-a6ece3586fd0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=006fa8e5-5b31-4e6d-9a03-a6ece3586fd0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDA2ZmE4ZTUtNWIzMS00ZTZkLTlhMDMtYTZlY2UzNTg2ZmQwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDA2ZmE4ZTUtNWIzMS00ZTZkLTlhMDMtYTZlY2UzNTg2ZmQwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:006fa8e5-5b31-4e6d-9a03-a6ece3586fd0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "006fa8e5-5b31-4e6d-9a03-a6ece3586fd0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2200480@Y=41398057@L=%23mcp%3AV%3Adonkey-barcelona%3A006fa8e5-5b31-4e6d-9a03-a6ece3586fd0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A006fa8e5-5b31-4e6d-9a03-a6ece3586fd0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.20048,
                    "lat": 41.398057
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b8420791-8a0a-40f2-a4a8-905f7c53cbfb",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b8420791-8a0a-40f2-a4a8-905f7c53cbfb"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b8420791-8a0a-40f2-a4a8-905f7c53cbfb",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b8420791-8a0a-40f2-a4a8-905f7c53cbfb"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjg0MjA3OTEtOGEwYS00MGYyLWE0YTgtOTA1ZjdjNTNjYmZiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjg0MjA3OTEtOGEwYS00MGYyLWE0YTgtOTA1ZjdjNTNjYmZiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b8420791-8a0a-40f2-a4a8-905f7c53cbfb_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b8420791-8a0a-40f2-a4a8-905f7c53cbfb",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191731@Y=41398183@L=%23mcp%3AV%3Adonkey-barcelona%3Ab8420791-8a0a-40f2-a4a8-905f7c53cbfb_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab8420791-8a0a-40f2-a4a8-905f7c53cbfb_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191731,
                    "lat": 41.398183
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5bfdbc2f-9e71-4df2-892f-f390ac8f3408",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5bfdbc2f-9e71-4df2-892f-f390ac8f3408"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5bfdbc2f-9e71-4df2-892f-f390ac8f3408",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5bfdbc2f-9e71-4df2-892f-f390ac8f3408"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWJmZGJjMmYtOWU3MS00ZGYyLTg5MmYtZjM5MGFjOGYzNDA4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWJmZGJjMmYtOWU3MS00ZGYyLTg5MmYtZjM5MGFjOGYzNDA4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5bfdbc2f-9e71-4df2-892f-f390ac8f3408_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5bfdbc2f-9e71-4df2-892f-f390ac8f3408",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2204741@Y=41398486@L=%23mcp%3AV%3Adonkey-barcelona%3A5bfdbc2f-9e71-4df2-892f-f390ac8f3408_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5bfdbc2f-9e71-4df2-892f-f390ac8f3408_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.204741,
                    "lat": 41.398486
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6fd9bc3e-acf5-4d79-a03e-9ab561da0f2a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6fd9bc3e-acf5-4d79-a03e-9ab561da0f2a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6fd9bc3e-acf5-4d79-a03e-9ab561da0f2a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6fd9bc3e-acf5-4d79-a03e-9ab561da0f2a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmZkOWJjM2UtYWNmNS00ZDc5LWEwM2UtOWFiNTYxZGEwZjJhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmZkOWJjM2UtYWNmNS00ZDc5LWEwM2UtOWFiNTYxZGEwZjJhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6fd9bc3e-acf5-4d79-a03e-9ab561da0f2a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6fd9bc3e-acf5-4d79-a03e-9ab561da0f2a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170986@Y=41398596@L=%23mcp%3AV%3Adonkey-barcelona%3A6fd9bc3e-acf5-4d79-a03e-9ab561da0f2a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6fd9bc3e-acf5-4d79-a03e-9ab561da0f2a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.170986,
                    "lat": 41.398596
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=27fc9bcb-b38a-45f3-9947-36736d106210",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=27fc9bcb-b38a-45f3-9947-36736d106210"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=27fc9bcb-b38a-45f3-9947-36736d106210",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=27fc9bcb-b38a-45f3-9947-36736d106210"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjdmYzliY2ItYjM4YS00NWYzLTk5NDctMzY3MzZkMTA2MjEwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjdmYzliY2ItYjM4YS00NWYzLTk5NDctMzY3MzZkMTA2MjEwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:27fc9bcb-b38a-45f3-9947-36736d106210_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "27fc9bcb-b38a-45f3-9947-36736d106210",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2170412@Y=41398848@L=%23mcp%3AV%3Adonkey-barcelona%3A27fc9bcb-b38a-45f3-9947-36736d106210_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A27fc9bcb-b38a-45f3-9947-36736d106210_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.170412,
                    "lat": 41.398848
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4d6fec40-39db-49e7-8b55-31254a4970af",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4d6fec40-39db-49e7-8b55-31254a4970af"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4d6fec40-39db-49e7-8b55-31254a4970af",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4d6fec40-39db-49e7-8b55-31254a4970af"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGQ2ZmVjNDAtMzlkYi00OWU3LThiNTUtMzEyNTRhNDk3MGFmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGQ2ZmVjNDAtMzlkYi00OWU3LThiNTUtMzEyNTRhNDk3MGFmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4d6fec40-39db-49e7-8b55-31254a4970af_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4d6fec40-39db-49e7-8b55-31254a4970af",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2176833@Y=41399053@L=%23mcp%3AV%3Adonkey-barcelona%3A4d6fec40-39db-49e7-8b55-31254a4970af_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4d6fec40-39db-49e7-8b55-31254a4970af_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.176833,
                    "lat": 41.399053
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f519acbe-85eb-444c-9375-0655f0fe4bfa",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f519acbe-85eb-444c-9375-0655f0fe4bfa"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f519acbe-85eb-444c-9375-0655f0fe4bfa",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f519acbe-85eb-444c-9375-0655f0fe4bfa"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjUxOWFjYmUtODVlYi00NDRjLTkzNzUtMDY1NWYwZmU0YmZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjUxOWFjYmUtODVlYi00NDRjLTkzNzUtMDY1NWYwZmU0YmZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f519acbe-85eb-444c-9375-0655f0fe4bfa_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f519acbe-85eb-444c-9375-0655f0fe4bfa",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189862@Y=41399551@L=%23mcp%3AV%3Adonkey-barcelona%3Af519acbe-85eb-444c-9375-0655f0fe4bfa_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af519acbe-85eb-444c-9375-0655f0fe4bfa_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.189862,
                    "lat": 41.399551
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dc90b476-eb8f-4fea-bf28-cc04cf0a32c0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dc90b476-eb8f-4fea-bf28-cc04cf0a32c0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dc90b476-eb8f-4fea-bf28-cc04cf0a32c0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dc90b476-eb8f-4fea-bf28-cc04cf0a32c0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGM5MGI0NzYtZWI4Zi00ZmVhLWJmMjgtY2MwNGNmMGEzMmMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGM5MGI0NzYtZWI4Zi00ZmVhLWJmMjgtY2MwNGNmMGEzMmMwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:dc90b476-eb8f-4fea-bf28-cc04cf0a32c0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "dc90b476-eb8f-4fea-bf28-cc04cf0a32c0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191361@Y=41399862@L=%23mcp%3AV%3Adonkey-barcelona%3Adc90b476-eb8f-4fea-bf28-cc04cf0a32c0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Adc90b476-eb8f-4fea-bf28-cc04cf0a32c0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191361,
                    "lat": 41.399862
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a1de9525-1dfe-4d81-be4f-89e5377542b3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a1de9525-1dfe-4d81-be4f-89e5377542b3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a1de9525-1dfe-4d81-be4f-89e5377542b3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a1de9525-1dfe-4d81-be4f-89e5377542b3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTFkZTk1MjUtMWRmZS00ZDgxLWJlNGYtODllNTM3NzU0MmIzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTFkZTk1MjUtMWRmZS00ZDgxLWJlNGYtODllNTM3NzU0MmIzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a1de9525-1dfe-4d81-be4f-89e5377542b3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a1de9525-1dfe-4d81-be4f-89e5377542b3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191704@Y=41400002@L=%23mcp%3AV%3Adonkey-barcelona%3Aa1de9525-1dfe-4d81-be4f-89e5377542b3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa1de9525-1dfe-4d81-be4f-89e5377542b3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191704,
                    "lat": 41.400002
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f04dc3ba-77b9-4856-a68b-9c9c491422ba",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f04dc3ba-77b9-4856-a68b-9c9c491422ba"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f04dc3ba-77b9-4856-a68b-9c9c491422ba",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f04dc3ba-77b9-4856-a68b-9c9c491422ba"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjA0ZGMzYmEtNzdiOS00ODU2LWE2OGItOWM5YzQ5MTQyMmJhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjA0ZGMzYmEtNzdiOS00ODU2LWE2OGItOWM5YzQ5MTQyMmJhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f04dc3ba-77b9-4856-a68b-9c9c491422ba_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f04dc3ba-77b9-4856-a68b-9c9c491422ba",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190731@Y=41400404@L=%23mcp%3AV%3Adonkey-barcelona%3Af04dc3ba-77b9-4856-a68b-9c9c491422ba_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af04dc3ba-77b9-4856-a68b-9c9c491422ba_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.190731,
                    "lat": 41.400404
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6e08ae85-8484-4427-9ca8-2e62dcf460fa",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6e08ae85-8484-4427-9ca8-2e62dcf460fa"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6e08ae85-8484-4427-9ca8-2e62dcf460fa",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6e08ae85-8484-4427-9ca8-2e62dcf460fa"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmUwOGFlODUtODQ4NC00NDI3LTljYTgtMmU2MmRjZjQ2MGZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmUwOGFlODUtODQ4NC00NDI3LTljYTgtMmU2MmRjZjQ2MGZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6e08ae85-8484-4427-9ca8-2e62dcf460fa_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6e08ae85-8484-4427-9ca8-2e62dcf460fa",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190768@Y=41400473@L=%23mcp%3AV%3Adonkey-barcelona%3A6e08ae85-8484-4427-9ca8-2e62dcf460fa_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6e08ae85-8484-4427-9ca8-2e62dcf460fa_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.190768,
                    "lat": 41.400473
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=05a5dbaa-ae81-4338-8d93-bf961635a921",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=05a5dbaa-ae81-4338-8d93-bf961635a921"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=05a5dbaa-ae81-4338-8d93-bf961635a921",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=05a5dbaa-ae81-4338-8d93-bf961635a921"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDVhNWRiYWEtYWU4MS00MzM4LThkOTMtYmY5NjE2MzVhOTIxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDVhNWRiYWEtYWU4MS00MzM4LThkOTMtYmY5NjE2MzVhOTIxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:05a5dbaa-ae81-4338-8d93-bf961635a921_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "05a5dbaa-ae81-4338-8d93-bf961635a921",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2206624@Y=41400563@L=%23mcp%3AV%3Adonkey-barcelona%3A05a5dbaa-ae81-4338-8d93-bf961635a921_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A05a5dbaa-ae81-4338-8d93-bf961635a921_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.206624,
                    "lat": 41.400563
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9ac7ff86-2a25-447c-a02c-a427a625a30c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9ac7ff86-2a25-447c-a02c-a427a625a30c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9ac7ff86-2a25-447c-a02c-a427a625a30c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9ac7ff86-2a25-447c-a02c-a427a625a30c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWFjN2ZmODYtMmEyNS00NDdjLWEwMmMtYTQyN2E2MjVhMzBjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWFjN2ZmODYtMmEyNS00NDdjLWEwMmMtYTQyN2E2MjVhMzBjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9ac7ff86-2a25-447c-a02c-a427a625a30c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9ac7ff86-2a25-447c-a02c-a427a625a30c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188013@Y=41400594@L=%23mcp%3AV%3Adonkey-barcelona%3A9ac7ff86-2a25-447c-a02c-a427a625a30c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9ac7ff86-2a25-447c-a02c-a427a625a30c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188013,
                    "lat": 41.400594
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=43a5240f-cb9b-48e0-90f4-c99f4b5b36df",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=43a5240f-cb9b-48e0-90f4-c99f4b5b36df"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=43a5240f-cb9b-48e0-90f4-c99f4b5b36df",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=43a5240f-cb9b-48e0-90f4-c99f4b5b36df"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDNhNTI0MGYtY2I5Yi00OGUwLTkwZjQtYzk5ZjRiNWIzNmRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDNhNTI0MGYtY2I5Yi00OGUwLTkwZjQtYzk5ZjRiNWIzNmRmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:43a5240f-cb9b-48e0-90f4-c99f4b5b36df_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "43a5240f-cb9b-48e0-90f4-c99f4b5b36df",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187976@Y=41400597@L=%23mcp%3AV%3Adonkey-barcelona%3A43a5240f-cb9b-48e0-90f4-c99f4b5b36df_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A43a5240f-cb9b-48e0-90f4-c99f4b5b36df_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187976,
                    "lat": 41.400597
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=80b2fbd6-2ddb-48f4-9601-51d97c3a5cc8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=80b2fbd6-2ddb-48f4-9601-51d97c3a5cc8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=80b2fbd6-2ddb-48f4-9601-51d97c3a5cc8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=80b2fbd6-2ddb-48f4-9601-51d97c3a5cc8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODBiMmZiZDYtMmRkYi00OGY0LTk2MDEtNTFkOTdjM2E1Y2M4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODBiMmZiZDYtMmRkYi00OGY0LTk2MDEtNTFkOTdjM2E1Y2M4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:80b2fbd6-2ddb-48f4-9601-51d97c3a5cc8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "80b2fbd6-2ddb-48f4-9601-51d97c3a5cc8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2213350@Y=41400627@L=%23mcp%3AV%3Adonkey-barcelona%3A80b2fbd6-2ddb-48f4-9601-51d97c3a5cc8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A80b2fbd6-2ddb-48f4-9601-51d97c3a5cc8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.21335,
                    "lat": 41.400627
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=558ae104-2ffc-45c0-8699-a291fd4a5d55",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=558ae104-2ffc-45c0-8699-a291fd4a5d55"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=558ae104-2ffc-45c0-8699-a291fd4a5d55",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=558ae104-2ffc-45c0-8699-a291fd4a5d55"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTU4YWUxMDQtMmZmYy00NWMwLTg2OTktYTI5MWZkNGE1ZDU1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTU4YWUxMDQtMmZmYy00NWMwLTg2OTktYTI5MWZkNGE1ZDU1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:558ae104-2ffc-45c0-8699-a291fd4a5d55_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "558ae104-2ffc-45c0-8699-a291fd4a5d55",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2206662@Y=41400634@L=%23mcp%3AV%3Adonkey-barcelona%3A558ae104-2ffc-45c0-8699-a291fd4a5d55_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A558ae104-2ffc-45c0-8699-a291fd4a5d55_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.206662,
                    "lat": 41.400634
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cf1c6cd7-d1ed-4d08-9dee-07c1c6d4fe65",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cf1c6cd7-d1ed-4d08-9dee-07c1c6d4fe65"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cf1c6cd7-d1ed-4d08-9dee-07c1c6d4fe65",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cf1c6cd7-d1ed-4d08-9dee-07c1c6d4fe65"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2YxYzZjZDctZDFlZC00ZDA4LTlkZWUtMDdjMWM2ZDRmZTY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2YxYzZjZDctZDFlZC00ZDA4LTlkZWUtMDdjMWM2ZDRmZTY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cf1c6cd7-d1ed-4d08-9dee-07c1c6d4fe65_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cf1c6cd7-d1ed-4d08-9dee-07c1c6d4fe65",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2188014@Y=41400638@L=%23mcp%3AV%3Adonkey-barcelona%3Acf1c6cd7-d1ed-4d08-9dee-07c1c6d4fe65_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acf1c6cd7-d1ed-4d08-9dee-07c1c6d4fe65_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.188014,
                    "lat": 41.400638
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=120cfe10-88b0-4792-a09b-b161521dac39",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=120cfe10-88b0-4792-a09b-b161521dac39"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=120cfe10-88b0-4792-a09b-b161521dac39",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=120cfe10-88b0-4792-a09b-b161521dac39"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTIwY2ZlMTAtODhiMC00NzkyLWEwOWItYjE2MTUyMWRhYzM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTIwY2ZlMTAtODhiMC00NzkyLWEwOWItYjE2MTUyMWRhYzM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:120cfe10-88b0-4792-a09b-b161521dac39_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "120cfe10-88b0-4792-a09b-b161521dac39",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2206589@Y=41400638@L=%23mcp%3AV%3Adonkey-barcelona%3A120cfe10-88b0-4792-a09b-b161521dac39_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A120cfe10-88b0-4792-a09b-b161521dac39_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.206589,
                    "lat": 41.400638
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3527ad3a-23eb-4ed7-9df1-d8bb1484321d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3527ad3a-23eb-4ed7-9df1-d8bb1484321d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3527ad3a-23eb-4ed7-9df1-d8bb1484321d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3527ad3a-23eb-4ed7-9df1-d8bb1484321d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzUyN2FkM2EtMjNlYi00ZWQ3LTlkZjEtZDhiYjE0ODQzMjFkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzUyN2FkM2EtMjNlYi00ZWQ3LTlkZjEtZDhiYjE0ODQzMjFkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3527ad3a-23eb-4ed7-9df1-d8bb1484321d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3527ad3a-23eb-4ed7-9df1-d8bb1484321d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187984@Y=41400645@L=%23mcp%3AV%3Adonkey-barcelona%3A3527ad3a-23eb-4ed7-9df1-d8bb1484321d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3527ad3a-23eb-4ed7-9df1-d8bb1484321d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187984,
                    "lat": 41.400645
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8af90017-0822-4cbe-8744-3f142a1af8cf",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8af90017-0822-4cbe-8744-3f142a1af8cf"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=8af90017-0822-4cbe-8744-3f142a1af8cf",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=8af90017-0822-4cbe-8744-3f142a1af8cf"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGFmOTAwMTctMDgyMi00Y2JlLTg3NDQtM2YxNDJhMWFmOGNmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOGFmOTAwMTctMDgyMi00Y2JlLTg3NDQtM2YxNDJhMWFmOGNmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:8af90017-0822-4cbe-8744-3f142a1af8cf_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "8af90017-0822-4cbe-8744-3f142a1af8cf",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2206453@Y=41400715@L=%23mcp%3AV%3Adonkey-barcelona%3A8af90017-0822-4cbe-8744-3f142a1af8cf_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A8af90017-0822-4cbe-8744-3f142a1af8cf_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.206453,
                    "lat": 41.400715
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=96c2d361-749e-4c1d-9614-0091c2c2b6d6",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=96c2d361-749e-4c1d-9614-0091c2c2b6d6"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=96c2d361-749e-4c1d-9614-0091c2c2b6d6",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=96c2d361-749e-4c1d-9614-0091c2c2b6d6"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTZjMmQzNjEtNzQ5ZS00YzFkLTk2MTQtMDA5MWMyYzJiNmQ2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTZjMmQzNjEtNzQ5ZS00YzFkLTk2MTQtMDA5MWMyYzJiNmQ2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:96c2d361-749e-4c1d-9614-0091c2c2b6d6_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "96c2d361-749e-4c1d-9614-0091c2c2b6d6",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2206331@Y=41400715@L=%23mcp%3AV%3Adonkey-barcelona%3A96c2d361-749e-4c1d-9614-0091c2c2b6d6_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A96c2d361-749e-4c1d-9614-0091c2c2b6d6_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.206331,
                    "lat": 41.400715
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9f0f21c5-44bd-454d-9a2f-06a59c5ef5ae",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9f0f21c5-44bd-454d-9a2f-06a59c5ef5ae"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9f0f21c5-44bd-454d-9a2f-06a59c5ef5ae",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9f0f21c5-44bd-454d-9a2f-06a59c5ef5ae"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWYwZjIxYzUtNDRiZC00NTRkLTlhMmYtMDZhNTljNWVmNWFlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWYwZjIxYzUtNDRiZC00NTRkLTlhMmYtMDZhNTljNWVmNWFlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9f0f21c5-44bd-454d-9a2f-06a59c5ef5ae_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9f0f21c5-44bd-454d-9a2f-06a59c5ef5ae",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2213287@Y=41400774@L=%23mcp%3AV%3Adonkey-barcelona%3A9f0f21c5-44bd-454d-9a2f-06a59c5ef5ae_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9f0f21c5-44bd-454d-9a2f-06a59c5ef5ae_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.213287,
                    "lat": 41.400774
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ea975e17-7d39-4319-b5e6-5486cebd2d76",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ea975e17-7d39-4319-b5e6-5486cebd2d76"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ea975e17-7d39-4319-b5e6-5486cebd2d76",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ea975e17-7d39-4319-b5e6-5486cebd2d76"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWE5NzVlMTctN2QzOS00MzE5LWI1ZTYtNTQ4NmNlYmQyZDc2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWE5NzVlMTctN2QzOS00MzE5LWI1ZTYtNTQ4NmNlYmQyZDc2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ea975e17-7d39-4319-b5e6-5486cebd2d76_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ea975e17-7d39-4319-b5e6-5486cebd2d76",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2213244@Y=41400814@L=%23mcp%3AV%3Adonkey-barcelona%3Aea975e17-7d39-4319-b5e6-5486cebd2d76_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aea975e17-7d39-4319-b5e6-5486cebd2d76_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.213244,
                    "lat": 41.400814
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1b4aee95-d039-4442-9ad7-72f3bd4fd660",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1b4aee95-d039-4442-9ad7-72f3bd4fd660"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1b4aee95-d039-4442-9ad7-72f3bd4fd660",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1b4aee95-d039-4442-9ad7-72f3bd4fd660"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWI0YWVlOTUtZDAzOS00NDQyLTlhZDctNzJmM2JkNGZkNjYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWI0YWVlOTUtZDAzOS00NDQyLTlhZDctNzJmM2JkNGZkNjYwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1b4aee95-d039-4442-9ad7-72f3bd4fd660_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1b4aee95-d039-4442-9ad7-72f3bd4fd660",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2169531@Y=41400815@L=%23mcp%3AV%3Adonkey-barcelona%3A1b4aee95-d039-4442-9ad7-72f3bd4fd660_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1b4aee95-d039-4442-9ad7-72f3bd4fd660_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.169531,
                    "lat": 41.400815
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3f5c62ab-4f3b-40bf-934c-ba2d6cb43692",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3f5c62ab-4f3b-40bf-934c-ba2d6cb43692"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3f5c62ab-4f3b-40bf-934c-ba2d6cb43692",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3f5c62ab-4f3b-40bf-934c-ba2d6cb43692"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2Y1YzYyYWItNGYzYi00MGJmLTkzNGMtYmEyZDZjYjQzNjkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2Y1YzYyYWItNGYzYi00MGJmLTkzNGMtYmEyZDZjYjQzNjkyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3f5c62ab-4f3b-40bf-934c-ba2d6cb43692_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3f5c62ab-4f3b-40bf-934c-ba2d6cb43692",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2213250@Y=41400826@L=%23mcp%3AV%3Adonkey-barcelona%3A3f5c62ab-4f3b-40bf-934c-ba2d6cb43692_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3f5c62ab-4f3b-40bf-934c-ba2d6cb43692_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.21325,
                    "lat": 41.400826
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b74b8c2b-ec49-4398-91eb-e0031d8100d9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b74b8c2b-ec49-4398-91eb-e0031d8100d9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b74b8c2b-ec49-4398-91eb-e0031d8100d9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b74b8c2b-ec49-4398-91eb-e0031d8100d9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjc0YjhjMmItZWM0OS00Mzk4LTkxZWItZTAwMzFkODEwMGQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjc0YjhjMmItZWM0OS00Mzk4LTkxZWItZTAwMzFkODEwMGQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b74b8c2b-ec49-4398-91eb-e0031d8100d9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b74b8c2b-ec49-4398-91eb-e0031d8100d9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2169478@Y=41400859@L=%23mcp%3AV%3Adonkey-barcelona%3Ab74b8c2b-ec49-4398-91eb-e0031d8100d9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab74b8c2b-ec49-4398-91eb-e0031d8100d9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.169478,
                    "lat": 41.400859
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cfe11340-f324-4818-ae05-333dbd93c7bc",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cfe11340-f324-4818-ae05-333dbd93c7bc"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cfe11340-f324-4818-ae05-333dbd93c7bc",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cfe11340-f324-4818-ae05-333dbd93c7bc"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2ZlMTEzNDAtZjMyNC00ODE4LWFlMDUtMzMzZGJkOTNjN2JjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2ZlMTEzNDAtZjMyNC00ODE4LWFlMDUtMzMzZGJkOTNjN2JjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cfe11340-f324-4818-ae05-333dbd93c7bc_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cfe11340-f324-4818-ae05-333dbd93c7bc",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2204778@Y=41401237@L=%23mcp%3AV%3Adonkey-barcelona%3Acfe11340-f324-4818-ae05-333dbd93c7bc_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acfe11340-f324-4818-ae05-333dbd93c7bc_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.204778,
                    "lat": 41.401237
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0fd36e9d-6660-4604-843b-e3350ad2be55",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0fd36e9d-6660-4604-843b-e3350ad2be55"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0fd36e9d-6660-4604-843b-e3350ad2be55",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0fd36e9d-6660-4604-843b-e3350ad2be55"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGZkMzZlOWQtNjY2MC00NjA0LTg0M2ItZTMzNTBhZDJiZTU1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGZkMzZlOWQtNjY2MC00NjA0LTg0M2ItZTMzNTBhZDJiZTU1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0fd36e9d-6660-4604-843b-e3350ad2be55_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0fd36e9d-6660-4604-843b-e3350ad2be55",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2171103@Y=41401562@L=%23mcp%3AV%3Adonkey-barcelona%3A0fd36e9d-6660-4604-843b-e3350ad2be55_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0fd36e9d-6660-4604-843b-e3350ad2be55_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.171103,
                    "lat": 41.401562
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d5d768d9-14ad-452c-b799-2a230db11968",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d5d768d9-14ad-452c-b799-2a230db11968"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d5d768d9-14ad-452c-b799-2a230db11968",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d5d768d9-14ad-452c-b799-2a230db11968"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDVkNzY4ZDktMTRhZC00NTJjLWI3OTktMmEyMzBkYjExOTY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDVkNzY4ZDktMTRhZC00NTJjLWI3OTktMmEyMzBkYjExOTY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d5d768d9-14ad-452c-b799-2a230db11968_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d5d768d9-14ad-452c-b799-2a230db11968",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2206317@Y=41401584@L=%23mcp%3AV%3Adonkey-barcelona%3Ad5d768d9-14ad-452c-b799-2a230db11968_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad5d768d9-14ad-452c-b799-2a230db11968_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.206317,
                    "lat": 41.401584
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b79cedca-b3a4-41fa-88f9-a819deb42b98",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b79cedca-b3a4-41fa-88f9-a819deb42b98"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b79cedca-b3a4-41fa-88f9-a819deb42b98",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b79cedca-b3a4-41fa-88f9-a819deb42b98"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjc5Y2VkY2EtYjNhNC00MWZhLTg4ZjktYTgxOWRlYjQyYjk4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjc5Y2VkY2EtYjNhNC00MWZhLTg4ZjktYTgxOWRlYjQyYjk4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b79cedca-b3a4-41fa-88f9-a819deb42b98_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b79cedca-b3a4-41fa-88f9-a819deb42b98",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2206347@Y=41401612@L=%23mcp%3AV%3Adonkey-barcelona%3Ab79cedca-b3a4-41fa-88f9-a819deb42b98_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab79cedca-b3a4-41fa-88f9-a819deb42b98_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.206347,
                    "lat": 41.401612
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=68fa7acc-9ebd-4a7d-b993-e170039be06c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=68fa7acc-9ebd-4a7d-b993-e170039be06c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=68fa7acc-9ebd-4a7d-b993-e170039be06c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=68fa7acc-9ebd-4a7d-b993-e170039be06c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjhmYTdhY2MtOWViZC00YTdkLWI5OTMtZTE3MDAzOWJlMDZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjhmYTdhY2MtOWViZC00YTdkLWI5OTMtZTE3MDAzOWJlMDZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:68fa7acc-9ebd-4a7d-b993-e170039be06c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "68fa7acc-9ebd-4a7d-b993-e170039be06c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173514@Y=41401653@L=%23mcp%3AV%3Adonkey-barcelona%3A68fa7acc-9ebd-4a7d-b993-e170039be06c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A68fa7acc-9ebd-4a7d-b993-e170039be06c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173514,
                    "lat": 41.401653
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=767b8fc4-643b-4f12-924f-2f75e87457ca",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=767b8fc4-643b-4f12-924f-2f75e87457ca"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=767b8fc4-643b-4f12-924f-2f75e87457ca",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=767b8fc4-643b-4f12-924f-2f75e87457ca"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzY3YjhmYzQtNjQzYi00ZjEyLTkyNGYtMmY3NWU4NzQ1N2NhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzY3YjhmYzQtNjQzYi00ZjEyLTkyNGYtMmY3NWU4NzQ1N2NhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:767b8fc4-643b-4f12-924f-2f75e87457ca_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "767b8fc4-643b-4f12-924f-2f75e87457ca",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173262@Y=41401801@L=%23mcp%3AV%3Adonkey-barcelona%3A767b8fc4-643b-4f12-924f-2f75e87457ca_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A767b8fc4-643b-4f12-924f-2f75e87457ca_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173262,
                    "lat": 41.401801
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7f4f0d45-d633-49ac-8bd0-1c6e51af1f00",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7f4f0d45-d633-49ac-8bd0-1c6e51af1f00"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7f4f0d45-d633-49ac-8bd0-1c6e51af1f00",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7f4f0d45-d633-49ac-8bd0-1c6e51af1f00"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2Y0ZjBkNDUtZDYzMy00OWFjLThiZDAtMWM2ZTUxYWYxZjAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2Y0ZjBkNDUtZDYzMy00OWFjLThiZDAtMWM2ZTUxYWYxZjAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7f4f0d45-d633-49ac-8bd0-1c6e51af1f00_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7f4f0d45-d633-49ac-8bd0-1c6e51af1f00",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173262@Y=41401801@L=%23mcp%3AV%3Adonkey-barcelona%3A7f4f0d45-d633-49ac-8bd0-1c6e51af1f00_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7f4f0d45-d633-49ac-8bd0-1c6e51af1f00_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173262,
                    "lat": 41.401801
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d1db94cc-5ade-4e17-9a60-d546d948234d",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d1db94cc-5ade-4e17-9a60-d546d948234d"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d1db94cc-5ade-4e17-9a60-d546d948234d",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d1db94cc-5ade-4e17-9a60-d546d948234d"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDFkYjk0Y2MtNWFkZS00ZTE3LTlhNjAtZDU0NmQ5NDgyMzRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDFkYjk0Y2MtNWFkZS00ZTE3LTlhNjAtZDU0NmQ5NDgyMzRkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d1db94cc-5ade-4e17-9a60-d546d948234d_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d1db94cc-5ade-4e17-9a60-d546d948234d",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173262@Y=41401801@L=%23mcp%3AV%3Adonkey-barcelona%3Ad1db94cc-5ade-4e17-9a60-d546d948234d_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad1db94cc-5ade-4e17-9a60-d546d948234d_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173262,
                    "lat": 41.401801
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=262f9639-fc19-43cd-aa5f-36d3623df157",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=262f9639-fc19-43cd-aa5f-36d3623df157"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=262f9639-fc19-43cd-aa5f-36d3623df157",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=262f9639-fc19-43cd-aa5f-36d3623df157"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjYyZjk2MzktZmMxOS00M2NkLWFhNWYtMzZkMzYyM2RmMTU3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjYyZjk2MzktZmMxOS00M2NkLWFhNWYtMzZkMzYyM2RmMTU3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:262f9639-fc19-43cd-aa5f-36d3623df157_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "262f9639-fc19-43cd-aa5f-36d3623df157",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2192319@Y=41402731@L=%23mcp%3AV%3Adonkey-barcelona%3A262f9639-fc19-43cd-aa5f-36d3623df157_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A262f9639-fc19-43cd-aa5f-36d3623df157_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.192319,
                    "lat": 41.402731
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=11ea803d-f828-4d17-938f-9c3e44d8e864",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=11ea803d-f828-4d17-938f-9c3e44d8e864"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=11ea803d-f828-4d17-938f-9c3e44d8e864",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=11ea803d-f828-4d17-938f-9c3e44d8e864"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTFlYTgwM2QtZjgyOC00ZDE3LTkzOGYtOWMzZTQ0ZDhlODY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTFlYTgwM2QtZjgyOC00ZDE3LTkzOGYtOWMzZTQ0ZDhlODY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:11ea803d-f828-4d17-938f-9c3e44d8e864_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "11ea803d-f828-4d17-938f-9c3e44d8e864",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2184662@Y=41403038@L=%23mcp%3AV%3Adonkey-barcelona%3A11ea803d-f828-4d17-938f-9c3e44d8e864_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A11ea803d-f828-4d17-938f-9c3e44d8e864_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.184662,
                    "lat": 41.403038
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5975baed-b436-4b94-9d97-c3d91e804e72",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5975baed-b436-4b94-9d97-c3d91e804e72"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5975baed-b436-4b94-9d97-c3d91e804e72",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5975baed-b436-4b94-9d97-c3d91e804e72"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTk3NWJhZWQtYjQzNi00Yjk0LTlkOTctYzNkOTFlODA0ZTcyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTk3NWJhZWQtYjQzNi00Yjk0LTlkOTctYzNkOTFlODA0ZTcyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5975baed-b436-4b94-9d97-c3d91e804e72_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5975baed-b436-4b94-9d97-c3d91e804e72",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2207539@Y=41403285@L=%23mcp%3AV%3Adonkey-barcelona%3A5975baed-b436-4b94-9d97-c3d91e804e72_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5975baed-b436-4b94-9d97-c3d91e804e72_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.207539,
                    "lat": 41.403285
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=325d745d-43de-4ba4-b066-8c01153f418e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=325d745d-43de-4ba4-b066-8c01153f418e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=325d745d-43de-4ba4-b066-8c01153f418e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=325d745d-43de-4ba4-b066-8c01153f418e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzI1ZDc0NWQtNDNkZS00YmE0LWIwNjYtOGMwMTE1M2Y0MThlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzI1ZDc0NWQtNDNkZS00YmE0LWIwNjYtOGMwMTE1M2Y0MThlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:325d745d-43de-4ba4-b066-8c01153f418e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "325d745d-43de-4ba4-b066-8c01153f418e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2207549@Y=41403308@L=%23mcp%3AV%3Adonkey-barcelona%3A325d745d-43de-4ba4-b066-8c01153f418e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A325d745d-43de-4ba4-b066-8c01153f418e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.207549,
                    "lat": 41.403308
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6618955e-8e9a-4ff2-b1f7-a5def184b3df",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6618955e-8e9a-4ff2-b1f7-a5def184b3df"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6618955e-8e9a-4ff2-b1f7-a5def184b3df",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6618955e-8e9a-4ff2-b1f7-a5def184b3df"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjYxODk1NWUtOGU5YS00ZmYyLWIxZjctYTVkZWYxODRiM2RmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjYxODk1NWUtOGU5YS00ZmYyLWIxZjctYTVkZWYxODRiM2RmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6618955e-8e9a-4ff2-b1f7-a5def184b3df_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6618955e-8e9a-4ff2-b1f7-a5def184b3df",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2207590@Y=41403347@L=%23mcp%3AV%3Adonkey-barcelona%3A6618955e-8e9a-4ff2-b1f7-a5def184b3df_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6618955e-8e9a-4ff2-b1f7-a5def184b3df_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.20759,
                    "lat": 41.403347
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=60a96531-3b87-4532-9de1-8307048bc263",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=60a96531-3b87-4532-9de1-8307048bc263"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=60a96531-3b87-4532-9de1-8307048bc263",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=60a96531-3b87-4532-9de1-8307048bc263"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjBhOTY1MzEtM2I4Ny00NTMyLTlkZTEtODMwNzA0OGJjMjYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjBhOTY1MzEtM2I4Ny00NTMyLTlkZTEtODMwNzA0OGJjMjYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:60a96531-3b87-4532-9de1-8307048bc263_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "60a96531-3b87-4532-9de1-8307048bc263",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2182137@Y=41403371@L=%23mcp%3AV%3Adonkey-barcelona%3A60a96531-3b87-4532-9de1-8307048bc263_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A60a96531-3b87-4532-9de1-8307048bc263_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.182137,
                    "lat": 41.403371
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7a150d2f-f9ad-4273-b2fa-f801a692ee5a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7a150d2f-f9ad-4273-b2fa-f801a692ee5a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7a150d2f-f9ad-4273-b2fa-f801a692ee5a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7a150d2f-f9ad-4273-b2fa-f801a692ee5a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2ExNTBkMmYtZjlhZC00MjczLWIyZmEtZjgwMWE2OTJlZTVhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2ExNTBkMmYtZjlhZC00MjczLWIyZmEtZjgwMWE2OTJlZTVhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7a150d2f-f9ad-4273-b2fa-f801a692ee5a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7a150d2f-f9ad-4273-b2fa-f801a692ee5a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173180@Y=41403405@L=%23mcp%3AV%3Adonkey-barcelona%3A7a150d2f-f9ad-4273-b2fa-f801a692ee5a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7a150d2f-f9ad-4273-b2fa-f801a692ee5a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.17318,
                    "lat": 41.403405
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c4d359a8-9e40-4274-9af8-b8b9f6b40998",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c4d359a8-9e40-4274-9af8-b8b9f6b40998"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c4d359a8-9e40-4274-9af8-b8b9f6b40998",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c4d359a8-9e40-4274-9af8-b8b9f6b40998"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzRkMzU5YTgtOWU0MC00Mjc0LTlhZjgtYjhiOWY2YjQwOTk4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzRkMzU5YTgtOWU0MC00Mjc0LTlhZjgtYjhiOWY2YjQwOTk4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c4d359a8-9e40-4274-9af8-b8b9f6b40998_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c4d359a8-9e40-4274-9af8-b8b9f6b40998",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173253@Y=41403405@L=%23mcp%3AV%3Adonkey-barcelona%3Ac4d359a8-9e40-4274-9af8-b8b9f6b40998_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac4d359a8-9e40-4274-9af8-b8b9f6b40998_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.173253,
                    "lat": 41.403405
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=893363ce-5515-4e3f-bfc8-b50d7adc5e67",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=893363ce-5515-4e3f-bfc8-b50d7adc5e67"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=893363ce-5515-4e3f-bfc8-b50d7adc5e67",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=893363ce-5515-4e3f-bfc8-b50d7adc5e67"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODkzMzYzY2UtNTUxNS00ZTNmLWJmYzgtYjUwZDdhZGM1ZTY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODkzMzYzY2UtNTUxNS00ZTNmLWJmYzgtYjUwZDdhZGM1ZTY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:893363ce-5515-4e3f-bfc8-b50d7adc5e67_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "893363ce-5515-4e3f-bfc8-b50d7adc5e67",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2209453@Y=41403411@L=%23mcp%3AV%3Adonkey-barcelona%3A893363ce-5515-4e3f-bfc8-b50d7adc5e67_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A893363ce-5515-4e3f-bfc8-b50d7adc5e67_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.209453,
                    "lat": 41.403411
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=42a55d63-bc09-462d-b248-88f91909709b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=42a55d63-bc09-462d-b248-88f91909709b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=42a55d63-bc09-462d-b248-88f91909709b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=42a55d63-bc09-462d-b248-88f91909709b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDJhNTVkNjMtYmMwOS00NjJkLWIyNDgtODhmOTE5MDk3MDliIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNDJhNTVkNjMtYmMwOS00NjJkLWIyNDgtODhmOTE5MDk3MDliIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:42a55d63-bc09-462d-b248-88f91909709b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "42a55d63-bc09-462d-b248-88f91909709b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196203@Y=41403432@L=%23mcp%3AV%3Adonkey-barcelona%3A42a55d63-bc09-462d-b248-88f91909709b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A42a55d63-bc09-462d-b248-88f91909709b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196203,
                    "lat": 41.403432
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2040446e-7b4d-4d10-a82e-9518a9b82b68",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2040446e-7b4d-4d10-a82e-9518a9b82b68"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2040446e-7b4d-4d10-a82e-9518a9b82b68",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2040446e-7b4d-4d10-a82e-9518a9b82b68"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjA0MDQ0NmUtN2I0ZC00ZDEwLWE4MmUtOTUxOGE5YjgyYjY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMjA0MDQ0NmUtN2I0ZC00ZDEwLWE4MmUtOTUxOGE5YjgyYjY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2040446e-7b4d-4d10-a82e-9518a9b82b68_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2040446e-7b4d-4d10-a82e-9518a9b82b68",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2209363@Y=41403433@L=%23mcp%3AV%3Adonkey-barcelona%3A2040446e-7b4d-4d10-a82e-9518a9b82b68_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2040446e-7b4d-4d10-a82e-9518a9b82b68_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.209363,
                    "lat": 41.403433
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e22a35fa-ac12-4d00-93cf-f02cce123a26",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e22a35fa-ac12-4d00-93cf-f02cce123a26"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e22a35fa-ac12-4d00-93cf-f02cce123a26",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e22a35fa-ac12-4d00-93cf-f02cce123a26"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTIyYTM1ZmEtYWMxMi00ZDAwLTkzY2YtZjAyY2NlMTIzYTI2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTIyYTM1ZmEtYWMxMi00ZDAwLTkzY2YtZjAyY2NlMTIzYTI2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e22a35fa-ac12-4d00-93cf-f02cce123a26_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e22a35fa-ac12-4d00-93cf-f02cce123a26",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2198405@Y=41403511@L=%23mcp%3AV%3Adonkey-barcelona%3Ae22a35fa-ac12-4d00-93cf-f02cce123a26_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae22a35fa-ac12-4d00-93cf-f02cce123a26_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.198405,
                    "lat": 41.403511
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fc7e9341-3f93-4d2d-9a02-9152dd598408",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fc7e9341-3f93-4d2d-9a02-9152dd598408"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=fc7e9341-3f93-4d2d-9a02-9152dd598408",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=fc7e9341-3f93-4d2d-9a02-9152dd598408"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmM3ZTkzNDEtM2Y5My00ZDJkLTlhMDItOTE1MmRkNTk4NDA4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZmM3ZTkzNDEtM2Y5My00ZDJkLTlhMDItOTE1MmRkNTk4NDA4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:fc7e9341-3f93-4d2d-9a02-9152dd598408_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "fc7e9341-3f93-4d2d-9a02-9152dd598408",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2173180@Y=41403512@L=%23mcp%3AV%3Adonkey-barcelona%3Afc7e9341-3f93-4d2d-9a02-9152dd598408_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Afc7e9341-3f93-4d2d-9a02-9152dd598408_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.17318,
                    "lat": 41.403512
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=74d79796-7e69-4d7b-8908-9bc0a3fcd7b1",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=74d79796-7e69-4d7b-8908-9bc0a3fcd7b1"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=74d79796-7e69-4d7b-8908-9bc0a3fcd7b1",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=74d79796-7e69-4d7b-8908-9bc0a3fcd7b1"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzRkNzk3OTYtN2U2OS00ZDdiLTg5MDgtOWJjMGEzZmNkN2IxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNzRkNzk3OTYtN2U2OS00ZDdiLTg5MDgtOWJjMGEzZmNkN2IxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:74d79796-7e69-4d7b-8908-9bc0a3fcd7b1_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "74d79796-7e69-4d7b-8908-9bc0a3fcd7b1",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2215895@Y=41403839@L=%23mcp%3AV%3Adonkey-barcelona%3A74d79796-7e69-4d7b-8908-9bc0a3fcd7b1_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A74d79796-7e69-4d7b-8908-9bc0a3fcd7b1_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.215895,
                    "lat": 41.403839
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=693e514b-46bc-4779-bb15-3130da89b0e0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=693e514b-46bc-4779-bb15-3130da89b0e0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=693e514b-46bc-4779-bb15-3130da89b0e0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=693e514b-46bc-4779-bb15-3130da89b0e0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjkzZTUxNGItNDZiYy00Nzc5LWJiMTUtMzEzMGRhODliMGUwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjkzZTUxNGItNDZiYy00Nzc5LWJiMTUtMzEzMGRhODliMGUwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:693e514b-46bc-4779-bb15-3130da89b0e0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "693e514b-46bc-4779-bb15-3130da89b0e0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2215884@Y=41403867@L=%23mcp%3AV%3Adonkey-barcelona%3A693e514b-46bc-4779-bb15-3130da89b0e0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A693e514b-46bc-4779-bb15-3130da89b0e0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.215884,
                    "lat": 41.403867
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d93ef9f8-c791-4917-b442-ada4a6ff6f26",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d93ef9f8-c791-4917-b442-ada4a6ff6f26"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d93ef9f8-c791-4917-b442-ada4a6ff6f26",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d93ef9f8-c791-4917-b442-ada4a6ff6f26"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDkzZWY5ZjgtYzc5MS00OTE3LWI0NDItYWRhNGE2ZmY2ZjI2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDkzZWY5ZjgtYzc5MS00OTE3LWI0NDItYWRhNGE2ZmY2ZjI2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d93ef9f8-c791-4917-b442-ada4a6ff6f26_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d93ef9f8-c791-4917-b442-ada4a6ff6f26",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2208351@Y=41404135@L=%23mcp%3AV%3Adonkey-barcelona%3Ad93ef9f8-c791-4917-b442-ada4a6ff6f26_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad93ef9f8-c791-4917-b442-ada4a6ff6f26_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.208351,
                    "lat": 41.404135
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5a85279a-8fa5-4d35-9852-e91b97dbe2f7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5a85279a-8fa5-4d35-9852-e91b97dbe2f7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=5a85279a-8fa5-4d35-9852-e91b97dbe2f7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=5a85279a-8fa5-4d35-9852-e91b97dbe2f7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWE4NTI3OWEtOGZhNS00ZDM1LTk4NTItZTkxYjk3ZGJlMmY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNWE4NTI3OWEtOGZhNS00ZDM1LTk4NTItZTkxYjk3ZGJlMmY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:5a85279a-8fa5-4d35-9852-e91b97dbe2f7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "5a85279a-8fa5-4d35-9852-e91b97dbe2f7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2208331@Y=41404145@L=%23mcp%3AV%3Adonkey-barcelona%3A5a85279a-8fa5-4d35-9852-e91b97dbe2f7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A5a85279a-8fa5-4d35-9852-e91b97dbe2f7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.208331,
                    "lat": 41.404145
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=813fb8d4-8359-4b56-b583-dea1e869014e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=813fb8d4-8359-4b56-b583-dea1e869014e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=813fb8d4-8359-4b56-b583-dea1e869014e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=813fb8d4-8359-4b56-b583-dea1e869014e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODEzZmI4ZDQtODM1OS00YjU2LWI1ODMtZGVhMWU4NjkwMTRlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODEzZmI4ZDQtODM1OS00YjU2LWI1ODMtZGVhMWU4NjkwMTRlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:813fb8d4-8359-4b56-b583-dea1e869014e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "813fb8d4-8359-4b56-b583-dea1e869014e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2189820@Y=41404409@L=%23mcp%3AV%3Adonkey-barcelona%3A813fb8d4-8359-4b56-b583-dea1e869014e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A813fb8d4-8359-4b56-b583-dea1e869014e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.18982,
                    "lat": 41.404409
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0fca70ae-39a3-4160-adf6-ea2ea13ae22a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0fca70ae-39a3-4160-adf6-ea2ea13ae22a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0fca70ae-39a3-4160-adf6-ea2ea13ae22a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0fca70ae-39a3-4160-adf6-ea2ea13ae22a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGZjYTcwYWUtMzlhMy00MTYwLWFkZjYtZWEyZWExM2FlMjJhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGZjYTcwYWUtMzlhMy00MTYwLWFkZjYtZWEyZWExM2FlMjJhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0fca70ae-39a3-4160-adf6-ea2ea13ae22a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0fca70ae-39a3-4160-adf6-ea2ea13ae22a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2174882@Y=41404709@L=%23mcp%3AV%3Adonkey-barcelona%3A0fca70ae-39a3-4160-adf6-ea2ea13ae22a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0fca70ae-39a3-4160-adf6-ea2ea13ae22a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.174882,
                    "lat": 41.404709
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b977637b-0512-4b39-9256-97705a50a9c7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b977637b-0512-4b39-9256-97705a50a9c7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b977637b-0512-4b39-9256-97705a50a9c7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b977637b-0512-4b39-9256-97705a50a9c7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjk3NzYzN2ItMDUxMi00YjM5LTkyNTYtOTc3MDVhNTBhOWM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjk3NzYzN2ItMDUxMi00YjM5LTkyNTYtOTc3MDVhNTBhOWM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b977637b-0512-4b39-9256-97705a50a9c7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b977637b-0512-4b39-9256-97705a50a9c7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2174871@Y=41404717@L=%23mcp%3AV%3Adonkey-barcelona%3Ab977637b-0512-4b39-9256-97705a50a9c7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab977637b-0512-4b39-9256-97705a50a9c7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.174871,
                    "lat": 41.404717
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e252bc4d-ed35-4cc7-8d31-989846e11c8b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e252bc4d-ed35-4cc7-8d31-989846e11c8b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e252bc4d-ed35-4cc7-8d31-989846e11c8b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e252bc4d-ed35-4cc7-8d31-989846e11c8b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTI1MmJjNGQtZWQzNS00Y2M3LThkMzEtOTg5ODQ2ZTExYzhiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTI1MmJjNGQtZWQzNS00Y2M3LThkMzEtOTg5ODQ2ZTExYzhiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e252bc4d-ed35-4cc7-8d31-989846e11c8b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e252bc4d-ed35-4cc7-8d31-989846e11c8b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2213502@Y=41405241@L=%23mcp%3AV%3Adonkey-barcelona%3Ae252bc4d-ed35-4cc7-8d31-989846e11c8b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae252bc4d-ed35-4cc7-8d31-989846e11c8b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.213502,
                    "lat": 41.405241
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c1c48fbb-5a54-4130-95d0-d7b1e3d07d35",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c1c48fbb-5a54-4130-95d0-d7b1e3d07d35"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c1c48fbb-5a54-4130-95d0-d7b1e3d07d35",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c1c48fbb-5a54-4130-95d0-d7b1e3d07d35"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzFjNDhmYmItNWE1NC00MTMwLTk1ZDAtZDdiMWUzZDA3ZDM1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzFjNDhmYmItNWE1NC00MTMwLTk1ZDAtZDdiMWUzZDA3ZDM1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c1c48fbb-5a54-4130-95d0-d7b1e3d07d35_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c1c48fbb-5a54-4130-95d0-d7b1e3d07d35",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2199855@Y=41405474@L=%23mcp%3AV%3Adonkey-barcelona%3Ac1c48fbb-5a54-4130-95d0-d7b1e3d07d35_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac1c48fbb-5a54-4130-95d0-d7b1e3d07d35_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.199855,
                    "lat": 41.405474
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4d4672f1-2614-4105-99e7-f843d9ab6112",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4d4672f1-2614-4105-99e7-f843d9ab6112"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=4d4672f1-2614-4105-99e7-f843d9ab6112",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=4d4672f1-2614-4105-99e7-f843d9ab6112"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGQ0NjcyZjEtMjYxNC00MTA1LTk5ZTctZjg0M2Q5YWI2MTEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNGQ0NjcyZjEtMjYxNC00MTA1LTk5ZTctZjg0M2Q5YWI2MTEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:4d4672f1-2614-4105-99e7-f843d9ab6112_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "4d4672f1-2614-4105-99e7-f843d9ab6112",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196744@Y=41405611@L=%23mcp%3AV%3Adonkey-barcelona%3A4d4672f1-2614-4105-99e7-f843d9ab6112_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A4d4672f1-2614-4105-99e7-f843d9ab6112_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196744,
                    "lat": 41.405611
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=02ccab05-4c6c-4358-b055-d576afa1a7f1",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=02ccab05-4c6c-4358-b055-d576afa1a7f1"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=02ccab05-4c6c-4358-b055-d576afa1a7f1",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=02ccab05-4c6c-4358-b055-d576afa1a7f1"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDJjY2FiMDUtNGM2Yy00MzU4LWIwNTUtZDU3NmFmYTFhN2YxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDJjY2FiMDUtNGM2Yy00MzU4LWIwNTUtZDU3NmFmYTFhN2YxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:02ccab05-4c6c-4358-b055-d576afa1a7f1_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "02ccab05-4c6c-4358-b055-d576afa1a7f1",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2207893@Y=41405923@L=%23mcp%3AV%3Adonkey-barcelona%3A02ccab05-4c6c-4358-b055-d576afa1a7f1_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A02ccab05-4c6c-4358-b055-d576afa1a7f1_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.207893,
                    "lat": 41.405923
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dac7a545-0308-4910-9284-668016013cfa",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dac7a545-0308-4910-9284-668016013cfa"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dac7a545-0308-4910-9284-668016013cfa",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dac7a545-0308-4910-9284-668016013cfa"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGFjN2E1NDUtMDMwOC00OTEwLTkyODQtNjY4MDE2MDEzY2ZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGFjN2E1NDUtMDMwOC00OTEwLTkyODQtNjY4MDE2MDEzY2ZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:dac7a545-0308-4910-9284-668016013cfa_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "dac7a545-0308-4910-9284-668016013cfa",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2208087@Y=41405980@L=%23mcp%3AV%3Adonkey-barcelona%3Adac7a545-0308-4910-9284-668016013cfa_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Adac7a545-0308-4910-9284-668016013cfa_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.208087,
                    "lat": 41.40598
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ad479bff-73af-457e-9da6-d23c76dc7320",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ad479bff-73af-457e-9da6-d23c76dc7320"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ad479bff-73af-457e-9da6-d23c76dc7320",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ad479bff-73af-457e-9da6-d23c76dc7320"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWQ0NzliZmYtNzNhZi00NTdlLTlkYTYtZDIzYzc2ZGM3MzIwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWQ0NzliZmYtNzNhZi00NTdlLTlkYTYtZDIzYzc2ZGM3MzIwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ad479bff-73af-457e-9da6-d23c76dc7320_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ad479bff-73af-457e-9da6-d23c76dc7320",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2196465@Y=41406962@L=%23mcp%3AV%3Adonkey-barcelona%3Aad479bff-73af-457e-9da6-d23c76dc7320_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aad479bff-73af-457e-9da6-d23c76dc7320_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.196465,
                    "lat": 41.406962
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d5f084c3-027c-4a9e-b5b3-20f9801cf381",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d5f084c3-027c-4a9e-b5b3-20f9801cf381"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d5f084c3-027c-4a9e-b5b3-20f9801cf381",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d5f084c3-027c-4a9e-b5b3-20f9801cf381"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDVmMDg0YzMtMDI3Yy00YTllLWI1YjMtMjBmOTgwMWNmMzgxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDVmMDg0YzMtMDI3Yy00YTllLWI1YjMtMjBmOTgwMWNmMzgxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d5f084c3-027c-4a9e-b5b3-20f9801cf381_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d5f084c3-027c-4a9e-b5b3-20f9801cf381",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2210379@Y=41407533@L=%23mcp%3AV%3Adonkey-barcelona%3Ad5f084c3-027c-4a9e-b5b3-20f9801cf381_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad5f084c3-027c-4a9e-b5b3-20f9801cf381_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.210379,
                    "lat": 41.407533
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ef15ebc8-7080-4a9d-a169-37fb1d80aff7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ef15ebc8-7080-4a9d-a169-37fb1d80aff7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ef15ebc8-7080-4a9d-a169-37fb1d80aff7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ef15ebc8-7080-4a9d-a169-37fb1d80aff7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWYxNWViYzgtNzA4MC00YTlkLWExNjktMzdmYjFkODBhZmY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWYxNWViYzgtNzA4MC00YTlkLWExNjktMzdmYjFkODBhZmY3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ef15ebc8-7080-4a9d-a169-37fb1d80aff7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ef15ebc8-7080-4a9d-a169-37fb1d80aff7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2210281@Y=41407601@L=%23mcp%3AV%3Adonkey-barcelona%3Aef15ebc8-7080-4a9d-a169-37fb1d80aff7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aef15ebc8-7080-4a9d-a169-37fb1d80aff7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.210281,
                    "lat": 41.407601
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=be3a7ba6-1f94-45f4-8f89-9bdb4c7753a2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=be3a7ba6-1f94-45f4-8f89-9bdb4c7753a2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=be3a7ba6-1f94-45f4-8f89-9bdb4c7753a2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=be3a7ba6-1f94-45f4-8f89-9bdb4c7753a2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmUzYTdiYTYtMWY5NC00NWY0LThmODktOWJkYjRjNzc1M2EyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmUzYTdiYTYtMWY5NC00NWY0LThmODktOWJkYjRjNzc1M2EyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:be3a7ba6-1f94-45f4-8f89-9bdb4c7753a2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "be3a7ba6-1f94-45f4-8f89-9bdb4c7753a2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2217535@Y=41407621@L=%23mcp%3AV%3Adonkey-barcelona%3Abe3a7ba6-1f94-45f4-8f89-9bdb4c7753a2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Abe3a7ba6-1f94-45f4-8f89-9bdb4c7753a2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.217535,
                    "lat": 41.407621
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=580cf509-4dff-404b-9955-c90211883375",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=580cf509-4dff-404b-9955-c90211883375"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=580cf509-4dff-404b-9955-c90211883375",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=580cf509-4dff-404b-9955-c90211883375"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTgwY2Y1MDktNGRmZi00MDRiLTk5NTUtYzkwMjExODgzMzc1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTgwY2Y1MDktNGRmZi00MDRiLTk5NTUtYzkwMjExODgzMzc1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:580cf509-4dff-404b-9955-c90211883375_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "580cf509-4dff-404b-9955-c90211883375",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2217609@Y=41407640@L=%23mcp%3AV%3Adonkey-barcelona%3A580cf509-4dff-404b-9955-c90211883375_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A580cf509-4dff-404b-9955-c90211883375_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.217609,
                    "lat": 41.40764
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ab8daeb0-9191-4f2f-a3ef-73ef53da5786",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ab8daeb0-9191-4f2f-a3ef-73ef53da5786"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ab8daeb0-9191-4f2f-a3ef-73ef53da5786",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ab8daeb0-9191-4f2f-a3ef-73ef53da5786"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWI4ZGFlYjAtOTE5MS00ZjJmLWEzZWYtNzNlZjUzZGE1Nzg2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWI4ZGFlYjAtOTE5MS00ZjJmLWEzZWYtNzNlZjUzZGE1Nzg2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ab8daeb0-9191-4f2f-a3ef-73ef53da5786_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ab8daeb0-9191-4f2f-a3ef-73ef53da5786",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2195127@Y=41407677@L=%23mcp%3AV%3Adonkey-barcelona%3Aab8daeb0-9191-4f2f-a3ef-73ef53da5786_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aab8daeb0-9191-4f2f-a3ef-73ef53da5786_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.195127,
                    "lat": 41.407677
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7d483eaa-e9af-4cdb-9ca2-07420f0d3654",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7d483eaa-e9af-4cdb-9ca2-07420f0d3654"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7d483eaa-e9af-4cdb-9ca2-07420f0d3654",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7d483eaa-e9af-4cdb-9ca2-07420f0d3654"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2Q0ODNlYWEtZTlhZi00Y2RiLTljYTItMDc0MjBmMGQzNjU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2Q0ODNlYWEtZTlhZi00Y2RiLTljYTItMDc0MjBmMGQzNjU0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7d483eaa-e9af-4cdb-9ca2-07420f0d3654_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7d483eaa-e9af-4cdb-9ca2-07420f0d3654",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2221636@Y=41408544@L=%23mcp%3AV%3Adonkey-barcelona%3A7d483eaa-e9af-4cdb-9ca2-07420f0d3654_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7d483eaa-e9af-4cdb-9ca2-07420f0d3654_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.221636,
                    "lat": 41.408544
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dbbe652c-c941-4ab5-bdd0-28dae458b06e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dbbe652c-c941-4ab5-bdd0-28dae458b06e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=dbbe652c-c941-4ab5-bdd0-28dae458b06e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=dbbe652c-c941-4ab5-bdd0-28dae458b06e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGJiZTY1MmMtYzk0MS00YWI1LWJkZDAtMjhkYWU0NThiMDZlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGJiZTY1MmMtYzk0MS00YWI1LWJkZDAtMjhkYWU0NThiMDZlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:dbbe652c-c941-4ab5-bdd0-28dae458b06e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "dbbe652c-c941-4ab5-bdd0-28dae458b06e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2192183@Y=41408574@L=%23mcp%3AV%3Adonkey-barcelona%3Adbbe652c-c941-4ab5-bdd0-28dae458b06e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Adbbe652c-c941-4ab5-bdd0-28dae458b06e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.192183,
                    "lat": 41.408574
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e20fa4f2-e4de-46c0-9e24-243bcdc88437",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e20fa4f2-e4de-46c0-9e24-243bcdc88437"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e20fa4f2-e4de-46c0-9e24-243bcdc88437",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e20fa4f2-e4de-46c0-9e24-243bcdc88437"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTIwZmE0ZjItZTRkZS00NmMwLTllMjQtMjQzYmNkYzg4NDM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTIwZmE0ZjItZTRkZS00NmMwLTllMjQtMjQzYmNkYzg4NDM3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e20fa4f2-e4de-46c0-9e24-243bcdc88437_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e20fa4f2-e4de-46c0-9e24-243bcdc88437",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2208564@Y=41408582@L=%23mcp%3AV%3Adonkey-barcelona%3Ae20fa4f2-e4de-46c0-9e24-243bcdc88437_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae20fa4f2-e4de-46c0-9e24-243bcdc88437_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.208564,
                    "lat": 41.408582
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cc92c363-d690-455e-92bb-c72ef38550a8",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cc92c363-d690-455e-92bb-c72ef38550a8"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=cc92c363-d690-455e-92bb-c72ef38550a8",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=cc92c363-d690-455e-92bb-c72ef38550a8"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2M5MmMzNjMtZDY5MC00NTVlLTkyYmItYzcyZWYzODU1MGE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2M5MmMzNjMtZDY5MC00NTVlLTkyYmItYzcyZWYzODU1MGE4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:cc92c363-d690-455e-92bb-c72ef38550a8_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "cc92c363-d690-455e-92bb-c72ef38550a8",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2203733@Y=41409091@L=%23mcp%3AV%3Adonkey-barcelona%3Acc92c363-d690-455e-92bb-c72ef38550a8_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Acc92c363-d690-455e-92bb-c72ef38550a8_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.203733,
                    "lat": 41.409091
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=68b7ba8d-72c0-4049-955a-058b198610f4",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=68b7ba8d-72c0-4049-955a-058b198610f4"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=68b7ba8d-72c0-4049-955a-058b198610f4",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=68b7ba8d-72c0-4049-955a-058b198610f4"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjhiN2JhOGQtNzJjMC00MDQ5LTk1NWEtMDU4YjE5ODYxMGY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjhiN2JhOGQtNzJjMC00MDQ5LTk1NWEtMDU4YjE5ODYxMGY0IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:68b7ba8d-72c0-4049-955a-058b198610f4_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "68b7ba8d-72c0-4049-955a-058b198610f4",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2217530@Y=41409152@L=%23mcp%3AV%3Adonkey-barcelona%3A68b7ba8d-72c0-4049-955a-058b198610f4_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A68b7ba8d-72c0-4049-955a-058b198610f4_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.21753,
                    "lat": 41.409152
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a60fba2f-ea32-4ded-bdf6-ad64ba804a02",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a60fba2f-ea32-4ded-bdf6-ad64ba804a02"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a60fba2f-ea32-4ded-bdf6-ad64ba804a02",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a60fba2f-ea32-4ded-bdf6-ad64ba804a02"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTYwZmJhMmYtZWEzMi00ZGVkLWJkZjYtYWQ2NGJhODA0YTAyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTYwZmJhMmYtZWEzMi00ZGVkLWJkZjYtYWQ2NGJhODA0YTAyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a60fba2f-ea32-4ded-bdf6-ad64ba804a02_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a60fba2f-ea32-4ded-bdf6-ad64ba804a02",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2217530@Y=41409152@L=%23mcp%3AV%3Adonkey-barcelona%3Aa60fba2f-ea32-4ded-bdf6-ad64ba804a02_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa60fba2f-ea32-4ded-bdf6-ad64ba804a02_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.21753,
                    "lat": 41.409152
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d1bd541f-642f-4984-856b-1c0144a8e0c5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d1bd541f-642f-4984-856b-1c0144a8e0c5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=d1bd541f-642f-4984-856b-1c0144a8e0c5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=d1bd541f-642f-4984-856b-1c0144a8e0c5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDFiZDU0MWYtNjQyZi00OTg0LTg1NmItMWMwMTQ0YThlMGM1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZDFiZDU0MWYtNjQyZi00OTg0LTg1NmItMWMwMTQ0YThlMGM1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:d1bd541f-642f-4984-856b-1c0144a8e0c5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "d1bd541f-642f-4984-856b-1c0144a8e0c5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2210937@Y=41409534@L=%23mcp%3AV%3Adonkey-barcelona%3Ad1bd541f-642f-4984-856b-1c0144a8e0c5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ad1bd541f-642f-4984-856b-1c0144a8e0c5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.210937,
                    "lat": 41.409534
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a7d3642c-c11a-4bc5-b72e-7cfb411e9f6c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a7d3642c-c11a-4bc5-b72e-7cfb411e9f6c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a7d3642c-c11a-4bc5-b72e-7cfb411e9f6c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a7d3642c-c11a-4bc5-b72e-7cfb411e9f6c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTdkMzY0MmMtYzExYS00YmM1LWI3MmUtN2NmYjQxMWU5ZjZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTdkMzY0MmMtYzExYS00YmM1LWI3MmUtN2NmYjQxMWU5ZjZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a7d3642c-c11a-4bc5-b72e-7cfb411e9f6c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a7d3642c-c11a-4bc5-b72e-7cfb411e9f6c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2213569@Y=41410134@L=%23mcp%3AV%3Adonkey-barcelona%3Aa7d3642c-c11a-4bc5-b72e-7cfb411e9f6c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa7d3642c-c11a-4bc5-b72e-7cfb411e9f6c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.213569,
                    "lat": 41.410134
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=543f8d4f-9abc-45da-af2c-2b7a4cd95672",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=543f8d4f-9abc-45da-af2c-2b7a4cd95672"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=543f8d4f-9abc-45da-af2c-2b7a4cd95672",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=543f8d4f-9abc-45da-af2c-2b7a4cd95672"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTQzZjhkNGYtOWFiYy00NWRhLWFmMmMtMmI3YTRjZDk1NjcyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTQzZjhkNGYtOWFiYy00NWRhLWFmMmMtMmI3YTRjZDk1NjcyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:543f8d4f-9abc-45da-af2c-2b7a4cd95672_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "543f8d4f-9abc-45da-af2c-2b7a4cd95672",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2215044@Y=41410295@L=%23mcp%3AV%3Adonkey-barcelona%3A543f8d4f-9abc-45da-af2c-2b7a4cd95672_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A543f8d4f-9abc-45da-af2c-2b7a4cd95672_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.215044,
                    "lat": 41.410295
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2b29f16b-b3c7-45ce-9099-a3b64e6e008a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2b29f16b-b3c7-45ce-9099-a3b64e6e008a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=2b29f16b-b3c7-45ce-9099-a3b64e6e008a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=2b29f16b-b3c7-45ce-9099-a3b64e6e008a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmIyOWYxNmItYjNjNy00NWNlLTkwOTktYTNiNjRlNmUwMDhhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMmIyOWYxNmItYjNjNy00NWNlLTkwOTktYTNiNjRlNmUwMDhhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:2b29f16b-b3c7-45ce-9099-a3b64e6e008a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "2b29f16b-b3c7-45ce-9099-a3b64e6e008a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2212809@Y=41410963@L=%23mcp%3AV%3Adonkey-barcelona%3A2b29f16b-b3c7-45ce-9099-a3b64e6e008a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A2b29f16b-b3c7-45ce-9099-a3b64e6e008a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.212809,
                    "lat": 41.410963
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=02e7ce9f-873c-4505-9b4f-748c52b5d063",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=02e7ce9f-873c-4505-9b4f-748c52b5d063"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=02e7ce9f-873c-4505-9b4f-748c52b5d063",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=02e7ce9f-873c-4505-9b4f-748c52b5d063"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDJlN2NlOWYtODczYy00NTA1LTliNGYtNzQ4YzUyYjVkMDYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMDJlN2NlOWYtODczYy00NTA1LTliNGYtNzQ4YzUyYjVkMDYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:02e7ce9f-873c-4505-9b4f-748c52b5d063_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "02e7ce9f-873c-4505-9b4f-748c52b5d063",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2219463@Y=41411133@L=%23mcp%3AV%3Adonkey-barcelona%3A02e7ce9f-873c-4505-9b4f-748c52b5d063_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A02e7ce9f-873c-4505-9b4f-748c52b5d063_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.219463,
                    "lat": 41.411133
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1f5144a7-8582-48d1-b693-b9717bad8993",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1f5144a7-8582-48d1-b693-b9717bad8993"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1f5144a7-8582-48d1-b693-b9717bad8993",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1f5144a7-8582-48d1-b693-b9717bad8993"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWY1MTQ0YTctODU4Mi00OGQxLWI2OTMtYjk3MTdiYWQ4OTkzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWY1MTQ0YTctODU4Mi00OGQxLWI2OTMtYjk3MTdiYWQ4OTkzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1f5144a7-8582-48d1-b693-b9717bad8993_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1f5144a7-8582-48d1-b693-b9717bad8993",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2219463@Y=41411133@L=%23mcp%3AV%3Adonkey-barcelona%3A1f5144a7-8582-48d1-b693-b9717bad8993_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1f5144a7-8582-48d1-b693-b9717bad8993_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.219463,
                    "lat": 41.411133
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=90133fb7-88fc-4880-b03f-591c649c07a5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=90133fb7-88fc-4880-b03f-591c649c07a5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=90133fb7-88fc-4880-b03f-591c649c07a5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=90133fb7-88fc-4880-b03f-591c649c07a5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTAxMzNmYjctODhmYy00ODgwLWIwM2YtNTkxYzY0OWMwN2E1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTAxMzNmYjctODhmYy00ODgwLWIwM2YtNTkxYzY0OWMwN2E1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:90133fb7-88fc-4880-b03f-591c649c07a5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "90133fb7-88fc-4880-b03f-591c649c07a5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2192253@Y=41411248@L=%23mcp%3AV%3Adonkey-barcelona%3A90133fb7-88fc-4880-b03f-591c649c07a5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A90133fb7-88fc-4880-b03f-591c649c07a5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.192253,
                    "lat": 41.411248
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0b40b915-693a-4f1c-aeb3-759a67bbc2d9",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0b40b915-693a-4f1c-aeb3-759a67bbc2d9"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0b40b915-693a-4f1c-aeb3-759a67bbc2d9",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0b40b915-693a-4f1c-aeb3-759a67bbc2d9"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGI0MGI5MTUtNjkzYS00ZjFjLWFlYjMtNzU5YTY3YmJjMmQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGI0MGI5MTUtNjkzYS00ZjFjLWFlYjMtNzU5YTY3YmJjMmQ5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0b40b915-693a-4f1c-aeb3-759a67bbc2d9_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0b40b915-693a-4f1c-aeb3-759a67bbc2d9",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2195513@Y=41411732@L=%23mcp%3AV%3Adonkey-barcelona%3A0b40b915-693a-4f1c-aeb3-759a67bbc2d9_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0b40b915-693a-4f1c-aeb3-759a67bbc2d9_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.195513,
                    "lat": 41.411732
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=54a1714a-e374-421f-b422-46daa95c4b00",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=54a1714a-e374-421f-b422-46daa95c4b00"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=54a1714a-e374-421f-b422-46daa95c4b00",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=54a1714a-e374-421f-b422-46daa95c4b00"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTRhMTcxNGEtZTM3NC00MjFmLWI0MjItNDZkYWE5NWM0YjAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNTRhMTcxNGEtZTM3NC00MjFmLWI0MjItNDZkYWE5NWM0YjAwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:54a1714a-e374-421f-b422-46daa95c4b00_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "54a1714a-e374-421f-b422-46daa95c4b00",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2217524@Y=41412052@L=%23mcp%3AV%3Adonkey-barcelona%3A54a1714a-e374-421f-b422-46daa95c4b00_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A54a1714a-e374-421f-b422-46daa95c4b00_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.217524,
                    "lat": 41.412052
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6b5b0750-2488-45ed-ba1a-4c0ff46f451f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6b5b0750-2488-45ed-ba1a-4c0ff46f451f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6b5b0750-2488-45ed-ba1a-4c0ff46f451f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6b5b0750-2488-45ed-ba1a-4c0ff46f451f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmI1YjA3NTAtMjQ4OC00NWVkLWJhMWEtNGMwZmY0NmY0NTFmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNmI1YjA3NTAtMjQ4OC00NWVkLWJhMWEtNGMwZmY0NmY0NTFmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6b5b0750-2488-45ed-ba1a-4c0ff46f451f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6b5b0750-2488-45ed-ba1a-4c0ff46f451f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2217428@Y=41412291@L=%23mcp%3AV%3Adonkey-barcelona%3A6b5b0750-2488-45ed-ba1a-4c0ff46f451f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6b5b0750-2488-45ed-ba1a-4c0ff46f451f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.217428,
                    "lat": 41.412291
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f962095c-73fb-4f5a-9b8e-7e228acf9a6c",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f962095c-73fb-4f5a-9b8e-7e228acf9a6c"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=f962095c-73fb-4f5a-9b8e-7e228acf9a6c",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=f962095c-73fb-4f5a-9b8e-7e228acf9a6c"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjk2MjA5NWMtNzNmYi00ZjVhLTliOGUtN2UyMjhhY2Y5YTZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZjk2MjA5NWMtNzNmYi00ZjVhLTliOGUtN2UyMjhhY2Y5YTZjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:f962095c-73fb-4f5a-9b8e-7e228acf9a6c_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "f962095c-73fb-4f5a-9b8e-7e228acf9a6c",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2220883@Y=41412398@L=%23mcp%3AV%3Adonkey-barcelona%3Af962095c-73fb-4f5a-9b8e-7e228acf9a6c_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Af962095c-73fb-4f5a-9b8e-7e228acf9a6c_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.220883,
                    "lat": 41.412398
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ade1d60a-9fe0-4130-be09-491e318ba03e",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ade1d60a-9fe0-4130-be09-491e318ba03e"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ade1d60a-9fe0-4130-be09-491e318ba03e",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ade1d60a-9fe0-4130-be09-491e318ba03e"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWRlMWQ2MGEtOWZlMC00MTMwLWJlMDktNDkxZTMxOGJhMDNlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYWRlMWQ2MGEtOWZlMC00MTMwLWJlMDktNDkxZTMxOGJhMDNlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ade1d60a-9fe0-4130-be09-491e318ba03e_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ade1d60a-9fe0-4130-be09-491e318ba03e",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2221153@Y=41412463@L=%23mcp%3AV%3Adonkey-barcelona%3Aade1d60a-9fe0-4130-be09-491e318ba03e_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aade1d60a-9fe0-4130-be09-491e318ba03e_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.221153,
                    "lat": 41.412463
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b2390f73-9a6c-4dc2-8bce-f45aab393468",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b2390f73-9a6c-4dc2-8bce-f45aab393468"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b2390f73-9a6c-4dc2-8bce-f45aab393468",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b2390f73-9a6c-4dc2-8bce-f45aab393468"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjIzOTBmNzMtOWE2Yy00ZGMyLThiY2UtZjQ1YWFiMzkzNDY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjIzOTBmNzMtOWE2Yy00ZGMyLThiY2UtZjQ1YWFiMzkzNDY4IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b2390f73-9a6c-4dc2-8bce-f45aab393468_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b2390f73-9a6c-4dc2-8bce-f45aab393468",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190328@Y=41412773@L=%23mcp%3AV%3Adonkey-barcelona%3Ab2390f73-9a6c-4dc2-8bce-f45aab393468_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab2390f73-9a6c-4dc2-8bce-f45aab393468_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.190328,
                    "lat": 41.412773
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1992bd1b-6f8d-4d02-a0e1-fd68de0cd72f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1992bd1b-6f8d-4d02-a0e1-fd68de0cd72f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1992bd1b-6f8d-4d02-a0e1-fd68de0cd72f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1992bd1b-6f8d-4d02-a0e1-fd68de0cd72f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTk5MmJkMWItNmY4ZC00ZDAyLWEwZTEtZmQ2OGRlMGNkNzJmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTk5MmJkMWItNmY4ZC00ZDAyLWEwZTEtZmQ2OGRlMGNkNzJmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1992bd1b-6f8d-4d02-a0e1-fd68de0cd72f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1992bd1b-6f8d-4d02-a0e1-fd68de0cd72f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2209246@Y=41412838@L=%23mcp%3AV%3Adonkey-barcelona%3A1992bd1b-6f8d-4d02-a0e1-fd68de0cd72f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1992bd1b-6f8d-4d02-a0e1-fd68de0cd72f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.209246,
                    "lat": 41.412838
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b16ca5d0-48fb-4619-875d-75f140ef2c71",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b16ca5d0-48fb-4619-875d-75f140ef2c71"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b16ca5d0-48fb-4619-875d-75f140ef2c71",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b16ca5d0-48fb-4619-875d-75f140ef2c71"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjE2Y2E1ZDAtNDhmYi00NjE5LTg3NWQtNzVmMTQwZWYyYzcxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjE2Y2E1ZDAtNDhmYi00NjE5LTg3NWQtNzVmMTQwZWYyYzcxIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b16ca5d0-48fb-4619-875d-75f140ef2c71_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b16ca5d0-48fb-4619-875d-75f140ef2c71",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2209235@Y=41412893@L=%23mcp%3AV%3Adonkey-barcelona%3Ab16ca5d0-48fb-4619-875d-75f140ef2c71_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab16ca5d0-48fb-4619-875d-75f140ef2c71_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.209235,
                    "lat": 41.412893
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e3599f21-5681-4e9b-adc9-4b400c0fb582",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e3599f21-5681-4e9b-adc9-4b400c0fb582"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e3599f21-5681-4e9b-adc9-4b400c0fb582",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e3599f21-5681-4e9b-adc9-4b400c0fb582"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTM1OTlmMjEtNTY4MS00ZTliLWFkYzktNGI0MDBjMGZiNTgyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTM1OTlmMjEtNTY4MS00ZTliLWFkYzktNGI0MDBjMGZiNTgyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e3599f21-5681-4e9b-adc9-4b400c0fb582_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e3599f21-5681-4e9b-adc9-4b400c0fb582",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190556@Y=41412936@L=%23mcp%3AV%3Adonkey-barcelona%3Ae3599f21-5681-4e9b-adc9-4b400c0fb582_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae3599f21-5681-4e9b-adc9-4b400c0fb582_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.190556,
                    "lat": 41.412936
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=817abcf6-be5e-4651-be30-2ef25e22e3b7",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=817abcf6-be5e-4651-be30-2ef25e22e3b7"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=817abcf6-be5e-4651-be30-2ef25e22e3b7",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=817abcf6-be5e-4651-be30-2ef25e22e3b7"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODE3YWJjZjYtYmU1ZS00NjUxLWJlMzAtMmVmMjVlMjJlM2I3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODE3YWJjZjYtYmU1ZS00NjUxLWJlMzAtMmVmMjVlMjJlM2I3IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:817abcf6-be5e-4651-be30-2ef25e22e3b7_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "817abcf6-be5e-4651-be30-2ef25e22e3b7",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2199039@Y=41413055@L=%23mcp%3AV%3Adonkey-barcelona%3A817abcf6-be5e-4651-be30-2ef25e22e3b7_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A817abcf6-be5e-4651-be30-2ef25e22e3b7_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.199039,
                    "lat": 41.413055
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=83d4cf09-b482-4d4f-8e4f-2dff597cc2b5",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=83d4cf09-b482-4d4f-8e4f-2dff597cc2b5"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=83d4cf09-b482-4d4f-8e4f-2dff597cc2b5",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=83d4cf09-b482-4d4f-8e4f-2dff597cc2b5"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODNkNGNmMDktYjQ4Mi00ZDRmLThlNGYtMmRmZjU5N2NjMmI1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiODNkNGNmMDktYjQ4Mi00ZDRmLThlNGYtMmRmZjU5N2NjMmI1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:83d4cf09-b482-4d4f-8e4f-2dff597cc2b5_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "83d4cf09-b482-4d4f-8e4f-2dff597cc2b5",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2222169@Y=41413147@L=%23mcp%3AV%3Adonkey-barcelona%3A83d4cf09-b482-4d4f-8e4f-2dff597cc2b5_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A83d4cf09-b482-4d4f-8e4f-2dff597cc2b5_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.222169,
                    "lat": 41.413147
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9bd1b6ff-9882-41f7-9e1e-d656857168d3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9bd1b6ff-9882-41f7-9e1e-d656857168d3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9bd1b6ff-9882-41f7-9e1e-d656857168d3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9bd1b6ff-9882-41f7-9e1e-d656857168d3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWJkMWI2ZmYtOTg4Mi00MWY3LTllMWUtZDY1Njg1NzE2OGQzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWJkMWI2ZmYtOTg4Mi00MWY3LTllMWUtZDY1Njg1NzE2OGQzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9bd1b6ff-9882-41f7-9e1e-d656857168d3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9bd1b6ff-9882-41f7-9e1e-d656857168d3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2222169@Y=41413147@L=%23mcp%3AV%3Adonkey-barcelona%3A9bd1b6ff-9882-41f7-9e1e-d656857168d3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9bd1b6ff-9882-41f7-9e1e-d656857168d3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.222169,
                    "lat": 41.413147
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=94236ea7-28a1-4db2-900f-5367b0863e3a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=94236ea7-28a1-4db2-900f-5367b0863e3a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=94236ea7-28a1-4db2-900f-5367b0863e3a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=94236ea7-28a1-4db2-900f-5367b0863e3a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTQyMzZlYTctMjhhMS00ZGIyLTkwMGYtNTM2N2IwODYzZTNhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTQyMzZlYTctMjhhMS00ZGIyLTkwMGYtNTM2N2IwODYzZTNhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:94236ea7-28a1-4db2-900f-5367b0863e3a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "94236ea7-28a1-4db2-900f-5367b0863e3a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2222169@Y=41413147@L=%23mcp%3AV%3Adonkey-barcelona%3A94236ea7-28a1-4db2-900f-5367b0863e3a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A94236ea7-28a1-4db2-900f-5367b0863e3a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.222169,
                    "lat": 41.413147
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7d71e5d9-2681-4d73-9475-6244366530fa",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7d71e5d9-2681-4d73-9475-6244366530fa"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7d71e5d9-2681-4d73-9475-6244366530fa",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7d71e5d9-2681-4d73-9475-6244366530fa"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2Q3MWU1ZDktMjY4MS00ZDczLTk0NzUtNjI0NDM2NjUzMGZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2Q3MWU1ZDktMjY4MS00ZDczLTk0NzUtNjI0NDM2NjUzMGZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7d71e5d9-2681-4d73-9475-6244366530fa_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7d71e5d9-2681-4d73-9475-6244366530fa",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2222169@Y=41413147@L=%23mcp%3AV%3Adonkey-barcelona%3A7d71e5d9-2681-4d73-9475-6244366530fa_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7d71e5d9-2681-4d73-9475-6244366530fa_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.222169,
                    "lat": 41.413147
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9f385107-0698-4dfa-8aaa-a4bf2b564c40",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9f385107-0698-4dfa-8aaa-a4bf2b564c40"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9f385107-0698-4dfa-8aaa-a4bf2b564c40",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9f385107-0698-4dfa-8aaa-a4bf2b564c40"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWYzODUxMDctMDY5OC00ZGZhLThhYWEtYTRiZjJiNTY0YzQwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWYzODUxMDctMDY5OC00ZGZhLThhYWEtYTRiZjJiNTY0YzQwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9f385107-0698-4dfa-8aaa-a4bf2b564c40_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9f385107-0698-4dfa-8aaa-a4bf2b564c40",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2221954@Y=41413337@L=%23mcp%3AV%3Adonkey-barcelona%3A9f385107-0698-4dfa-8aaa-a4bf2b564c40_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9f385107-0698-4dfa-8aaa-a4bf2b564c40_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.221954,
                    "lat": 41.413337
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0d47aa34-7c51-4cf3-9ed5-016945acb75a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0d47aa34-7c51-4cf3-9ed5-016945acb75a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=0d47aa34-7c51-4cf3-9ed5-016945acb75a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=0d47aa34-7c51-4cf3-9ed5-016945acb75a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGQ0N2FhMzQtN2M1MS00Y2YzLTllZDUtMDE2OTQ1YWNiNzVhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMGQ0N2FhMzQtN2M1MS00Y2YzLTllZDUtMDE2OTQ1YWNiNzVhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:0d47aa34-7c51-4cf3-9ed5-016945acb75a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "0d47aa34-7c51-4cf3-9ed5-016945acb75a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2221974@Y=41413337@L=%23mcp%3AV%3Adonkey-barcelona%3A0d47aa34-7c51-4cf3-9ed5-016945acb75a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A0d47aa34-7c51-4cf3-9ed5-016945acb75a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.221974,
                    "lat": 41.413337
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ce284534-05eb-4c02-9096-627ddcf7e01b",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ce284534-05eb-4c02-9096-627ddcf7e01b"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ce284534-05eb-4c02-9096-627ddcf7e01b",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ce284534-05eb-4c02-9096-627ddcf7e01b"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2UyODQ1MzQtMDVlYi00YzAyLTkwOTYtNjI3ZGRjZjdlMDFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiY2UyODQ1MzQtMDVlYi00YzAyLTkwOTYtNjI3ZGRjZjdlMDFiIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ce284534-05eb-4c02-9096-627ddcf7e01b_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ce284534-05eb-4c02-9096-627ddcf7e01b",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2194110@Y=41414331@L=%23mcp%3AV%3Adonkey-barcelona%3Ace284534-05eb-4c02-9096-627ddcf7e01b_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ace284534-05eb-4c02-9096-627ddcf7e01b_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.19411,
                    "lat": 41.414331
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=62a7b429-c9ef-42e1-a01a-00fc0910fba3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=62a7b429-c9ef-42e1-a01a-00fc0910fba3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=62a7b429-c9ef-42e1-a01a-00fc0910fba3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=62a7b429-c9ef-42e1-a01a-00fc0910fba3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjJhN2I0MjktYzllZi00MmUxLWEwMWEtMDBmYzA5MTBmYmEzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjJhN2I0MjktYzllZi00MmUxLWEwMWEtMDBmYzA5MTBmYmEzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:62a7b429-c9ef-42e1-a01a-00fc0910fba3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "62a7b429-c9ef-42e1-a01a-00fc0910fba3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2194110@Y=41414331@L=%23mcp%3AV%3Adonkey-barcelona%3A62a7b429-c9ef-42e1-a01a-00fc0910fba3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A62a7b429-c9ef-42e1-a01a-00fc0910fba3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.19411,
                    "lat": 41.414331
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1de16803-7e00-4f85-99e6-593cb71c636a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1de16803-7e00-4f85-99e6-593cb71c636a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1de16803-7e00-4f85-99e6-593cb71c636a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1de16803-7e00-4f85-99e6-593cb71c636a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWRlMTY4MDMtN2UwMC00Zjg1LTk5ZTYtNTkzY2I3MWM2MzZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWRlMTY4MDMtN2UwMC00Zjg1LTk5ZTYtNTkzY2I3MWM2MzZhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1de16803-7e00-4f85-99e6-593cb71c636a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1de16803-7e00-4f85-99e6-593cb71c636a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2194379@Y=41414407@L=%23mcp%3AV%3Adonkey-barcelona%3A1de16803-7e00-4f85-99e6-593cb71c636a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1de16803-7e00-4f85-99e6-593cb71c636a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.194379,
                    "lat": 41.414407
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=394a390b-7fdc-4d42-96cd-715c3ee2f7da",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=394a390b-7fdc-4d42-96cd-715c3ee2f7da"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=394a390b-7fdc-4d42-96cd-715c3ee2f7da",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=394a390b-7fdc-4d42-96cd-715c3ee2f7da"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzk0YTM5MGItN2ZkYy00ZDQyLTk2Y2QtNzE1YzNlZTJmN2RhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMzk0YTM5MGItN2ZkYy00ZDQyLTk2Y2QtNzE1YzNlZTJmN2RhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:394a390b-7fdc-4d42-96cd-715c3ee2f7da_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "394a390b-7fdc-4d42-96cd-715c3ee2f7da",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2194595@Y=41414502@L=%23mcp%3AV%3Adonkey-barcelona%3A394a390b-7fdc-4d42-96cd-715c3ee2f7da_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A394a390b-7fdc-4d42-96cd-715c3ee2f7da_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.194595,
                    "lat": 41.414502
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c87df1aa-4e93-497d-b85d-35bfe6dd8ba2",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c87df1aa-4e93-497d-b85d-35bfe6dd8ba2"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=c87df1aa-4e93-497d-b85d-35bfe6dd8ba2",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=c87df1aa-4e93-497d-b85d-35bfe6dd8ba2"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzg3ZGYxYWEtNGU5My00OTdkLWI4NWQtMzViZmU2ZGQ4YmEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYzg3ZGYxYWEtNGU5My00OTdkLWI4NWQtMzViZmU2ZGQ4YmEyIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:c87df1aa-4e93-497d-b85d-35bfe6dd8ba2_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "c87df1aa-4e93-497d-b85d-35bfe6dd8ba2",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2194595@Y=41414502@L=%23mcp%3AV%3Adonkey-barcelona%3Ac87df1aa-4e93-497d-b85d-35bfe6dd8ba2_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ac87df1aa-4e93-497d-b85d-35bfe6dd8ba2_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.194595,
                    "lat": 41.414502
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ba5ebdd1-caed-4e28-b37d-f40eb10dd939",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ba5ebdd1-caed-4e28-b37d-f40eb10dd939"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ba5ebdd1-caed-4e28-b37d-f40eb10dd939",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ba5ebdd1-caed-4e28-b37d-f40eb10dd939"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmE1ZWJkZDEtY2FlZC00ZTI4LWIzN2QtZjQwZWIxMGRkOTM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYmE1ZWJkZDEtY2FlZC00ZTI4LWIzN2QtZjQwZWIxMGRkOTM5IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ba5ebdd1-caed-4e28-b37d-f40eb10dd939_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ba5ebdd1-caed-4e28-b37d-f40eb10dd939",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2220671@Y=41415028@L=%23mcp%3AV%3Adonkey-barcelona%3Aba5ebdd1-caed-4e28-b37d-f40eb10dd939_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aba5ebdd1-caed-4e28-b37d-f40eb10dd939_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.220671,
                    "lat": 41.415028
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9d14d62b-296a-4c07-bf15-17f50c3c73b0",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9d14d62b-296a-4c07-bf15-17f50c3c73b0"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=9d14d62b-296a-4c07-bf15-17f50c3c73b0",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=9d14d62b-296a-4c07-bf15-17f50c3c73b0"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWQxNGQ2MmItMjk2YS00YzA3LWJmMTUtMTdmNTBjM2M3M2IwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOWQxNGQ2MmItMjk2YS00YzA3LWJmMTUtMTdmNTBjM2M3M2IwIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:9d14d62b-296a-4c07-bf15-17f50c3c73b0_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "9d14d62b-296a-4c07-bf15-17f50c3c73b0",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2212539@Y=41415719@L=%23mcp%3AV%3Adonkey-barcelona%3A9d14d62b-296a-4c07-bf15-17f50c3c73b0_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A9d14d62b-296a-4c07-bf15-17f50c3c73b0_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.212539,
                    "lat": 41.415719
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=179db65f-858e-494c-a09b-997ce89d7795",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=179db65f-858e-494c-a09b-997ce89d7795"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=179db65f-858e-494c-a09b-997ce89d7795",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=179db65f-858e-494c-a09b-997ce89d7795"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTc5ZGI2NWYtODU4ZS00OTRjLWEwOWItOTk3Y2U4OWQ3Nzk1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMTc5ZGI2NWYtODU4ZS00OTRjLWEwOWItOTk3Y2U4OWQ3Nzk1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:179db65f-858e-494c-a09b-997ce89d7795_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "179db65f-858e-494c-a09b-997ce89d7795",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2213067@Y=41415964@L=%23mcp%3AV%3Adonkey-barcelona%3A179db65f-858e-494c-a09b-997ce89d7795_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A179db65f-858e-494c-a09b-997ce89d7795_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.213067,
                    "lat": 41.415964
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=934f4244-972f-4ead-a12d-d1c3b858da65",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=934f4244-972f-4ead-a12d-d1c3b858da65"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=934f4244-972f-4ead-a12d-d1c3b858da65",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=934f4244-972f-4ead-a12d-d1c3b858da65"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTM0ZjQyNDQtOTcyZi00ZWFkLWExMmQtZDFjM2I4NThkYTY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTM0ZjQyNDQtOTcyZi00ZWFkLWExMmQtZDFjM2I4NThkYTY1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:934f4244-972f-4ead-a12d-d1c3b858da65_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "934f4244-972f-4ead-a12d-d1c3b858da65",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2213062@Y=41415975@L=%23mcp%3AV%3Adonkey-barcelona%3A934f4244-972f-4ead-a12d-d1c3b858da65_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A934f4244-972f-4ead-a12d-d1c3b858da65_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.213062,
                    "lat": 41.415975
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1d61f2c5-4c97-4882-86e3-98bb6262b645",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1d61f2c5-4c97-4882-86e3-98bb6262b645"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=1d61f2c5-4c97-4882-86e3-98bb6262b645",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=1d61f2c5-4c97-4882-86e3-98bb6262b645"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWQ2MWYyYzUtNGM5Ny00ODgyLTg2ZTMtOThiYjYyNjJiNjQ1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiMWQ2MWYyYzUtNGM5Ny00ODgyLTg2ZTMtOThiYjYyNjJiNjQ1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:1d61f2c5-4c97-4882-86e3-98bb6262b645_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "1d61f2c5-4c97-4882-86e3-98bb6262b645",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2185828@Y=41416254@L=%23mcp%3AV%3Adonkey-barcelona%3A1d61f2c5-4c97-4882-86e3-98bb6262b645_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A1d61f2c5-4c97-4882-86e3-98bb6262b645_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.185828,
                    "lat": 41.416254
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=97729da1-91ce-4d07-8d53-985ff5a0f763",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=97729da1-91ce-4d07-8d53-985ff5a0f763"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=97729da1-91ce-4d07-8d53-985ff5a0f763",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=97729da1-91ce-4d07-8d53-985ff5a0f763"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTc3MjlkYTEtOTFjZS00ZDA3LThkNTMtOTg1ZmY1YTBmNzYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTc3MjlkYTEtOTFjZS00ZDA3LThkNTMtOTg1ZmY1YTBmNzYzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:97729da1-91ce-4d07-8d53-985ff5a0f763_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "97729da1-91ce-4d07-8d53-985ff5a0f763",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2198377@Y=41416808@L=%23mcp%3AV%3Adonkey-barcelona%3A97729da1-91ce-4d07-8d53-985ff5a0f763_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A97729da1-91ce-4d07-8d53-985ff5a0f763_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.198377,
                    "lat": 41.416808
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7c1059de-e88b-4e32-81dd-0a1ba922e4ee",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7c1059de-e88b-4e32-81dd-0a1ba922e4ee"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=7c1059de-e88b-4e32-81dd-0a1ba922e4ee",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=7c1059de-e88b-4e32-81dd-0a1ba922e4ee"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2MxMDU5ZGUtZTg4Yi00ZTMyLTgxZGQtMGExYmE5MjJlNGVlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiN2MxMDU5ZGUtZTg4Yi00ZTMyLTgxZGQtMGExYmE5MjJlNGVlIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:7c1059de-e88b-4e32-81dd-0a1ba922e4ee_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "7c1059de-e88b-4e32-81dd-0a1ba922e4ee",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2209021@Y=41417212@L=%23mcp%3AV%3Adonkey-barcelona%3A7c1059de-e88b-4e32-81dd-0a1ba922e4ee_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A7c1059de-e88b-4e32-81dd-0a1ba922e4ee_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.209021,
                    "lat": 41.417212
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=988dfc01-e978-439b-84ab-9f107c8e7c35",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=988dfc01-e978-439b-84ab-9f107c8e7c35"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=988dfc01-e978-439b-84ab-9f107c8e7c35",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=988dfc01-e978-439b-84ab-9f107c8e7c35"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTg4ZGZjMDEtZTk3OC00MzliLTg0YWItOWYxMDdjOGU3YzM1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiOTg4ZGZjMDEtZTk3OC00MzliLTg0YWItOWYxMDdjOGU3YzM1IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:988dfc01-e978-439b-84ab-9f107c8e7c35_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "988dfc01-e978-439b-84ab-9f107c8e7c35",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2208940@Y=41417245@L=%23mcp%3AV%3Adonkey-barcelona%3A988dfc01-e978-439b-84ab-9f107c8e7c35_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A988dfc01-e978-439b-84ab-9f107c8e7c35_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.20894,
                    "lat": 41.417245
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b2765a8d-26ae-4ced-a53a-3716c8bf30d3",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b2765a8d-26ae-4ced-a53a-3716c8bf30d3"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=b2765a8d-26ae-4ced-a53a-3716c8bf30d3",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=b2765a8d-26ae-4ced-a53a-3716c8bf30d3"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjI3NjVhOGQtMjZhZS00Y2VkLWE1M2EtMzcxNmM4YmYzMGQzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYjI3NjVhOGQtMjZhZS00Y2VkLWE1M2EtMzcxNmM4YmYzMGQzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:b2765a8d-26ae-4ced-a53a-3716c8bf30d3_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "b2765a8d-26ae-4ced-a53a-3716c8bf30d3",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2190220@Y=41417912@L=%23mcp%3AV%3Adonkey-barcelona%3Ab2765a8d-26ae-4ced-a53a-3716c8bf30d3_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ab2765a8d-26ae-4ced-a53a-3716c8bf30d3_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.19022,
                    "lat": 41.417912
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a4987bf8-87ef-4054-a135-f8ff39ece713",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a4987bf8-87ef-4054-a135-f8ff39ece713"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a4987bf8-87ef-4054-a135-f8ff39ece713",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a4987bf8-87ef-4054-a135-f8ff39ece713"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTQ5ODdiZjgtODdlZi00MDU0LWExMzUtZjhmZjM5ZWNlNzEzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYTQ5ODdiZjgtODdlZi00MDU0LWExMzUtZjhmZjM5ZWNlNzEzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a4987bf8-87ef-4054-a135-f8ff39ece713_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a4987bf8-87ef-4054-a135-f8ff39ece713",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2187087@Y=41419116@L=%23mcp%3AV%3Adonkey-barcelona%3Aa4987bf8-87ef-4054-a135-f8ff39ece713_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa4987bf8-87ef-4054-a135-f8ff39ece713_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.187087,
                    "lat": 41.419116
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6516cff1-bb5a-48df-b181-aa60bfcf22cd",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6516cff1-bb5a-48df-b181-aa60bfcf22cd"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=6516cff1-bb5a-48df-b181-aa60bfcf22cd",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=6516cff1-bb5a-48df-b181-aa60bfcf22cd"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjUxNmNmZjEtYmI1YS00OGRmLWIxODEtYWE2MGJmY2YyMmNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiNjUxNmNmZjEtYmI1YS00OGRmLWIxODEtYWE2MGJmY2YyMmNkIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:6516cff1-bb5a-48df-b181-aa60bfcf22cd_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "6516cff1-bb5a-48df-b181-aa60bfcf22cd",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2186718@Y=41420084@L=%23mcp%3AV%3Adonkey-barcelona%3A6516cff1-bb5a-48df-b181-aa60bfcf22cd_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A6516cff1-bb5a-48df-b181-aa60bfcf22cd_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.186718,
                    "lat": 41.420084
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e6458843-63be-4687-8f8e-1c95e9a34336",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e6458843-63be-4687-8f8e-1c95e9a34336"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=e6458843-63be-4687-8f8e-1c95e9a34336",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=e6458843-63be-4687-8f8e-1c95e9a34336"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTY0NTg4NDMtNjNiZS00Njg3LThmOGUtMWM5NWU5YTM0MzM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZTY0NTg4NDMtNjNiZS00Njg3LThmOGUtMWM5NWU5YTM0MzM2IiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:e6458843-63be-4687-8f8e-1c95e9a34336_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "e6458843-63be-4687-8f8e-1c95e9a34336",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2205075@Y=41422013@L=%23mcp%3AV%3Adonkey-barcelona%3Ae6458843-63be-4687-8f8e-1c95e9a34336_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ae6458843-63be-4687-8f8e-1c95e9a34336_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.205075,
                    "lat": 41.422013
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ec588a09-a52d-481b-a7e7-495c74e610ec",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ec588a09-a52d-481b-a7e7-495c74e610ec"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=ec588a09-a52d-481b-a7e7-495c74e610ec",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=ec588a09-a52d-481b-a7e7-495c74e610ec"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWM1ODhhMDktYTUyZC00ODFiLWE3ZTctNDk1Yzc0ZTYxMGVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZWM1ODhhMDktYTUyZC00ODFiLWE3ZTctNDk1Yzc0ZTYxMGVjIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:ec588a09-a52d-481b-a7e7-495c74e610ec_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "ec588a09-a52d-481b-a7e7-495c74e610ec",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2204888@Y=41422046@L=%23mcp%3AV%3Adonkey-barcelona%3Aec588a09-a52d-481b-a7e7-495c74e610ec_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aec588a09-a52d-481b-a7e7-495c74e610ec_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.204888,
                    "lat": 41.422046
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a8b679b5-f630-43ba-9c8d-6e17136de553",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a8b679b5-f630-43ba-9c8d-6e17136de553"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=a8b679b5-f630-43ba-9c8d-6e17136de553",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=a8b679b5-f630-43ba-9c8d-6e17136de553"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYThiNjc5YjUtZjYzMC00M2JhLTljOGQtNmUxNzEzNmRlNTUzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiYThiNjc5YjUtZjYzMC00M2JhLTljOGQtNmUxNzEzNmRlNTUzIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:a8b679b5-f630-43ba-9c8d-6e17136de553_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "a8b679b5-f630-43ba-9c8d-6e17136de553",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2191372@Y=41422617@L=%23mcp%3AV%3Adonkey-barcelona%3Aa8b679b5-f630-43ba-9c8d-6e17136de553_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Aa8b679b5-f630-43ba-9c8d-6e17136de553_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.191372,
                    "lat": 41.422617
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=de5b4cc6-4af6-4685-a891-a1423f9e046f",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=de5b4cc6-4af6-4685-a891-a1423f9e046f"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=de5b4cc6-4af6-4685-a891-a1423f9e046f",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=de5b4cc6-4af6-4685-a891-a1423f9e046f"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGU1YjRjYzYtNGFmNi00Njg1LWE4OTEtYTE0MjNmOWUwNDZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiZGU1YjRjYzYtNGFmNi00Njg1LWE4OTEtYTE0MjNmOWUwNDZmIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:de5b4cc6-4af6-4685-a891-a1423f9e046f_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "de5b4cc6-4af6-4685-a891-a1423f9e046f",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2180245@Y=41425066@L=%23mcp%3AV%3Adonkey-barcelona%3Ade5b4cc6-4af6-4685-a891-a1423f9e046f_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3Ade5b4cc6-4af6-4685-a891-a1423f9e046f_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.180245,
                    "lat": 41.425066
                }
            },
            {
                "CoordLocation": {
                    "LocationNotes": {
                        "LocationNote": [
                            {
                                "value": "bike",
                                "key": "GBFS_VEHICLE_TYPE_ID",
                                "type": "W",
                                "txtN": "bike"
                            },
                            {
                                "value": "bicycle",
                                "key": "VEHICLE_TYPE",
                                "type": "W",
                                "txtN": "bicycle"
                            },
                            {
                                "value": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window.",
                                "key": "PRICING_DESCRIPTION",
                                "type": "W",
                                "txtN": "With the new Just Ride pricing, you now pay a flat fee for the first several minutes of your ride. After that, the price accumulates on a per-minute basis until the cap price is reached in each 24 h window."
                            },
                            {
                                "value": "Bike",
                                "key": "BOOKEE_NAME",
                                "type": "W",
                                "txtN": "Bike"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_STALE_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "2100-01-01T00:00:00Z",
                                "key": "UPDATE_INFO_EXPIRATION_TIME",
                                "type": "W",
                                "txtN": "2100-01-01T00:00:00Z"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_IOS",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://www.donkey.bike/cities/bike-rental-barcelona/",
                                "key": "LINK_WEB",
                                "type": "W",
                                "txtN": "https://www.donkey.bike/cities/bike-rental-barcelona/"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3fa4679e-c872-4004-95fe-bd0c7e32131a",
                                "key": "DEEP_LINK_IOS",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3fa4679e-c872-4004-95fe-bd0c7e32131a"
                            },
                            {
                                "value": "https://dnky.bike/bike?bike_id=3fa4679e-c872-4004-95fe-bd0c7e32131a",
                                "key": "DEEP_LINK_ANDROID",
                                "type": "W",
                                "txtN": "https://dnky.bike/bike?bike_id=3fa4679e-c872-4004-95fe-bd0c7e32131a"
                            },
                            {
                                "value": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2ZhNDY3OWUtYzg3Mi00MDA0LTk1ZmUtYmQwYzdlMzIxMzFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9",
                                "key": "BOOKING_CONTEXT",
                                "type": "W",
                                "txtN": "eyJ0eXBlIjoiZ2JmcyIsInZlcnNpb24iOiIxLjIzIiwidmVoaWNsZUlkIjoiM2ZhNDY3OWUtYzg3Mi00MDA0LTk1ZmUtYmQwYzdlMzIxMzFhIiwicHJvdmlkZXJJZCI6ImRvbmtleS1yZXB1YmxpYyJ9"
                            },
                            {
                                "value": "[\"donkey-barcelona:bike_service_area\"]",
                                "key": "ASSIGNED_SERVICE_AREA_IDS",
                                "type": "W",
                                "txtN": "[\"donkey-barcelona:bike_service_area\"]"
                            },
                            {
                                "value": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ==",
                                "key": "TARIFF_INFO",
                                "type": "W",
                                "txtN": "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6IjgwIiwibmFtZSI6IkJpa2UgcHJpY2luZyIsImRlc2NyaXB0aW9uIjoiV2l0aCB0aGUgbmV3IEp1c3QgUmlkZSBwcmljaW5nLCB5b3Ugbm93IHBheSBhIGZsYXQgZmVlIGZvciB0aGUgZmlyc3Qgc2V2ZXJhbCBtaW51dGVzIG9mIHlvdXIgcmlkZS4gQWZ0ZXIgdGhhdCwgdGhlIHByaWNlIGFjY3VtdWxhdGVzIG9uIGEgcGVyLW1pbnV0ZSBiYXNpcyB1bnRpbCB0aGUgY2FwIHByaWNlIGlzIHJlYWNoZWQgaW4gZWFjaCAyNCBoIHdpbmRvdy4iLCJjdXJyZW5jeSI6IkVVUiIsImJhc2VDb3N0IjoiMi4wMCIsImNvc3RQZXJTZWNvbmQiOlt7ImFtb3VudCI6IjIuMDAiLCJyYW5nZSI6eyJtaW4iOjkwMCwibWF4IjoxNTYwLCJsb3dlckJvdW5kIjoiQ0xPU0VEIiwidXBwZXJCb3VuZCI6Ik9QRU4ifSwiaW50ZXJ2YWwiOjkwMH0seyJhbW91bnQiOiIyLjAwIiwicmFuZ2UiOnsibWluIjo4NjQwMCwibWF4Ijo4NzEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MTcyODAwLCJtYXgiOjE3MzUyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MjU5MjAwLCJtYXgiOjI1OTkyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6MzQ1NjAwLCJtYXgiOjM0NjMyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NDMyMDAwLCJtYXgiOjQzMjcyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9LHsiYW1vdW50IjoiMi4wMCIsInJhbmdlIjp7Im1pbiI6NTE4NDAwLCJtYXgiOjUxOTEyMCwibG93ZXJCb3VuZCI6IkNMT1NFRCIsInVwcGVyQm91bmQiOiJPUEVOIn0sImludGVydmFsIjo5MDB9XX1dfQ=="
                            },
                            {
                                "value": "[\"AREA\",\"FLEX_STATION\"]",
                                "key": "RETURN_TYPES",
                                "type": "W",
                                "txtN": "[\"AREA\",\"FLEX_STATION\"]"
                            },
                            {
                                "value": "Human",
                                "key": "PROPULSION",
                                "type": "W",
                                "txtN": "HUMAN"
                            },
                            {
                                "value": "Bicycle",
                                "key": "FORM_FACTOR",
                                "type": "W",
                                "txtN": "BICYCLE"
                            },
                            {
                                "value": "donkey-barcelona",
                                "key": "REGION_ID",
                                "type": "W",
                                "txtN": "donkey-barcelona"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "PROVIDER_NAME",
                                "type": "W",
                                "txtN": "Donkey Republic Spain"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "providerName",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "PROVIDER_ID",
                                "type": "W",
                                "txtN": "donkey-republic"
                            },
                            {
                                "value": "Bookee",
                                "key": "MCP_TYPE",
                                "type": "W",
                                "txtN": "BOOKEE"
                            },
                            {
                                "value": "donkey-republic",
                                "key": "provider",
                                "type": "U"
                            },
                            {
                                "value": "Donkey Republic Spain",
                                "key": "providerName",
                                "type": "U"
                            },
                            {
                                "value": "A",
                                "key": "availability",
                                "type": "U"
                            },
                            {
                                "value": "donkey-barcelona:3fa4679e-c872-4004-95fe-bd0c7e32131a_b",
                                "key": "mcpId",
                                "type": "U"
                            },
                            {
                                "value": "3fa4679e-c872-4004-95fe-bd0c7e32131a",
                                "key": "externalId",
                                "type": "U"
                            },
                            {
                                "value": "V",
                                "key": "mcpType",
                                "type": "U"
                            }
                        ]
                    },
                    "icon": {
                        "res": "prod_donkey"
                    },
                    "id": "A=2048@O=Bike@X=2176891@Y=41427930@L=%23mcp%3AV%3Adonkey-barcelona%3A3fa4679e-c872-4004-95fe-bd0c7e32131a_b@S=2@",
                    "extId": "%23mcp%3AV%3Adonkey-barcelona%3A3fa4679e-c872-4004-95fe-bd0c7e32131a_b",
                    "name": "Bike",
                    "type": "MCP",
                    "lon": 2.176891,
                    "lat": 41.42793
                }
            }
        ]
    }
}